import './assets/index.0be93ae4.css';
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value2) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value: value2 }) : obj[key] = value2;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve2, reject) => {
    var fulfilled = (value2) => {
      try {
        step(generator.next(value2));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value2) => {
      try {
        step(generator.throw(value2));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve2(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { defineComponent, openBlock, createElementBlock, createElementVNode, normalizeClass, normalizeStyle, renderSlot as renderSlot$2, createBlock, createCommentVNode, getCurrentInstance, nextTick, reactive, computed, unref, toDisplayString, h, withDirectives, Fragment, renderList, createVNode, vShow, watch, useAttrs, resolveComponent, mergeProps, isRef, withCtx, createTextVNode, resolveDynamicComponent, ref, toRefs, vModelText, createSlots, onMounted, provide, inject, toRaw, withModifiers, resolveDirective, pushScopeId, popScopeId, useSlots, onBeforeUnmount, onUpdated, createStaticVNode, toHandlers } from "vue";
import { Loading, Notification, Message, Dialog, Button, Select, Option, Cascader as Cascader$1, CheckboxGroup, Checkbox as Checkbox$1, Tooltip, DatePicker, RadioGroup, RadioButton, RadioTag, Radio as Radio$1, Upload, Popover, ImageViewer, Progress, Image as Image$1, DropdownMenu, DropdownItem, Dropdown, Table, TableColumn, FormItem, Col, Row, CollapseItem, Form as Form$1, Drawer, MessageBox } from "@ks/kwai-ui";
import { isFunction as isFunction$2, cloneDeep, get as get$1, uniq, set as set$1, omit, debounce as debounce$2, isObject as isObject$6, merge as merge$1, isEmpty as isEmpty$1 } from "lodash";
import moment from "moment";
import { IconDirectionRight, IconGeneralClose, IconGeneralQuestion, IconGeneralAddItem, IconGeneralEye, IconGeneralDelete, IconGeneralCloseCircle, IconGeneralSetting, IconGeneralDownload, IconGeneralMore, IconColourUserNormal, IconGeneralFilter, IconDirectionDown, IconDirectionUp, IconMediaPlay, IconEditorEdit, IconEditorCopy } from "@kibt/pro-icons";
import { useRouter, useRoute } from "vue-router";
import Draggable from "vuedraggable";
import { useSyncRouter, sendWebloggerClick } from "@kibt/pro-lib";
import * as echarts from "echarts";
import Hls from "hls.js";
const noahIcon_vue_vue_type_style_index_0_scoped_true_lang = "";
const _export_sfc = (sfc, props) => {
  const target = sfc.__vccOpts || sfc;
  for (const [key, val] of props) {
    target[key] = val;
  }
  return target;
};
const _sfc_main$1i = defineComponent({
  name: "NoahIcon",
  components: {},
  props: {
    type: {
      type: String,
      default: "font"
    },
    id: {
      type: String
    },
    size: {
      type: String,
      default: "default"
    },
    style: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  setup() {
  }
});
const _hoisted_1$W = {
  key: 0,
  class: "noah-font-wrapper",
  "aria-hidden": "true"
};
const _hoisted_2$B = ["xlink:href"];
function _sfc_render$n(_ctx, _cache, $props, $setup, $data, $options) {
  return _ctx.type === "svg" ? (openBlock(), createElementBlock("svg", _hoisted_1$W, [
    createElementVNode("use", {
      "xlink:href": `#${_ctx.id}`
    }, null, 8, _hoisted_2$B)
  ])) : (openBlock(), createElementBlock("i", {
    key: 1,
    class: normalizeClass(["noah-font-wrapper", _ctx.id]),
    style: normalizeStyle(_ctx.style)
  }, null, 6));
}
const NoahIcon = /* @__PURE__ */ _export_sfc(_sfc_main$1i, [["render", _sfc_render$n], ["__scopeId", "data-v-07e28e89"]]);
const Tag_vue_vue_type_style_index_0_scoped_true_lang = "";
const _hoisted_1$V = {
  key: 0,
  class: "light_tag"
};
const _hoisted_2$A = { class: "text_wrapper" };
const _hoisted_3$r = { class: "text_wrapper" };
const _sfc_main$1h = /* @__PURE__ */ defineComponent({
  __name: "Tag",
  props: {
    className: {
      type: String,
      default: "normal"
    },
    icon: {
      type: String,
      default: ""
    },
    light: {
      type: Boolean,
      default: false
    },
    style: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  emits: ["click"],
  setup(__props) {
    return (_ctx, _cache) => {
      return __props.light ? (openBlock(), createElementBlock("span", _hoisted_1$V, [
        createElementVNode("span", {
          class: normalizeClass(["light_tag__circle", `${__props.className}-bg`])
        }, null, 2),
        createElementVNode("span", _hoisted_2$A, [
          renderSlot$2(_ctx.$slots, "default", {}, void 0, true)
        ])
      ])) : (openBlock(), createElementBlock("span", {
        key: 1,
        class: normalizeClass(["tag", __props.className]),
        style: normalizeStyle(__props.style)
      }, [
        __props.icon ? (openBlock(), createBlock(NoahIcon, {
          key: 0,
          id: __props.icon,
          class: "icon"
        }, null, 8, ["id"])) : createCommentVNode("", true),
        createElementVNode("span", _hoisted_3$r, [
          renderSlot$2(_ctx.$slots, "default", {}, void 0, true)
        ])
      ], 6));
    };
  }
});
const Tag = /* @__PURE__ */ _export_sfc(_sfc_main$1h, [["__scopeId", "data-v-7a15d856"]]);
const MUSTACHE = /^{{(.+)}}$/;
function parseValue$1(str, replaceKey, datasource, index2) {
  if (typeof str === "string") {
    return parseMustacheValue(str, replaceKey, datasource, index2);
  }
  if (isFunction$2(str)) {
    return str(datasource);
  }
  return "";
}
function parseMustacheValue(str, replaceKey, datasource, index2) {
  if (typeof str === "string") {
    const matchResult = str.match(MUSTACHE);
    if (matchResult == null ? void 0 : matchResult.length) {
      const reg = new RegExp(`${replaceKey}\\.([_$a-zA-Z]\\w*)`, "g");
      return matchResult[1].replace(reg, (match, p1) => {
        const temp = datasource[p1];
        if (Array.isArray(temp)) {
          return (temp == null ? void 0 : temp[index2 || 0]) || "";
        }
        return datasource[p1] || "";
      });
    }
  }
  return str;
}
function getMustacheContent(str) {
  if (typeof str === "string") {
    const matchResult = str.match(MUSTACHE);
    if (matchResult == null ? void 0 : matchResult.length) {
      return matchResult[1];
    }
  }
  return str;
}
function transformMustacheToFunc(str, replaceKey, datasource) {
  try {
    const func = new Function(replaceKey, `return ${str};`);
    return func(datasource);
  } catch (e) {
    console.warn("[ProTable] transformMustacheToFunc error");
    return str;
  }
}
function strip(num, toFixed = 1, replaceZero = false, precision = 12) {
  if (typeof num !== "number") {
    return `${num}`;
  }
  const count = +parseFloat(num.toPrecision(precision));
  const value2 = count.toFixed(toFixed);
  return replaceZero ? value2.replace(/(\.\d+?)0*$/, "$1") : value2;
}
function formatValue(count, toFixed = 1, unit = true) {
  let num = parseFloat(`${count}`);
  const sign = num >= 0 ? "" : "-";
  num = Math.abs(num);
  if (Number.isNaN(num)) {
    return count;
  }
  if (num < 1e3) {
    if (num % 1 === 0) {
      return `${sign}${num}`;
    }
    return `${sign}${strip(num, toFixed)}`;
  }
  if (num >= 1e3 && num < 1e6) {
    return `${sign}${strip(num / 1e3, toFixed)}${unit ? "K" : ""}`;
  }
  if (num >= 1e6 && num < 1e9) {
    return `${sign}${strip(num / 1e6, toFixed)}${unit ? "M" : ""}`;
  }
  return `${sign}${strip(num / 1e9, toFixed)}${unit ? "B" : ""}`;
}
function underline(str) {
  return str.replace(/\B([A-Z])/g, "-$1").toLowerCase();
}
function isEffectiveNumber(value2) {
  return value2 && !Number.isNaN(Number(value2));
}
function formatRate(value2, multiply = 100, toFixed = 2) {
  const num = Number(value2);
  if (Number.isNaN(num)) {
    if (!value2) {
      return "--";
    }
    return value2;
  }
  return `${(num * multiply).toFixed(toFixed)}%`;
}
var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};
function getAugmentedNamespace(n) {
  var f = n.default;
  if (typeof f == "function") {
    var a = function() {
      return f.apply(this, arguments);
    };
    a.prototype = f.prototype;
  } else
    a = {};
  Object.defineProperty(a, "__esModule", { value: true });
  Object.keys(n).forEach(function(k) {
    var d = Object.getOwnPropertyDescriptor(n, k);
    Object.defineProperty(a, k, d.get ? d : {
      enumerable: true,
      get: function() {
        return n[k];
      }
    });
  });
  return a;
}
var isArray$7 = Array.isArray;
var isArray_1 = isArray$7;
var freeGlobal$1 = typeof commonjsGlobal == "object" && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
var _freeGlobal = freeGlobal$1;
var freeGlobal = _freeGlobal;
var freeSelf = typeof self == "object" && self && self.Object === Object && self;
var root$4 = freeGlobal || freeSelf || Function("return this")();
var _root = root$4;
var root$3 = _root;
var Symbol$4 = root$3.Symbol;
var _Symbol = Symbol$4;
var Symbol$3 = _Symbol;
var objectProto$4 = Object.prototype;
var hasOwnProperty$3 = objectProto$4.hasOwnProperty;
var nativeObjectToString$1 = objectProto$4.toString;
var symToStringTag$1 = Symbol$3 ? Symbol$3.toStringTag : void 0;
function getRawTag$1(value2) {
  var isOwn = hasOwnProperty$3.call(value2, symToStringTag$1), tag = value2[symToStringTag$1];
  try {
    value2[symToStringTag$1] = void 0;
    var unmasked = true;
  } catch (e) {
  }
  var result = nativeObjectToString$1.call(value2);
  if (unmasked) {
    if (isOwn) {
      value2[symToStringTag$1] = tag;
    } else {
      delete value2[symToStringTag$1];
    }
  }
  return result;
}
var _getRawTag = getRawTag$1;
var objectProto$3 = Object.prototype;
var nativeObjectToString = objectProto$3.toString;
function objectToString$2(value2) {
  return nativeObjectToString.call(value2);
}
var _objectToString = objectToString$2;
var Symbol$2 = _Symbol, getRawTag = _getRawTag, objectToString$1 = _objectToString;
var nullTag = "[object Null]", undefinedTag = "[object Undefined]";
var symToStringTag = Symbol$2 ? Symbol$2.toStringTag : void 0;
function baseGetTag$2(value2) {
  if (value2 == null) {
    return value2 === void 0 ? undefinedTag : nullTag;
  }
  return symToStringTag && symToStringTag in Object(value2) ? getRawTag(value2) : objectToString$1(value2);
}
var _baseGetTag = baseGetTag$2;
function isObjectLike$1(value2) {
  return value2 != null && typeof value2 == "object";
}
var isObjectLike_1 = isObjectLike$1;
var baseGetTag$1 = _baseGetTag, isObjectLike = isObjectLike_1;
var symbolTag = "[object Symbol]";
function isSymbol$5(value2) {
  return typeof value2 == "symbol" || isObjectLike(value2) && baseGetTag$1(value2) == symbolTag;
}
var isSymbol_1 = isSymbol$5;
var isArray$6 = isArray_1, isSymbol$4 = isSymbol_1;
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/;
function isKey$1(value2, object) {
  if (isArray$6(value2)) {
    return false;
  }
  var type = typeof value2;
  if (type == "number" || type == "symbol" || type == "boolean" || value2 == null || isSymbol$4(value2)) {
    return true;
  }
  return reIsPlainProp.test(value2) || !reIsDeepProp.test(value2) || object != null && value2 in Object(object);
}
var _isKey = isKey$1;
function isObject$5(value2) {
  var type = typeof value2;
  return value2 != null && (type == "object" || type == "function");
}
var isObject_1 = isObject$5;
var baseGetTag = _baseGetTag, isObject$4 = isObject_1;
var asyncTag = "[object AsyncFunction]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", proxyTag = "[object Proxy]";
function isFunction$1(value2) {
  if (!isObject$4(value2)) {
    return false;
  }
  var tag = baseGetTag(value2);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}
var isFunction_1 = isFunction$1;
var root$2 = _root;
var coreJsData$1 = root$2["__core-js_shared__"];
var _coreJsData = coreJsData$1;
var coreJsData = _coreJsData;
var maskSrcKey = function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
  return uid ? "Symbol(src)_1." + uid : "";
}();
function isMasked$1(func) {
  return !!maskSrcKey && maskSrcKey in func;
}
var _isMasked = isMasked$1;
var funcProto$1 = Function.prototype;
var funcToString$1 = funcProto$1.toString;
function toSource$1(func) {
  if (func != null) {
    try {
      return funcToString$1.call(func);
    } catch (e) {
    }
    try {
      return func + "";
    } catch (e) {
    }
  }
  return "";
}
var _toSource = toSource$1;
var isFunction = isFunction_1, isMasked = _isMasked, isObject$3 = isObject_1, toSource = _toSource;
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
var reIsHostCtor = /^\[object .+?Constructor\]$/;
var funcProto = Function.prototype, objectProto$2 = Object.prototype;
var funcToString = funcProto.toString;
var hasOwnProperty$2 = objectProto$2.hasOwnProperty;
var reIsNative = RegExp(
  "^" + funcToString.call(hasOwnProperty$2).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function baseIsNative$1(value2) {
  if (!isObject$3(value2) || isMasked(value2)) {
    return false;
  }
  var pattern = isFunction(value2) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value2));
}
var _baseIsNative = baseIsNative$1;
function getValue$1(object, key) {
  return object == null ? void 0 : object[key];
}
var _getValue = getValue$1;
var baseIsNative = _baseIsNative, getValue = _getValue;
function getNative$2(object, key) {
  var value2 = getValue(object, key);
  return baseIsNative(value2) ? value2 : void 0;
}
var _getNative = getNative$2;
var getNative$1 = _getNative;
var nativeCreate$4 = getNative$1(Object, "create");
var _nativeCreate = nativeCreate$4;
var nativeCreate$3 = _nativeCreate;
function hashClear$1() {
  this.__data__ = nativeCreate$3 ? nativeCreate$3(null) : {};
  this.size = 0;
}
var _hashClear = hashClear$1;
function hashDelete$1(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}
var _hashDelete = hashDelete$1;
var nativeCreate$2 = _nativeCreate;
var HASH_UNDEFINED$1 = "__lodash_hash_undefined__";
var objectProto$1 = Object.prototype;
var hasOwnProperty$1 = objectProto$1.hasOwnProperty;
function hashGet$1(key) {
  var data = this.__data__;
  if (nativeCreate$2) {
    var result = data[key];
    return result === HASH_UNDEFINED$1 ? void 0 : result;
  }
  return hasOwnProperty$1.call(data, key) ? data[key] : void 0;
}
var _hashGet = hashGet$1;
var nativeCreate$1 = _nativeCreate;
var objectProto = Object.prototype;
var hasOwnProperty = objectProto.hasOwnProperty;
function hashHas$1(key) {
  var data = this.__data__;
  return nativeCreate$1 ? data[key] !== void 0 : hasOwnProperty.call(data, key);
}
var _hashHas = hashHas$1;
var nativeCreate = _nativeCreate;
var HASH_UNDEFINED = "__lodash_hash_undefined__";
function hashSet$1(key, value2) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = nativeCreate && value2 === void 0 ? HASH_UNDEFINED : value2;
  return this;
}
var _hashSet = hashSet$1;
var hashClear = _hashClear, hashDelete = _hashDelete, hashGet = _hashGet, hashHas = _hashHas, hashSet = _hashSet;
function Hash$1(entries) {
  var index2 = -1, length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index2 < length) {
    var entry = entries[index2];
    this.set(entry[0], entry[1]);
  }
}
Hash$1.prototype.clear = hashClear;
Hash$1.prototype["delete"] = hashDelete;
Hash$1.prototype.get = hashGet;
Hash$1.prototype.has = hashHas;
Hash$1.prototype.set = hashSet;
var _Hash = Hash$1;
function listCacheClear$1() {
  this.__data__ = [];
  this.size = 0;
}
var _listCacheClear = listCacheClear$1;
function eq$1(value2, other) {
  return value2 === other || value2 !== value2 && other !== other;
}
var eq_1 = eq$1;
var eq = eq_1;
function assocIndexOf$4(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}
var _assocIndexOf = assocIndexOf$4;
var assocIndexOf$3 = _assocIndexOf;
var arrayProto = Array.prototype;
var splice = arrayProto.splice;
function listCacheDelete$1(key) {
  var data = this.__data__, index2 = assocIndexOf$3(data, key);
  if (index2 < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index2 == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index2, 1);
  }
  --this.size;
  return true;
}
var _listCacheDelete = listCacheDelete$1;
var assocIndexOf$2 = _assocIndexOf;
function listCacheGet$1(key) {
  var data = this.__data__, index2 = assocIndexOf$2(data, key);
  return index2 < 0 ? void 0 : data[index2][1];
}
var _listCacheGet = listCacheGet$1;
var assocIndexOf$1 = _assocIndexOf;
function listCacheHas$1(key) {
  return assocIndexOf$1(this.__data__, key) > -1;
}
var _listCacheHas = listCacheHas$1;
var assocIndexOf = _assocIndexOf;
function listCacheSet$1(key, value2) {
  var data = this.__data__, index2 = assocIndexOf(data, key);
  if (index2 < 0) {
    ++this.size;
    data.push([key, value2]);
  } else {
    data[index2][1] = value2;
  }
  return this;
}
var _listCacheSet = listCacheSet$1;
var listCacheClear = _listCacheClear, listCacheDelete = _listCacheDelete, listCacheGet = _listCacheGet, listCacheHas = _listCacheHas, listCacheSet = _listCacheSet;
function ListCache$1(entries) {
  var index2 = -1, length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index2 < length) {
    var entry = entries[index2];
    this.set(entry[0], entry[1]);
  }
}
ListCache$1.prototype.clear = listCacheClear;
ListCache$1.prototype["delete"] = listCacheDelete;
ListCache$1.prototype.get = listCacheGet;
ListCache$1.prototype.has = listCacheHas;
ListCache$1.prototype.set = listCacheSet;
var _ListCache = ListCache$1;
var getNative = _getNative, root$1 = _root;
var Map$2 = getNative(root$1, "Map");
var _Map = Map$2;
var Hash = _Hash, ListCache = _ListCache, Map$1 = _Map;
function mapCacheClear$1() {
  this.size = 0;
  this.__data__ = {
    "hash": new Hash(),
    "map": new (Map$1 || ListCache)(),
    "string": new Hash()
  };
}
var _mapCacheClear = mapCacheClear$1;
function isKeyable$1(value2) {
  var type = typeof value2;
  return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value2 !== "__proto__" : value2 === null;
}
var _isKeyable = isKeyable$1;
var isKeyable = _isKeyable;
function getMapData$4(map, key) {
  var data = map.__data__;
  return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
var _getMapData = getMapData$4;
var getMapData$3 = _getMapData;
function mapCacheDelete$1(key) {
  var result = getMapData$3(this, key)["delete"](key);
  this.size -= result ? 1 : 0;
  return result;
}
var _mapCacheDelete = mapCacheDelete$1;
var getMapData$2 = _getMapData;
function mapCacheGet$1(key) {
  return getMapData$2(this, key).get(key);
}
var _mapCacheGet = mapCacheGet$1;
var getMapData$1 = _getMapData;
function mapCacheHas$1(key) {
  return getMapData$1(this, key).has(key);
}
var _mapCacheHas = mapCacheHas$1;
var getMapData = _getMapData;
function mapCacheSet$1(key, value2) {
  var data = getMapData(this, key), size = data.size;
  data.set(key, value2);
  this.size += data.size == size ? 0 : 1;
  return this;
}
var _mapCacheSet = mapCacheSet$1;
var mapCacheClear = _mapCacheClear, mapCacheDelete = _mapCacheDelete, mapCacheGet = _mapCacheGet, mapCacheHas = _mapCacheHas, mapCacheSet = _mapCacheSet;
function MapCache$1(entries) {
  var index2 = -1, length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index2 < length) {
    var entry = entries[index2];
    this.set(entry[0], entry[1]);
  }
}
MapCache$1.prototype.clear = mapCacheClear;
MapCache$1.prototype["delete"] = mapCacheDelete;
MapCache$1.prototype.get = mapCacheGet;
MapCache$1.prototype.has = mapCacheHas;
MapCache$1.prototype.set = mapCacheSet;
var _MapCache = MapCache$1;
var MapCache = _MapCache;
var FUNC_ERROR_TEXT$1 = "Expected a function";
function memoize$1(func, resolver) {
  if (typeof func != "function" || resolver != null && typeof resolver != "function") {
    throw new TypeError(FUNC_ERROR_TEXT$1);
  }
  var memoized = function() {
    var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize$1.Cache || MapCache)();
  return memoized;
}
memoize$1.Cache = MapCache;
var memoize_1 = memoize$1;
var memoize = memoize_1;
var MAX_MEMOIZE_SIZE = 500;
function memoizeCapped$1(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });
  var cache = result.cache;
  return result;
}
var _memoizeCapped = memoizeCapped$1;
var memoizeCapped = _memoizeCapped;
var rePropName$1 = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
var reEscapeChar$1 = /\\(\\)?/g;
var stringToPath$2 = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46) {
    result.push("");
  }
  string.replace(rePropName$1, function(match, number, quote2, subString) {
    result.push(quote2 ? subString.replace(reEscapeChar$1, "$1") : number || match);
  });
  return result;
});
var _stringToPath = stringToPath$2;
function arrayMap$1(array, iteratee) {
  var index2 = -1, length = array == null ? 0 : array.length, result = Array(length);
  while (++index2 < length) {
    result[index2] = iteratee(array[index2], index2, array);
  }
  return result;
}
var _arrayMap = arrayMap$1;
var Symbol$1 = _Symbol, arrayMap = _arrayMap, isArray$5 = isArray_1, isSymbol$3 = isSymbol_1;
var INFINITY$1 = 1 / 0;
var symbolProto = Symbol$1 ? Symbol$1.prototype : void 0, symbolToString = symbolProto ? symbolProto.toString : void 0;
function baseToString$1(value2) {
  if (typeof value2 == "string") {
    return value2;
  }
  if (isArray$5(value2)) {
    return arrayMap(value2, baseToString$1) + "";
  }
  if (isSymbol$3(value2)) {
    return symbolToString ? symbolToString.call(value2) : "";
  }
  var result = value2 + "";
  return result == "0" && 1 / value2 == -INFINITY$1 ? "-0" : result;
}
var _baseToString = baseToString$1;
var baseToString = _baseToString;
function toString$2(value2) {
  return value2 == null ? "" : baseToString(value2);
}
var toString_1 = toString$2;
var isArray$4 = isArray_1, isKey = _isKey, stringToPath$1 = _stringToPath, toString$1 = toString_1;
function castPath$1(value2, object) {
  if (isArray$4(value2)) {
    return value2;
  }
  return isKey(value2, object) ? [value2] : stringToPath$1(toString$1(value2));
}
var _castPath = castPath$1;
var isSymbol$2 = isSymbol_1;
var INFINITY = 1 / 0;
function toKey$1(value2) {
  if (typeof value2 == "string" || isSymbol$2(value2)) {
    return value2;
  }
  var result = value2 + "";
  return result == "0" && 1 / value2 == -INFINITY ? "-0" : result;
}
var _toKey = toKey$1;
var castPath = _castPath, toKey = _toKey;
function baseGet$1(object, path) {
  path = castPath(path, object);
  var index2 = 0, length = path.length;
  while (object != null && index2 < length) {
    object = object[toKey(path[index2++])];
  }
  return index2 && index2 == length ? object : void 0;
}
var _baseGet = baseGet$1;
var baseGet = _baseGet;
function get(object, path, defaultValue) {
  var result = object == null ? void 0 : baseGet(object, path);
  return result === void 0 ? defaultValue : result;
}
var get_1 = get;
const emptyFunc = () => ({});
const TEXT_EMPTY_VALUE = "- -";
const TABLE_ITEM_TYPE = {
  IMG: "img",
  TEXT: "text",
  LINK: "link",
  DATE: "date",
  SLOT: "slot",
  BTNS: "btns",
  TAG: "tag",
  NUMBER: "num",
  WIDGET: "widget",
  HTML: "html",
  SELECTION: "selection",
  RANK: "rank",
  PERCENTBAR: "percentBar",
  EXPAND: "expand",
  EXPAND_CUSTOM: "expand_custom",
  USER_HEAD_LIST: "userHeadList",
  IMAGE_INFO_BOX: "imageInfoBox"
};
var requiresPort = function required(port2, protocol) {
  protocol = protocol.split(":")[0];
  port2 = +port2;
  if (!port2)
    return false;
  switch (protocol) {
    case "http":
    case "ws":
      return port2 !== 80;
    case "https":
    case "wss":
      return port2 !== 443;
    case "ftp":
      return port2 !== 21;
    case "gopher":
      return port2 !== 70;
    case "file":
      return false;
  }
  return port2 !== 0;
};
var querystringify$1 = {};
var has$4 = Object.prototype.hasOwnProperty, undef;
function decode$1(input) {
  try {
    return decodeURIComponent(input.replace(/\+/g, " "));
  } catch (e) {
    return null;
  }
}
function encode$1(input) {
  try {
    return encodeURIComponent(input);
  } catch (e) {
    return null;
  }
}
function querystring(query) {
  var parser = /([^=?#&]+)=?([^&]*)/g, result = {}, part;
  while (part = parser.exec(query)) {
    var key = decode$1(part[1]), value2 = decode$1(part[2]);
    if (key === null || value2 === null || key in result)
      continue;
    result[key] = value2;
  }
  return result;
}
function querystringify(obj, prefix) {
  prefix = prefix || "";
  var pairs = [], value2, key;
  if ("string" !== typeof prefix)
    prefix = "?";
  for (key in obj) {
    if (has$4.call(obj, key)) {
      value2 = obj[key];
      if (!value2 && (value2 === null || value2 === undef || isNaN(value2))) {
        value2 = "";
      }
      key = encode$1(key);
      value2 = encode$1(value2);
      if (key === null || value2 === null)
        continue;
      pairs.push(key + "=" + value2);
    }
  }
  return pairs.length ? prefix + pairs.join("&") : "";
}
querystringify$1.stringify = querystringify;
querystringify$1.parse = querystring;
var required2 = requiresPort, qs = querystringify$1, controlOrWhitespace = /^[\x00-\x20\u00a0\u1680\u2000-\u200a\u2028\u2029\u202f\u205f\u3000\ufeff]+/, CRHTLF = /[\n\r\t]/g, slashes = /^[A-Za-z][A-Za-z0-9+-.]*:\/\//, port = /:\d+$/, protocolre = /^([a-z][a-z0-9.+-]*:)?(\/\/)?([\\/]+)?([\S\s]*)/i, windowsDriveLetter = /^[a-zA-Z]:/;
function trimLeft(str) {
  return (str ? str : "").toString().replace(controlOrWhitespace, "");
}
var rules = [
  ["#", "hash"],
  ["?", "query"],
  function sanitize(address, url) {
    return isSpecial(url.protocol) ? address.replace(/\\/g, "/") : address;
  },
  ["/", "pathname"],
  ["@", "auth", 1],
  [NaN, "host", void 0, 1, 1],
  [/:(\d*)$/, "port", void 0, 1],
  [NaN, "hostname", void 0, 1, 1]
];
var ignore = { hash: 1, query: 1 };
function lolcation(loc) {
  var globalVar;
  if (typeof window !== "undefined")
    globalVar = window;
  else if (typeof commonjsGlobal !== "undefined")
    globalVar = commonjsGlobal;
  else if (typeof self !== "undefined")
    globalVar = self;
  else
    globalVar = {};
  var location2 = globalVar.location || {};
  loc = loc || location2;
  var finaldestination = {}, type = typeof loc, key;
  if ("blob:" === loc.protocol) {
    finaldestination = new Url(unescape(loc.pathname), {});
  } else if ("string" === type) {
    finaldestination = new Url(loc, {});
    for (key in ignore)
      delete finaldestination[key];
  } else if ("object" === type) {
    for (key in loc) {
      if (key in ignore)
        continue;
      finaldestination[key] = loc[key];
    }
    if (finaldestination.slashes === void 0) {
      finaldestination.slashes = slashes.test(loc.href);
    }
  }
  return finaldestination;
}
function isSpecial(scheme) {
  return scheme === "file:" || scheme === "ftp:" || scheme === "http:" || scheme === "https:" || scheme === "ws:" || scheme === "wss:";
}
function extractProtocol(address, location2) {
  address = trimLeft(address);
  address = address.replace(CRHTLF, "");
  location2 = location2 || {};
  var match = protocolre.exec(address);
  var protocol = match[1] ? match[1].toLowerCase() : "";
  var forwardSlashes = !!match[2];
  var otherSlashes = !!match[3];
  var slashesCount = 0;
  var rest;
  if (forwardSlashes) {
    if (otherSlashes) {
      rest = match[2] + match[3] + match[4];
      slashesCount = match[2].length + match[3].length;
    } else {
      rest = match[2] + match[4];
      slashesCount = match[2].length;
    }
  } else {
    if (otherSlashes) {
      rest = match[3] + match[4];
      slashesCount = match[3].length;
    } else {
      rest = match[4];
    }
  }
  if (protocol === "file:") {
    if (slashesCount >= 2) {
      rest = rest.slice(2);
    }
  } else if (isSpecial(protocol)) {
    rest = match[4];
  } else if (protocol) {
    if (forwardSlashes) {
      rest = rest.slice(2);
    }
  } else if (slashesCount >= 2 && isSpecial(location2.protocol)) {
    rest = match[4];
  }
  return {
    protocol,
    slashes: forwardSlashes || isSpecial(protocol),
    slashesCount,
    rest
  };
}
function resolve(relative, base) {
  if (relative === "")
    return base;
  var path = (base || "/").split("/").slice(0, -1).concat(relative.split("/")), i = path.length, last = path[i - 1], unshift = false, up = 0;
  while (i--) {
    if (path[i] === ".") {
      path.splice(i, 1);
    } else if (path[i] === "..") {
      path.splice(i, 1);
      up++;
    } else if (up) {
      if (i === 0)
        unshift = true;
      path.splice(i, 1);
      up--;
    }
  }
  if (unshift)
    path.unshift("");
  if (last === "." || last === "..")
    path.push("");
  return path.join("/");
}
function Url(address, location2, parser) {
  address = trimLeft(address);
  address = address.replace(CRHTLF, "");
  if (!(this instanceof Url)) {
    return new Url(address, location2, parser);
  }
  var relative, extracted, parse2, instruction, index2, key, instructions = rules.slice(), type = typeof location2, url = this, i = 0;
  if ("object" !== type && "string" !== type) {
    parser = location2;
    location2 = null;
  }
  if (parser && "function" !== typeof parser)
    parser = qs.parse;
  location2 = lolcation(location2);
  extracted = extractProtocol(address || "", location2);
  relative = !extracted.protocol && !extracted.slashes;
  url.slashes = extracted.slashes || relative && location2.slashes;
  url.protocol = extracted.protocol || location2.protocol || "";
  address = extracted.rest;
  if (extracted.protocol === "file:" && (extracted.slashesCount !== 2 || windowsDriveLetter.test(address)) || !extracted.slashes && (extracted.protocol || extracted.slashesCount < 2 || !isSpecial(url.protocol))) {
    instructions[3] = [/(.*)/, "pathname"];
  }
  for (; i < instructions.length; i++) {
    instruction = instructions[i];
    if (typeof instruction === "function") {
      address = instruction(address, url);
      continue;
    }
    parse2 = instruction[0];
    key = instruction[1];
    if (parse2 !== parse2) {
      url[key] = address;
    } else if ("string" === typeof parse2) {
      index2 = parse2 === "@" ? address.lastIndexOf(parse2) : address.indexOf(parse2);
      if (~index2) {
        if ("number" === typeof instruction[2]) {
          url[key] = address.slice(0, index2);
          address = address.slice(index2 + instruction[2]);
        } else {
          url[key] = address.slice(index2);
          address = address.slice(0, index2);
        }
      }
    } else if (index2 = parse2.exec(address)) {
      url[key] = index2[1];
      address = address.slice(0, index2.index);
    }
    url[key] = url[key] || (relative && instruction[3] ? location2[key] || "" : "");
    if (instruction[4])
      url[key] = url[key].toLowerCase();
  }
  if (parser)
    url.query = parser(url.query);
  if (relative && location2.slashes && url.pathname.charAt(0) !== "/" && (url.pathname !== "" || location2.pathname !== "")) {
    url.pathname = resolve(url.pathname, location2.pathname);
  }
  if (url.pathname.charAt(0) !== "/" && isSpecial(url.protocol)) {
    url.pathname = "/" + url.pathname;
  }
  if (!required2(url.port, url.protocol)) {
    url.host = url.hostname;
    url.port = "";
  }
  url.username = url.password = "";
  if (url.auth) {
    index2 = url.auth.indexOf(":");
    if (~index2) {
      url.username = url.auth.slice(0, index2);
      url.username = encodeURIComponent(decodeURIComponent(url.username));
      url.password = url.auth.slice(index2 + 1);
      url.password = encodeURIComponent(decodeURIComponent(url.password));
    } else {
      url.username = encodeURIComponent(decodeURIComponent(url.auth));
    }
    url.auth = url.password ? url.username + ":" + url.password : url.username;
  }
  url.origin = url.protocol !== "file:" && isSpecial(url.protocol) && url.host ? url.protocol + "//" + url.host : "null";
  url.href = url.toString();
}
function set(part, value2, fn2) {
  var url = this;
  switch (part) {
    case "query":
      if ("string" === typeof value2 && value2.length) {
        value2 = (fn2 || qs.parse)(value2);
      }
      url[part] = value2;
      break;
    case "port":
      url[part] = value2;
      if (!required2(value2, url.protocol)) {
        url.host = url.hostname;
        url[part] = "";
      } else if (value2) {
        url.host = url.hostname + ":" + value2;
      }
      break;
    case "hostname":
      url[part] = value2;
      if (url.port)
        value2 += ":" + url.port;
      url.host = value2;
      break;
    case "host":
      url[part] = value2;
      if (port.test(value2)) {
        value2 = value2.split(":");
        url.port = value2.pop();
        url.hostname = value2.join(":");
      } else {
        url.hostname = value2;
        url.port = "";
      }
      break;
    case "protocol":
      url.protocol = value2.toLowerCase();
      url.slashes = !fn2;
      break;
    case "pathname":
    case "hash":
      if (value2) {
        var char = part === "pathname" ? "/" : "#";
        url[part] = value2.charAt(0) !== char ? char + value2 : value2;
      } else {
        url[part] = value2;
      }
      break;
    case "username":
    case "password":
      url[part] = encodeURIComponent(value2);
      break;
    case "auth":
      var index2 = value2.indexOf(":");
      if (~index2) {
        url.username = value2.slice(0, index2);
        url.username = encodeURIComponent(decodeURIComponent(url.username));
        url.password = value2.slice(index2 + 1);
        url.password = encodeURIComponent(decodeURIComponent(url.password));
      } else {
        url.username = encodeURIComponent(decodeURIComponent(value2));
      }
  }
  for (var i = 0; i < rules.length; i++) {
    var ins = rules[i];
    if (ins[4])
      url[ins[1]] = url[ins[1]].toLowerCase();
  }
  url.auth = url.password ? url.username + ":" + url.password : url.username;
  url.origin = url.protocol !== "file:" && isSpecial(url.protocol) && url.host ? url.protocol + "//" + url.host : "null";
  url.href = url.toString();
  return url;
}
function toString(stringify3) {
  if (!stringify3 || "function" !== typeof stringify3)
    stringify3 = qs.stringify;
  var query, url = this, host = url.host, protocol = url.protocol;
  if (protocol && protocol.charAt(protocol.length - 1) !== ":")
    protocol += ":";
  var result = protocol + (url.protocol && url.slashes || isSpecial(url.protocol) ? "//" : "");
  if (url.username) {
    result += url.username;
    if (url.password)
      result += ":" + url.password;
    result += "@";
  } else if (url.password) {
    result += ":" + url.password;
    result += "@";
  } else if (url.protocol !== "file:" && isSpecial(url.protocol) && !host && url.pathname !== "/") {
    result += "@";
  }
  if (host[host.length - 1] === ":" || port.test(url.hostname) && !url.port) {
    host += ":";
  }
  result += host + url.pathname;
  query = "object" === typeof url.query ? stringify3(url.query) : url.query;
  if (query)
    result += "?" !== query.charAt(0) ? "?" + query : query;
  if (url.hash)
    result += url.hash;
  return result;
}
Url.prototype = { set, toString };
Url.extractProtocol = extractProtocol;
Url.location = lolcation;
Url.trimLeft = trimLeft;
Url.qs = qs;
var urlParse = Url;
var shams = function hasSymbols() {
  if (typeof Symbol !== "function" || typeof Object.getOwnPropertySymbols !== "function") {
    return false;
  }
  if (typeof Symbol.iterator === "symbol") {
    return true;
  }
  var obj = {};
  var sym = Symbol("test");
  var symObj = Object(sym);
  if (typeof sym === "string") {
    return false;
  }
  if (Object.prototype.toString.call(sym) !== "[object Symbol]") {
    return false;
  }
  if (Object.prototype.toString.call(symObj) !== "[object Symbol]") {
    return false;
  }
  var symVal = 42;
  obj[sym] = symVal;
  for (sym in obj) {
    return false;
  }
  if (typeof Object.keys === "function" && Object.keys(obj).length !== 0) {
    return false;
  }
  if (typeof Object.getOwnPropertyNames === "function" && Object.getOwnPropertyNames(obj).length !== 0) {
    return false;
  }
  var syms = Object.getOwnPropertySymbols(obj);
  if (syms.length !== 1 || syms[0] !== sym) {
    return false;
  }
  if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) {
    return false;
  }
  if (typeof Object.getOwnPropertyDescriptor === "function") {
    var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
    if (descriptor.value !== symVal || descriptor.enumerable !== true) {
      return false;
    }
  }
  return true;
};
var origSymbol = typeof Symbol !== "undefined" && Symbol;
var hasSymbolSham = shams;
var hasSymbols$1 = function hasNativeSymbols() {
  if (typeof origSymbol !== "function") {
    return false;
  }
  if (typeof Symbol !== "function") {
    return false;
  }
  if (typeof origSymbol("foo") !== "symbol") {
    return false;
  }
  if (typeof Symbol("bar") !== "symbol") {
    return false;
  }
  return hasSymbolSham();
};
var ERROR_MESSAGE = "Function.prototype.bind called on incompatible ";
var slice = Array.prototype.slice;
var toStr$1 = Object.prototype.toString;
var funcType = "[object Function]";
var implementation$1 = function bind(that) {
  var target = this;
  if (typeof target !== "function" || toStr$1.call(target) !== funcType) {
    throw new TypeError(ERROR_MESSAGE + target);
  }
  var args = slice.call(arguments, 1);
  var bound;
  var binder = function() {
    if (this instanceof bound) {
      var result = target.apply(
        this,
        args.concat(slice.call(arguments))
      );
      if (Object(result) === result) {
        return result;
      }
      return this;
    } else {
      return target.apply(
        that,
        args.concat(slice.call(arguments))
      );
    }
  };
  var boundLength = Math.max(0, target.length - args.length);
  var boundArgs = [];
  for (var i = 0; i < boundLength; i++) {
    boundArgs.push("$" + i);
  }
  bound = Function("binder", "return function (" + boundArgs.join(",") + "){ return binder.apply(this,arguments); }")(binder);
  if (target.prototype) {
    var Empty = function Empty2() {
    };
    Empty.prototype = target.prototype;
    bound.prototype = new Empty();
    Empty.prototype = null;
  }
  return bound;
};
var implementation = implementation$1;
var functionBind = Function.prototype.bind || implementation;
var bind$1 = functionBind;
var src = bind$1.call(Function.call, Object.prototype.hasOwnProperty);
var undefined$1;
var $SyntaxError = SyntaxError;
var $Function = Function;
var $TypeError$1 = TypeError;
var getEvalledConstructor = function(expressionSyntax) {
  try {
    return $Function('"use strict"; return (' + expressionSyntax + ").constructor;")();
  } catch (e) {
  }
};
var $gOPD = Object.getOwnPropertyDescriptor;
if ($gOPD) {
  try {
    $gOPD({}, "");
  } catch (e) {
    $gOPD = null;
  }
}
var throwTypeError = function() {
  throw new $TypeError$1();
};
var ThrowTypeError = $gOPD ? function() {
  try {
    arguments.callee;
    return throwTypeError;
  } catch (calleeThrows) {
    try {
      return $gOPD(arguments, "callee").get;
    } catch (gOPDthrows) {
      return throwTypeError;
    }
  }
}() : throwTypeError;
var hasSymbols2 = hasSymbols$1();
var getProto = Object.getPrototypeOf || function(x) {
  return x.__proto__;
};
var needsEval = {};
var TypedArray = typeof Uint8Array === "undefined" ? undefined$1 : getProto(Uint8Array);
var INTRINSICS = {
  "%AggregateError%": typeof AggregateError === "undefined" ? undefined$1 : AggregateError,
  "%Array%": Array,
  "%ArrayBuffer%": typeof ArrayBuffer === "undefined" ? undefined$1 : ArrayBuffer,
  "%ArrayIteratorPrototype%": hasSymbols2 ? getProto([][Symbol.iterator]()) : undefined$1,
  "%AsyncFromSyncIteratorPrototype%": undefined$1,
  "%AsyncFunction%": needsEval,
  "%AsyncGenerator%": needsEval,
  "%AsyncGeneratorFunction%": needsEval,
  "%AsyncIteratorPrototype%": needsEval,
  "%Atomics%": typeof Atomics === "undefined" ? undefined$1 : Atomics,
  "%BigInt%": typeof BigInt === "undefined" ? undefined$1 : BigInt,
  "%Boolean%": Boolean,
  "%DataView%": typeof DataView === "undefined" ? undefined$1 : DataView,
  "%Date%": Date,
  "%decodeURI%": decodeURI,
  "%decodeURIComponent%": decodeURIComponent,
  "%encodeURI%": encodeURI,
  "%encodeURIComponent%": encodeURIComponent,
  "%Error%": Error,
  "%eval%": eval,
  "%EvalError%": EvalError,
  "%Float32Array%": typeof Float32Array === "undefined" ? undefined$1 : Float32Array,
  "%Float64Array%": typeof Float64Array === "undefined" ? undefined$1 : Float64Array,
  "%FinalizationRegistry%": typeof FinalizationRegistry === "undefined" ? undefined$1 : FinalizationRegistry,
  "%Function%": $Function,
  "%GeneratorFunction%": needsEval,
  "%Int8Array%": typeof Int8Array === "undefined" ? undefined$1 : Int8Array,
  "%Int16Array%": typeof Int16Array === "undefined" ? undefined$1 : Int16Array,
  "%Int32Array%": typeof Int32Array === "undefined" ? undefined$1 : Int32Array,
  "%isFinite%": isFinite,
  "%isNaN%": isNaN,
  "%IteratorPrototype%": hasSymbols2 ? getProto(getProto([][Symbol.iterator]())) : undefined$1,
  "%JSON%": typeof JSON === "object" ? JSON : undefined$1,
  "%Map%": typeof Map === "undefined" ? undefined$1 : Map,
  "%MapIteratorPrototype%": typeof Map === "undefined" || !hasSymbols2 ? undefined$1 : getProto((/* @__PURE__ */ new Map())[Symbol.iterator]()),
  "%Math%": Math,
  "%Number%": Number,
  "%Object%": Object,
  "%parseFloat%": parseFloat,
  "%parseInt%": parseInt,
  "%Promise%": typeof Promise === "undefined" ? undefined$1 : Promise,
  "%Proxy%": typeof Proxy === "undefined" ? undefined$1 : Proxy,
  "%RangeError%": RangeError,
  "%ReferenceError%": ReferenceError,
  "%Reflect%": typeof Reflect === "undefined" ? undefined$1 : Reflect,
  "%RegExp%": RegExp,
  "%Set%": typeof Set === "undefined" ? undefined$1 : Set,
  "%SetIteratorPrototype%": typeof Set === "undefined" || !hasSymbols2 ? undefined$1 : getProto((/* @__PURE__ */ new Set())[Symbol.iterator]()),
  "%SharedArrayBuffer%": typeof SharedArrayBuffer === "undefined" ? undefined$1 : SharedArrayBuffer,
  "%String%": String,
  "%StringIteratorPrototype%": hasSymbols2 ? getProto(""[Symbol.iterator]()) : undefined$1,
  "%Symbol%": hasSymbols2 ? Symbol : undefined$1,
  "%SyntaxError%": $SyntaxError,
  "%ThrowTypeError%": ThrowTypeError,
  "%TypedArray%": TypedArray,
  "%TypeError%": $TypeError$1,
  "%Uint8Array%": typeof Uint8Array === "undefined" ? undefined$1 : Uint8Array,
  "%Uint8ClampedArray%": typeof Uint8ClampedArray === "undefined" ? undefined$1 : Uint8ClampedArray,
  "%Uint16Array%": typeof Uint16Array === "undefined" ? undefined$1 : Uint16Array,
  "%Uint32Array%": typeof Uint32Array === "undefined" ? undefined$1 : Uint32Array,
  "%URIError%": URIError,
  "%WeakMap%": typeof WeakMap === "undefined" ? undefined$1 : WeakMap,
  "%WeakRef%": typeof WeakRef === "undefined" ? undefined$1 : WeakRef,
  "%WeakSet%": typeof WeakSet === "undefined" ? undefined$1 : WeakSet
};
var doEval = function doEval2(name) {
  var value2;
  if (name === "%AsyncFunction%") {
    value2 = getEvalledConstructor("async function () {}");
  } else if (name === "%GeneratorFunction%") {
    value2 = getEvalledConstructor("function* () {}");
  } else if (name === "%AsyncGeneratorFunction%") {
    value2 = getEvalledConstructor("async function* () {}");
  } else if (name === "%AsyncGenerator%") {
    var fn2 = doEval2("%AsyncGeneratorFunction%");
    if (fn2) {
      value2 = fn2.prototype;
    }
  } else if (name === "%AsyncIteratorPrototype%") {
    var gen = doEval2("%AsyncGenerator%");
    if (gen) {
      value2 = getProto(gen.prototype);
    }
  }
  INTRINSICS[name] = value2;
  return value2;
};
var LEGACY_ALIASES = {
  "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
  "%ArrayPrototype%": ["Array", "prototype"],
  "%ArrayProto_entries%": ["Array", "prototype", "entries"],
  "%ArrayProto_forEach%": ["Array", "prototype", "forEach"],
  "%ArrayProto_keys%": ["Array", "prototype", "keys"],
  "%ArrayProto_values%": ["Array", "prototype", "values"],
  "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
  "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
  "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"],
  "%BooleanPrototype%": ["Boolean", "prototype"],
  "%DataViewPrototype%": ["DataView", "prototype"],
  "%DatePrototype%": ["Date", "prototype"],
  "%ErrorPrototype%": ["Error", "prototype"],
  "%EvalErrorPrototype%": ["EvalError", "prototype"],
  "%Float32ArrayPrototype%": ["Float32Array", "prototype"],
  "%Float64ArrayPrototype%": ["Float64Array", "prototype"],
  "%FunctionPrototype%": ["Function", "prototype"],
  "%Generator%": ["GeneratorFunction", "prototype"],
  "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"],
  "%Int8ArrayPrototype%": ["Int8Array", "prototype"],
  "%Int16ArrayPrototype%": ["Int16Array", "prototype"],
  "%Int32ArrayPrototype%": ["Int32Array", "prototype"],
  "%JSONParse%": ["JSON", "parse"],
  "%JSONStringify%": ["JSON", "stringify"],
  "%MapPrototype%": ["Map", "prototype"],
  "%NumberPrototype%": ["Number", "prototype"],
  "%ObjectPrototype%": ["Object", "prototype"],
  "%ObjProto_toString%": ["Object", "prototype", "toString"],
  "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"],
  "%PromisePrototype%": ["Promise", "prototype"],
  "%PromiseProto_then%": ["Promise", "prototype", "then"],
  "%Promise_all%": ["Promise", "all"],
  "%Promise_reject%": ["Promise", "reject"],
  "%Promise_resolve%": ["Promise", "resolve"],
  "%RangeErrorPrototype%": ["RangeError", "prototype"],
  "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
  "%RegExpPrototype%": ["RegExp", "prototype"],
  "%SetPrototype%": ["Set", "prototype"],
  "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
  "%StringPrototype%": ["String", "prototype"],
  "%SymbolPrototype%": ["Symbol", "prototype"],
  "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
  "%TypedArrayPrototype%": ["TypedArray", "prototype"],
  "%TypeErrorPrototype%": ["TypeError", "prototype"],
  "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
  "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
  "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
  "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
  "%URIErrorPrototype%": ["URIError", "prototype"],
  "%WeakMapPrototype%": ["WeakMap", "prototype"],
  "%WeakSetPrototype%": ["WeakSet", "prototype"]
};
var bind2 = functionBind;
var hasOwn$1 = src;
var $concat$1 = bind2.call(Function.call, Array.prototype.concat);
var $spliceApply = bind2.call(Function.apply, Array.prototype.splice);
var $replace$1 = bind2.call(Function.call, String.prototype.replace);
var $strSlice = bind2.call(Function.call, String.prototype.slice);
var $exec = bind2.call(Function.call, RegExp.prototype.exec);
var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar = /\\(\\)?/g;
var stringToPath = function stringToPath2(string) {
  var first = $strSlice(string, 0, 1);
  var last = $strSlice(string, -1);
  if (first === "%" && last !== "%") {
    throw new $SyntaxError("invalid intrinsic syntax, expected closing `%`");
  } else if (last === "%" && first !== "%") {
    throw new $SyntaxError("invalid intrinsic syntax, expected opening `%`");
  }
  var result = [];
  $replace$1(string, rePropName, function(match, number, quote2, subString) {
    result[result.length] = quote2 ? $replace$1(subString, reEscapeChar, "$1") : number || match;
  });
  return result;
};
var getBaseIntrinsic = function getBaseIntrinsic2(name, allowMissing) {
  var intrinsicName = name;
  var alias;
  if (hasOwn$1(LEGACY_ALIASES, intrinsicName)) {
    alias = LEGACY_ALIASES[intrinsicName];
    intrinsicName = "%" + alias[0] + "%";
  }
  if (hasOwn$1(INTRINSICS, intrinsicName)) {
    var value2 = INTRINSICS[intrinsicName];
    if (value2 === needsEval) {
      value2 = doEval(intrinsicName);
    }
    if (typeof value2 === "undefined" && !allowMissing) {
      throw new $TypeError$1("intrinsic " + name + " exists, but is not available. Please file an issue!");
    }
    return {
      alias,
      name: intrinsicName,
      value: value2
    };
  }
  throw new $SyntaxError("intrinsic " + name + " does not exist!");
};
var getIntrinsic = function GetIntrinsic(name, allowMissing) {
  if (typeof name !== "string" || name.length === 0) {
    throw new $TypeError$1("intrinsic name must be a non-empty string");
  }
  if (arguments.length > 1 && typeof allowMissing !== "boolean") {
    throw new $TypeError$1('"allowMissing" argument must be a boolean');
  }
  if ($exec(/^%?[^%]*%?$/, name) === null) {
    throw new $SyntaxError("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
  }
  var parts = stringToPath(name);
  var intrinsicBaseName = parts.length > 0 ? parts[0] : "";
  var intrinsic = getBaseIntrinsic("%" + intrinsicBaseName + "%", allowMissing);
  var intrinsicRealName = intrinsic.name;
  var value2 = intrinsic.value;
  var skipFurtherCaching = false;
  var alias = intrinsic.alias;
  if (alias) {
    intrinsicBaseName = alias[0];
    $spliceApply(parts, $concat$1([0, 1], alias));
  }
  for (var i = 1, isOwn = true; i < parts.length; i += 1) {
    var part = parts[i];
    var first = $strSlice(part, 0, 1);
    var last = $strSlice(part, -1);
    if ((first === '"' || first === "'" || first === "`" || (last === '"' || last === "'" || last === "`")) && first !== last) {
      throw new $SyntaxError("property names with quotes must have matching quotes");
    }
    if (part === "constructor" || !isOwn) {
      skipFurtherCaching = true;
    }
    intrinsicBaseName += "." + part;
    intrinsicRealName = "%" + intrinsicBaseName + "%";
    if (hasOwn$1(INTRINSICS, intrinsicRealName)) {
      value2 = INTRINSICS[intrinsicRealName];
    } else if (value2 != null) {
      if (!(part in value2)) {
        if (!allowMissing) {
          throw new $TypeError$1("base intrinsic for " + name + " exists, but the property is not available.");
        }
        return void 0;
      }
      if ($gOPD && i + 1 >= parts.length) {
        var desc = $gOPD(value2, part);
        isOwn = !!desc;
        if (isOwn && "get" in desc && !("originalValue" in desc.get)) {
          value2 = desc.get;
        } else {
          value2 = value2[part];
        }
      } else {
        isOwn = hasOwn$1(value2, part);
        value2 = value2[part];
      }
      if (isOwn && !skipFurtherCaching) {
        INTRINSICS[intrinsicRealName] = value2;
      }
    }
  }
  return value2;
};
var callBind$1 = { exports: {} };
(function(module) {
  var bind3 = functionBind;
  var GetIntrinsic3 = getIntrinsic;
  var $apply = GetIntrinsic3("%Function.prototype.apply%");
  var $call = GetIntrinsic3("%Function.prototype.call%");
  var $reflectApply = GetIntrinsic3("%Reflect.apply%", true) || bind3.call($call, $apply);
  var $gOPD2 = GetIntrinsic3("%Object.getOwnPropertyDescriptor%", true);
  var $defineProperty = GetIntrinsic3("%Object.defineProperty%", true);
  var $max = GetIntrinsic3("%Math.max%");
  if ($defineProperty) {
    try {
      $defineProperty({}, "a", { value: 1 });
    } catch (e) {
      $defineProperty = null;
    }
  }
  module.exports = function callBind2(originalFunction) {
    var func = $reflectApply(bind3, $call, arguments);
    if ($gOPD2 && $defineProperty) {
      var desc = $gOPD2(func, "length");
      if (desc.configurable) {
        $defineProperty(
          func,
          "length",
          { value: 1 + $max(0, originalFunction.length - (arguments.length - 1)) }
        );
      }
    }
    return func;
  };
  var applyBind = function applyBind2() {
    return $reflectApply(bind3, $apply, arguments);
  };
  if ($defineProperty) {
    $defineProperty(module.exports, "apply", { value: applyBind });
  } else {
    module.exports.apply = applyBind;
  }
})(callBind$1);
var GetIntrinsic$1 = getIntrinsic;
var callBind = callBind$1.exports;
var $indexOf = callBind(GetIntrinsic$1("String.prototype.indexOf"));
var callBound$1 = function callBoundIntrinsic(name, allowMissing) {
  var intrinsic = GetIntrinsic$1(name, !!allowMissing);
  if (typeof intrinsic === "function" && $indexOf(name, ".prototype.") > -1) {
    return callBind(intrinsic);
  }
  return intrinsic;
};
const __viteBrowserExternal = {};
const __viteBrowserExternal$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: __viteBrowserExternal
}, Symbol.toStringTag, { value: "Module" }));
const require$$0 = /* @__PURE__ */ getAugmentedNamespace(__viteBrowserExternal$1);
var hasMap = typeof Map === "function" && Map.prototype;
var mapSizeDescriptor = Object.getOwnPropertyDescriptor && hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, "size") : null;
var mapSize = hasMap && mapSizeDescriptor && typeof mapSizeDescriptor.get === "function" ? mapSizeDescriptor.get : null;
var mapForEach = hasMap && Map.prototype.forEach;
var hasSet = typeof Set === "function" && Set.prototype;
var setSizeDescriptor = Object.getOwnPropertyDescriptor && hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, "size") : null;
var setSize = hasSet && setSizeDescriptor && typeof setSizeDescriptor.get === "function" ? setSizeDescriptor.get : null;
var setForEach = hasSet && Set.prototype.forEach;
var hasWeakMap = typeof WeakMap === "function" && WeakMap.prototype;
var weakMapHas = hasWeakMap ? WeakMap.prototype.has : null;
var hasWeakSet = typeof WeakSet === "function" && WeakSet.prototype;
var weakSetHas = hasWeakSet ? WeakSet.prototype.has : null;
var hasWeakRef = typeof WeakRef === "function" && WeakRef.prototype;
var weakRefDeref = hasWeakRef ? WeakRef.prototype.deref : null;
var booleanValueOf = Boolean.prototype.valueOf;
var objectToString = Object.prototype.toString;
var functionToString = Function.prototype.toString;
var $match = String.prototype.match;
var $slice = String.prototype.slice;
var $replace = String.prototype.replace;
var $toUpperCase = String.prototype.toUpperCase;
var $toLowerCase = String.prototype.toLowerCase;
var $test = RegExp.prototype.test;
var $concat = Array.prototype.concat;
var $join = Array.prototype.join;
var $arrSlice = Array.prototype.slice;
var $floor = Math.floor;
var bigIntValueOf = typeof BigInt === "function" ? BigInt.prototype.valueOf : null;
var gOPS = Object.getOwnPropertySymbols;
var symToString = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? Symbol.prototype.toString : null;
var hasShammedSymbols = typeof Symbol === "function" && typeof Symbol.iterator === "object";
var toStringTag = typeof Symbol === "function" && Symbol.toStringTag && (typeof Symbol.toStringTag === hasShammedSymbols ? "object" : "symbol") ? Symbol.toStringTag : null;
var isEnumerable = Object.prototype.propertyIsEnumerable;
var gPO = (typeof Reflect === "function" ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype ? function(O) {
  return O.__proto__;
} : null);
function addNumericSeparator(num, str) {
  if (num === Infinity || num === -Infinity || num !== num || num && num > -1e3 && num < 1e3 || $test.call(/e/, str)) {
    return str;
  }
  var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
  if (typeof num === "number") {
    var int = num < 0 ? -$floor(-num) : $floor(num);
    if (int !== num) {
      var intStr = String(int);
      var dec = $slice.call(str, intStr.length + 1);
      return $replace.call(intStr, sepRegex, "$&_") + "." + $replace.call($replace.call(dec, /([0-9]{3})/g, "$&_"), /_$/, "");
    }
  }
  return $replace.call(str, sepRegex, "$&_");
}
var utilInspect = require$$0;
var inspectCustom = utilInspect.custom;
var inspectSymbol = isSymbol$1(inspectCustom) ? inspectCustom : null;
var objectInspect = function inspect_(obj, options, depth, seen) {
  var opts = options || {};
  if (has$3(opts, "quoteStyle") && (opts.quoteStyle !== "single" && opts.quoteStyle !== "double")) {
    throw new TypeError('option "quoteStyle" must be "single" or "double"');
  }
  if (has$3(opts, "maxStringLength") && (typeof opts.maxStringLength === "number" ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity : opts.maxStringLength !== null)) {
    throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
  }
  var customInspect = has$3(opts, "customInspect") ? opts.customInspect : true;
  if (typeof customInspect !== "boolean" && customInspect !== "symbol") {
    throw new TypeError("option \"customInspect\", if provided, must be `true`, `false`, or `'symbol'`");
  }
  if (has$3(opts, "indent") && opts.indent !== null && opts.indent !== "	" && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)) {
    throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
  }
  if (has$3(opts, "numericSeparator") && typeof opts.numericSeparator !== "boolean") {
    throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
  }
  var numericSeparator = opts.numericSeparator;
  if (typeof obj === "undefined") {
    return "undefined";
  }
  if (obj === null) {
    return "null";
  }
  if (typeof obj === "boolean") {
    return obj ? "true" : "false";
  }
  if (typeof obj === "string") {
    return inspectString(obj, opts);
  }
  if (typeof obj === "number") {
    if (obj === 0) {
      return Infinity / obj > 0 ? "0" : "-0";
    }
    var str = String(obj);
    return numericSeparator ? addNumericSeparator(obj, str) : str;
  }
  if (typeof obj === "bigint") {
    var bigIntStr = String(obj) + "n";
    return numericSeparator ? addNumericSeparator(obj, bigIntStr) : bigIntStr;
  }
  var maxDepth = typeof opts.depth === "undefined" ? 5 : opts.depth;
  if (typeof depth === "undefined") {
    depth = 0;
  }
  if (depth >= maxDepth && maxDepth > 0 && typeof obj === "object") {
    return isArray$3(obj) ? "[Array]" : "[Object]";
  }
  var indent = getIndent(opts, depth);
  if (typeof seen === "undefined") {
    seen = [];
  } else if (indexOf(seen, obj) >= 0) {
    return "[Circular]";
  }
  function inspect2(value2, from, noIndent) {
    if (from) {
      seen = $arrSlice.call(seen);
      seen.push(from);
    }
    if (noIndent) {
      var newOpts = {
        depth: opts.depth
      };
      if (has$3(opts, "quoteStyle")) {
        newOpts.quoteStyle = opts.quoteStyle;
      }
      return inspect_(value2, newOpts, depth + 1, seen);
    }
    return inspect_(value2, opts, depth + 1, seen);
  }
  if (typeof obj === "function" && !isRegExp$1(obj)) {
    var name = nameOf(obj);
    var keys = arrObjKeys(obj, inspect2);
    return "[Function" + (name ? ": " + name : " (anonymous)") + "]" + (keys.length > 0 ? " { " + $join.call(keys, ", ") + " }" : "");
  }
  if (isSymbol$1(obj)) {
    var symString = hasShammedSymbols ? $replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, "$1") : symToString.call(obj);
    return typeof obj === "object" && !hasShammedSymbols ? markBoxed(symString) : symString;
  }
  if (isElement$1(obj)) {
    var s = "<" + $toLowerCase.call(String(obj.nodeName));
    var attrs = obj.attributes || [];
    for (var i = 0; i < attrs.length; i++) {
      s += " " + attrs[i].name + "=" + wrapQuotes(quote(attrs[i].value), "double", opts);
    }
    s += ">";
    if (obj.childNodes && obj.childNodes.length) {
      s += "...";
    }
    s += "</" + $toLowerCase.call(String(obj.nodeName)) + ">";
    return s;
  }
  if (isArray$3(obj)) {
    if (obj.length === 0) {
      return "[]";
    }
    var xs = arrObjKeys(obj, inspect2);
    if (indent && !singleLineValues(xs)) {
      return "[" + indentedJoin(xs, indent) + "]";
    }
    return "[ " + $join.call(xs, ", ") + " ]";
  }
  if (isError(obj)) {
    var parts = arrObjKeys(obj, inspect2);
    if (!("cause" in Error.prototype) && "cause" in obj && !isEnumerable.call(obj, "cause")) {
      return "{ [" + String(obj) + "] " + $join.call($concat.call("[cause]: " + inspect2(obj.cause), parts), ", ") + " }";
    }
    if (parts.length === 0) {
      return "[" + String(obj) + "]";
    }
    return "{ [" + String(obj) + "] " + $join.call(parts, ", ") + " }";
  }
  if (typeof obj === "object" && customInspect) {
    if (inspectSymbol && typeof obj[inspectSymbol] === "function" && utilInspect) {
      return utilInspect(obj, { depth: maxDepth - depth });
    } else if (customInspect !== "symbol" && typeof obj.inspect === "function") {
      return obj.inspect();
    }
  }
  if (isMap(obj)) {
    var mapParts = [];
    mapForEach.call(obj, function(value2, key) {
      mapParts.push(inspect2(key, obj, true) + " => " + inspect2(value2, obj));
    });
    return collectionOf("Map", mapSize.call(obj), mapParts, indent);
  }
  if (isSet(obj)) {
    var setParts = [];
    setForEach.call(obj, function(value2) {
      setParts.push(inspect2(value2, obj));
    });
    return collectionOf("Set", setSize.call(obj), setParts, indent);
  }
  if (isWeakMap(obj)) {
    return weakCollectionOf("WeakMap");
  }
  if (isWeakSet(obj)) {
    return weakCollectionOf("WeakSet");
  }
  if (isWeakRef(obj)) {
    return weakCollectionOf("WeakRef");
  }
  if (isNumber(obj)) {
    return markBoxed(inspect2(Number(obj)));
  }
  if (isBigInt(obj)) {
    return markBoxed(inspect2(bigIntValueOf.call(obj)));
  }
  if (isBoolean(obj)) {
    return markBoxed(booleanValueOf.call(obj));
  }
  if (isString(obj)) {
    return markBoxed(inspect2(String(obj)));
  }
  if (!isDate(obj) && !isRegExp$1(obj)) {
    var ys = arrObjKeys(obj, inspect2);
    var isPlainObject = gPO ? gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
    var protoTag = obj instanceof Object ? "" : "null prototype";
    var stringTag = !isPlainObject && toStringTag && Object(obj) === obj && toStringTag in obj ? $slice.call(toStr(obj), 8, -1) : protoTag ? "Object" : "";
    var constructorTag = isPlainObject || typeof obj.constructor !== "function" ? "" : obj.constructor.name ? obj.constructor.name + " " : "";
    var tag = constructorTag + (stringTag || protoTag ? "[" + $join.call($concat.call([], stringTag || [], protoTag || []), ": ") + "] " : "");
    if (ys.length === 0) {
      return tag + "{}";
    }
    if (indent) {
      return tag + "{" + indentedJoin(ys, indent) + "}";
    }
    return tag + "{ " + $join.call(ys, ", ") + " }";
  }
  return String(obj);
};
function wrapQuotes(s, defaultStyle, opts) {
  var quoteChar = (opts.quoteStyle || defaultStyle) === "double" ? '"' : "'";
  return quoteChar + s + quoteChar;
}
function quote(s) {
  return $replace.call(String(s), /"/g, "&quot;");
}
function isArray$3(obj) {
  return toStr(obj) === "[object Array]" && (!toStringTag || !(typeof obj === "object" && toStringTag in obj));
}
function isDate(obj) {
  return toStr(obj) === "[object Date]" && (!toStringTag || !(typeof obj === "object" && toStringTag in obj));
}
function isRegExp$1(obj) {
  return toStr(obj) === "[object RegExp]" && (!toStringTag || !(typeof obj === "object" && toStringTag in obj));
}
function isError(obj) {
  return toStr(obj) === "[object Error]" && (!toStringTag || !(typeof obj === "object" && toStringTag in obj));
}
function isString(obj) {
  return toStr(obj) === "[object String]" && (!toStringTag || !(typeof obj === "object" && toStringTag in obj));
}
function isNumber(obj) {
  return toStr(obj) === "[object Number]" && (!toStringTag || !(typeof obj === "object" && toStringTag in obj));
}
function isBoolean(obj) {
  return toStr(obj) === "[object Boolean]" && (!toStringTag || !(typeof obj === "object" && toStringTag in obj));
}
function isSymbol$1(obj) {
  if (hasShammedSymbols) {
    return obj && typeof obj === "object" && obj instanceof Symbol;
  }
  if (typeof obj === "symbol") {
    return true;
  }
  if (!obj || typeof obj !== "object" || !symToString) {
    return false;
  }
  try {
    symToString.call(obj);
    return true;
  } catch (e) {
  }
  return false;
}
function isBigInt(obj) {
  if (!obj || typeof obj !== "object" || !bigIntValueOf) {
    return false;
  }
  try {
    bigIntValueOf.call(obj);
    return true;
  } catch (e) {
  }
  return false;
}
var hasOwn = Object.prototype.hasOwnProperty || function(key) {
  return key in this;
};
function has$3(obj, key) {
  return hasOwn.call(obj, key);
}
function toStr(obj) {
  return objectToString.call(obj);
}
function nameOf(f) {
  if (f.name) {
    return f.name;
  }
  var m = $match.call(functionToString.call(f), /^function\s*([\w$]+)/);
  if (m) {
    return m[1];
  }
  return null;
}
function indexOf(xs, x) {
  if (xs.indexOf) {
    return xs.indexOf(x);
  }
  for (var i = 0, l = xs.length; i < l; i++) {
    if (xs[i] === x) {
      return i;
    }
  }
  return -1;
}
function isMap(x) {
  if (!mapSize || !x || typeof x !== "object") {
    return false;
  }
  try {
    mapSize.call(x);
    try {
      setSize.call(x);
    } catch (s) {
      return true;
    }
    return x instanceof Map;
  } catch (e) {
  }
  return false;
}
function isWeakMap(x) {
  if (!weakMapHas || !x || typeof x !== "object") {
    return false;
  }
  try {
    weakMapHas.call(x, weakMapHas);
    try {
      weakSetHas.call(x, weakSetHas);
    } catch (s) {
      return true;
    }
    return x instanceof WeakMap;
  } catch (e) {
  }
  return false;
}
function isWeakRef(x) {
  if (!weakRefDeref || !x || typeof x !== "object") {
    return false;
  }
  try {
    weakRefDeref.call(x);
    return true;
  } catch (e) {
  }
  return false;
}
function isSet(x) {
  if (!setSize || !x || typeof x !== "object") {
    return false;
  }
  try {
    setSize.call(x);
    try {
      mapSize.call(x);
    } catch (m) {
      return true;
    }
    return x instanceof Set;
  } catch (e) {
  }
  return false;
}
function isWeakSet(x) {
  if (!weakSetHas || !x || typeof x !== "object") {
    return false;
  }
  try {
    weakSetHas.call(x, weakSetHas);
    try {
      weakMapHas.call(x, weakMapHas);
    } catch (s) {
      return true;
    }
    return x instanceof WeakSet;
  } catch (e) {
  }
  return false;
}
function isElement$1(x) {
  if (!x || typeof x !== "object") {
    return false;
  }
  if (typeof HTMLElement !== "undefined" && x instanceof HTMLElement) {
    return true;
  }
  return typeof x.nodeName === "string" && typeof x.getAttribute === "function";
}
function inspectString(str, opts) {
  if (str.length > opts.maxStringLength) {
    var remaining = str.length - opts.maxStringLength;
    var trailer = "... " + remaining + " more character" + (remaining > 1 ? "s" : "");
    return inspectString($slice.call(str, 0, opts.maxStringLength), opts) + trailer;
  }
  var s = $replace.call($replace.call(str, /(['\\])/g, "\\$1"), /[\x00-\x1f]/g, lowbyte);
  return wrapQuotes(s, "single", opts);
}
function lowbyte(c) {
  var n = c.charCodeAt(0);
  var x = {
    8: "b",
    9: "t",
    10: "n",
    12: "f",
    13: "r"
  }[n];
  if (x) {
    return "\\" + x;
  }
  return "\\x" + (n < 16 ? "0" : "") + $toUpperCase.call(n.toString(16));
}
function markBoxed(str) {
  return "Object(" + str + ")";
}
function weakCollectionOf(type) {
  return type + " { ? }";
}
function collectionOf(type, size, entries, indent) {
  var joinedEntries = indent ? indentedJoin(entries, indent) : $join.call(entries, ", ");
  return type + " (" + size + ") {" + joinedEntries + "}";
}
function singleLineValues(xs) {
  for (var i = 0; i < xs.length; i++) {
    if (indexOf(xs[i], "\n") >= 0) {
      return false;
    }
  }
  return true;
}
function getIndent(opts, depth) {
  var baseIndent;
  if (opts.indent === "	") {
    baseIndent = "	";
  } else if (typeof opts.indent === "number" && opts.indent > 0) {
    baseIndent = $join.call(Array(opts.indent + 1), " ");
  } else {
    return null;
  }
  return {
    base: baseIndent,
    prev: $join.call(Array(depth + 1), baseIndent)
  };
}
function indentedJoin(xs, indent) {
  if (xs.length === 0) {
    return "";
  }
  var lineJoiner = "\n" + indent.prev + indent.base;
  return lineJoiner + $join.call(xs, "," + lineJoiner) + "\n" + indent.prev;
}
function arrObjKeys(obj, inspect2) {
  var isArr = isArray$3(obj);
  var xs = [];
  if (isArr) {
    xs.length = obj.length;
    for (var i = 0; i < obj.length; i++) {
      xs[i] = has$3(obj, i) ? inspect2(obj[i], obj) : "";
    }
  }
  var syms = typeof gOPS === "function" ? gOPS(obj) : [];
  var symMap;
  if (hasShammedSymbols) {
    symMap = {};
    for (var k = 0; k < syms.length; k++) {
      symMap["$" + syms[k]] = syms[k];
    }
  }
  for (var key in obj) {
    if (!has$3(obj, key)) {
      continue;
    }
    if (isArr && String(Number(key)) === key && key < obj.length) {
      continue;
    }
    if (hasShammedSymbols && symMap["$" + key] instanceof Symbol) {
      continue;
    } else if ($test.call(/[^\w$]/, key)) {
      xs.push(inspect2(key, obj) + ": " + inspect2(obj[key], obj));
    } else {
      xs.push(key + ": " + inspect2(obj[key], obj));
    }
  }
  if (typeof gOPS === "function") {
    for (var j = 0; j < syms.length; j++) {
      if (isEnumerable.call(obj, syms[j])) {
        xs.push("[" + inspect2(syms[j]) + "]: " + inspect2(obj[syms[j]], obj));
      }
    }
  }
  return xs;
}
var GetIntrinsic2 = getIntrinsic;
var callBound = callBound$1;
var inspect = objectInspect;
var $TypeError = GetIntrinsic2("%TypeError%");
var $WeakMap = GetIntrinsic2("%WeakMap%", true);
var $Map = GetIntrinsic2("%Map%", true);
var $weakMapGet = callBound("WeakMap.prototype.get", true);
var $weakMapSet = callBound("WeakMap.prototype.set", true);
var $weakMapHas = callBound("WeakMap.prototype.has", true);
var $mapGet = callBound("Map.prototype.get", true);
var $mapSet = callBound("Map.prototype.set", true);
var $mapHas = callBound("Map.prototype.has", true);
var listGetNode = function(list, key) {
  for (var prev = list, curr; (curr = prev.next) !== null; prev = curr) {
    if (curr.key === key) {
      prev.next = curr.next;
      curr.next = list.next;
      list.next = curr;
      return curr;
    }
  }
};
var listGet = function(objects, key) {
  var node = listGetNode(objects, key);
  return node && node.value;
};
var listSet = function(objects, key, value2) {
  var node = listGetNode(objects, key);
  if (node) {
    node.value = value2;
  } else {
    objects.next = {
      key,
      next: objects.next,
      value: value2
    };
  }
};
var listHas = function(objects, key) {
  return !!listGetNode(objects, key);
};
var sideChannel = function getSideChannel() {
  var $wm;
  var $m;
  var $o;
  var channel = {
    assert: function(key) {
      if (!channel.has(key)) {
        throw new $TypeError("Side channel does not contain " + inspect(key));
      }
    },
    get: function(key) {
      if ($WeakMap && key && (typeof key === "object" || typeof key === "function")) {
        if ($wm) {
          return $weakMapGet($wm, key);
        }
      } else if ($Map) {
        if ($m) {
          return $mapGet($m, key);
        }
      } else {
        if ($o) {
          return listGet($o, key);
        }
      }
    },
    has: function(key) {
      if ($WeakMap && key && (typeof key === "object" || typeof key === "function")) {
        if ($wm) {
          return $weakMapHas($wm, key);
        }
      } else if ($Map) {
        if ($m) {
          return $mapHas($m, key);
        }
      } else {
        if ($o) {
          return listHas($o, key);
        }
      }
      return false;
    },
    set: function(key, value2) {
      if ($WeakMap && key && (typeof key === "object" || typeof key === "function")) {
        if (!$wm) {
          $wm = new $WeakMap();
        }
        $weakMapSet($wm, key, value2);
      } else if ($Map) {
        if (!$m) {
          $m = new $Map();
        }
        $mapSet($m, key, value2);
      } else {
        if (!$o) {
          $o = { key: {}, next: null };
        }
        listSet($o, key, value2);
      }
    }
  };
  return channel;
};
var replace = String.prototype.replace;
var percentTwenties = /%20/g;
var Format = {
  RFC1738: "RFC1738",
  RFC3986: "RFC3986"
};
var formats$3 = {
  "default": Format.RFC3986,
  formatters: {
    RFC1738: function(value2) {
      return replace.call(value2, percentTwenties, "+");
    },
    RFC3986: function(value2) {
      return String(value2);
    }
  },
  RFC1738: Format.RFC1738,
  RFC3986: Format.RFC3986
};
var formats$2 = formats$3;
var has$2 = Object.prototype.hasOwnProperty;
var isArray$2 = Array.isArray;
var hexTable = function() {
  var array = [];
  for (var i = 0; i < 256; ++i) {
    array.push("%" + ((i < 16 ? "0" : "") + i.toString(16)).toUpperCase());
  }
  return array;
}();
var compactQueue = function compactQueue2(queue) {
  while (queue.length > 1) {
    var item = queue.pop();
    var obj = item.obj[item.prop];
    if (isArray$2(obj)) {
      var compacted = [];
      for (var j = 0; j < obj.length; ++j) {
        if (typeof obj[j] !== "undefined") {
          compacted.push(obj[j]);
        }
      }
      item.obj[item.prop] = compacted;
    }
  }
};
var arrayToObject = function arrayToObject2(source, options) {
  var obj = options && options.plainObjects ? /* @__PURE__ */ Object.create(null) : {};
  for (var i = 0; i < source.length; ++i) {
    if (typeof source[i] !== "undefined") {
      obj[i] = source[i];
    }
  }
  return obj;
};
var merge = function merge2(target, source, options) {
  if (!source) {
    return target;
  }
  if (typeof source !== "object") {
    if (isArray$2(target)) {
      target.push(source);
    } else if (target && typeof target === "object") {
      if (options && (options.plainObjects || options.allowPrototypes) || !has$2.call(Object.prototype, source)) {
        target[source] = true;
      }
    } else {
      return [target, source];
    }
    return target;
  }
  if (!target || typeof target !== "object") {
    return [target].concat(source);
  }
  var mergeTarget = target;
  if (isArray$2(target) && !isArray$2(source)) {
    mergeTarget = arrayToObject(target, options);
  }
  if (isArray$2(target) && isArray$2(source)) {
    source.forEach(function(item, i) {
      if (has$2.call(target, i)) {
        var targetItem = target[i];
        if (targetItem && typeof targetItem === "object" && item && typeof item === "object") {
          target[i] = merge2(targetItem, item, options);
        } else {
          target.push(item);
        }
      } else {
        target[i] = item;
      }
    });
    return target;
  }
  return Object.keys(source).reduce(function(acc, key) {
    var value2 = source[key];
    if (has$2.call(acc, key)) {
      acc[key] = merge2(acc[key], value2, options);
    } else {
      acc[key] = value2;
    }
    return acc;
  }, mergeTarget);
};
var assign = function assignSingleSource(target, source) {
  return Object.keys(source).reduce(function(acc, key) {
    acc[key] = source[key];
    return acc;
  }, target);
};
var decode = function(str, decoder, charset) {
  var strWithoutPlus = str.replace(/\+/g, " ");
  if (charset === "iso-8859-1") {
    return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
  }
  try {
    return decodeURIComponent(strWithoutPlus);
  } catch (e) {
    return strWithoutPlus;
  }
};
var encode = function encode2(str, defaultEncoder, charset, kind, format2) {
  if (str.length === 0) {
    return str;
  }
  var string = str;
  if (typeof str === "symbol") {
    string = Symbol.prototype.toString.call(str);
  } else if (typeof str !== "string") {
    string = String(str);
  }
  if (charset === "iso-8859-1") {
    return escape(string).replace(/%u[0-9a-f]{4}/gi, function($0) {
      return "%26%23" + parseInt($0.slice(2), 16) + "%3B";
    });
  }
  var out = "";
  for (var i = 0; i < string.length; ++i) {
    var c = string.charCodeAt(i);
    if (c === 45 || c === 46 || c === 95 || c === 126 || c >= 48 && c <= 57 || c >= 65 && c <= 90 || c >= 97 && c <= 122 || format2 === formats$2.RFC1738 && (c === 40 || c === 41)) {
      out += string.charAt(i);
      continue;
    }
    if (c < 128) {
      out = out + hexTable[c];
      continue;
    }
    if (c < 2048) {
      out = out + (hexTable[192 | c >> 6] + hexTable[128 | c & 63]);
      continue;
    }
    if (c < 55296 || c >= 57344) {
      out = out + (hexTable[224 | c >> 12] + hexTable[128 | c >> 6 & 63] + hexTable[128 | c & 63]);
      continue;
    }
    i += 1;
    c = 65536 + ((c & 1023) << 10 | string.charCodeAt(i) & 1023);
    out += hexTable[240 | c >> 18] + hexTable[128 | c >> 12 & 63] + hexTable[128 | c >> 6 & 63] + hexTable[128 | c & 63];
  }
  return out;
};
var compact = function compact2(value2) {
  var queue = [{ obj: { o: value2 }, prop: "o" }];
  var refs = [];
  for (var i = 0; i < queue.length; ++i) {
    var item = queue[i];
    var obj = item.obj[item.prop];
    var keys = Object.keys(obj);
    for (var j = 0; j < keys.length; ++j) {
      var key = keys[j];
      var val = obj[key];
      if (typeof val === "object" && val !== null && refs.indexOf(val) === -1) {
        queue.push({ obj, prop: key });
        refs.push(val);
      }
    }
  }
  compactQueue(queue);
  return value2;
};
var isRegExp = function isRegExp2(obj) {
  return Object.prototype.toString.call(obj) === "[object RegExp]";
};
var isBuffer = function isBuffer2(obj) {
  if (!obj || typeof obj !== "object") {
    return false;
  }
  return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};
var combine = function combine2(a, b) {
  return [].concat(a, b);
};
var maybeMap = function maybeMap2(val, fn2) {
  if (isArray$2(val)) {
    var mapped = [];
    for (var i = 0; i < val.length; i += 1) {
      mapped.push(fn2(val[i]));
    }
    return mapped;
  }
  return fn2(val);
};
var utils$2 = {
  arrayToObject,
  assign,
  combine,
  compact,
  decode,
  encode,
  isBuffer,
  isRegExp,
  maybeMap,
  merge
};
var getSideChannel2 = sideChannel;
var utils$1 = utils$2;
var formats$1 = formats$3;
var has$1 = Object.prototype.hasOwnProperty;
var arrayPrefixGenerators = {
  brackets: function brackets(prefix) {
    return prefix + "[]";
  },
  comma: "comma",
  indices: function indices(prefix, key) {
    return prefix + "[" + key + "]";
  },
  repeat: function repeat(prefix) {
    return prefix;
  }
};
var isArray$1 = Array.isArray;
var split = String.prototype.split;
var push = Array.prototype.push;
var pushToArray = function(arr, valueOrArray) {
  push.apply(arr, isArray$1(valueOrArray) ? valueOrArray : [valueOrArray]);
};
var toISO = Date.prototype.toISOString;
var defaultFormat = formats$1["default"];
var defaults$1 = {
  addQueryPrefix: false,
  allowDots: false,
  charset: "utf-8",
  charsetSentinel: false,
  delimiter: "&",
  encode: true,
  encoder: utils$1.encode,
  encodeValuesOnly: false,
  format: defaultFormat,
  formatter: formats$1.formatters[defaultFormat],
  indices: false,
  serializeDate: function serializeDate(date) {
    return toISO.call(date);
  },
  skipNulls: false,
  strictNullHandling: false
};
var isNonNullishPrimitive = function isNonNullishPrimitive2(v) {
  return typeof v === "string" || typeof v === "number" || typeof v === "boolean" || typeof v === "symbol" || typeof v === "bigint";
};
var sentinel = {};
var stringify$1 = function stringify(object, prefix, generateArrayPrefix, commaRoundTrip, strictNullHandling, skipNulls, encoder, filter, sort, allowDots, serializeDate2, format2, formatter, encodeValuesOnly, charset, sideChannel2) {
  var obj = object;
  var tmpSc = sideChannel2;
  var step = 0;
  var findFlag = false;
  while ((tmpSc = tmpSc.get(sentinel)) !== void 0 && !findFlag) {
    var pos = tmpSc.get(object);
    step += 1;
    if (typeof pos !== "undefined") {
      if (pos === step) {
        throw new RangeError("Cyclic object value");
      } else {
        findFlag = true;
      }
    }
    if (typeof tmpSc.get(sentinel) === "undefined") {
      step = 0;
    }
  }
  if (typeof filter === "function") {
    obj = filter(prefix, obj);
  } else if (obj instanceof Date) {
    obj = serializeDate2(obj);
  } else if (generateArrayPrefix === "comma" && isArray$1(obj)) {
    obj = utils$1.maybeMap(obj, function(value3) {
      if (value3 instanceof Date) {
        return serializeDate2(value3);
      }
      return value3;
    });
  }
  if (obj === null) {
    if (strictNullHandling) {
      return encoder && !encodeValuesOnly ? encoder(prefix, defaults$1.encoder, charset, "key", format2) : prefix;
    }
    obj = "";
  }
  if (isNonNullishPrimitive(obj) || utils$1.isBuffer(obj)) {
    if (encoder) {
      var keyValue = encodeValuesOnly ? prefix : encoder(prefix, defaults$1.encoder, charset, "key", format2);
      if (generateArrayPrefix === "comma" && encodeValuesOnly) {
        var valuesArray = split.call(String(obj), ",");
        var valuesJoined = "";
        for (var i = 0; i < valuesArray.length; ++i) {
          valuesJoined += (i === 0 ? "" : ",") + formatter(encoder(valuesArray[i], defaults$1.encoder, charset, "value", format2));
        }
        return [formatter(keyValue) + (commaRoundTrip && isArray$1(obj) && valuesArray.length === 1 ? "[]" : "") + "=" + valuesJoined];
      }
      return [formatter(keyValue) + "=" + formatter(encoder(obj, defaults$1.encoder, charset, "value", format2))];
    }
    return [formatter(prefix) + "=" + formatter(String(obj))];
  }
  var values = [];
  if (typeof obj === "undefined") {
    return values;
  }
  var objKeys;
  if (generateArrayPrefix === "comma" && isArray$1(obj)) {
    objKeys = [{ value: obj.length > 0 ? obj.join(",") || null : void 0 }];
  } else if (isArray$1(filter)) {
    objKeys = filter;
  } else {
    var keys = Object.keys(obj);
    objKeys = sort ? keys.sort(sort) : keys;
  }
  var adjustedPrefix = commaRoundTrip && isArray$1(obj) && obj.length === 1 ? prefix + "[]" : prefix;
  for (var j = 0; j < objKeys.length; ++j) {
    var key = objKeys[j];
    var value2 = typeof key === "object" && typeof key.value !== "undefined" ? key.value : obj[key];
    if (skipNulls && value2 === null) {
      continue;
    }
    var keyPrefix = isArray$1(obj) ? typeof generateArrayPrefix === "function" ? generateArrayPrefix(adjustedPrefix, key) : adjustedPrefix : adjustedPrefix + (allowDots ? "." + key : "[" + key + "]");
    sideChannel2.set(object, step);
    var valueSideChannel = getSideChannel2();
    valueSideChannel.set(sentinel, sideChannel2);
    pushToArray(values, stringify(
      value2,
      keyPrefix,
      generateArrayPrefix,
      commaRoundTrip,
      strictNullHandling,
      skipNulls,
      encoder,
      filter,
      sort,
      allowDots,
      serializeDate2,
      format2,
      formatter,
      encodeValuesOnly,
      charset,
      valueSideChannel
    ));
  }
  return values;
};
var normalizeStringifyOptions = function normalizeStringifyOptions2(opts) {
  if (!opts) {
    return defaults$1;
  }
  if (opts.encoder !== null && typeof opts.encoder !== "undefined" && typeof opts.encoder !== "function") {
    throw new TypeError("Encoder has to be a function.");
  }
  var charset = opts.charset || defaults$1.charset;
  if (typeof opts.charset !== "undefined" && opts.charset !== "utf-8" && opts.charset !== "iso-8859-1") {
    throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
  }
  var format2 = formats$1["default"];
  if (typeof opts.format !== "undefined") {
    if (!has$1.call(formats$1.formatters, opts.format)) {
      throw new TypeError("Unknown format option provided.");
    }
    format2 = opts.format;
  }
  var formatter = formats$1.formatters[format2];
  var filter = defaults$1.filter;
  if (typeof opts.filter === "function" || isArray$1(opts.filter)) {
    filter = opts.filter;
  }
  return {
    addQueryPrefix: typeof opts.addQueryPrefix === "boolean" ? opts.addQueryPrefix : defaults$1.addQueryPrefix,
    allowDots: typeof opts.allowDots === "undefined" ? defaults$1.allowDots : !!opts.allowDots,
    charset,
    charsetSentinel: typeof opts.charsetSentinel === "boolean" ? opts.charsetSentinel : defaults$1.charsetSentinel,
    delimiter: typeof opts.delimiter === "undefined" ? defaults$1.delimiter : opts.delimiter,
    encode: typeof opts.encode === "boolean" ? opts.encode : defaults$1.encode,
    encoder: typeof opts.encoder === "function" ? opts.encoder : defaults$1.encoder,
    encodeValuesOnly: typeof opts.encodeValuesOnly === "boolean" ? opts.encodeValuesOnly : defaults$1.encodeValuesOnly,
    filter,
    format: format2,
    formatter,
    serializeDate: typeof opts.serializeDate === "function" ? opts.serializeDate : defaults$1.serializeDate,
    skipNulls: typeof opts.skipNulls === "boolean" ? opts.skipNulls : defaults$1.skipNulls,
    sort: typeof opts.sort === "function" ? opts.sort : null,
    strictNullHandling: typeof opts.strictNullHandling === "boolean" ? opts.strictNullHandling : defaults$1.strictNullHandling
  };
};
var stringify_1 = function(object, opts) {
  var obj = object;
  var options = normalizeStringifyOptions(opts);
  var objKeys;
  var filter;
  if (typeof options.filter === "function") {
    filter = options.filter;
    obj = filter("", obj);
  } else if (isArray$1(options.filter)) {
    filter = options.filter;
    objKeys = filter;
  }
  var keys = [];
  if (typeof obj !== "object" || obj === null) {
    return "";
  }
  var arrayFormat;
  if (opts && opts.arrayFormat in arrayPrefixGenerators) {
    arrayFormat = opts.arrayFormat;
  } else if (opts && "indices" in opts) {
    arrayFormat = opts.indices ? "indices" : "repeat";
  } else {
    arrayFormat = "indices";
  }
  var generateArrayPrefix = arrayPrefixGenerators[arrayFormat];
  if (opts && "commaRoundTrip" in opts && typeof opts.commaRoundTrip !== "boolean") {
    throw new TypeError("`commaRoundTrip` must be a boolean, or absent");
  }
  var commaRoundTrip = generateArrayPrefix === "comma" && opts && opts.commaRoundTrip;
  if (!objKeys) {
    objKeys = Object.keys(obj);
  }
  if (options.sort) {
    objKeys.sort(options.sort);
  }
  var sideChannel2 = getSideChannel2();
  for (var i = 0; i < objKeys.length; ++i) {
    var key = objKeys[i];
    if (options.skipNulls && obj[key] === null) {
      continue;
    }
    pushToArray(keys, stringify$1(
      obj[key],
      key,
      generateArrayPrefix,
      commaRoundTrip,
      options.strictNullHandling,
      options.skipNulls,
      options.encode ? options.encoder : null,
      options.filter,
      options.sort,
      options.allowDots,
      options.serializeDate,
      options.format,
      options.formatter,
      options.encodeValuesOnly,
      options.charset,
      sideChannel2
    ));
  }
  var joined = keys.join(options.delimiter);
  var prefix = options.addQueryPrefix === true ? "?" : "";
  if (options.charsetSentinel) {
    if (options.charset === "iso-8859-1") {
      prefix += "utf8=%26%2310003%3B&";
    } else {
      prefix += "utf8=%E2%9C%93&";
    }
  }
  return joined.length > 0 ? prefix + joined : "";
};
var utils = utils$2;
var has = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;
var defaults = {
  allowDots: false,
  allowPrototypes: false,
  allowSparse: false,
  arrayLimit: 20,
  charset: "utf-8",
  charsetSentinel: false,
  comma: false,
  decoder: utils.decode,
  delimiter: "&",
  depth: 5,
  ignoreQueryPrefix: false,
  interpretNumericEntities: false,
  parameterLimit: 1e3,
  parseArrays: true,
  plainObjects: false,
  strictNullHandling: false
};
var interpretNumericEntities = function(str) {
  return str.replace(/&#(\d+);/g, function($0, numberStr) {
    return String.fromCharCode(parseInt(numberStr, 10));
  });
};
var parseArrayValue = function(val, options) {
  if (val && typeof val === "string" && options.comma && val.indexOf(",") > -1) {
    return val.split(",");
  }
  return val;
};
var isoSentinel = "utf8=%26%2310003%3B";
var charsetSentinel = "utf8=%E2%9C%93";
var parseValues = function parseQueryStringValues(str, options) {
  var obj = {};
  var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, "") : str;
  var limit = options.parameterLimit === Infinity ? void 0 : options.parameterLimit;
  var parts = cleanStr.split(options.delimiter, limit);
  var skipIndex = -1;
  var i;
  var charset = options.charset;
  if (options.charsetSentinel) {
    for (i = 0; i < parts.length; ++i) {
      if (parts[i].indexOf("utf8=") === 0) {
        if (parts[i] === charsetSentinel) {
          charset = "utf-8";
        } else if (parts[i] === isoSentinel) {
          charset = "iso-8859-1";
        }
        skipIndex = i;
        i = parts.length;
      }
    }
  }
  for (i = 0; i < parts.length; ++i) {
    if (i === skipIndex) {
      continue;
    }
    var part = parts[i];
    var bracketEqualsPos = part.indexOf("]=");
    var pos = bracketEqualsPos === -1 ? part.indexOf("=") : bracketEqualsPos + 1;
    var key, val;
    if (pos === -1) {
      key = options.decoder(part, defaults.decoder, charset, "key");
      val = options.strictNullHandling ? null : "";
    } else {
      key = options.decoder(part.slice(0, pos), defaults.decoder, charset, "key");
      val = utils.maybeMap(
        parseArrayValue(part.slice(pos + 1), options),
        function(encodedVal) {
          return options.decoder(encodedVal, defaults.decoder, charset, "value");
        }
      );
    }
    if (val && options.interpretNumericEntities && charset === "iso-8859-1") {
      val = interpretNumericEntities(val);
    }
    if (part.indexOf("[]=") > -1) {
      val = isArray(val) ? [val] : val;
    }
    if (has.call(obj, key)) {
      obj[key] = utils.combine(obj[key], val);
    } else {
      obj[key] = val;
    }
  }
  return obj;
};
var parseObject = function(chain, val, options, valuesParsed) {
  var leaf = valuesParsed ? val : parseArrayValue(val, options);
  for (var i = chain.length - 1; i >= 0; --i) {
    var obj;
    var root2 = chain[i];
    if (root2 === "[]" && options.parseArrays) {
      obj = [].concat(leaf);
    } else {
      obj = options.plainObjects ? /* @__PURE__ */ Object.create(null) : {};
      var cleanRoot = root2.charAt(0) === "[" && root2.charAt(root2.length - 1) === "]" ? root2.slice(1, -1) : root2;
      var index2 = parseInt(cleanRoot, 10);
      if (!options.parseArrays && cleanRoot === "") {
        obj = { 0: leaf };
      } else if (!isNaN(index2) && root2 !== cleanRoot && String(index2) === cleanRoot && index2 >= 0 && (options.parseArrays && index2 <= options.arrayLimit)) {
        obj = [];
        obj[index2] = leaf;
      } else if (cleanRoot !== "__proto__") {
        obj[cleanRoot] = leaf;
      }
    }
    leaf = obj;
  }
  return leaf;
};
var parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
  if (!givenKey) {
    return;
  }
  var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, "[$1]") : givenKey;
  var brackets2 = /(\[[^[\]]*])/;
  var child = /(\[[^[\]]*])/g;
  var segment = options.depth > 0 && brackets2.exec(key);
  var parent = segment ? key.slice(0, segment.index) : key;
  var keys = [];
  if (parent) {
    if (!options.plainObjects && has.call(Object.prototype, parent)) {
      if (!options.allowPrototypes) {
        return;
      }
    }
    keys.push(parent);
  }
  var i = 0;
  while (options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth) {
    i += 1;
    if (!options.plainObjects && has.call(Object.prototype, segment[1].slice(1, -1))) {
      if (!options.allowPrototypes) {
        return;
      }
    }
    keys.push(segment[1]);
  }
  if (segment) {
    keys.push("[" + key.slice(segment.index) + "]");
  }
  return parseObject(keys, val, options, valuesParsed);
};
var normalizeParseOptions = function normalizeParseOptions2(opts) {
  if (!opts) {
    return defaults;
  }
  if (opts.decoder !== null && opts.decoder !== void 0 && typeof opts.decoder !== "function") {
    throw new TypeError("Decoder has to be a function.");
  }
  if (typeof opts.charset !== "undefined" && opts.charset !== "utf-8" && opts.charset !== "iso-8859-1") {
    throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
  }
  var charset = typeof opts.charset === "undefined" ? defaults.charset : opts.charset;
  return {
    allowDots: typeof opts.allowDots === "undefined" ? defaults.allowDots : !!opts.allowDots,
    allowPrototypes: typeof opts.allowPrototypes === "boolean" ? opts.allowPrototypes : defaults.allowPrototypes,
    allowSparse: typeof opts.allowSparse === "boolean" ? opts.allowSparse : defaults.allowSparse,
    arrayLimit: typeof opts.arrayLimit === "number" ? opts.arrayLimit : defaults.arrayLimit,
    charset,
    charsetSentinel: typeof opts.charsetSentinel === "boolean" ? opts.charsetSentinel : defaults.charsetSentinel,
    comma: typeof opts.comma === "boolean" ? opts.comma : defaults.comma,
    decoder: typeof opts.decoder === "function" ? opts.decoder : defaults.decoder,
    delimiter: typeof opts.delimiter === "string" || utils.isRegExp(opts.delimiter) ? opts.delimiter : defaults.delimiter,
    depth: typeof opts.depth === "number" || opts.depth === false ? +opts.depth : defaults.depth,
    ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
    interpretNumericEntities: typeof opts.interpretNumericEntities === "boolean" ? opts.interpretNumericEntities : defaults.interpretNumericEntities,
    parameterLimit: typeof opts.parameterLimit === "number" ? opts.parameterLimit : defaults.parameterLimit,
    parseArrays: opts.parseArrays !== false,
    plainObjects: typeof opts.plainObjects === "boolean" ? opts.plainObjects : defaults.plainObjects,
    strictNullHandling: typeof opts.strictNullHandling === "boolean" ? opts.strictNullHandling : defaults.strictNullHandling
  };
};
var parse$1 = function(str, opts) {
  var options = normalizeParseOptions(opts);
  if (str === "" || str === null || typeof str === "undefined") {
    return options.plainObjects ? /* @__PURE__ */ Object.create(null) : {};
  }
  var tempObj = typeof str === "string" ? parseValues(str, options) : str;
  var obj = options.plainObjects ? /* @__PURE__ */ Object.create(null) : {};
  var keys = Object.keys(tempObj);
  for (var i = 0; i < keys.length; ++i) {
    var key = keys[i];
    var newObj = parseKeys(key, tempObj[key], options, typeof str === "string");
    obj = utils.merge(obj, newObj, options);
  }
  if (options.allowSparse === true) {
    return obj;
  }
  return utils.compact(obj);
};
var stringify2 = stringify_1;
var parse = parse$1;
var formats = formats$3;
var lib = {
  formats,
  parse,
  stringify: stringify2
};
const istLocalEnv = window.location.host.includes(":");
let loadingInstance;
let loadingCount = 0;
function showLoading(config, show = true) {
  if (show) {
    if (loadingCount === 0) {
      loadingInstance = Loading.service(config);
    }
    loadingCount++;
  } else {
    loadingCount--;
    if (loadingInstance && loadingCount <= 0) {
      loadingInstance.close();
    }
  }
}
const codeMessage = {
  "200": "\u670D\u52A1\u5668\u6210\u529F\u8FD4\u56DE\u8BF7\u6C42\u7684\u6570\u636E\u3002",
  "201": "\u65B0\u5EFA\u6216\u4FEE\u6539\u6570\u636E\u6210\u529F\u3002",
  "202": "\u8BF7\u6C42\u5DF2\u7ECF\u8FDB\u5165\u540E\u53F0\u6392\u961F\uFF08\u5F02\u6B65\u4EFB\u52A1\uFF09\u3002",
  "204": "\u5220\u9664\u6570\u636E\u6210\u529F\u3002",
  "400": "\u8BF7\u6C42\u6709\u9519\u8BEF\uFF0C\u670D\u52A1\u5668\u65E0\u64CD\u4F5C\u3002",
  "401": "\u7528\u6237\u6CA1\u6709\u6743\u9650",
  "403": "\u7528\u6237\u672A\u88AB\u6388\u6743\uFF0C\u8BF7\u7533\u8BF7\u6743\u9650\u3002",
  "404": "\u670D\u52A1\u7AEF\u672A\u627E\u5230\u6B64API\u3002",
  "406": "\u8BF7\u6C42\u7684\u683C\u5F0F\u4E0D\u53EF\u5F97\u3002",
  "410": "\u8BF7\u6C42\u7684\u8D44\u6E90\u88AB\u6C38\u4E45\u5220\u9664\uFF0C\u4E14\u4E0D\u4F1A\u518D\u5F97\u5230\u7684\u3002",
  "422": "\u521B\u5EFA\u5BF9\u8C61\u65F6\uFF0C\u53D1\u751F\u9A8C\u8BC1\u9519\u8BEF\u3002",
  "500": "\u670D\u52A1\u5668\u53D1\u751F\u9519\u8BEF\uFF0C\u8BF7\u68C0\u67E5\u670D\u52A1\u5668\u3002",
  "502": "\u7F51\u5173\u9519\u8BEF\u3002",
  "503": "\u670D\u52A1\u4E0D\u53EF\u7528\uFF0C\u670D\u52A1\u5668\u6682\u65F6\u8FC7\u8F7D\u6216\u7EF4\u62A4\u3002",
  "504": "\u7F51\u5173\u8D85\u65F6\u3002"
};
setTimeout(() => {
  localStorage.removeItem("loginStatus");
}, 5e3);
const checkStatus = (response) => {
  if (response.status >= 200 && response.status < 300) {
    return response;
  }
  const eText = codeMessage[response.status] || response.statusText;
  if (response.status === 401) {
    response.json().then((res) => {
      if (res.reason === "\u672A\u767B\u5F55") {
        if (istLocalEnv) {
          Notification({
            type: "error",
            title: "\u6743\u9650\u4E2D\u53F0\uFF1A\u767B\u5F55\u72B6\u6001\u5DF2\u8FC7\u671F",
            dangerouslyUseHTMLString: true,
            message: `<b>${response.status}: ${eText}</b> </br> <a href="https://noah-test.staging.kuaishou.com" rel="noreferrer">\u4ECE\u6D4B\u8BD5\u73AF\u5883\u83B7\u53D6Cookie\uFF0C\u518D\u5237\u65B0\u672C\u9875\u9762</a>`,
            duration: 0
          });
        } else {
          if (!localStorage.getItem("loginStatus")) {
            localStorage.setItem("loginStatus", "true");
            location.reload();
          } else {
            Notification({
              type: "error",
              title: "\u6743\u9650\u4E2D\u53F0\uFF1A\u767B\u5F55\u72B6\u6001\u5DF2\u8FC7\u671F",
              dangerouslyUseHTMLString: true,
              message: `<b>${response.status}: ${eText}</b> </br> <a href="javascript:window.location.reload()" rel="noreferrer">\u7ACB\u5373\u5237\u65B0</a>`,
              duration: 0
            });
          }
        }
      } else if (res.reason === "\u65E0\u6743\u9650\u8BBF\u95EE")
        ;
    });
  } else {
    if (eText) {
      Notification({
        type: "error",
        title: "\u65E0\u6CD5\u83B7\u53D6\u9875\u9762\u4FE1\u606F",
        dangerouslyUseHTMLString: true,
        message: `<b>${response.status}: ${eText}</b> </br> <a target='_blank' href="${response.url}" rel="noreferrer">${response.url}</a>`
      });
    }
    const error = new Error(eText);
    error.name = response.status;
    throw error;
  }
};
function request(url, option, config) {
  const { track, fullscreen: fullscreen2 = false, trackSubmit = false, signal = false, manualResponse = false } = config || {};
  const options = __spreadValues({}, option);
  const network = localStorage.getItem("ksNetwork") || "";
  const defaultOptions = {
    credentials: "include",
    mode: "cors"
  };
  const newOptions = __spreadValues(__spreadValues({}, defaultOptions), options);
  if (newOptions.method === "POST" || newOptions.method === "PUT" || newOptions.method === "DELETE") {
    if (!(newOptions.body instanceof FormData)) {
      newOptions.headers = __spreadProps(__spreadValues({
        Accept: "application/json",
        "Content-Type": "application/json; charset=utf-8"
      }, newOptions.headers), {
        "admin-office": network
      });
      newOptions.body = JSON.stringify(newOptions.body);
    } else {
      newOptions.headers = __spreadProps(__spreadValues({
        Accept: "application/json"
      }, newOptions.headers), {
        "admin-office": network
      });
    }
  } else {
    newOptions.headers = __spreadProps(__spreadValues({
      Accept: "application/json"
    }, newOptions.headers), {
      "admin-office": network
    });
  }
  const loadingConfig = {
    fullscreen: fullscreen2 || false,
    customClass: fullscreen2 ? "" : "customLoading"
  };
  if (signal) {
    newOptions.signal = signal;
  }
  return fetch(url, newOptions).then(checkStatus).then((response) => {
    if (newOptions.method === "DELETE" || (response == null ? void 0 : response.status) === 204) {
      return response.text();
    }
    return response.json();
  }).then((response) => {
    if (manualResponse) {
      return response;
    }
    if (response.status && response.status !== 200) {
      return __spreadProps(__spreadValues({}, response), { data: {}, status: response.status });
    }
    if (!response.data) {
      return __spreadProps(__spreadValues({}, response), { data: {} });
    }
    return response;
  }).catch(() => {
    return { data: {} };
  }).finally(() => {
    showLoading(loadingConfig, false);
  });
}
function http(apiPromise, option, config = {}) {
  return new Promise((resolve2, reject) => {
    if (apiPromise) {
      apiPromise(option, config).then((res) => {
        if (res.result || !res.data && res.result) {
          resolve2(res);
        } else {
          resolve2(__spreadProps(__spreadValues({}, res), {
            data: {}
          }));
        }
      });
    }
  });
}
const formRequestData = (params) => {
  const keys = Object.keys(params);
  const fd = new FormData();
  for (const key of keys) {
    fd.append(key, params[key]);
  }
  return fd;
};
const adminLanguage = localStorage.getItem("ksLocal") || "en";
function joinArray(arr1, arr2) {
  const res = [];
  for (let i = 0; i < arr1.length; i++) {
    arr1[i] && res.push(arr1[i]);
    arr2[i] && res.push(arr2[i]);
  }
  return res.join("");
}
const GET = (preParams = {}) => (string, ...val) => {
  return (..._0) => __async(void 0, [..._0], function* (params = {}, config = {}) {
    const api = joinArray(string, val);
    return request(`${api}?${lib.stringify(__spreadValues(__spreadValues({}, preParams), params))}`, {
      headers: __spreadValues({
        "admin-language": adminLanguage
      }, config.headers)
    }, config);
  });
};
const POST = (preParams = {}) => (string, ...val) => {
  return (..._0) => __async(void 0, [..._0], function* (params = {}, config = {}) {
    const api = joinArray(string, val);
    return request(api, {
      body: __spreadValues(__spreadValues({}, preParams), params),
      headers: __spreadValues({
        "admin-language": adminLanguage
      }, config.headers),
      method: "POST"
    }, config);
  });
};
const Form = () => (string, ...val) => {
  return (..._0) => __async(void 0, [..._0], function* (params = {}, config = {}) {
    const api = joinArray(string, val);
    return request(api, {
      body: formRequestData(params),
      headers: __spreadValues({
        "admin-language": adminLanguage
      }, config.headers),
      method: "POST"
    }, config);
  });
};
const transform = (str) => {
  return `on${str.replace(/(^|-)(\w)/g, (m, $1, $2) => $2.toUpperCase())}`;
};
function getRequest() {
  return __async(this, arguments, function* ({ successTxt = "\u64CD\u4F5C\u6210\u529F", errorTxt = "\u64CD\u4F5C\u5931\u8D25", successToast = false, errorToast = true, url = "", method = "POST", payload } = {}, config = {}) {
    const $k18n = getK18n();
    const { pathname, query } = urlParse(url, true);
    let httpUrl;
    switch (method.toUpperCase()) {
      case "GET":
        httpUrl = GET()`${pathname}`;
        break;
      case "FORM":
        httpUrl = Form()`${pathname}`;
        break;
      default:
        httpUrl = POST()`${pathname}`;
    }
    const res = yield http(httpUrl, __spreadValues(__spreadValues({}, query), payload), config);
    const { result, message, data } = res;
    if (result === 1) {
      successToast && Message.success({
        message: $k18n(successTxt || "\u64CD\u4F5C\u6210\u529F"),
        type: "success"
      });
    } else {
      errorToast && Message.error({
        message: $k18n(errorTxt || message),
        type: "error"
      });
    }
    return res;
  });
}
const download = (url) => {
  const aEl = document.createElement("a");
  aEl.href = url;
  document.body.append(aEl);
  aEl.click();
  aEl.remove();
};
const getSelectorsKeyTransferValue = (mapKey, val) => {
  var _a;
  const commonSelectorsStr = localStorage.getItem("commonSelectors");
  const commonSelectorsValue = commonSelectorsStr && JSON.parse(commonSelectorsStr);
  const typeMap = commonSelectorsValue[mapKey];
  if (typeMap) {
    if (Array.isArray(val)) {
      const newVal = [];
      val.map((item) => {
        newVal.push(typeMap[item]);
      });
      val = newVal;
    } else if (Array.isArray(typeMap)) {
      val = ((_a = typeMap.find((item) => (item == null ? void 0 : item.value) === val)) == null ? void 0 : _a.label) || "";
    } else {
      val = typeMap[val];
    }
  }
  return val;
};
const copyData = function copyData2(label, value2, $k18n) {
  const transfer = document.createElement("input");
  document.body.appendChild(transfer);
  transfer.value = `${value2}`;
  transfer.select();
  if (document.execCommand("copy")) {
    document.execCommand("copy");
  }
  if ($k18n) {
    Message($k18n(`\u590D\u5236${label}\u6210\u529F`));
  } else {
    Message(`\u590D\u5236${label}\u6210\u529F`);
  }
  document.body.removeChild(transfer);
};
function replaceSymbols(str) {
  return str == null ? void 0 : str.replace(/^[\W*\s*]*|[\W*\s*]*$/g, "");
}
const openPage = (path, query, type) => {
  let url = path;
  if (query) {
    let paramsStr = Object.keys(query).reduce((str, current) => {
      str += `&${current}=${query[current] == null ? "" : query[current]}`;
      return str;
    }, "");
    if (path.indexOf("?") === -1) {
      paramsStr = paramsStr.replace("&", "?");
    }
    url = path + paramsStr;
  }
  if (type) {
    window.location.href = url;
  } else {
    window.open(url, "_blank");
  }
};
const getDownload = (url = "", options = {}) => {
  options.body = options.body || {};
  options.body.username = options.body.auditor = localStorage.getItem("username") || "admin";
  const params = {
    headers: __spreadValues({
      username: options.body.username,
      "Content-Disposition": "attachment",
      "Content-Type": "application/json; charset=utf-8",
      "admin-language": localStorage.getItem("ksLocal") || "en"
    }, options.headers || {}),
    credentials: "include",
    mode: "cors",
    method: "POST",
    body: JSON.stringify(options.body || {})
  };
  let fileName;
  fetch(url, params).then((res) => {
    var _a;
    fileName = (_a = res.headers.get("content-disposition")) == null ? void 0 : _a.split("filename=")[1];
    return res && res.blob();
  }).then((res) => {
    const aLink = document.createElement("a");
    aLink.download = fileName;
    aLink.style.display = "none";
    aLink.href = URL.createObjectURL(res);
    document.body.appendChild(aLink);
    aLink.click();
    document.body.removeChild(aLink);
  }).catch(() => {
  });
};
function getTransformData(data, item, emptyValue = "") {
  const { transform: transform2 = "", key } = item;
  const value2 = get_1(data, key);
  if (MUSTACHE.test(transform2)) {
    const str = getMustacheContent(transform2);
    return transformMustacheToFunc(str, "row", data);
  }
  if (typeof transform2 === "function") {
    return transform2(value2, data);
  }
  return getEmptyValue(value2, emptyValue);
}
function getCopyValueByConfig(data, item, emptyValue = "") {
  const key = item.copyValue || item.key;
  if (typeof key === "string" && MUSTACHE.test(key)) {
    const str = getMustacheContent(key);
    return transformMustacheToFunc(str, "row", data);
  }
  const value2 = get_1(data, item.key);
  const transformedValue = getTransformData(data, item, emptyValue);
  if (typeof key === "function") {
    return key(value2, data, transformedValue);
  }
  return getEmptyValue(value2, emptyValue);
}
function getEmptyValue(value2, emptyValue = TEXT_EMPTY_VALUE) {
  if (value2 === "" || value2 === void 0 || value2 === null) {
    return emptyValue;
  }
  return value2;
}
function getMapValue(row2, value2, item) {
  var _a;
  const { key, map } = item;
  let val = value2;
  if (map) {
    if (typeof map === "string") {
      val = getSelectorsKeyTransferValue(map, row2[key]);
    } else if (Array.isArray(map)) {
      val = ((_a = map.find((item2) => (item2 == null ? void 0 : item2.value) === val)) == null ? void 0 : _a.label) || "";
    } else {
      val = map[val];
    }
  }
  return val;
}
function getK18nValue(value2, item, k18n) {
  const $k18n = k18n || getK18n();
  const { isK18n, k18nDesc = "" } = item;
  return isK18n ? $k18n({ text: value2, desc: k18nDesc }) : value2;
}
function getK18nValueResult(value2, k18nDesc) {
  return getK18nValue(value2, { isK18n: true, k18nDesc });
}
const $PROCONFIG = {};
function useGlobalConfig() {
  const vm = getCurrentInstance();
  if (vm && vm.proxy && "$PROCONFIG" in vm.proxy) {
    return vm.proxy.$PROCONFIG;
  }
  return $PROCONFIG || { widget: {} };
}
function DEFAULTK18N(text2) {
  if (typeof text2 === "object") {
    return text2.text;
  }
  return text2;
}
function getK18n() {
  const $PROCONFIG2 = useGlobalConfig();
  return ($PROCONFIG2 == null ? void 0 : $PROCONFIG2.$k18n) || DEFAULTK18N;
}
const getUrlParams = (urlSearch, config) => {
  const urlSearchList = urlSearch && /\?.*/.exec(urlSearch);
  urlSearch = urlSearchList && urlSearchList[0] || location.search;
  if (urlSearch.indexOf("?") !== -1) {
    urlSearch = urlSearch.slice(1);
  }
  const queryString = urlSearch.length ? urlSearch : "";
  const result = {};
  const items = queryString.length ? queryString.split("&") : [];
  items.forEach((item) => {
    item = item.split("=");
    const name = window.decodeURIComponent(item[0]);
    let value2 = window.decodeURIComponent(item[1]);
    if (name && name.length && !result[name]) {
      if (config == null ? void 0 : config.decodeBool) {
        if (value2 === "true")
          value2 = true;
        if (value2 === "false")
          value2 = false;
      }
      result[name] = value2;
    }
  });
  return result;
};
const ONE_DAY = 24 * 3600 * 1e3;
const DAY_START = new Date(0, 0, 0, 0, 0, 0);
const DAY_END = new Date(0, 0, 0, 23, 59, 59);
const TODAY_START = new Date().setHours(0, 0, 0, 0);
const TODAY_END = new Date().setHours(23, 59, 59, 0);
const index$4 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  MUSTACHE,
  parseValue: parseValue$1,
  parseMustacheValue,
  getMustacheContent,
  transformMustacheToFunc,
  strip,
  formatValue,
  underline,
  isEffectiveNumber,
  formatRate,
  getTransformData,
  getCopyValueByConfig,
  getEmptyValue,
  getMapValue,
  getK18nValue,
  getK18nValueResult,
  useGlobalConfig,
  getK18n,
  getUrlParams,
  ONE_DAY,
  DAY_START,
  DAY_END,
  TODAY_START,
  TODAY_END,
  transform,
  getRequest,
  download,
  getSelectorsKeyTransferValue,
  copyData,
  replaceSymbols,
  openPage,
  getDownload
}, Symbol.toStringTag, { value: "Module" }));
function getTableClass(props, ctx) {
  const result = [];
  result.push(getBorderClass(ctx));
  result.push(getFixHeaderClass(props));
  return result.join(" ");
}
function getFixHeaderClass(props) {
  return props.headerSticky ? "pro_header_fixed" : "";
}
function getBorderClass(ctx) {
  const { attrs } = ctx;
  const keys = Object.keys(attrs);
  if (keys.includes("border") || attrs.border) {
    return "pro_table__border";
  }
  return "";
}
function getTableLabel(item) {
  var _a, _b;
  const $k18n = getK18n();
  const isEn = ((_b = (_a = $k18n == null ? void 0 : $k18n.global) == null ? void 0 : _a.locale) == null ? void 0 : _b.value) === "en";
  if (isEn && item.enLabel) {
    return item.enLabel;
  }
  return $k18n(item.label);
}
function formatDate(date, format2 = DEFAULT$4.format) {
  return moment(new Date(date)).format(format2);
}
const DEFAULT$4 = {
  separator: "break",
  format: "YYYY/MM/DD HH:mm"
};
const letterWidthCache = {};
const CELL_PADDING = 28;
const CELL_REST = 1;
const COPY_ICON_WIDTH = 18;
const TAG_PADDING = 16;
const HEADER_FILTER_ICON = 16;
const HEADER_DESC_ICON = 18;
const HEADER_SORTABLE_ICON = 20;
const OTHER_LETTER_WIDTH = 5;
const CHINESE_LETTER_WIDTH = 14;
const TABLE_COLUMN_WIDTH = {
  medium: 260,
  small: 200,
  mini: 120
};
function getColWidth(props, item) {
  var _a;
  getLetterCacheWidth();
  const width = getItemByKey(item, "width") || {};
  const minWidth = (_a = getItemByKey(item, "minWidth")) == null ? void 0 : _a["min-width"];
  const suitableWidth = calSuitableWidth(props, item);
  return __spreadProps(__spreadValues({}, width), {
    minWidth: Math.max(suitableWidth, minWidth)
  });
}
function calSuitableWidth(props, oriItem) {
  var _a;
  const { useEnHeaderWrap, useCnHeaderWrap, formItems } = props;
  const item = __spreadValues({
    useCnHeaderWrap: true,
    useEnHeaderWrap: true
  }, oriItem);
  const hasHeaderFilter = formItems.length;
  const label = getTableLabel(item) || "";
  let headerTextWidth = getStringPxWidth(label);
  const contentTextWidth = getContentWidth(props, item);
  if (useEnHeaderWrap || useCnHeaderWrap) {
    headerTextWidth = calHeaderTextWrap(props, item, label, headerTextWidth, contentTextWidth);
  }
  const headerWidth = getHeaderWidth(item, headerTextWidth, hasHeaderFilter);
  const maxWidth = (_a = getItemByKey(item, "maxWidth")) == null ? void 0 : _a["max-width"];
  const colMaxWidth = maxWidth || props.colMaxWidth;
  const contentWidth = Math.min(contentTextWidth + CELL_PADDING + CELL_REST, colMaxWidth);
  return Math.max(headerWidth, contentWidth);
}
function calHeaderTextWrap(props, item, label, headerTextWidth, contentWidth) {
  const { useEnHeaderWrap, useCnHeaderWrap } = props;
  if (2 * contentWidth < headerTextWidth) {
    const en = /^[A-Za-z0-9-_\s]+$/.test(label);
    const labelArr = label.split(/\s/);
    const labelArrLen = labelArr.length;
    const labelWidth = labelArr.map((item2) => getStringPxWidth(item2)) || [];
    if (useEnHeaderWrap && item.useEnHeaderWrap && en) {
      if (labelArrLen === 2) {
        return Math.max(...labelWidth) + OTHER_LETTER_WIDTH;
      }
      if (labelArrLen > 2) {
        return Math.ceil(headerTextWidth / 2) + (labelArrLen + 1) * OTHER_LETTER_WIDTH;
      }
    }
    if (useCnHeaderWrap && item.useCnHeaderWrap && !en) {
      if (label.length > 2) {
        const isChinese = /^[\u4E00-\u9FA5]+$/.test(label);
        if (isChinese) {
          return Math.ceil(labelArrLen % 2 === 0 ? headerTextWidth / 2 : (headerTextWidth + CHINESE_LETTER_WIDTH) / 2);
        }
        return Math.ceil(headerTextWidth / 2) + CHINESE_LETTER_WIDTH;
      }
    }
  }
  return headerTextWidth;
}
function getHeaderWidth(item, headerTextWidth, hasHeaderFilter = 0) {
  const filterIcon = hasHeaderFilter ? HEADER_FILTER_ICON : 0;
  const headerDesc = (item == null ? void 0 : item.headerDesc) ? HEADER_DESC_ICON : 0;
  const sortable = (item == null ? void 0 : item.sortable) ? HEADER_SORTABLE_ICON : 0;
  return Math.ceil(headerTextWidth + CELL_PADDING + filterIcon + headerDesc + sortable);
}
function getContentWidth(props, item) {
  const { data } = props;
  let result = 0;
  data == null ? void 0 : data.forEach((dataItem) => {
    const value2 = getTransformData(dataItem, item);
    let stringValue = getMapValue(dataItem, value2, item) || "";
    if (stringValue) {
      stringValue = getK18nValue(stringValue, item);
    }
    if (item.type === TABLE_ITEM_TYPE.DATE && isEffectiveNumber(stringValue)) {
      stringValue = formatDate(stringValue, item.format = DEFAULT$4.format);
    }
    result = Math.max(result, getStringPxWidth(`${stringValue}`));
  });
  if (item.type === TABLE_ITEM_TYPE.NUMBER) {
    result += 24;
  }
  if (item.type === TABLE_ITEM_TYPE.TAG) {
    result += TAG_PADDING;
  }
  if (item.copy) {
    result += COPY_ICON_WIDTH;
  }
  return Math.ceil(result);
}
function getStringPxWidth(label) {
  const chinese = label.match(/[\u4E00-\u9FA5]/g) || [];
  const letter = label.match(/[\u0021-\u007E（）]/g) || [];
  const others = label.length - chinese.length - letter.length;
  const othersWidth = OTHER_LETTER_WIDTH;
  let letterWidthSum = 0;
  letter == null ? void 0 : letter.forEach((l) => {
    const letterWidth = parseFloat(letterWidthCache[l]);
    if (letterWidth && !Number.isNaN(letterWidth)) {
      letterWidthSum += letterWidth;
    } else {
      letterWidthSum += othersWidth;
    }
  });
  return Math.ceil(CHINESE_LETTER_WIDTH * chinese.length + letterWidthSum + others * othersWidth);
}
function getLetterCacheWidth() {
  if (!Object.keys(letterWidthCache).length) {
    const fragment = document.createDocumentFragment();
    for (let i = 33; i <= 126; i++) {
      appendToFragment(fragment, i);
    }
    const uniqueCode = [65288, 65289];
    uniqueCode.forEach((item) => {
      appendToFragment(fragment, item);
    });
    const body = document.querySelector("body");
    body == null ? void 0 : body.appendChild(fragment);
    const dom = document.querySelectorAll(".proTable_letter_width_cache");
    dom == null ? void 0 : dom.forEach((item) => {
      var _a;
      if (item.textContent) {
        letterWidthCache[item.textContent] = (_a = item.getBoundingClientRect()) == null ? void 0 : _a.width;
      }
    });
    nextTick(() => {
      dom == null ? void 0 : dom.forEach((item) => {
        body == null ? void 0 : body.removeChild(item);
      });
    });
  }
}
function appendToFragment(fragment, code) {
  const span = document.createElement("span");
  span.style.opacity = 0;
  span.className = "proTable_letter_width_cache";
  span.textContent = String.fromCharCode(code);
  fragment.append(span);
}
function getItemByKey(item, humpKey) {
  const underlineKey = underline(humpKey);
  const value2 = parseFloat(item[humpKey] || item[underlineKey]) || 0;
  const width = TABLE_COLUMN_WIDTH[value2];
  if (width) {
    return {
      [underlineKey]: width
    };
  }
  if (value2) {
    return {
      [underlineKey]: value2
    };
  }
  return {
    [underlineKey]: value2
  };
}
const ExpandCell_vue_vue_type_style_index_0_scoped_true_lang = "";
const _hoisted_1$U = { key: 1 };
const _sfc_main$1g = /* @__PURE__ */ defineComponent({
  __name: "ExpandCell",
  props: {
    item: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ["click"],
  setup(__props, { emit: emit2 }) {
    const props = __props;
    const $k18n = getK18n();
    const state = reactive({
      show: false
    });
    const iconLeft = computed(() => {
      var _a;
      return ((_a = props.item) == null ? void 0 : _a.expandIconPosition) === "left";
    });
    function handleClick() {
      state.show = !state.show;
      emit2("click");
    }
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("span", {
        class: normalizeClass([{ show: state.show }, "expand_cell"]),
        onClick: handleClick
      }, [
        unref(iconLeft) ? (openBlock(), createBlock(unref(IconDirectionRight), { key: 0 })) : createCommentVNode("", true),
        __props.item.expandContent ? (openBlock(), createElementBlock("span", _hoisted_1$U, toDisplayString(unref($k18n)(__props.item.expandContent)), 1)) : createCommentVNode("", true),
        !unref(iconLeft) ? (openBlock(), createBlock(unref(IconDirectionRight), { key: 2 })) : createCommentVNode("", true)
      ], 2);
    };
  }
});
const ExpandCell = /* @__PURE__ */ _export_sfc(_sfc_main$1g, [["__scopeId", "data-v-3b1624e8"]]);
function renderExpand(scope, item) {
  const instance = getCurrentInstance();
  function onClick() {
    var _a, _b, _c;
    (_c = (_b = (_a = instance == null ? void 0 : instance.exposed) == null ? void 0 : _a.ksTableRef) == null ? void 0 : _b.value) == null ? void 0 : _c.toggleRowExpansion(scope.row);
  }
  return h(ExpandCell, { onClick, item });
}
function transformExpandColumns(columns) {
  const cloneColumns = cloneDeep(columns);
  cloneColumns == null ? void 0 : cloneColumns.forEach((item, index2) => {
    if (item.type === TABLE_ITEM_TYPE.EXPAND && item.expandContent) {
      cloneColumns.splice(index2 + 1, 0, __spreadProps(__spreadValues({}, item), {
        type: TABLE_ITEM_TYPE.EXPAND_CUSTOM,
        key: `${item.key}_custom_inner`
      }));
      item.width = "1";
      item["class-name"] = "ks_table_expand_change";
      item["label-class-name"] = "ks_table_expand_change";
      item.label = "";
      item.isLabelK18n = false;
    }
  });
  return cloneColumns;
}
const index_vue_vue_type_style_index_0_scoped_true_lang$6 = "";
const _hoisted_1$T = { class: "pro_selection__bar" };
const _hoisted_2$z = { class: "pro_selection__bar-num" };
const _hoisted_3$q = { class: "pro_selection__bar-center" };
const _hoisted_4$j = { class: "pro_selection__bar-btns" };
const _hoisted_5$b = {
  key: 0,
  class: "split-line"
};
const _hoisted_6$7 = ["onClick"];
const _sfc_main$1f = /* @__PURE__ */ defineComponent({
  __name: "index",
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    showFirstSplitLine: {
      type: Boolean,
      default: false
    },
    btns: {
      type: [Array, String],
      default: () => []
    },
    num: {
      type: Number,
      default: 0
    },
    label: {
      type: String,
      default: "Selected"
    }
  },
  emits: ["update:modelValue", "click", "close"],
  setup(__props, { emit: emit2 }) {
    const props = __props;
    const btnConfigs = computed(() => {
      const { btns } = props;
      if (typeof btns === "string") {
        return [
          {
            label: btns,
            key: btns
          }
        ];
      }
      return btns;
    });
    function handleClose() {
      emit2("update:modelValue", false);
      emit2("close", false);
    }
    function handleClick(item) {
      emit2("click", item.key, item);
    }
    return (_ctx, _cache) => {
      return withDirectives((openBlock(), createElementBlock("div", _hoisted_1$T, [
        createElementVNode("div", _hoisted_2$z, toDisplayString(__props.num), 1),
        createElementVNode("div", _hoisted_3$q, [
          createElementVNode("div", null, toDisplayString(__props.label), 1),
          createElementVNode("div", _hoisted_4$j, [
            renderSlot$2(_ctx.$slots, "default", {}, void 0, true),
            createElementVNode("div", null, [
              (openBlock(true), createElementBlock(Fragment, null, renderList(unref(btnConfigs), (item, index2) => {
                return openBlock(), createElementBlock(Fragment, {
                  key: item.key
                }, [
                  __props.showFirstSplitLine && index2 === 0 ? (openBlock(), createElementBlock("span", _hoisted_5$b, "\uFF5C")) : createCommentVNode("", true),
                  createElementVNode("span", {
                    class: "operate-link",
                    onClick: ($event) => handleClick(item)
                  }, toDisplayString(item.label), 9, _hoisted_6$7)
                ], 64);
              }), 128))
            ])
          ])
        ]),
        createElementVNode("div", {
          class: "pro_selection__bar-close",
          onClick: _cache[0] || (_cache[0] = ($event) => handleClose())
        }, [
          createVNode(unref(IconGeneralClose))
        ])
      ], 512)), [
        [vShow, __props.modelValue]
      ]);
    };
  }
});
const SelectionBar = /* @__PURE__ */ _export_sfc(_sfc_main$1f, [["__scopeId", "data-v-3dbff552"]]);
function renderSelectionBar(props, ctx, ksTableRef, state) {
  var _a;
  const selectionBar = props.selectionBar;
  if (!selectionBar) {
    return "";
  }
  function handleClose() {
    ctx.emit("selection-bar-close");
  }
  function clearSelection() {
    var _a2;
    state.selection = [];
    (_a2 = ksTableRef.value) == null ? void 0 : _a2.clearSelection();
  }
  function handleClick(key, item) {
    ctx.emit("selection-bar-click", key, state.selection, item);
  }
  watch(() => props.selectionBar.visible, (val) => {
    if (!val) {
      clearSelection();
    }
  });
  return h(SelectionBar, __spreadProps(__spreadValues({}, props.selectionBar || {}), {
    num: (_a = state.selection) == null ? void 0 : _a.length,
    onClose: handleClose,
    modelValue: selectionBar.visible,
    "onUpdate:modelValue": (value2) => selectionBar.visible = value2,
    onClick: handleClick
  }));
}
const BindDrawer_vue_vue_type_style_index_0_scoped_true_lang = "";
const BindDrawer_vue_vue_type_style_index_1_lang = "";
const _hoisted_1$S = { class: "title" };
const _sfc_main$1e = /* @__PURE__ */ defineComponent({
  __name: "BindDrawer",
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ""
    }
  },
  emits: ["update:modelValue"],
  setup(__props, { emit: emit2 }) {
    const attrs = useAttrs();
    const bindProps = computed(() => {
      return __spreadValues({
        "custom-class": "pro_bind__drawer",
        direction: "rtl",
        "show-close": false
      }, attrs);
    });
    function handleClick(show) {
      emit2("update:modelValue", show);
    }
    return (_ctx, _cache) => {
      const _component_k18n = resolveComponent("k18n");
      const _component_ks_drawer = resolveComponent("ks-drawer");
      return openBlock(), createBlock(_component_ks_drawer, mergeProps({
        modelValue: __props.modelValue,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => isRef(modelValue) ? modelValue.value = $event : null)
      }, unref(bindProps), {
        onClose: _cache[2] || (_cache[2] = ($event) => handleClick(false))
      }), {
        title: withCtx(() => [
          createElementVNode("div", _hoisted_1$S, [
            createVNode(_component_k18n, null, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(__props.title), 1)
              ]),
              _: 1
            })
          ]),
          !unref(bindProps)["show-close"] ? (openBlock(), createElementBlock("div", {
            key: 0,
            class: "ks-icon-upload2",
            onClick: _cache[0] || (_cache[0] = ($event) => handleClick(false))
          })) : createCommentVNode("", true)
        ]),
        default: withCtx(() => [
          renderSlot$2(_ctx.$slots, "default", {}, void 0, true)
        ]),
        _: 3
      }, 16, ["modelValue"]);
    };
  }
});
const BindDrawer = /* @__PURE__ */ _export_sfc(_sfc_main$1e, [["__scopeId", "data-v-590fb210"]]);
const _sfc_main$1d = /* @__PURE__ */ defineComponent({
  __name: "index",
  props: {
    drawerProps: {
      type: Object,
      default: null
    }
  },
  emits: ["close", "reload"],
  setup(__props, { expose, emit: emit2 }) {
    const state = reactive({
      list: [],
      component: FormDrawer,
      drawerProps: "",
      slotName: "",
      kconfKey: "",
      payload: "",
      slots: [],
      title: "",
      show: false,
      loading: false,
      requestPayload: {},
      tableColumn: []
    });
    function handleClickShow(item, scope) {
      return __async(this, null, function* () {
        const _a = item || {}, { title, label, type } = _a, drawerProps = __objRest(_a, ["title", "label", "type"]);
        state.drawerProps = __spreadValues({
          size: 560,
          width: 560
        }, drawerProps);
        switch (type) {
          case "drawer":
            state.component = BindDrawer;
            break;
          case "dialog":
            state.component = Dialog;
            break;
          case "curdDrawer":
          case "curdDialog":
            state.component = CurdDrawer;
            break;
          case "formDrawer":
          case "formDialog":
          default:
            state.component = FormDrawer;
            break;
        }
        const _b = item, { slotName, request: request2 } = _b, rest = __objRest(_b, ["slotName", "request"]);
        state.slotName = slotName;
        state.item = rest;
        state.payload = item.payload;
        state.title = title || label;
        state.row = scope.row;
        state.kconfKey = item.kconfKey;
        state.kconfKey || state.slotName;
        if (request2 == null ? void 0 : request2.payload) {
          const payloadKeys = Object.keys(request2 == null ? void 0 : request2.payload);
          payloadKeys.forEach((key) => {
            request2.payload[key] = parseValue$1(request2.payload[key], "row", row);
          });
          const { result, data } = yield getRequest(item.request);
          if (result === 1) {
            state.row = data;
          }
        }
        state.show = true;
      });
    }
    function handleSubmit() {
      state.show = false;
      emit2("reload");
    }
    function handleClickClose() {
      state.show = false;
    }
    expose({ handleClickShow });
    return (_ctx, _cache) => {
      var _a;
      return state.kconfKey || state.payload.kconf ? (openBlock(), createBlock(resolveDynamicComponent(state.component), mergeProps({
        key: 0,
        modelValue: state.show,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => state.show = $event),
        component: (_a = state == null ? void 0 : state.item) == null ? void 0 : _a.type,
        title: state.title
      }, Object.assign(_ctx.config[state.kconfKey] || {}, state.payload), {
        row: state.row,
        onSubmit: handleSubmit,
        onClose: handleClickClose
      }), {
        default: withCtx(() => [
          (openBlock(true), createElementBlock(Fragment, null, renderList(state.item.slots, (name) => {
            return renderSlot$2(_ctx.$slots, name);
          }), 256))
        ]),
        _: 3
      }, 16, ["modelValue", "component", "title", "row"])) : (openBlock(), createBlock(resolveDynamicComponent(state.component), mergeProps({
        key: 1,
        modelValue: state.show,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => state.show = $event),
        title: state.title
      }, state.drawerProps), {
        default: withCtx(() => [
          state.show ? renderSlot$2(_ctx.$slots, state.slotName, {
            key: 0,
            row: state.row,
            submit: handleSubmit,
            close: handleClickClose
          }) : createCommentVNode("", true)
        ]),
        _: 3
      }, 16, ["modelValue", "title"]));
    };
  }
});
function renderDrawerComponent(props, ctx, drawerComponentRef) {
  var _a;
  const { columns } = props;
  const { slots } = ctx;
  const btns = ((_a = columns == null ? void 0 : columns.find((item) => Array.isArray(item.btns))) == null ? void 0 : _a.btns) || [];
  const slotsMap = {};
  btns.forEach((item) => {
    if (item.slotName) {
      slotsMap[item.slotName] = slots[item.slotName];
    }
  });
  return h(_sfc_main$1d, {
    drawerProps: props.drawerProps,
    ref: drawerComponentRef,
    onReload: () => {
      ctx.emit("reload");
    }
  }, __spreadValues({}, slotsMap));
}
function setDataHighlight(payload) {
  nextTick(() => {
    var _a, _b;
    const bodyWrapper = document.querySelector(".ks-table__body-wrapper");
    const cells = bodyWrapper == null ? void 0 : bodyWrapper.querySelectorAll("td");
    const trendMap = {};
    const columnsLen = payload.columns.length;
    (_a = payload.list) == null ? void 0 : _a.map((item) => {
      var _a2;
      (_a2 = payload.columns) == null ? void 0 : _a2.forEach((col) => {
        const { key, dataTrend } = col;
        if (dataTrend) {
          const value2 = parseStringValue(item[key]) || 0;
          if (!trendMap[key]) {
            trendMap[key] = {
              max: value2,
              min: value2
            };
          } else {
            const { max: max2, min: min2 } = trendMap[key];
            if (value2 > max2) {
              trendMap[key].max = value2;
            }
            if (value2 < min2) {
              trendMap[key].min = value2;
            }
          }
        }
      });
    });
    (_b = payload.list) == null ? void 0 : _b.map((item, i) => {
      var _a2;
      (_a2 = payload.columns) == null ? void 0 : _a2.forEach((col, j) => {
        const { key, dataTrend } = col;
        if (dataTrend) {
          const { max: max2, min: min2 } = trendMap[key];
          let value2 = item[key];
          if (value2 || value2 === 0) {
            value2 = parseStringValue(value2);
            if (cells[columnsLen * i + j]) {
              const cellItem = cells[columnsLen * i + j];
              if (payload.show && max2 !== min2) {
                const cellRgba = gradientRGBA("214, 225, 254", (value2 - min2) / (max2 - min2));
                cellItem.style.background = cellRgba.background;
              } else {
                cellItem.style.background = "";
              }
            }
          }
        }
      });
    });
  });
}
function parseStringValue(value2) {
  let result = value2;
  if (typeof value2 === "string") {
    const valueNum = parseFloat(value2);
    if (value2.includes("m")) {
      result = valueNum * 1e7;
    } else if (value2.includes("k")) {
      result = valueNum * 1e4;
    } else {
      result = valueNum;
    }
  }
  return result;
}
function gradientRGBA(rgbStr, value2) {
  return {
    background: `rgba(${rgbStr},${value2.toFixed(2)})`
  };
}
var BUTTON_TYPE_ENUM = /* @__PURE__ */ ((BUTTON_TYPE_ENUM2) => {
  BUTTON_TYPE_ENUM2["router"] = "router";
  BUTTON_TYPE_ENUM2["href"] = "href";
  BUTTON_TYPE_ENUM2["request"] = "request";
  BUTTON_TYPE_ENUM2["dialog"] = "dialog";
  BUTTON_TYPE_ENUM2["drawer"] = "drawer";
  BUTTON_TYPE_ENUM2["formDrawer"] = "formDrawer";
  BUTTON_TYPE_ENUM2["formDialog"] = "formDialog";
  BUTTON_TYPE_ENUM2["curdDrawer"] = "curdDrawer";
  BUTTON_TYPE_ENUM2["curdDialog"] = "curdDialog";
  return BUTTON_TYPE_ENUM2;
})(BUTTON_TYPE_ENUM || {});
const _hoisted_1$R = { style: { "margin": "4px 0 12px 4px" } };
const _hoisted_2$y = { key: 0 };
const _hoisted_3$p = { key: 1 };
const _hoisted_4$i = { style: { "margin-left": "36px", "display": "flex" } };
const _sfc_main$1c = /* @__PURE__ */ defineComponent({
  __name: "BtnConfirm",
  props: {
    label: {
      type: String,
      default: ""
    },
    toolTip: {
      type: String,
      default: "\u6CA1\u6709\u6743\u9650, \u8BF7\u8054\u7CFB\u8D1F\u8D23\u4EBA\u6216\u521B\u5EFA\u4EBA"
    },
    disabled: {
      type: Boolean,
      default: false
    },
    toolTipDisabled: {
      type: Boolean,
      default: false
    },
    row: {
      type: Object,
      default: () => ({})
    },
    message: {
      type: String,
      default: ""
    },
    popoverWidth: {
      type: [String, Number],
      default: 150
    }
  },
  emits: ["confirm"],
  setup(__props, { emit: emit2 }) {
    const props = __props;
    const $k18n = getK18n();
    const visible = ref(false);
    const handleClickCancel = () => {
      visible.value = false;
    };
    const handleClickConfirm = () => {
      visible.value = false;
      emit2("confirm", props.row);
    };
    const onDeletePopupShow = () => {
      visible.value = true;
    };
    return (_ctx, _cache) => {
      const _component_ks_button = resolveComponent("ks-button");
      const _component_ks_popover = resolveComponent("ks-popover");
      const _component_ks_tooltip = resolveComponent("ks-tooltip");
      return !__props.disabled ? (openBlock(), createBlock(_component_ks_popover, {
        key: 0,
        placement: "top",
        visible: visible.value,
        width: __props.popoverWidth
      }, {
        reference: withCtx(() => [
          createElementVNode("span", { onClick: onDeletePopupShow }, [
            renderSlot$2(_ctx.$slots, "reference", {}, () => [
              createVNode(_component_ks_button, mergeProps({
                type: "text",
                size: "small"
              }, _ctx.$attrs), {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(unref($k18n)(__props.label)), 1)
                ]),
                _: 1
              }, 16)
            ])
          ])
        ]),
        default: withCtx(() => [
          createElementVNode("p", _hoisted_1$R, [
            __props.message ? (openBlock(), createElementBlock("span", _hoisted_2$y, toDisplayString(unref($k18n)(__props.message)), 1)) : (openBlock(), createElementBlock("span", _hoisted_3$p, toDisplayString(unref($k18n)(`\u786E\u8BA4${__props.label}\u5417\uFF1F`)), 1))
          ]),
          createElementVNode("div", _hoisted_4$i, [
            createVNode(_component_ks_button, {
              size: "mini",
              onClick: handleClickCancel
            }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(unref($k18n)("\u53D6\u6D88")), 1)
              ]),
              _: 1
            }),
            createVNode(_component_ks_button, {
              size: "mini",
              type: "primary",
              onClick: handleClickConfirm
            }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(unref($k18n)("\u786E\u5B9A")), 1)
              ]),
              _: 1
            })
          ])
        ]),
        _: 3
      }, 8, ["visible", "width"])) : (openBlock(), createBlock(_component_ks_tooltip, {
        key: 1,
        effect: "dark",
        disabled: __props.toolTipDisabled,
        placement: "top"
      }, {
        content: withCtx(() => [
          createTextVNode(toDisplayString(unref($k18n)(__props.toolTip)), 1)
        ]),
        default: withCtx(() => [
          createElementVNode("span", null, [
            createVNode(_component_ks_button, {
              type: "text",
              size: "small",
              disabled: true
            }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(unref($k18n)(__props.label)), 1)
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["disabled"]));
    };
  }
});
function genTextBtn(item, scope) {
  const { label, handler, props, show, disabled, k18nDesc } = item;
  const $k18n = getK18n();
  const DEFAULT2 = {
    type: "text",
    size: "small"
  };
  if (show) {
    return h(Button, __spreadProps(__spreadValues(__spreadValues({}, DEFAULT2), props), {
      disabled: !!disabled,
      onClick: () => handler(scope, item)
    }), { default: $k18n({ text: label, desc: k18nDesc || "" }) });
  }
  return "";
}
function parseValue(str, replaceKey, scope, index2) {
  if (typeof str === "string") {
    return parseMustacheValue(str, replaceKey, scope.row, index2);
  }
  if (isFunction$2(str)) {
    return str(scope);
  }
  return "";
}
function parseUrl(url, scope) {
  const result = parseValue(url, "row", scope);
  if (typeof result === "string") {
    return urlParse(result, true);
  }
  return result;
}
function processDynamicKey(item, scope) {
  const booleanKey = ["show", "disabled"];
  booleanKey.forEach((key) => {
    const value2 = item[key];
    if (value2) {
      if (MUSTACHE.test(value2)) {
        const result = getMustacheContent(value2);
        const funcResult = transformMustacheToFunc(result, "row", scope.row);
        item[key] = !!funcResult;
      } else if (typeof value2 === "function") {
        item[key] = value2(scope, item);
      } else {
        item[key] = value2;
      }
    }
  });
}
function renderBuiltInBtn(configItem, scope = { row: {}, $index: 0 }) {
  const DEFAULT_ITEM = {
    show: true,
    useConfirm: true,
    target: "_blank",
    props: {},
    payload: {}
  };
  const item = __spreadValues(__spreadValues({}, DEFAULT_ITEM), configItem);
  const { type } = item;
  processDynamicKey(item, scope);
  switch (type) {
    case BUTTON_TYPE_ENUM.router:
      return renderRouter(item, scope);
    case BUTTON_TYPE_ENUM.request:
      return renderRequest(item, scope);
    case BUTTON_TYPE_ENUM.href:
      return renderHref(item, scope);
    case BUTTON_TYPE_ENUM.dialog:
    case BUTTON_TYPE_ENUM.drawer:
    case BUTTON_TYPE_ENUM.formDrawer:
    case BUTTON_TYPE_ENUM.formDialog:
    case BUTTON_TYPE_ENUM.curdDrawer:
    case BUTTON_TYPE_ENUM.curdDialog:
      return renderDialog(item, scope);
    default:
      return renderDefaultBtn(item, scope);
  }
}
function renderRouter(item, scope) {
  const { url, payload, target } = item;
  const router = useRouter();
  if (!item.handler) {
    item.handler = () => {
      const { pathname, query } = parseUrl(url, scope);
      if (target === "_blank") {
        const routerData = router.resolve({
          path: pathname,
          query: __spreadValues(__spreadValues({}, query), payload)
        });
        window.open(routerData.href, "_blank");
      } else {
        router.push({
          path: pathname,
          query: __spreadValues(__spreadValues({}, query), payload)
        });
      }
    };
  }
  return genTextBtn(item, scope);
}
function renderRequest(item, scope) {
  const $k18n = getK18n();
  const { url, method = "POST", label, successTxt, errorTxt, useConfirm, show, message, disabled, toolTip, payload, toolTipDisabled, showLoading: showLoading2, onlyUseSuccessText, popoverWidth } = item;
  const instance = getCurrentInstance();
  let loading = false;
  function onConfirm() {
    return __async(this, null, function* () {
      const { pathname, query } = parseUrl(url, scope);
      let httpUrl;
      switch (method) {
        case "GET":
          httpUrl = GET()`${pathname}`;
          break;
        case "FORM":
          httpUrl = Form()`${pathname}`;
          break;
        default:
          httpUrl = POST()`${pathname}`;
      }
      try {
        if (loading) {
          Message.info($k18n("\u63A5\u53E3\u8BF7\u6C42\u4E2D..."));
          return;
        }
        loading = true;
        if (showLoading2) {
          Message.info($k18n("\u6570\u636E\u8BF7\u6C42\u4E2D\uFF0C\u8BF7\u7A0D\u540E..."));
        }
        const res = yield http(httpUrl, __spreadValues(__spreadValues({}, query), payload));
        const { result, message: message2 } = res;
        const isSuccessText = (message2 == null ? void 0 : message2.toLowerCase()) === "success";
        let successResponse = result === 1 || isSuccessText;
        if (onlyUseSuccessText) {
          successResponse = isSuccessText;
        }
        if (successResponse) {
          Message.success({
            message: $k18n(successTxt || "\u64CD\u4F5C\u6210\u529F"),
            type: "success"
          });
          instance == null ? void 0 : instance.emit("reload");
        } else {
          Message.error({
            message: $k18n(errorTxt || message2 || "error"),
            type: "error"
          });
        }
      } finally {
        loading = false;
      }
    });
  }
  if (useConfirm) {
    if (show) {
      const btnConfirmFunc = !item.handler ? onConfirm : item.handler;
      return h(_sfc_main$1c, {
        label,
        message,
        row: scope.row,
        disabled,
        toolTip,
        popoverWidth,
        toolTipDisabled,
        onConfirm: btnConfirmFunc
      });
    }
    return "";
  }
  if (!item.handler) {
    item.handler = () => __async(this, null, function* () {
      onConfirm();
    });
  }
  return genTextBtn(item, scope);
}
function renderHref(item, scope) {
  const { url, target } = item;
  if (!item.handler) {
    item.handler = () => {
      window.open(scope.row[url] || `${parseValue(url, "row", scope)}`, target);
    };
  }
  return genTextBtn(item, scope);
}
function renderDialog(item, scope) {
  const instance = getCurrentInstance();
  if (!item.handler) {
    item.handler = () => {
      var _a;
      instance == null ? void 0 : instance.emit("show", item, scope || {});
      (_a = instance == null ? void 0 : instance.exposed) == null ? void 0 : _a.handleDrawerComponentShow(item, scope);
    };
  }
  return genTextBtn(item, scope);
}
function renderDefaultBtn(item, scope) {
  return h("span", {}, genTextBtn(item, scope));
}
const _sfc_main$1b = defineComponent({
  props: {
    operators: {
      type: Array,
      default: () => []
    }
  },
  emits: ["show"],
  setup(props) {
    function render2() {
      return (props.operators || []).map((item) => {
        const cloneItem = cloneDeep(item);
        cloneItem.props = __spreadValues({
          type: "primary",
          size: "small"
        }, cloneItem.props);
        return renderBuiltInBtn(cloneItem);
      });
    }
    return render2;
  }
});
const BatchIdText_vue_vue_type_style_index_0_scoped_true_lang = "";
const _hoisted_1$Q = { class: "batch-id-search-content" };
const _hoisted_2$x = ["placeholder"];
const _hoisted_3$o = { class: "batch-id-search-btn" };
const _hoisted_4$h = { class: "uids-cnt" };
const _sfc_main$1a = /* @__PURE__ */ defineComponent({
  __name: "BatchIdText",
  props: {
    inputVal: {
      type: [String, Array],
      default: ""
    },
    limit: {
      type: Number,
      default: 400
    },
    inputType: {
      type: String,
      default: "default"
    },
    reg: {
      type: Object,
      default: /[\s|,|\n|]/g
    },
    placeholder: {
      type: String,
      default: "\u6279\u91CF\u8F93\u5165ID\uFF0C\u4EE5\u82F1\u6587\u9017\u53F7\u6216\u7A7A\u683C\u6216\u6362\u884C\u7B26\u9694\u5F00"
    },
    format: {
      type: String,
      default: "string"
    }
  },
  emits: ["confirm", "cancel"],
  setup(__props, { emit: emit2 }) {
    const props = __props;
    const $k18n = getK18n();
    let userIdsStr = [];
    const state = reactive({
      textarea: "",
      inputCnt: 0,
      visible: false
    });
    const { inputVal } = toRefs(props);
    const regMap = {
      number: /\D/g
    };
    watch(
      () => inputVal.value,
      (curr) => {
        if (Array.isArray(curr)) {
          state.textarea = curr.join("\n");
        } else {
          state.textarea = curr;
        }
      },
      { immediate: true }
    );
    watch(
      () => state.textarea,
      (curr) => {
        let list;
        if (Array.isArray(curr)) {
          list = curr;
        } else {
          list = (curr || "").toString().split(regMap[props.inputType] || props.reg).filter((v) => v);
        }
        if (state.inputCnt > props.limit) {
          list = list.slice(0, props.limit);
          state.textarea = props.format === "array" ? list.join("\n") : list.join(",");
        }
        state.inputCnt = list.length;
        userIdsStr = list;
      },
      { immediate: true }
    );
    const onCancel = () => {
      state.textarea = inputVal.value;
      emit2("cancel");
    };
    const onConfirm = () => {
      let value2;
      switch (props.format) {
        case "array":
          value2 = userIdsStr;
          break;
        case "arrayNumber":
          value2 = userIdsStr.map((item) => +item);
          break;
        case "string":
        default:
          value2 = userIdsStr.join(",");
          break;
      }
      emit2("confirm", value2);
    };
    return (_ctx, _cache) => {
      const _component_k18n = resolveComponent("k18n");
      const _component_ks_button = resolveComponent("ks-button");
      return openBlock(), createElementBlock("div", _hoisted_1$Q, [
        withDirectives(createElementVNode("textarea", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => state.textarea = $event),
          type: "textarea",
          placeholder: unref($k18n)(__props.placeholder)
        }, null, 8, _hoisted_2$x), [
          [vModelText, state.textarea]
        ]),
        createElementVNode("div", _hoisted_3$o, [
          createVNode(_component_ks_button, { onClick: onCancel }, {
            default: withCtx(() => [
              createVNode(_component_k18n, null, {
                default: withCtx(() => [
                  createTextVNode("\u53D6\u6D88")
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          createVNode(_component_ks_button, {
            type: "primary",
            onClick: onConfirm
          }, {
            default: withCtx(() => [
              createVNode(_component_k18n, null, {
                default: withCtx(() => [
                  createTextVNode("\u786E\u8BA4")
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        createElementVNode("span", _hoisted_4$h, toDisplayString(state.inputCnt) + "/" + toDisplayString(__props.limit), 1)
      ]);
    };
  }
});
const BatchIdText = /* @__PURE__ */ _export_sfc(_sfc_main$1a, [["__scopeId", "data-v-b2c4ef42"]]);
var root = _root;
var now$1 = function() {
  return root.Date.now();
};
var now_1 = now$1;
var reWhitespace = /\s/;
function trimmedEndIndex$1(string) {
  var index2 = string.length;
  while (index2-- && reWhitespace.test(string.charAt(index2))) {
  }
  return index2;
}
var _trimmedEndIndex = trimmedEndIndex$1;
var trimmedEndIndex = _trimmedEndIndex;
var reTrimStart = /^\s+/;
function baseTrim$1(string) {
  return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, "") : string;
}
var _baseTrim = baseTrim$1;
var baseTrim = _baseTrim, isObject$2 = isObject_1, isSymbol = isSymbol_1;
var NAN = 0 / 0;
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
var reIsBinary = /^0b[01]+$/i;
var reIsOctal = /^0o[0-7]+$/i;
var freeParseInt = parseInt;
function toNumber$1(value2) {
  if (typeof value2 == "number") {
    return value2;
  }
  if (isSymbol(value2)) {
    return NAN;
  }
  if (isObject$2(value2)) {
    var other = typeof value2.valueOf == "function" ? value2.valueOf() : value2;
    value2 = isObject$2(other) ? other + "" : other;
  }
  if (typeof value2 != "string") {
    return value2 === 0 ? value2 : +value2;
  }
  value2 = baseTrim(value2);
  var isBinary = reIsBinary.test(value2);
  return isBinary || reIsOctal.test(value2) ? freeParseInt(value2.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value2) ? NAN : +value2;
}
var toNumber_1 = toNumber$1;
var isObject$1 = isObject_1, now = now_1, toNumber = toNumber_1;
var FUNC_ERROR_TEXT = "Expected a function";
var nativeMax = Math.max, nativeMin = Math.min;
function debounce$1(func, wait, options) {
  var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
  if (typeof func != "function") {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject$1(options)) {
    leading = !!options.leading;
    maxing = "maxWait" in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = "trailing" in options ? !!options.trailing : trailing;
  }
  function invokeFunc(time) {
    var args = lastArgs, thisArg = lastThis;
    lastArgs = lastThis = void 0;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }
  function leadingEdge(time) {
    lastInvokeTime = time;
    timerId = setTimeout(timerExpired, wait);
    return leading ? invokeFunc(time) : result;
  }
  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
    return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
  }
  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
    return lastCallTime === void 0 || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
  }
  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    timerId = setTimeout(timerExpired, remainingWait(time));
  }
  function trailingEdge(time) {
    timerId = void 0;
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = void 0;
    return result;
  }
  function cancel() {
    if (timerId !== void 0) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = void 0;
  }
  function flush() {
    return timerId === void 0 ? result : trailingEdge(now());
  }
  function debounced() {
    var time = now(), isInvoking = shouldInvoke(time);
    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;
    if (isInvoking) {
      if (timerId === void 0) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === void 0) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}
var debounce_1 = debounce$1;
const trans = (props) => {
  const { label, val, options } = props;
  if (options && Array.isArray(options) && options[0] && !options[0][label]) {
    return options.map((opItem) => {
      return {
        [label]: opItem,
        [val]: isNaN(Number(opItem)) ? opItem : Number(opItem)
      };
    });
  }
  if (Object.prototype.toString.call(options) === "[object Object]") {
    const optionsArr = [];
    for (const key in options) {
      optionsArr.push({
        label: options[key],
        value: isNaN(Number(key)) ? key : Number(key)
      });
    }
    return optionsArr;
  }
  return options;
};
const ProSelect_vue_vue_type_style_index_0_lang = "";
const _sfc_main$19 = defineComponent({
  name: "ProSelect",
  components: {
    KsSelect: Select,
    KsOption: Option
  },
  props: {
    isK18n: {
      type: Boolean,
      default: false
    },
    k18nDesc: {
      type: String,
      default: ""
    },
    options: {
      type: [Array, Object],
      default: () => []
    },
    modelValue: {
      type: [String, Number],
      default: () => ""
    },
    label: {
      type: String,
      default: "label"
    },
    transform: {
      type: String,
      default: ""
    },
    val: {
      type: String,
      default: "value"
    },
    request: {
      type: [Object, String],
      default: ""
    },
    selectAll: {
      type: Boolean,
      default: false
    },
    allMatchValue: {
      type: [Number, String],
      default: -1
    },
    defaultAll: {
      type: Boolean,
      default: false
    }
  },
  emits: ["update:modelValue", "change"],
  setup(props, ctx) {
    const k18n = getK18n();
    const selectRef = ref(null);
    const isSelectAll = ref(false);
    const optionsKeyLength = computed(() => {
      return transOptions.value.length;
    });
    const model = computed({
      get() {
        var _a, _b, _c;
        if (props.transform === "array" && !ctx.attrs.multiple) {
          return ((_a = props.modelValue) == null ? void 0 : _a[0]) || "";
        }
        if (props.selectAll && isSelectAll.value && ((_b = props.modelValue) == null ? void 0 : _b[0]) === props.allMatchValue) {
          return (_c = transOptions.value) == null ? void 0 : _c.map((item) => item[props.val]);
        }
        return props.modelValue;
      },
      set(val) {
        let result = val;
        if (props.transform === "array" && !Array.isArray(val)) {
          if (val === "" || val === void 0) {
            result = [];
          } else {
            result = [val];
          }
        }
        if (props.selectAll) {
          ctx.emit("update:modelValue", isSelectAll.value && val.length == optionsKeyLength.value ? [props.allMatchValue] : result);
        } else {
          ctx.emit("update:modelValue", result);
        }
        ctx.emit("change", result);
      }
    });
    const transOptions = ref(trans(props));
    if (!props.request) {
      watch(
        () => props.options,
        (newVal) => {
          transOptions.value = trans(props);
        }
      );
    }
    const checkDefaultAllValue = () => {
      var _a;
      if (props.selectAll && props.defaultAll) {
        model.value = (_a = transOptions.value) == null ? void 0 : _a.map((item) => item[props.val]);
      }
    };
    const remoteMethod = (query) => __async(this, null, function* () {
      if (!query)
        return;
      let url = props.request.url;
      if (query) {
        const queryKey = props.request.queryKey || "search";
        url = url.includes("?") ? `${url}&${queryKey}=${query}` : `${url}?${queryKey}=${query}`;
      }
      props.request.debounceTime ? debouncedQueryChange(url) : requestHandler(url);
    });
    const requestHandler = (url) => __async(this, null, function* () {
      var _a;
      const res = yield getRequest(__spreadProps(__spreadValues({}, props.request), { url }));
      const { data } = res;
      transOptions.value = trans({
        label: props.label,
        val: props.val,
        options: ((_a = props.request) == null ? void 0 : _a.mapkey) ? get$1(data, props.request.mapkey) : data
      });
    });
    const debouncedQueryChange = debounce_1((url) => {
      requestHandler(url);
    }, props.request.debounceTime);
    const bindProps = computed(() => {
      let defaultAttrs = {
        placeholder: k18n("\u8BF7\u9009\u62E9")
      };
      if (props.request) {
        if (Reflect.has(ctx.attrs, "remote")) {
          defaultAttrs = {
            filterable: true,
            remote: true,
            "remote-method": remoteMethod,
            "token-separators": '[",", "+"]',
            placeholder: k18n("\u8BF7\u8F93\u5165"),
            "no-data-text": k18n("\u65E0\u6570\u636E"),
            "loading-text": k18n("\u52A0\u8F7D\u4E2D")
          };
        } else {
          remoteMethod(true);
        }
      }
      return __spreadValues(__spreadValues({}, defaultAttrs), ctx.attrs);
    });
    const selectAllOption = () => {
      var _a;
      if (isSelectAll.value) {
        model.value = (_a = transOptions.value) == null ? void 0 : _a.map((item) => item[props.val]);
      } else {
        model.value.length = 0;
      }
    };
    const changeSelect = () => {
      if (props.selectAll) {
        const modelLength = computed(() => {
          return model.value;
        });
        isSelectAll.value = modelLength.value === optionsKeyLength.value;
      }
    };
    watch(
      () => props.modelValue,
      (newVal) => {
        if (props.selectAll && newVal.length === optionsKeyLength.value) {
          isSelectAll.value = true;
          selectAllOption();
        }
      },
      { immediate: true, deep: true }
    );
    checkDefaultAllValue();
    return {
      bindProps,
      model,
      optionsKeyLength,
      isSelectAll,
      transOptions,
      k18n,
      selectAllOption,
      changeSelect,
      checkDefaultAllValue,
      selectRef
    };
  }
});
const _hoisted_1$P = { class: "all-select" };
function _sfc_render$m(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ks_checkbox = resolveComponent("ks-checkbox");
  const _component_ks_option = resolveComponent("ks-option");
  const _component_ks_select = resolveComponent("ks-select");
  return openBlock(), createBlock(_component_ks_select, mergeProps({
    ref: "selectRef",
    modelValue: _ctx.model,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => _ctx.model = $event),
    class: "co_select",
    "popper-class": "co_select_popper"
  }, _ctx.bindProps, { onChange: _ctx.changeSelect }), createSlots({
    default: withCtx(() => [
      (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.transOptions, (item, v) => {
        return openBlock(), createBlock(_component_ks_option, {
          key: v,
          label: _ctx.isK18n ? _ctx.k18n({ desc: _ctx.k18nDesc, text: item[_ctx.label] }) : item[_ctx.label],
          value: item[_ctx.val],
          disabled: item.disabled
        }, {
          default: withCtx(() => [
            renderSlot$2(_ctx.$slots, "custom-option")
          ]),
          _: 2
        }, 1032, ["label", "value", "disabled"]);
      }), 128)),
      renderSlot$2(_ctx.$slots, "after-option")
    ]),
    _: 2
  }, [
    _ctx.selectAll ? {
      name: "menu-prefix",
      fn: withCtx(() => [
        createElementVNode("div", _hoisted_1$P, [
          createVNode(_component_ks_checkbox, {
            ref: "checkbox",
            modelValue: _ctx.isSelectAll,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.isSelectAll = $event),
            onChange: _ctx.selectAllOption
          }, {
            default: withCtx(() => [
              createTextVNode(toDisplayString(_ctx.k18n("\u5168\u9009")), 1)
            ]),
            _: 1
          }, 8, ["modelValue", "onChange"])
        ])
      ]),
      key: "0"
    } : void 0,
    renderList(_ctx.$slots, (slotVal, slotName) => {
      return {
        name: slotName,
        fn: withCtx(() => [
          renderSlot$2(_ctx.$slots, slotName)
        ])
      };
    })
  ]), 1040, ["modelValue", "onChange"]);
}
const ProSelect = /* @__PURE__ */ _export_sfc(_sfc_main$19, [["render", _sfc_render$m]]);
const BatchInput_vue_vue_type_style_index_0_scoped_true_lang = "";
const _sfc_main$18 = /* @__PURE__ */ defineComponent({
  __name: "BatchInput",
  props: {
    inputValue: {
      type: String,
      default: ""
    },
    selectValue: {
      type: String,
      default: ""
    },
    limit: {
      type: Number,
      default: 400
    },
    reg: {
      type: Object,
      default: /[\s|,|\n|]/g
    },
    inputType: {
      type: String,
      default: "default"
    },
    placeholder: {
      type: String,
      default: "\u6279\u91CF\u8F93\u5165ID\uFF0C\u4EE5\u82F1\u6587\u9017\u53F7\u6216\u7A7A\u683C\u6216\u6362\u884C\u7B26\u9694\u5F00"
    },
    inputPlaceholder: {
      type: String,
      default: "\u8BF7\u8F93\u5165\u5185\u5BB9"
    },
    enumerate: {
      type: Array
    },
    optionLabel: {
      type: String,
      default: "label"
    },
    optionVal: {
      type: String,
      default: "value"
    },
    format: {
      type: String,
      default: "string"
    }
  },
  emits: ["update:inputValue", "update:selectValue", "change"],
  setup(__props, { emit: emits }) {
    const props = __props;
    const $k18n = getK18n();
    const inputModel = computed({
      get() {
        return Array.isArray(props.inputValue) ? props.inputValue.join(",") : props.inputValue;
      },
      set(val) {
        let arrValue = [];
        let strValue = "";
        if (Array.isArray(val)) {
          arrValue = val;
          strValue = val.join(",");
        } else {
          arrValue = val.split(",");
          strValue = val;
        }
        let value2;
        switch (props.format) {
          case "array":
            value2 = arrValue;
            break;
          case "arrayNumber":
            value2 = arrValue.map((item) => +item);
            break;
          case "string":
          default:
            value2 = strValue;
            break;
        }
        emits("update:inputValue", value2);
        emits("change", value2);
      }
    });
    const selectModel = computed({
      get() {
        return props.selectValue;
      },
      set(val) {
        if (val !== "") {
          emits("update:selectValue", val);
          emits("change", val);
        }
      }
    });
    const visible = ref(false);
    const onConfirm = (val) => {
      emits("update:inputValue", val);
      emits("change", val);
      visible.value = false;
    };
    const onCancel = () => {
      visible.value = false;
    };
    return (_ctx, _cache) => {
      const _component_ks_input = resolveComponent("ks-input");
      const _component_ks_popover = resolveComponent("ks-popover");
      return openBlock(), createBlock(_component_ks_popover, {
        visible: visible.value,
        "onUpdate:visible": _cache[2] || (_cache[2] = ($event) => visible.value = $event),
        placement: "bottom",
        width: 310,
        trigger: "click",
        "show-arrow": false,
        class: "batch-id-search"
      }, {
        reference: withCtx(() => [
          createVNode(_component_ks_input, {
            modelValue: unref(inputModel),
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => isRef(inputModel) ? inputModel.value = $event : null),
            placeholder: unref($k18n)(__props.inputPlaceholder),
            class: "input-with-select"
          }, createSlots({ _: 2 }, [
            __props.enumerate ? {
              name: "prepend",
              fn: withCtx(() => [
                createVNode(ProSelect, {
                  modelValue: unref(selectModel),
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => isRef(selectModel) ? selectModel.value = $event : null),
                  label: __props.optionLabel,
                  val: __props.optionVal,
                  options: __props.enumerate,
                  clearable: ""
                }, null, 8, ["modelValue", "label", "val", "options"])
              ]),
              key: "0"
            } : void 0
          ]), 1032, ["modelValue", "placeholder"])
        ]),
        default: withCtx(() => [
          createVNode(BatchIdText, {
            "input-val": __props.inputValue,
            limit: __props.limit,
            reg: __props.reg,
            format: __props.format,
            "input-type": __props.inputType,
            placeholder: unref($k18n)(__props.placeholder),
            clearable: "",
            onConfirm,
            onCancel
          }, null, 8, ["input-val", "limit", "reg", "format", "input-type", "placeholder"])
        ]),
        _: 1
      }, 8, ["visible"]);
    };
  }
});
const BatchInput = /* @__PURE__ */ _export_sfc(_sfc_main$18, [["__scopeId", "data-v-4e427263"]]);
const ProBatchId_vue_vue_type_style_index_0_scoped_true_lang = "";
const _hoisted_1$O = { class: "batch-id-search-content" };
const _hoisted_2$w = { class: "uids-cnt" };
const _sfc_main$17 = /* @__PURE__ */ defineComponent({
  __name: "ProBatchId",
  props: {
    modelValue: {
      type: [String, Array],
      default: ""
    },
    limit: {
      type: Number,
      default: 400
    },
    inputType: {
      type: String,
      default: "default"
    },
    reg: {
      type: Object,
      default: /[\s|,|\n|]/g
    },
    placeholder: {
      type: String,
      default: "\u6279\u91CF\u8F93\u5165ID\uFF0C\u4EE5\u82F1\u6587\u9017\u53F7\u6216\u7A7A\u683C\u6216\u6362\u884C\u7B26\u9694\u5F00"
    },
    transform: {
      type: String,
      default: "default"
    }
  },
  emits: ["update:modelValue"],
  setup(__props, { emit: emits }) {
    const props = __props;
    const $k18n = getK18n();
    let userIdsStr = [];
    const state = reactive({
      textarea: "",
      inputCnt: 0,
      visible: false
    });
    const { modelValue: modelValue2 } = toRefs(props);
    const regMap = { number: /\D/g };
    watch(
      () => modelValue2.value,
      (curr) => {
        if (Array.isArray(curr)) {
          state.textarea = curr.join("\n");
        } else {
          state.textarea = curr;
        }
      },
      { immediate: true }
    );
    watch(
      () => state.textarea,
      (curr) => {
        let list;
        if (Array.isArray(curr)) {
          list = curr;
        } else {
          list = (curr || "").split(regMap[props.inputType] || props.reg).filter((v) => v);
        }
        if (state.inputCnt > props.limit) {
          list = list.slice(0, props.limit);
        }
        state.inputCnt = list.length;
        userIdsStr = list;
      },
      { immediate: true }
    );
    const onBlur = () => {
      emits("update:modelValue", props.transform === "array" ? userIdsStr : userIdsStr.join(","));
    };
    return (_ctx, _cache) => {
      const _component_ks_input = resolveComponent("ks-input");
      return openBlock(), createElementBlock("div", _hoisted_1$O, [
        createVNode(_component_ks_input, mergeProps({
          modelValue: state.textarea,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => state.textarea = $event),
          rows: 3,
          type: "textarea",
          placeholder: unref($k18n)(__props.placeholder)
        }, _ctx.$attrs, { onBlur }), null, 16, ["modelValue", "placeholder"]),
        createElementVNode("span", _hoisted_2$w, toDisplayString(state.inputCnt) + "/" + toDisplayString(__props.limit), 1)
      ]);
    };
  }
});
const ProBatchId = /* @__PURE__ */ _export_sfc(_sfc_main$17, [["__scopeId", "data-v-a5516546"]]);
const ProCascader_vue_vue_type_style_index_0_lang = "";
const _sfc_main$16 = defineComponent({
  name: "ProCascader",
  components: {
    KsCascader: Cascader$1
  },
  props: {
    modelValue: {
      type: [String, Array, Number, Boolean],
      default: ""
    },
    hideRadio: {
      type: Boolean,
      default: false
    },
    hideSelectMenu: {
      type: Boolean,
      default: false
    },
    options: {
      type: Array,
      default: () => []
    },
    setNull: {
      type: Boolean,
      default: false
    },
    emitLabel: {
      type: Boolean,
      default: false
    }
  },
  emits: ["update:modelValue", "change", "visible-change"],
  setup(props, ctx) {
    const cascaderRef = ref(null);
    const valToLabelMap = reactive({});
    const LabelToValueMap = reactive({});
    const state = reactive({
      coCascaderPopper: null,
      transformOptions: []
    });
    const model = computed({
      get() {
        if (props.emitLabel) {
          if (Array.isArray(props.modelValue)) {
            return props.modelValue.map((key) => LabelToValueMap[key]);
          }
          return LabelToValueMap[props.modelValue];
        }
        return props.modelValue;
      },
      set(val) {
        let resultValue = val;
        if (props.emitLabel) {
          if (Array.isArray(val)) {
            resultValue = val.map((key) => valToLabelMap[key]);
          } else {
            resultValue = valToLabelMap[val];
          }
        }
        ctx.emit("update:modelValue", resultValue);
        if (resultValue && resultValue.length === 0) {
          ctx.emit("change", resultValue);
        }
      }
    });
    const bindProps = computed(() => {
      const result = __spreadValues({ label: "label", value: "value", children: "children" }, ctx.attrs.props || {});
      return __spreadProps(__spreadValues({
        "collapse-tags": true,
        "popper-class": "co_cascader_popper"
      }, ctx.attrs), {
        props: result
      });
    });
    function handleClickItemLabel(node, data) {
      const { props: componentProps } = ctx.attrs;
      if (componentProps.multiple)
        return;
      const { emitPath, value: value2 = "value", checkStrictly } = componentProps;
      if (!checkStrictly && !node.isLeaf) {
        return;
      }
      if (props.hideSelectMenu) {
        cascaderRef.value.popperVisible = false;
      }
      let emitValue = node.pathValues;
      if (!emitPath) {
        emitValue = data[value2];
      }
      ctx.emit("update:modelValue", emitValue);
      ctx.emit("change", emitValue);
      ctx.emit("visible-change", false);
    }
    onMounted(() => {
      const coCascaderPopper = document.querySelectorAll(`.${bindProps.value["popper-class"]} .ks-cascader-panel`);
      if (props.hideRadio && coCascaderPopper.length) {
        coCascaderPopper.forEach((element) => {
          element.classList.add("co_cascader_popper_hide_radio");
        });
      }
    });
    function transformOptions(list) {
      const result = [];
      if (list.length === 0) {
        return null;
      }
      for (let i = 0; i < list.length; i++) {
        const item = list[i];
        const { props: componentProps } = bindProps.value;
        const labelKey = componentProps.label;
        const valueKey = componentProps.value;
        const childKey = componentProps.children;
        valToLabelMap[item[valueKey]] = item[labelKey];
        LabelToValueMap[item[labelKey]] = item[valueKey];
        result.push({
          [labelKey]: item[labelKey],
          [valueKey]: item[valueKey],
          [childKey]: item[childKey] ? transformOptions(item[childKey]) : null
        });
      }
      return result;
    }
    function handleChange() {
      ctx.emit("change");
    }
    watch(
      () => props.options,
      (val) => {
        if (props.setNull) {
          state.transformOptions = transformOptions(val) || [];
        } else {
          state.transformOptions = val;
        }
      },
      { immediate: true, deep: true }
    );
    return __spreadProps(__spreadValues({}, toRefs(state)), {
      cascaderRef,
      bindProps,
      model,
      handleClickItemLabel,
      handleChange
    });
  }
});
const _hoisted_1$N = ["onClick"];
function _sfc_render$l(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ks_cascader = resolveComponent("ks-cascader");
  return openBlock(), createBlock(_component_ks_cascader, mergeProps({
    ref: "cascaderRef",
    modelValue: _ctx.model,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.model = $event),
    class: "co_cascader",
    options: _ctx.transformOptions
  }, _ctx.bindProps, { onChange: _ctx.handleChange }), {
    default: withCtx(({ node, data }) => [
      _ctx.hideRadio ? (openBlock(), createElementBlock("span", {
        key: 0,
        class: "label",
        onClick: ($event) => _ctx.handleClickItemLabel(node, data)
      }, toDisplayString(data[_ctx.bindProps.props.label] ? data[_ctx.bindProps.props.label] : data.name), 9, _hoisted_1$N)) : renderSlot$2(_ctx.$slots, "default", {
        key: 1,
        node,
        data,
        onClick: ($event) => _ctx.handleClickItemLabel(node, data)
      }, () => [
        createTextVNode(toDisplayString(data[_ctx.$attrs.props.label || "label"]), 1)
      ])
    ]),
    _: 3
  }, 16, ["modelValue", "options", "onChange"]);
}
const Cascader = /* @__PURE__ */ _export_sfc(_sfc_main$16, [["render", _sfc_render$l]]);
const ProTooltip_vue_vue_type_style_index_0_scoped_true_lang = "";
const _sfc_main$15 = defineComponent({
  name: "ProTooltip",
  components: {
    IconGeneralQuestion
  },
  props: {
    lineClamp: {
      type: [Number, String],
      default: void 0
    },
    content: {
      type: [Number, String],
      default: ""
    },
    maxWidth: {
      type: String,
      default: "155px"
    },
    contentWidth: {
      type: String,
      default: "250px"
    },
    iconfont: {
      type: String,
      default: "sys-icon-question"
    },
    len: {
      type: Number,
      default: 0
    },
    size: {
      type: [String, Number],
      default: ""
    },
    color: {
      type: [String, Number],
      default: ""
    },
    clickCopyContent: {
      type: Boolean,
      default: false
    }
  },
  setup(props, { attrs, slots }) {
    const state = reactive({
      disabled: true
    });
    const defaultWrapperRef = ref(null);
    const contentStyle = computed(() => {
      return {
        "max-width": `${props.contentWidth}` || "auto"
      };
    });
    const isSingleText = computed(() => {
      return props.lineClamp === 1;
    });
    onMounted(() => {
      setDisabled();
      watch(
        () => props.content,
        () => {
          setDisabled();
        }
      );
    });
    const lineClampStyle = computed(() => {
      const styleObj = {
        "-webkit-line-clamp": props.lineClamp
      };
      if (props.clickCopyContent) {
        styleObj.cursor = "pointer";
      }
      return styleObj;
    });
    const lineClampClass = computed(() => {
      return isSingleText.value ? "single_text" : "multiline_text";
    });
    function setDisabled() {
      const { len, content, lineClamp } = props;
      if (typeof attrs.disabled === "boolean") {
        state.disabled = attrs.disabled;
        return;
      }
      if (!lineClamp) {
        state.disabled = false;
        return;
      }
      if (!content && !slots.default || attrs.disabled) {
        state.disabled = true;
        return;
      }
      if (len > 0) {
        state.disabled = `${content}`.length <= len;
        return;
      }
      if (isSingleText.value) {
        nextTick(() => {
          if (!(defaultWrapperRef == null ? void 0 : defaultWrapperRef.value)) {
            return true;
          }
          const refValue = (defaultWrapperRef == null ? void 0 : defaultWrapperRef.value) || {};
          state.disabled = refValue.scrollWidth <= parseFloat(props.maxWidth);
        });
        return;
      }
      state.disabled = true;
    }
    function handleClickContent() {
      if (props.clickCopyContent) {
        copyData("", `${props.content}`);
      }
    }
    return {
      state,
      contentStyle,
      lineClampStyle,
      setDisabled,
      lineClampClass,
      defaultWrapperRef,
      isSingleText,
      handleClickContent
    };
  }
});
const _hoisted_1$M = { key: 1 };
function _sfc_render$k(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_IconGeneralQuestion = resolveComponent("IconGeneralQuestion");
  const _component_ks_tooltip = resolveComponent("ks-tooltip");
  return openBlock(), createBlock(_component_ks_tooltip, mergeProps({
    style: { maxWidth: _ctx.maxWidth }
  }, _ctx.$attrs, {
    disabled: _ctx.state.disabled
  }), {
    content: withCtx(() => [
      createElementVNode("div", {
        style: normalizeStyle(_ctx.contentStyle)
      }, [
        renderSlot$2(_ctx.$slots, "content", {}, () => [
          createElementVNode("div", null, toDisplayString(_ctx.content), 1)
        ], true)
      ], 4)
    ]),
    default: withCtx(() => [
      _ctx.lineClamp ? (openBlock(), createElementBlock("span", {
        key: 0,
        ref: "defaultWrapperRef",
        class: normalizeClass(["line_clamp_default__wrapper", _ctx.lineClampClass]),
        style: normalizeStyle(_ctx.lineClampStyle),
        onClick: _cache[0] || (_cache[0] = (...args) => _ctx.handleClickContent && _ctx.handleClickContent(...args))
      }, [
        renderSlot$2(_ctx.$slots, "default", {}, () => [
          createTextVNode(toDisplayString(_ctx.content), 1)
        ], true)
      ], 6)) : (openBlock(), createElementBlock("span", _hoisted_1$M, [
        renderSlot$2(_ctx.$slots, "default", {}, () => [
          createVNode(_component_IconGeneralQuestion, {
            size: _ctx.size,
            color: _ctx.color
          }, null, 8, ["size", "color"])
        ], true)
      ]))
    ]),
    _: 3
  }, 16, ["style", "disabled"]);
}
const ProTooltip = /* @__PURE__ */ _export_sfc(_sfc_main$15, [["render", _sfc_render$k], ["__scopeId", "data-v-05cde0da"]]);
const _sfc_main$14 = defineComponent({
  name: "ProCheckbox",
  components: {
    KsCheckboxGroup: CheckboxGroup,
    KsCheckbox: Checkbox$1,
    ProTooltip
  },
  props: {
    isK18n: {
      type: Boolean,
      default: false
    },
    k18nDesc: {
      type: String,
      default: ""
    },
    options: {
      type: Array,
      default: () => []
    },
    label: {
      type: String,
      default: "label"
    },
    val: {
      type: String,
      default: "value"
    },
    modelValue: {
      type: [Array, Boolean],
      default: false
    },
    tooltips: {
      type: Array,
      default: () => []
    },
    content: {
      type: String
    }
  },
  emits: ["update:modelValue", "change"],
  setup(props, ctx) {
    const k18n = getK18n();
    const isSingleCheckBox = computed(() => Array.isArray(props.options) && !props.options.length);
    const model = computed({
      get() {
        return isSingleCheckBox.value ? props.modelValue || false : props.modelValue || [];
      },
      set(val) {
        ctx.emit("update:modelValue", val);
        ctx.emit("change", val);
      }
    });
    const transOptions = computed(() => {
      const { label, val, options } = props;
      if (Object.prototype.toString.call(options) === "[object Object]") {
        const optionsArr = [];
        for (const key in options) {
          optionsArr.push({
            label: options[key],
            value: key
          });
        }
        return optionsArr;
      }
      return options;
    });
    return {
      model,
      transOptions,
      isSingleCheckBox,
      k18n
    };
  }
});
function _sfc_render$j(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ProTooltip = resolveComponent("ProTooltip");
  const _component_ks_checkbox = resolveComponent("ks-checkbox");
  const _component_ks_checkbox_group = resolveComponent("ks-checkbox-group");
  return _ctx.isSingleCheckBox ? (openBlock(), createBlock(_component_ks_checkbox, mergeProps({
    key: 0,
    modelValue: _ctx.model,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.model = $event)
  }, _ctx.$attrs), {
    default: withCtx(() => {
      var _a, _b;
      return [
        createTextVNode(toDisplayString(_ctx.isK18n ? _ctx.k18n({ desc: _ctx.k18nDesc, text: _ctx.content }) : _ctx.content) + " ", 1),
        ((_a = _ctx.tooltips) == null ? void 0 : _a[0]) ? (openBlock(), createBlock(_component_ProTooltip, {
          key: 0,
          content: _ctx.k18n((_b = _ctx.tooltips) == null ? void 0 : _b[0])
        }, null, 8, ["content"])) : createCommentVNode("", true)
      ];
    }),
    _: 1
  }, 16, ["modelValue"])) : (openBlock(), createBlock(_component_ks_checkbox_group, mergeProps({
    key: 1,
    modelValue: _ctx.model,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => _ctx.model = $event)
  }, _ctx.$attrs), {
    default: withCtx(() => [
      (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.transOptions, (item, v) => {
        return openBlock(), createBlock(_component_ks_checkbox, {
          key: item[_ctx.val] || v,
          label: item[_ctx.val],
          disabled: item.disabled
        }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString(_ctx.isK18n ? _ctx.k18n({ desc: _ctx.k18nDesc, text: item[_ctx.label] }) : item[_ctx.label]) + " ", 1),
            _ctx.tooltips[v] || item.tooltip ? (openBlock(), createBlock(_component_ProTooltip, {
              key: 0,
              content: _ctx.k18n(_ctx.tooltips[v] || item.tooltip)
            }, null, 8, ["content"])) : createCommentVNode("", true)
          ]),
          _: 2
        }, 1032, ["label", "disabled"]);
      }), 128))
    ]),
    _: 1
  }, 16, ["modelValue"]));
}
const Checkbox = /* @__PURE__ */ _export_sfc(_sfc_main$14, [["render", _sfc_render$j]]);
function mitt$1(n) {
  return { all: n = n || /* @__PURE__ */ new Map(), on: function(t, e) {
    var i = n.get(t);
    i && i.push(e) || n.set(t, [e]);
  }, off: function(t, e) {
    var i = n.get(t);
    i && i.splice(i.indexOf(e) >>> 0, 1);
  }, emit: function(t, e) {
    (n.get(t) || []).slice().map(function(n2) {
      n2(e);
    }), (n.get("*") || []).slice().map(function(n2) {
      n2(t, e);
    });
  } };
}
const elFormKey = "elForm";
const elFormItemKey = "elFormItem";
const elFormEvents = {
  addField: "el.form.addField",
  removeField: "el.form.removeField",
  formBlur: "el.form.blur",
  formChange: "el.form.change"
};
function useFormLabelWidth() {
  const potentialLabelWidthArr = ref([]);
  const autoLabelWidth = computed(() => {
    if (!potentialLabelWidthArr.value.length)
      return "0";
    const max2 = Math.max(...potentialLabelWidthArr.value);
    return max2 ? `${max2}px` : "";
  });
  function getLabelWidthIndex(width) {
    const index2 = potentialLabelWidthArr.value.indexOf(width);
    if (index2 === -1) {
      console.warn("[Element Warn][ElementForm]unexpected width " + width);
    }
    return index2;
  }
  function registerLabelWidth(val, oldVal) {
    if (val && oldVal) {
      const index2 = getLabelWidthIndex(oldVal);
      potentialLabelWidthArr.value.splice(index2, 1, val);
    } else if (val) {
      potentialLabelWidthArr.value.push(val);
    }
  }
  function deregisterLabelWidth(val) {
    const index2 = getLabelWidthIndex(val);
    index2 > -1 && potentialLabelWidthArr.value.splice(index2, 1);
  }
  return {
    autoLabelWidth,
    registerLabelWidth,
    deregisterLabelWidth
  };
}
var script = defineComponent({
  name: "ks-form",
  componentName: "ks-form",
  props: {
    model: Object,
    rules: Object,
    labelPosition: String,
    labelWidth: String,
    labelSuffix: {
      type: String,
      default: ""
    },
    inline: Boolean,
    inlineMessage: Boolean,
    statusIcon: Boolean,
    showMessage: {
      type: Boolean,
      default: true
    },
    size: String,
    disabled: Boolean,
    validateOnRuleChange: {
      type: Boolean,
      default: true
    },
    hideRequiredAsterisk: {
      type: Boolean,
      default: false
    }
  },
  emits: ["validate"],
  setup(props, { emit: emit2 }) {
    const formMitt = mitt$1();
    const fields = [];
    watch(() => props.rules, () => {
      fields.forEach((field) => {
        field.removeValidateEvents();
        field.addValidateEvents();
      });
      if (props.validateOnRuleChange) {
        validate(() => ({}));
      }
    });
    formMitt.on(elFormEvents.addField, (field) => {
      if (field) {
        fields.push(field);
      }
    });
    formMitt.on(elFormEvents.removeField, (field) => {
      if (field.prop) {
        fields.splice(fields.indexOf(field), 1);
      }
    });
    const resetFields = () => {
      if (!props.model) {
        console.warn("[Element Warn][Form]model is required for resetFields to work.");
        return;
      }
      fields.forEach((field) => {
        field.resetField();
      });
    };
    const clearValidate = (props2 = []) => {
      const fds = props2.length ? typeof props2 === "string" ? fields.filter((field) => props2 === field.prop) : fields.filter((field) => props2.indexOf(field.prop) > -1) : fields;
      fds.forEach((field) => {
        field.clearValidate();
      });
    };
    const validate = (callback) => {
      if (!props.model) {
        console.warn("[Element Warn][Form]model is required for validate to work!");
        return;
      }
      let promise;
      if (typeof callback !== "function") {
        promise = new Promise((resolve2, reject) => {
          callback = function(valid2, invalidFields2) {
            if (valid2) {
              resolve2(true);
            } else {
              reject(invalidFields2);
            }
          };
        });
      }
      if (fields.length === 0) {
        callback(true);
      }
      let valid = true;
      let count = 0;
      let invalidFields = {};
      for (const field of fields) {
        field.validate("", (message, field2) => {
          if (message) {
            valid = false;
          }
          invalidFields = Object.assign(Object.assign({}, invalidFields), field2);
          if (++count === fields.length) {
            callback(valid, invalidFields);
          }
        });
      }
      return promise;
    };
    const validateField = (props2, cb) => {
      props2 = [].concat(props2);
      const fds = fields.filter((field) => props2.indexOf(field.prop) !== -1);
      if (!fields.length) {
        console.warn("[Element Warn]please pass correct props!");
        return;
      }
      fds.forEach((field) => {
        field.validate("", cb);
      });
    };
    const elForm = reactive(Object.assign(Object.assign(Object.assign({ formMitt }, toRefs(props)), {
      resetFields,
      clearValidate,
      validateField,
      emit: emit2
    }), useFormLabelWidth()));
    provide(elFormKey, elForm);
    return {
      validate,
      resetFields,
      clearValidate,
      validateField
    };
  }
});
function render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createBlock("form", {
    class: ["ks-form", [
      _ctx.labelPosition ? "ks-form--label-" + _ctx.labelPosition : "",
      { "ks-form--inline": _ctx.inline },
      { "is-rules": _ctx.rules }
    ]]
  }, [
    renderSlot$2(_ctx.$slots, "default")
  ], 2);
}
script.render = render;
script.__file = "packages/form/src/form.vue";
script.install = (app) => {
  app.component(script.name, script);
};
const ProInput_vue_vue_type_style_index_0_scoped_true_lang = "";
const _sfc_main$13 = /* @__PURE__ */ defineComponent({
  __name: "ProInput",
  props: {
    modelValue: {
      type: [String, Array, Number],
      default: ""
    },
    transform: {
      type: String,
      default: "default"
    },
    suffixType: {
      type: String,
      default: ""
    }
  },
  emits: ["update:modelValue", "change", "focus", "suffix-click", "blur", "clear"],
  setup(__props, { expose, emit: emits }) {
    const props = __props;
    const attrs = useAttrs();
    const TYPE_TRANSFORM_METHODS = {
      number: {
        get(value2) {
          return value2;
        },
        output(value2) {
          const trimValue = value2.trim();
          if (trimValue.indexOf("0") === 0) {
            return 0;
          }
          return trimValue.replace(/\D/g, "");
        }
      },
      float: {
        get(value2) {
          return value2;
        },
        output(value2) {
          const trimValue = value2.trim();
          if (trimValue.indexOf("0") === 0) {
            return 0;
          }
          return trimValue.replace(/[^\d+.?]/g, "");
        }
      },
      comma: {
        get(value2) {
          return value2;
        },
        output(value2) {
          return value2.trim().replace(/，/g, ",");
        }
      },
      array: {
        get(value2) {
          if (Array.isArray(value2)) {
            return value2.join();
          }
          return value2;
        },
        output(value2) {
          if (!value2) {
            return [];
          }
          return value2.trim().split(/,|，/);
        }
      },
      lineBreak: {
        get(value2) {
          return value2;
        },
        output(value2) {
          const pasteValue = state.uidPasteValue.replace(/\r+\n*|\n+/g, " ").replace(/(^\s*)|(\s*$)/g, "");
          const commaValue = state.uidPasteValue.replace(/\r+\n*|\n+/g, ",");
          return value2.replace(pasteValue, commaValue).replace(/\s*,\s*/g, ",");
        }
      },
      trim: {
        get(value2) {
          return value2;
        },
        output(value2) {
          return value2.trim();
        }
      }
    };
    const inputRef = ref();
    const state = reactive({
      uidPasteValue: ""
    });
    const transformMethod = computed(() => {
      return TYPE_TRANSFORM_METHODS[props.transform];
    });
    const model = computed({
      get() {
        const { modelValue: modelValue2 } = props;
        if (transformMethod.value) {
          return transformMethod.value.get(modelValue2);
        }
        return modelValue2;
      },
      set(val) {
        let result = val;
        if (transformMethod.value) {
          result = transformMethod.value.output(val);
        }
        emits("update:modelValue", result);
        emits("change", result);
      }
    });
    const inputClass = computed(() => {
      const { suffixType } = props;
      if (props.suffixType) {
        return `suffix_${suffixType}`;
      }
      return "";
    });
    const bindProps = computed(() => {
      return __spreadValues({
        clearable: true
      }, attrs);
    });
    const focus = () => {
      inputRef.value.focus();
    };
    const blur = () => {
      inputRef.value.blur();
    };
    const handleFocus = () => {
      emits("focus");
    };
    const handleClickSuffix = () => {
      emits("suffix-click");
    };
    const handleBlur = () => {
      emits("blur");
    };
    const getPasteValue = (e) => {
      {
        const clipboardData = e.clipboardData;
        state.uidPasteValue = clipboardData.getData("text");
      }
    };
    expose({
      focus,
      blur
    });
    return (_ctx, _cache) => {
      const _component_ks_input = resolveComponent("ks-input");
      return openBlock(), createBlock(_component_ks_input, mergeProps({
        ref_key: "inputRef",
        ref: inputRef,
        modelValue: unref(model),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => isRef(model) ? model.value = $event : null)
      }, unref(bindProps), {
        class: unref(inputClass),
        onPaste: getPasteValue,
        onBlur: handleBlur,
        onClear: _cache[1] || (_cache[1] = ($event) => _ctx.$emit("clear")),
        onFocus: handleFocus
      }), createSlots({
        suffix: withCtx(() => [
          renderSlot$2(_ctx.$slots, "suffix", {}, () => [
            __props.suffixType && __props.suffixType.search ? (openBlock(), createElementBlock("i", {
              key: 0,
              class: "ks-icon-search search-icon",
              onClick: handleClickSuffix
            })) : createCommentVNode("", true)
          ], true)
        ]),
        _: 2
      }, [
        _ctx.$slots.prepend ? {
          name: "prepend",
          fn: withCtx(() => [
            renderSlot$2(_ctx.$slots, "prepend", {}, void 0, true)
          ]),
          key: "0"
        } : void 0,
        _ctx.$slots.append ? {
          name: "append",
          fn: withCtx(() => [
            renderSlot$2(_ctx.$slots, "append", {}, void 0, true)
          ]),
          key: "1"
        } : void 0
      ]), 1040, ["modelValue", "class"]);
    };
  }
});
const ProInput = /* @__PURE__ */ _export_sfc(_sfc_main$13, [["__scopeId", "data-v-1ecd7278"]]);
function isEmpty(val) {
  return val === void 0 || val === "undefined" || val === null || !val.toString().length;
}
const DEV = process.env.NODE_ENV === "development" || process.env.NODE_ENV === "dev";
const isObject = (obj) => {
  return Object.prototype.toString.call(obj) === "[object Object]";
};
function isExpression(func) {
  if (typeof func !== "string")
    return false;
  const pattern = /^{{(.+)}}$/;
  const reg1 = /^{{function\(.+}}$/;
  if (typeof func === "string" && func.match(pattern) && !func.match(reg1)) {
    return true;
  }
  return false;
}
const ProCheckboxInput_vue_vue_type_style_index_0_lang = "";
const _sfc_main$12 = defineComponent({
  name: "ProCheckbox",
  components: {
    KsCheckboxGroup: CheckboxGroup,
    KsCheckbox: Checkbox$1,
    ProInput,
    ProTooltip
  },
  props: {
    isK18n: {
      type: Boolean,
      default: false
    },
    k18nDesc: {
      type: String,
      default: ""
    },
    options: {
      type: Array,
      default: () => []
    },
    label: {
      type: String,
      default: "label"
    },
    val: {
      type: String,
      default: "value"
    },
    modelValue: {
      type: Object,
      default: () => {
      }
    },
    widget: {
      type: String,
      default: "checkbox"
    },
    validateEvent: {
      type: Boolean,
      default: true
    },
    tooltips: {
      type: Array,
      default: () => []
    }
  },
  setup(props, ctx) {
    const k18n = getK18n();
    const elFormItem = inject(elFormItemKey, {});
    const type = computed(() => props.widget === "radio" ? "checkValue" : "checked");
    const model = computed({
      get() {
        if (isEmpty(props.modelValue) || JSON.stringify(props.modelValue) === "{}") {
          console.error("\u8BF7\u68C0\u67E5v-module\u4F20\u5165\u7684\u503C\uFF0C \u9700\u8981\u4F20\u5165\u4E00\u4E2A\u5BF9\u50CF");
        }
        return props.modelValue;
      },
      set(val) {
        var _a;
        ctx.emit("update:modelValue", val);
        ctx.emit("change", val);
        if (props.validateEvent) {
          (_a = elFormItem.formItemMitt) == null ? void 0 : _a.emit(elFormEvents.formChange, val);
        }
      }
    });
    const onChange = (val, item) => {
      var _a;
      if (props.widget === "radio") {
        Object.keys(model.value).forEach((key) => {
          if (key === item.key) {
            model.value[key].checked = true;
          } else {
            model.value[key].checked = false;
            model.value[key].checkValue = -1;
          }
        });
        ctx.emit("change", model);
        if (props.validateEvent) {
          (_a = elFormItem.formItemMitt) == null ? void 0 : _a.emit(elFormEvents.formChange, model);
        }
      }
    };
    const WIDGETDEFAULTPROPS = {
      style: { width: "100px", "margin-left": "4px" }
    };
    const getWidgetProps = (widget) => {
      const _a = widget, { type: type2, disabled } = _a, attrs = __objRest(_a, ["type", "disabled"]);
      return __spreadValues(__spreadValues({}, WIDGETDEFAULTPROPS), attrs);
    };
    return {
      model,
      type,
      getWidgetProps,
      onChange,
      k18n
    };
  }
});
const _hoisted_1$L = { class: "checkbox-input" };
function _sfc_render$i(_ctx, _cache) {
  const _component_ProTooltip = resolveComponent("ProTooltip");
  return openBlock(), createElementBlock("div", null, [
    (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.options, (item, v) => {
      return openBlock(), createElementBlock("span", _hoisted_1$L, [
        (openBlock(), createBlock(resolveDynamicComponent("ks-" + _ctx.widget), {
          key: item[_ctx.val] || v,
          modelValue: _ctx.model[item.key][_ctx.type],
          "onUpdate:modelValue": ($event) => _ctx.model[item.key][_ctx.type] = $event,
          label: item[_ctx.val],
          disabled: item.disabled || _ctx.$attrs.disabled,
          onChange: ($event) => _ctx.onChange($event, item)
        }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString(_ctx.isK18n ? _ctx.$k18n({ desc: _ctx.k18nDesc, text: item[_ctx.label] }) : item[_ctx.label]) + " ", 1),
            _ctx.tooltips[v] || item.tooltip ? (openBlock(), createBlock(_component_ProTooltip, {
              key: 0,
              content: _ctx.k18n(_ctx.tooltips[v] || item.tooltip)
            }, null, 8, ["content"])) : createCommentVNode("", true)
          ]),
          _: 2
        }, 1064, ["modelValue", "onUpdate:modelValue", "label", "disabled", "onChange"])),
        item.widget ? (openBlock(), createBlock(resolveDynamicComponent(item.widget.type || "ProInput"), mergeProps({ key: 0 }, _ctx.getWidgetProps(item.widget), {
          modelValue: _ctx.model[item.key].value,
          "onUpdate:modelValue": ($event) => _ctx.model[item.key].value = $event,
          disabled: item.widget.disabled || _ctx.$attrs.disabled,
          width: "100px",
          class: _ctx.widget + "-widget"
        }), null, 16, ["modelValue", "onUpdate:modelValue", "disabled", "class"])) : createCommentVNode("", true)
      ]);
    }), 256))
  ]);
}
const ProCheckboxInput = /* @__PURE__ */ _export_sfc(_sfc_main$12, [["render", _sfc_render$i]]);
const ProColorPicker_vue_vue_type_style_index_0_scoped_true_lang = "";
const _hoisted_1$K = { style: { "margin-left": "4px" } };
const _sfc_main$11 = /* @__PURE__ */ defineComponent({
  __name: "ProColorPicker",
  props: {
    modelValue: {
      type: [String, Number],
      default: () => ""
    }
  },
  emits: ["update:modelValue", "change"],
  setup(__props, { emit: emits }) {
    const props = __props;
    const elForm = inject(elFormKey, {});
    const attrs = useAttrs();
    const colorDisabled = computed(() => {
      return attrs.disabled || elForm.disabled;
    });
    const model = computed({
      get() {
        return props.modelValue;
      },
      set(val) {
        emits("update:modelValue", val);
        emits("change", val);
      }
    });
    return (_ctx, _cache) => {
      const _component_ks_color_picker = resolveComponent("ks-color-picker");
      const _component_ks_row = resolveComponent("ks-row");
      return openBlock(), createBlock(_component_ks_row, {
        type: "flex",
        class: normalizeClass(["atmosphereBgColor-wrapper", unref(colorDisabled) ? "is-disabled" : ""])
      }, {
        default: withCtx(() => [
          createVNode(_component_ks_color_picker, mergeProps({
            modelValue: unref(model),
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => isRef(model) ? model.value = $event : null)
          }, _ctx.$attrs), null, 16, ["modelValue"]),
          createElementVNode("span", _hoisted_1$K, toDisplayString(unref(model)), 1)
        ]),
        _: 1
      }, 8, ["class"]);
    };
  }
});
const ColorPicker = /* @__PURE__ */ _export_sfc(_sfc_main$11, [["__scopeId", "data-v-1ace7565"]]);
const ProInputRange_vue_vue_type_style_index_0_scoped_true_lang = "";
const _hoisted_1$J = {
  key: 0,
  class: "input-range-title"
};
const _hoisted_2$v = { class: "joiner" };
const _sfc_main$10 = /* @__PURE__ */ defineComponent({
  __name: "ProInputRange",
  props: {
    modelValue: {
      type: Array,
      default: () => []
    },
    title: {
      type: String,
      default: ""
    },
    min: {
      type: [String, Number],
      default: ""
    },
    max: {
      type: [String, Number],
      default: ""
    },
    minProps: {
      type: Object,
      default: () => ({})
    },
    maxProps: {
      type: Object,
      default: () => ({})
    },
    split: {
      type: String,
      default: "to"
    },
    validateEvent: {
      type: Boolean,
      default: true
    }
  },
  emits: ["update:modelValue", "update:min", "update:max", "blur", "change"],
  setup(__props, { expose, emit: emits }) {
    const props = __props;
    const $k18n = getK18n();
    const elFormItem = inject(elFormItemKey, {});
    const attrs = useAttrs();
    const minAttrs = computed(() => __spreadValues(__spreadValues({ placeholder: $k18n("\u6700\u5C0F\u503C") }, attrs), props.minProps));
    const maxAttrs = computed(() => __spreadValues(__spreadValues({ placeholder: $k18n("\u6700\u5927\u503C") }, attrs), props.maxProps));
    function isEmpty2(min2, max2) {
      return (min2 === "" || min2 === void 0) && (max2 === "" || max2 === void 0);
    }
    const minModel = computed({
      get() {
        const { min: min2, modelValue: modelValue2 } = props;
        return min2 || (modelValue2 == null ? void 0 : modelValue2[0]) || "";
      },
      set(val) {
        props.modelValue[0] = val;
        if (isEmpty2(val, props.modelValue[1])) {
          emits("update:modelValue", []);
        } else {
          emits("update:modelValue", props.modelValue);
        }
        emits("update:min", val);
      }
    });
    const maxModel = computed({
      get() {
        const { max: max2, modelValue: modelValue2 } = props;
        return max2 || (modelValue2 == null ? void 0 : modelValue2[1]) || "";
      },
      set(val) {
        props.modelValue[1] = val;
        if (isEmpty2(props.modelValue[0], val)) {
          emits("update:modelValue", []);
        } else {
          emits("update:modelValue", props.modelValue);
        }
        emits("update:max", val);
      }
    });
    const handleBlur = (event, type) => {
      var _a;
      emits("blur", event, type);
      if (props.validateEvent) {
        (_a = elFormItem.formItemMitt) == null ? void 0 : _a.emit(elFormEvents.formBlur, [event]);
      }
    };
    const handleChange = (event, type) => {
      var _a;
      emits("change", event, type);
      if (props.validateEvent) {
        (_a = elFormItem.formItemMitt) == null ? void 0 : _a.emit(elFormEvents.formChange, [event]);
      }
    };
    expose({
      validate,
      validateEmpty
    });
    function validateEmpty() {
      const { min: min2, max: max2 } = props;
      if (!min2 && parseInt(`${min2}`) !== 0 || !max2) {
        Message.error($k18n("\u8BF7\u8F93\u5165\u5185\u5BB9"));
        return false;
      }
      return true;
    }
    function validate() {
      const min2 = Number(props.min);
      const max2 = Number(props.max);
      if (min2 && max2) {
        if (min2 > max2) {
          Message.error($k18n("\u8BF7\u4ECE\u5C0F\u5230\u5927\u8F93\u5165\u6570\u5B57"));
          return false;
        }
      }
      return true;
    }
    return (_ctx, _cache) => {
      const _component_ks_divider = resolveComponent("ks-divider");
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(_ctx.$attrs.disabled ? "input-range disabled" : "input-range")
      }, [
        __props.title ? (openBlock(), createElementBlock("span", _hoisted_1$J, toDisplayString(__props.title), 1)) : createCommentVNode("", true),
        __props.title ? (openBlock(), createBlock(_component_ks_divider, {
          key: 1,
          direction: "vertical",
          class: "input-range-title-split"
        })) : createCommentVNode("", true),
        createVNode(ProInput, mergeProps({
          modelValue: unref(minModel),
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => isRef(minModel) ? minModel.value = $event : null)
        }, unref(minAttrs), {
          onBlur: handleBlur,
          onChange: _cache[1] || (_cache[1] = ($event) => handleChange("$event", "min"))
        }), createSlots({ _: 2 }, [
          renderList(_ctx.$slots, (slotVal, slotName) => {
            return {
              name: slotName,
              fn: withCtx(() => [
                renderSlot$2(_ctx.$slots, slotName, {}, void 0, true)
              ])
            };
          })
        ]), 1040, ["modelValue"]),
        createElementVNode("span", _hoisted_2$v, toDisplayString(__props.split), 1),
        createVNode(ProInput, mergeProps({
          modelValue: unref(maxModel),
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => isRef(maxModel) ? maxModel.value = $event : null)
        }, unref(maxAttrs), {
          onBlur: handleBlur,
          onChange: _cache[3] || (_cache[3] = ($event) => handleChange("$event", "max"))
        }), createSlots({ _: 2 }, [
          renderList(_ctx.$slots, (slotVal, slotName) => {
            return {
              name: slotName,
              fn: withCtx(() => [
                renderSlot$2(_ctx.$slots, slotName, {}, void 0, true)
              ])
            };
          })
        ]), 1040, ["modelValue"])
      ], 2);
    };
  }
});
const ProInputRange = /* @__PURE__ */ _export_sfc(_sfc_main$10, [["__scopeId", "data-v-75c417bd"]]);
const ProTreeSelect_vue_vue_type_style_index_0_scoped_true_lang = "";
const _hoisted_1$I = { class: "tree-com" };
const _hoisted_2$u = { class: "tree" };
const _sfc_main$$ = /* @__PURE__ */ defineComponent({
  __name: "ProTreeSelect",
  props: {
    isK18n: {
      type: Boolean,
      default: false
    },
    k18nDesc: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: ""
    },
    enumerate: {
      type: Array,
      default: () => []
    },
    modelValue: {
      type: Array,
      default: () => {
        return [];
      }
    },
    collapseTags: {
      type: Boolean,
      default: false
    },
    treeProps: {
      type: Object,
      default: () => {
        return {
          label: "desc",
          children: "children",
          value: "value"
        };
      }
    },
    style: {
      type: Object,
      default: () => {
        return {};
      }
    },
    size: {
      type: String,
      default: "medium"
    },
    onChange: {
      type: Function,
      default: () => null
    },
    format: {
      type: Function,
      default: () => null
    },
    disabled: {
      type: Boolean,
      default: () => false
    }
  },
  emits: ["update:modelValue"],
  setup(__props, { emit: emits }) {
    const props = __props;
    const k18n = getK18n();
    const selectRef = ref(null);
    const treeRef = ref(null);
    const { style: style2, onChange, format: format2 } = toRaw(props);
    const { enumerate, modelValue: modelValue2, treeProps } = toRefs(props);
    const computedStyle = computed(() => {
      return __spreadValues({}, style2);
    });
    const selectModel = ref([]);
    const treeData = ref([]);
    const treekey = ref(1);
    watch(
      () => modelValue2,
      (newval) => {
        init();
      },
      { deep: true }
    );
    watch(
      () => enumerate.value,
      (val) => {
        treeData.value = [];
        flatTreeData(val);
        init();
      },
      { deep: true, immediate: true }
    );
    const onModelChange = (val) => {
      var _a;
      const curModel = uniq(getKeys2(val));
      if (val.length) {
        (_a = treeRef.value) == null ? void 0 : _a.setCheckedNodes(curModel);
      } else {
        treekey.value++;
      }
      const formatValue2 = format2 && format2(curModel) || curModel;
      onChange && onChange(formatValue2);
      emits("update:modelValue", formatValue2);
    };
    const onCheckClick = (node) => {
      const resultKeys = treeRef.value.getCheckedNodes().map((item) => {
        return item[treeProps.value.value];
      });
      const curModel = uniq(resultKeys);
      selectModel.value = treeRef.value.getCheckedNodes().map((item) => {
        return item[treeProps.value.label];
      });
      const formatValue2 = format2(curModel) || curModel;
      onChange && onChange(formatValue2);
      emits("update:modelValue", formatValue2);
    };
    function flatTreeData(enumerate2) {
      enumerate2 == null ? void 0 : enumerate2.map((item) => {
        treeData.value.push({
          desc: item[treeProps.value.label],
          value: item[treeProps.value.value]
        });
        if (item[treeProps.value.children] && item[treeProps.value.children].length) {
          flatTreeData(item[treeProps.value.children]);
        }
      });
    }
    function getKeys2(model, type) {
      const result = [];
      model.map((item) => {
        treeData.value.map((tItem) => {
          if (type === "label") {
            if (tItem.value === item) {
              result.push(tItem.desc);
            }
          } else if (tItem.desc === item) {
            result.push(tItem.value);
          }
        });
      });
      return result;
    }
    function init() {
      var _a, _b;
      if ((_a = modelValue2.value) == null ? void 0 : _a.length) {
        selectModel.value = uniq(getKeys2(modelValue2.value, "label"));
        (_b = treeRef.value) == null ? void 0 : _b.setCheckedKeys(modelValue2.value);
      } else {
        selectModel.value = modelValue2.value;
        treekey.value++;
      }
    }
    return (_ctx, _cache) => {
      const _component_ks_tree = resolveComponent("ks-tree");
      const _component_ks_select = resolveComponent("ks-select");
      return openBlock(), createElementBlock("div", _hoisted_1$I, [
        createVNode(_component_ks_select, {
          ref_key: "selectRef",
          ref: selectRef,
          modelValue: selectModel.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => selectModel.value = $event),
          style: normalizeStyle(unref(computedStyle)),
          "collapse-tags": __props.collapseTags,
          disabled: __props.disabled,
          multiple: "",
          clearable: "",
          size: __props.size,
          placeholder: unref(k18n)({ desc: __props.k18nDesc, text: __props.placeholder || "\u8BF7\u8F93\u5165" }),
          onChange: onModelChange
        }, {
          empty: withCtx(() => [
            createElementVNode("div", _hoisted_2$u, [
              (openBlock(), createBlock(_component_ks_tree, {
                key: treekey.value,
                ref_key: "treeRef",
                ref: treeRef,
                data: unref(enumerate),
                "show-checkbox": true,
                size: "mini",
                "node-key": unref(treeProps).value,
                "highlight-current": "",
                props: unref(treeProps),
                onCheck: onCheckClick
              }, null, 8, ["data", "node-key", "props"]))
            ])
          ]),
          _: 1
        }, 8, ["modelValue", "style", "collapse-tags", "disabled", "size", "placeholder"])
      ]);
    };
  }
});
const ProTreeSelect = /* @__PURE__ */ _export_sfc(_sfc_main$$, [["__scopeId", "data-v-7dfde45d"]]);
const copyIcon_vue_vue_type_style_index_0_scoped_true_lang = "";
const _sfc_main$_ = /* @__PURE__ */ defineComponent({
  __name: "copy-icon",
  props: {
    value: {
      type: [String, Number],
      default: ""
    },
    checkValue: {
      type: Boolean,
      default: false
    }
  },
  setup(__props) {
    const $k18n = getK18n();
    return (_ctx, _cache) => {
      return (__props.checkValue ? !!__props.value : true) ? (openBlock(), createElementBlock("span", {
        key: 0,
        class: "sys-icon-copy",
        onClick: _cache[0] || (_cache[0] = withModifiers(($event) => unref(copyData)("", `${__props.value}`, unref($k18n)), ["stop"]))
      })) : createCommentVNode("", true);
    };
  }
});
const CopyIcon = /* @__PURE__ */ _export_sfc(_sfc_main$_, [["__scopeId", "data-v-38ba1b05"]]);
const ProDatePicker_vue_vue_type_style_index_0_scoped_true_lang = "";
const _sfc_main$Z = defineComponent({
  name: "ProDatePicker",
  components: {
    KsTooltip: Tooltip,
    KsDatePicker: DatePicker
  },
  props: {
    pickStartTime: {
      type: [Number, Boolean],
      default: 1
    },
    pickEndTime: {
      type: Number,
      default: 0
    },
    pickTimeNum: {
      type: Number,
      default: 0
    },
    pickTimeText: {
      type: String,
      default: ""
    },
    shortcuts: {
      type: [Array, Boolean],
      default: false
    },
    shortcutsAllDay: {
      type: Boolean,
      default: true
    },
    bindStartValue: {
      type: String,
      default: void 0
    },
    bindEndValue: {
      type: String,
      default: void 0
    },
    modelValue: {
      type: [Array, Number, Object, String],
      default: () => []
    }
  },
  emits: ["update:modelValue", "change"],
  setup(props, ctx) {
    let choiceDate = 0;
    const $k18n = getK18n();
    const defaultConfig = {
      type: "datetimerange",
      "range-separator": "to",
      "start-placeholder": $k18n("\u5F00\u59CB\u65F6\u95F4"),
      placeholder: "-",
      "end-placeholder": $k18n("\u7ED3\u675F\u65F6\u95F4"),
      "value-format": "timestamp",
      format: "YYYY/MM/DD HH:mm:ss",
      "text-align": "center"
    };
    const NOW = Date.now();
    const datePickShortCut = (props2) => {
      const { shortcutsAllDay } = props2;
      const dayArray = [1, 3, 7, 30, 90, 180];
      const dayArrayText = ["\u6628\u5929", "\u8FD13\u5929", "\u8FD17\u5929", "\u8FD11\u4E2A\u6708", "\u8FD13\u4E2A\u6708", "\u8FD1\u534A\u5E74"];
      const result = {};
      dayArray.forEach((key, index2) => {
        result[key] = {
          text: $k18n(dayArrayText[index2]),
          value: (() => {
            if (shortcutsAllDay) {
              return [TODAY_START - key * ONE_DAY, TODAY_END - ONE_DAY];
            }
            return [NOW - key * ONE_DAY, NOW];
          })()
        };
      });
      return result;
    };
    function onRangePick({ maxDate, minDate }) {
      choiceDate = minDate.getTime();
      if (maxDate) {
        choiceDate = "";
      }
    }
    function disabledDate(time) {
      let pickStartTime = props.pickStartTime;
      const pickEndTime = props.pickEndTime;
      let choiceMinTime = 0;
      let choiceMaxTime = 0;
      let step = 0;
      if (pickStartTime && typeof pickStartTime === "boolean") {
        pickStartTime = new Date().getTime() - ONE_DAY;
      }
      if (props.pickTimeNum) {
        step = (props.pickTimeNum - 1) * ONE_DAY;
        choiceMinTime = choiceDate - step;
        choiceMaxTime = choiceDate + step;
      }
      if (choiceDate) {
        const minTime = choiceMinTime < pickStartTime ? pickStartTime : choiceMinTime;
        let maxTime;
        if (choiceMaxTime && pickEndTime) {
          maxTime = choiceMaxTime > pickEndTime ? pickEndTime : choiceMaxTime;
        } else {
          maxTime = pickEndTime || choiceMaxTime;
        }
        return time.getTime() < minTime || maxTime && time.getTime() > maxTime;
      }
      if (pickStartTime || pickEndTime) {
        return time.getTime() < pickStartTime || pickEndTime && time.getTime() > pickEndTime;
      }
      return false;
    }
    const isObjectValue = computed(() => {
      const { bindStartValue, bindEndValue, modelValue: modelValue2 } = props;
      const valueToString = Object.prototype.toString.call(modelValue2);
      return bindStartValue && bindEndValue && valueToString === "[object Object]";
    });
    const toolTipContent = computed(() => {
      if (props.pickTimeNum === 31 || props.pickTimeNum === 30) {
        return "\u6700\u591A\u9009\u62E91\u4E2A\u6708";
      }
      if (props.pickTimeNum !== 0 && props.pickTimeNum % 7 === 0) {
        return `\u6700\u591A\u9009\u62E9${props.pickTimeNum / 7}\u5468`;
      }
      return `\u6700\u591A\u9009\u62E9${props.pickTimeNum}\u5929`;
    });
    const model = computed({
      get() {
        const { bindStartValue, bindEndValue, modelValue: modelValue2 } = props;
        if (isObjectValue.value) {
          const startTime = props.modelValue[bindStartValue];
          const endTime = props.modelValue[bindEndValue];
          return startTime && endTime ? [startTime, endTime] : [];
        }
        return modelValue2;
      },
      set(value2) {
        const { bindStartValue, bindEndValue } = props;
        if (isObjectValue.value) {
          props.modelValue[bindStartValue] = value2 && value2[0];
          props.modelValue[bindEndValue] = value2 && value2[1];
        } else {
          ctx.emit("update:modelValue", value2);
        }
        ctx.emit("change", value2);
      }
    });
    const bindProps = computed(() => {
      return __spreadValues(__spreadValues({}, defaultConfig), ctx.attrs);
    });
    function getShortcuts() {
      const { shortcuts } = props;
      if (!shortcuts) {
        return [];
      }
      const defaultShortcutsConfig = datePickShortCut(props);
      if (Array.isArray(shortcuts)) {
        const result = [];
        shortcuts.forEach((item) => {
          if (typeof item === "number" && defaultShortcutsConfig[item]) {
            result.push(defaultShortcutsConfig[item]);
          } else {
            result.push(item);
          }
        });
        return result;
      }
      return Object.values(defaultShortcutsConfig);
    }
    return {
      model,
      bindProps,
      toolTipContent,
      disabledDate,
      onRangePick,
      getShortcuts
    };
  }
});
const _hoisted_1$H = { class: "co_date_picker" };
function _sfc_render$h(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ks_date_picker = resolveComponent("ks-date-picker");
  const _component_ks_tooltip = resolveComponent("ks-tooltip");
  return openBlock(), createElementBlock("span", _hoisted_1$H, [
    createVNode(_component_ks_tooltip, {
      disabled: !_ctx.pickTimeNum,
      effect: "dark",
      content: _ctx.toolTipContent,
      placement: "bottom"
    }, {
      default: withCtx(() => [
        createVNode(_component_ks_date_picker, mergeProps({
          modelValue: _ctx.model,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.model = $event)
        }, _ctx.bindProps, {
          "disabled-date": _ctx.disabledDate,
          "popper-class": "co_date_picker_popper",
          shortcuts: _ctx.getShortcuts(),
          onRangePick: _ctx.onRangePick
        }), null, 16, ["modelValue", "disabled-date", "shortcuts", "onRangePick"])
      ]),
      _: 1
    }, 8, ["disabled", "content"])
  ]);
}
const ProDatePicker = /* @__PURE__ */ _export_sfc(_sfc_main$Z, [["render", _sfc_render$h], ["__scopeId", "data-v-5827af28"]]);
const ProRadio_vue_vue_type_style_index_0_scoped_true_lang = "";
const _sfc_main$Y = defineComponent({
  name: "ProRadio",
  components: {
    KsRadioGroup: RadioGroup,
    KsRadioButton: RadioButton,
    KsRadioTag: RadioTag,
    KsRadio: Radio$1,
    ProTooltip
  },
  props: {
    isK18n: {
      type: Boolean,
      default: false
    },
    k18nDesc: {
      type: String,
      default: ""
    },
    radioType: {
      type: String,
      default: ""
    },
    options: {
      type: Array,
      default: () => []
    },
    modelValue: {
      type: [String, Boolean, Number],
      default: ""
    },
    label: {
      type: String,
      default: "label"
    },
    val: {
      type: String,
      default: "value"
    },
    tooltips: {
      type: Array,
      default: () => []
    },
    transform: {
      type: String,
      default: ""
    }
  },
  emits: ["update:modelValue", "change"],
  setup(props, ctx) {
    const $k18n = getK18n();
    const comType = computed(() => {
      switch (props.radioType) {
        case "button":
          return "KsRadioButton";
        case "tag":
          return "KsRadioTag";
        case "switch":
          return "KsRadioTag";
        default:
          return "KsRadio";
      }
    });
    const model = computed({
      get() {
        if (["tag", "switch"].includes(props.radioType)) {
          if (typeof props.modelValue === "string") {
            return [props.modelValue];
          }
          if (typeof props.modelValue === "boolean") {
            return [+props.modelValue];
          }
        }
        return props.modelValue;
      },
      set(val) {
        let result = val;
        if (props.transform === "string" && typeof val !== "string") {
          result = val.toString();
        }
        if (props.transform === "boolean" && typeof val !== "boolean") {
          result = !!Number(val);
        }
        ctx.emit("update:modelValue", result);
        ctx.emit("change", result);
      }
    });
    const bindProps = computed(() => {
      return __spreadValues({}, ctx.attrs);
    });
    const transOptions = ref(trans(props));
    watch(
      () => props.options,
      (newVal) => {
        transOptions.value = trans(props);
      }
    );
    const getRadioKey = (item, index2) => {
      const val = item[props.val];
      if (typeof val === "number" || typeof val === "boolean") {
        return val;
      }
      return val || index2;
    };
    return {
      comType,
      model,
      bindProps,
      getRadioKey,
      transOptions,
      $k18n
    };
  }
});
function _sfc_render$g(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ProTooltip = resolveComponent("ProTooltip");
  const _component_ks_radio_group = resolveComponent("ks-radio-group");
  return openBlock(), createBlock(_component_ks_radio_group, mergeProps({
    modelValue: _ctx.model,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.model = $event)
  }, _ctx.bindProps, {
    class: _ctx.radioType === "switch" ? "switch-radio" : ""
  }), {
    default: withCtx(() => [
      (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.transOptions, (item, v) => {
        return openBlock(), createBlock(resolveDynamicComponent(_ctx.comType), {
          key: _ctx.getRadioKey(item, v),
          disabled: item.disabled,
          label: item[_ctx.val]
        }, {
          default: withCtx(() => [
            renderSlot$2(_ctx.$slots, "prepend", { item }, void 0, true),
            createTextVNode(" " + toDisplayString(_ctx.isK18n ? _ctx.$k18n(item[_ctx.label]) : item[_ctx.label]) + " ", 1),
            _ctx.tooltips[v] || item.tooltip ? (openBlock(), createBlock(_component_ProTooltip, {
              key: 0,
              content: _ctx.$k18n(_ctx.tooltips[v] || item.tooltip)
            }, null, 8, ["content"])) : createCommentVNode("", true),
            renderSlot$2(_ctx.$slots, "append", { item }, void 0, true)
          ]),
          _: 2
        }, 1032, ["disabled", "label"]);
      }), 128))
    ]),
    _: 3
  }, 16, ["modelValue", "class"]);
}
const Radio = /* @__PURE__ */ _export_sfc(_sfc_main$Y, [["render", _sfc_render$g], ["__scopeId", "data-v-05b52954"]]);
const uploadFileForAdmin = "/api/noah/common/file/uploadFileForAdmin";
const deleteImg = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAACXBIWXMAAAABAAAAAQBPJcTWAAACJElEQVR4nM2YO44CMQyGOQJHmKPMTeAGy02YjgrYggoK9gRMA/W0dHMAkFaiovPmj2LWRAlJhgBjyVJ2J48P24mdDAaJQkSF0i+lS6Wt0l/6F7QbpVvTp0idPwVkrLSmdAHgKCdIaSyh5Xq90vF4pN1uR+v1mhaLBc1mM61o43/4hj7oK6R9CkwNHiqd8myXy4X2+/0dQIwCDmOFYM5hKkxhTK1/JUBSIFx6OBykxdro+DIwLVtltVo9DcOKuYS1wlDGTRrmfD5nhZFQp9NJBrzffRwzuS0TsNTUBzPmmHkljIQSMVW6gLSrcgRwSqBzPDmtAzP6BmP74hehD9qhxWL7C9eNJJDe4pEDKdQX36QAzNcXHjFSy23+cBDUOnW9UDZMyPLz+VzOXQBoghaO+pALXCKhYvq4FGsbmQBoGzMotGBXGGve5S1+kBRjdoZv4a4w0M1mw0NaAOl6JiVpxkDFwnAcGfkdcCt2cAxUCgwrSy+BeueyFq2eBHUDoO/YwW/Y9j+9PBhvqeNRHNm5zLeQCyohLRWcz2r89aj0sHNZSnINVRFGmuTyA98BFhsXMf2d5cenCjRRetwXaAaoZH9/oIR1XyDVh4pd98Yiv3LCGCBcg3T2f+U1CHOzqyh0i6U+XRRdULmu0phDxEwTDWO5r5JnSWoWx0ELEOtQrYJuCoCNKd9zTNkZxAPWULrUlPPBygHGT3pbA2g/6cESS+r4pPcHf4JNdIC594cAAAAASUVORK5CYII=";
const excelIcon = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAACACAYAAADDPmHLAAAACXBIWXMAAAABAAAAAQBPJcTWAAADLUlEQVR4nO3cS27aUBSA4Swla+m8C8go407bBXRJ6aAdo3RQKaNIIYYQqhYjbMQgNTZteFW69aFBLVVUIMG+j/Mf6VcyMvjeD0OkmKMjhmEYhmEYhmEYhmGYPWY4HB6XNcqyMqO1NE0vy5+ntvej1nnY/GycF2Y2X5j58qfavt9PzWg0Egxvbe9LbVOqP8uLifXFt9nkx/16483dt0wXAjnpqfJXvjRbLHUikBO2vfiuJG8B688DahAA4E9yFfj7Q6EKBADY7N+/DIJHAID/AwgeAQC2AwgaAQB2AxAsAgDsDiBIBADYD0BwCACwP4CgEADgaQCCQQCApwMIAgEAngfAewQAeD4ArxEA4DAAvEUAgMMB8BIBAA4LwDsEADg8AK8QAKAaAN4gAEB1ALxAAIBqATiPAACbJUmqCwEANhskSSUAnEUAgM2+xv3KrgJOIgDAZvKv4e1O1/TiuA4E9m9DA8DjCL70YtOMWgetc9s1g8Hvt5iHexAatvcfADW3vgNJfpe1t73/AKixu2xcvr3cmpsyAChN7sPsdD8DQHNZXgBAc+u7sQGgPAAoDwDKA4DyAKA8ACgPAMoDgPIAoDwAKC9IAB+Sc/Py0yvz4uNpUJ1cvFmdGwC2dHLx2vpmVZXABsCWbG9S1QEAAAAAAAAAAID9ALh6XJuPBwAHjgsAAADAh4UDAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADgPIJQAAAAAAAAAAAAAAAAAAADsCsDV49p8PAA4cFwAAAAAPiwcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA8ARBKAAAAAAAAAAAA4PFC/JbQdfJtoQDY0vv0PMhvCxXYcm4AIAAQAAgABAACAAGAAEAAIAAQAAgABAACAAGAAEAAIAAQAAgA5CSAJEnNdL6wvhjami2WbgDo9/tmnOfWF0RbeTExcRzbBxC1O5lcBfKi4EpQQ7LG8oKTNY/aN/YBNFuthjyRXqlRLklUbbLxctWVNb+Kone29//ost0+vrqOsmbUMlRfsuay9rb3fzXyRMondWZ7UTS0erFdtxrObD7DMAzDMAzDMJ7NL6CTRA+Q+iXlAAAAAElFTkSuQmCC";
const ProFileUpload_vue_vue_type_style_index_0_scoped_true_lang = "";
const _withScopeId$7 = (n) => (pushScopeId("data-v-3cd9605a"), n = n(), popScopeId(), n);
const _hoisted_1$G = { class: "pro_file_upload__wrapper" };
const _hoisted_2$t = { class: "upload_box" };
const _hoisted_3$n = /* @__PURE__ */ _withScopeId$7(() => /* @__PURE__ */ createElementVNode("i", { class: "ks-icon-plus" }, null, -1));
const _hoisted_4$g = { class: "upload_box finish" };
const _hoisted_5$a = { class: "finish__content" };
const _hoisted_6$6 = ["src"];
const _hoisted_7$3 = ["src"];
const _hoisted_8$2 = { class: "finish__content__name" };
const _sfc_main$X = /* @__PURE__ */ defineComponent({
  __name: "ProFileUpload",
  props: {
    limit: {
      type: Number,
      default: 0
    },
    urlKey: {
      type: String,
      default: "key"
    },
    maxSize: {
      type: [String, Number],
      default: ""
    }
  },
  emits: ["update:modelValue", "change"],
  setup(__props, { expose, emit: emit2 }) {
    const props = __props;
    const $k18n = getK18n();
    const elFormItem = inject(elFormItemKey, {});
    const DEFAULT_PROPS = {
      "max-size": 100 * 1024 * 1024,
      accept: ".xlsx",
      action: uploadFileForAdmin,
      "show-file-list": false
    };
    const attrs = useAttrs();
    const bindProps = computed(() => {
      const { limit } = props;
      return __spreadValues(__spreadValues({
        limit,
        multiple: limit > 1
      }, DEFAULT_PROPS), attrs);
    });
    const uploadedFile = computed(() => get$1(state.fileList, "0", void 0));
    const beforeFileUpload = (file) => {
      var _a;
      const maxSize = Number.parseFloat(props.maxSize);
      if (maxSize) {
        const isSize = file.size / 1024 / 1024 < maxSize;
        if (!isSize) {
          Message.error(`${$k18n("\u6587\u4EF6\u5927\u5C0F\u4E0D\u8D85\u8FC7")}${maxSize}M`);
          return false;
        }
      }
      const fileType = file.name.slice(file.name.lastIndexOf("."));
      if (!((_a = bindProps.value.accept) == null ? void 0 : _a.split(",").includes(fileType))) {
        Message.error($k18n("\u4E0D\u652F\u6301\u7684\u6587\u4EF6\u7C7B\u578B"));
        return false;
      }
      state.loading = true;
    };
    const state = reactive({
      fileList: [],
      fileKey: "",
      loading: false
    });
    const handleUploadSuccess = (response, file, fileLis) => {
      var _a;
      if (!response) {
        return;
      }
      const { data } = response;
      const { urlKey } = props;
      const url = (data == null ? void 0 : data[urlKey]) ? data == null ? void 0 : data[urlKey] : data;
      state.fileList = fileLis;
      state.fileKey = url;
      emit2("update:modelValue", url);
      (_a = elFormItem.formItemMitt) == null ? void 0 : _a.emit(elFormEvents.formChange, [url]);
      state.loading = false;
    };
    const handleError = () => {
      Message.error($k18n("\u4E0A\u4F20\u5931\u8D25"));
      state.loading = false;
    };
    const handleUploadRemove = () => {
      var _a;
      state.fileList = [];
      state.fileKey = "";
      state.loading = false;
      (_a = elFormItem.formItemMitt) == null ? void 0 : _a.emit(elFormEvents.formChange, [state.fileKey]);
      emit2("update:modelValue", state.fileKey);
    };
    expose({
      handleUploadRemove
    });
    return (_ctx, _cache) => {
      var _a;
      const _component_k18n = resolveComponent("k18n");
      const _component_ks_upload = resolveComponent("ks-upload");
      const _directive_loading = resolveDirective("loading");
      return openBlock(), createElementBlock("div", _hoisted_1$G, [
        withDirectives(createVNode(_component_ks_upload, mergeProps({
          ref: "upload-file",
          drag: ""
        }, unref(bindProps), {
          "on-success": handleUploadSuccess,
          "before-upload": beforeFileUpload,
          "file-list": state.fileList,
          "on-error": handleError,
          "on-remove": handleUploadRemove
        }), {
          default: withCtx(() => [
            withDirectives((openBlock(), createElementBlock("div", _hoisted_2$t, [
              _hoisted_3$n,
              createVNode(_component_k18n, {
                block: "",
                class: "upload-title"
              }, {
                default: withCtx(() => [
                  createTextVNode("\u70B9\u51FB\u6B64\u5904\u6216\u5C06\u6587\u4EF6\u62D6\u62FD\u5230\u6B64\u5904\u8FDB\u884C\u4E0A\u4F20")
                ]),
                _: 1
              }),
              createElementVNode("div", null, [
                createVNode(_component_k18n, { class: "upload-tip" }, {
                  default: withCtx(() => [
                    createTextVNode("\u53EA\u652F\u6301")
                  ]),
                  _: 1
                }),
                createTextVNode(toDisplayString(unref(bindProps).accept), 1)
              ])
            ])), [
              [_directive_loading, state.loading]
            ])
          ]),
          _: 1
        }, 16, ["file-list"]), [
          [vShow, state.fileList.length === 0]
        ]),
        withDirectives(createElementVNode("div", _hoisted_4$g, [
          createElementVNode("div", _hoisted_5$a, [
            createElementVNode("img", {
              class: "finish__content__delimg",
              src: unref(deleteImg),
              alt: "",
              onClick: handleUploadRemove
            }, null, 8, _hoisted_6$6),
            createElementVNode("img", {
              class: "finish__content__iconimg",
              src: unref(excelIcon),
              alt: ""
            }, null, 8, _hoisted_7$3),
            createElementVNode("span", _hoisted_8$2, toDisplayString((_a = unref(uploadedFile)) == null ? void 0 : _a.name), 1)
          ])
        ], 512), [
          [vShow, state.fileList.length]
        ])
      ]);
    };
  }
});
const ProFileUpload = /* @__PURE__ */ _export_sfc(_sfc_main$X, [["__scopeId", "data-v-3cd9605a"]]);
const ProUploadImage_vue_vue_type_style_index_0_scoped_true_lang = "";
const STATE = {
  ALL: "all",
  WIDTH: "width",
  HEIGHT: "height",
  NONE: "none"
};
function limitComposition(props) {
  const limitWidthNum = computed(() => {
    return Number(props.limitWidth);
  });
  const limitHeightNum = computed(() => {
    return Number(props.limitHeight);
  });
  const scaleArr = computed(() => {
    return props.scale.split(":") || [];
  });
  const hasScale = computed(() => {
    return props.scale !== "";
  });
  const getLimitState = computed(() => {
    if (limitWidthNum.value) {
      if (limitHeightNum.value) {
        return STATE.ALL;
      }
      return STATE.WIDTH;
    }
    if (limitHeightNum.value) {
      return STATE.HEIGHT;
    }
    return STATE.NONE;
  });
  function handleBeforeUpload(file) {
    const { limitWidth, limitHeight } = props;
    const maxSize = Number(props.maxSize);
    const img = new Image();
    if (maxSize) {
      const isSize = file.size / 1024 < maxSize;
      if (!isSize) {
        Message.error(`The uploaded image cannot exceed ${maxSize} kb!`);
        return false;
      }
    }
    if (maxSize === 0 && limitHeight === "" && limitWidth === "") {
      return true;
    }
    return new Promise((resolve2, reject) => {
      img.onload = () => {
        const valid = validateImgLimit(img);
        if (valid) {
          resolve2(valid);
        } else {
          reject();
        }
      };
      img.src = URL.createObjectURL(file);
    }).then(
      () => {
        return file;
      },
      () => {
        const msg = `\u60A8\u4E0A\u4F20\u56FE\u7247\u5C3A\u5BF8\u4E3A\uFF1A${img.width}*${img.height},${limitWidth && limitHeight ? `\u4F46\u56FE\u7247\u5C3A\u5BF8\u9650\u5236\u4E3A${limitWidth} x ${limitHeight}` : "\u4E0D\u7B26\u5408\u8981\u6C42"}`;
        Message.error(msg);
        return Promise.reject();
      }
    );
  }
  function validateImgLimit(img) {
    let valid = true;
    const state = getLimitState.value;
    const [scaleW, scaleH] = scaleArr.value;
    let validWidth = true;
    let validHeight = true;
    if (props.isMaxLimit) {
      validWidth = img.width <= limitWidthNum.value;
      validHeight = img.height <= limitHeightNum.value;
    } else {
      validWidth = img.width === limitWidthNum.value;
      validHeight = img.height === limitHeightNum.value;
    }
    switch (state) {
      case STATE.ALL:
        if (hasScale.value) {
          validWidth = img.width <= limitWidthNum.value;
          validHeight = img.height <= limitHeightNum.value;
          valid = img.width * scaleH === img.height * scaleW;
        }
        valid = valid && validHeight && validWidth;
        break;
      case STATE.WIDTH:
        valid = validWidth;
        break;
      case STATE.HEIGHT:
        valid = validHeight;
        break;
      case STATE.NONE:
        if (hasScale.value) {
          valid = img.width * scaleH === img.height * scaleW;
        }
        break;
    }
    return valid;
  }
  return {
    limitWidthNum,
    handleBeforeUpload
  };
}
function downLoadComposition() {
  const state = reactive({
    docCanvas: {},
    docImg: {},
    docA: {}
  });
  onMounted(() => {
    state.docCanvas = document.createElement("canvas");
    state.docImg = document.createElement("img");
    state.docA = document.createElement("a");
  });
  function handleClickDownload(file) {
    const src2 = file.url;
    const { canvas, img } = state;
    img.onload = () => {
      canvas.width = img.width;
      canvas.height = img.height;
      const context = canvas.getContext("2d");
      context.drawImage(img, 0, 0, img.width, img.height);
      canvas.toBlob((blob) => {
        const link = state.docA;
        link.href = URL.createObjectURL(blob);
        link.download = new Date().getTime();
        link.click();
      }, "image/png");
    };
    img.setAttribute("crossOrigin", "Anonymous");
    img.src = src2;
  }
  return {
    handleClickDownload
  };
}
const _sfc_main$W = defineComponent({
  name: "ProUploadImage",
  components: {
    KsUpload: Upload,
    IconGeneralAddItem
  },
  props: {
    modelValue: {
      type: [String, Array, Object],
      default: ""
    },
    limitWidth: {
      type: [String, Number],
      default: ""
    },
    limitHeight: {
      type: [String, Number],
      default: ""
    },
    scale: {
      type: String,
      default: ""
    },
    isMaxLimit: {
      type: [String, Boolean],
      default: false
    },
    maxSize: {
      type: [String, Number],
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    },
    isDetail: {
      type: Boolean,
      default: false
    },
    limit: {
      type: Number,
      default: 1
    },
    getUrlAction: {
      type: String,
      default: ""
    },
    urlKey: {
      type: String,
      default: "url"
    },
    uploadText: {
      type: String,
      default: ""
    },
    responseCallback: {
      type: Function,
      default: () => {
      }
    }
  },
  emits: ["file-data", "update:modelValue"],
  setup(props, ctx) {
    const uploadRef = ref(null);
    const state = reactive({
      uploadClass: "",
      fileList: [],
      uploadSuccessTag: false,
      initIndex: 0,
      isSlideShow: false
    });
    const limitComposite = limitComposition(props);
    const downLoadComposite = downLoadComposition();
    const bindProps = computed(() => {
      const { limit } = props;
      return __spreadValues({
        limit,
        accept: "image/*",
        multiple: limit > 1
      }, ctx.attrs);
    });
    const previewList = computed(() => {
      const data = props.modelValue;
      if (!bindProps.value.multiple) {
        return [data[props.urlKey] || data];
      }
      return [];
    });
    function handleUploadSuccess(res, file, fileList) {
      var _a;
      if (!res) {
        return;
      }
      const response = res;
      const { responseCallback } = props;
      if (responseCallback && typeof responseCallback === "function") {
        const callbackRes = responseCallback(res);
        if (!callbackRes && typeof callbackRes === "boolean") {
          (_a = uploadRef.value) == null ? void 0 : _a.clearFiles();
          emit("update:modelValue", "");
          return;
        }
      }
      const { data } = response;
      const url = (data == null ? void 0 : data[props.urlKey]) || data;
      state.uploadSuccessTag = true;
      if (bindProps.value.multiple && Array.isArray(props.modelValue)) {
        ctx.emit("update:modelValue", [...props.modelValue, url]);
      } else {
        ctx.emit("update:modelValue", url);
      }
      ctx.emit("file-data", res.data);
      state.fileList = fileList;
      nextTick(() => {
        setUploadClass();
      });
    }
    function handleUploadError() {
      Message.error("\u56FE\u7247\u4E0A\u4F20\u63A5\u53E3\u51FA\u9519\uFF01");
    }
    function handleUploadExceed() {
      Message.error(`\u8D85\u8FC7\u6700\u5927\u4E0A\u4F20\u6587\u4EF6\u6570\u91CF\uFF08${props.limit}\uFF09\u9650\u5236\uFF01`);
    }
    function handleUploadRemove(file, fileList) {
      state.fileList = fileList;
    }
    function handleClickRemove(file) {
      state.uploadSuccessTag = true;
      uploadRef.value.handleRemove(file);
      if (bindProps.value.multiple) {
        const index2 = getImgIndex(file);
        props.modelValue.splice(index2, 1);
      } else {
        if (Object.prototype.toString.call(props.modelValue) === "[object Object]") {
          ctx.emit("update:modelValue", {});
        }
        if (typeof props.modelValue === "string") {
          ctx.emit("update:modelValue", "");
        }
        state.fileList = [];
      }
      state.uploadClass = "";
    }
    function getImgIndex(file) {
      if (typeof file === "number") {
        return file;
      }
      const url = file && file.response && file.response.data || file.url;
      return bindProps.value.multiple ? props.modelValue.indexOf(url) : 0;
    }
    function setUploadClass() {
      const { modelValue: modelValue2, limit, urlKey } = props;
      if (!bindProps.value.multiple && modelValue2) {
        if (Object.prototype.toString.call(modelValue2) === "[object Object]" && value[urlKey]) {
          state.uploadClass = "fill-upload";
        }
        if (Array.isArray(modelValue2) && value.length === limit) {
          state.uploadClass = "fill-upload";
        }
        if (typeof modelValue2 === "string") {
          state.uploadClass = "fill-upload";
        }
      }
    }
    function handlePicturePreview(file) {
      state.initIndex = getImgIndex(file);
      state.isSlideShow = true;
    }
    function setFileList() {
      const { modelValue: modelValue2, getUrlAction } = props;
      state.fileList = [{ url: `${getUrlAction}${modelValue2}` }];
    }
    watch(
      () => props.modelValue,
      (val) => {
        if (state.uploadSuccessTag) {
          return;
        }
        if (val) {
          setUploadClass();
          setFileList();
        }
      },
      { deep: true, immediate: true }
    );
    return __spreadValues(__spreadValues(__spreadProps(__spreadValues({}, toRefs(state)), {
      uploadRef,
      bindProps,
      previewList,
      handleUploadError,
      handleUploadExceed,
      handleUploadRemove,
      handleUploadSuccess,
      handleClickRemove,
      handlePicturePreview
    }), limitComposite), downLoadComposite);
  }
});
const _withScopeId$6 = (n) => (pushScopeId("data-v-3179a0a8"), n = n(), popScopeId(), n);
const _hoisted_1$F = { class: "upload_text__wrapper" };
const _hoisted_2$s = {
  key: 0,
  class: "upload_text"
};
const _hoisted_3$m = ["src"];
const _hoisted_4$f = { class: "ks-upload-list__item-actions" };
const _hoisted_5$9 = ["onClick"];
const _hoisted_6$5 = /* @__PURE__ */ _withScopeId$6(() => /* @__PURE__ */ createElementVNode("i", { class: "ks-icon-delete" }, null, -1));
const _hoisted_7$2 = [
  _hoisted_6$5
];
const _hoisted_8$1 = ["onClick"];
const _hoisted_9 = /* @__PURE__ */ _withScopeId$6(() => /* @__PURE__ */ createElementVNode("i", { class: "ks-icon-download" }, null, -1));
const _hoisted_10 = [
  _hoisted_9
];
const _hoisted_11 = { class: "el-upload__tip" };
function _sfc_render$f(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_IconGeneralAddItem = resolveComponent("IconGeneralAddItem");
  const _component_ks_upload = resolveComponent("ks-upload");
  return openBlock(), createElementBlock("div", null, [
    createVNode(_component_ks_upload, mergeProps({
      ref: "uploadRef",
      class: _ctx.uploadClass,
      "list-type": "picture-card",
      "file-list": _ctx.fileList,
      "on-success": _ctx.handleUploadSuccess,
      "before-upload": _ctx.handleBeforeUpload,
      "on-error": _ctx.handleUploadError,
      "on-remove": _ctx.handleUploadRemove,
      "on-exceed": _ctx.handleUploadExceed
    }, _ctx.bindProps), {
      default: withCtx(() => [
        createElementVNode("div", _hoisted_1$F, [
          createVNode(_component_IconGeneralAddItem),
          _ctx.uploadText ? (openBlock(), createElementBlock("div", _hoisted_2$s, toDisplayString(_ctx.uploadText), 1)) : createCommentVNode("", true)
        ])
      ]),
      file: withCtx(({ file }) => [
        createElementVNode("img", {
          class: "ks-upload-list__item-thumbnail",
          src: file.url,
          alt: "img"
        }, null, 8, _hoisted_3$m),
        createElementVNode("span", _hoisted_4$f, [
          !_ctx.disabled && !_ctx.isDetail ? (openBlock(), createElementBlock("span", {
            key: 0,
            class: "ks-upload-list__item-delete",
            onClick: ($event) => _ctx.handleClickRemove(file)
          }, _hoisted_7$2, 8, _hoisted_5$9)) : createCommentVNode("", true),
          _ctx.isDetail ? (openBlock(), createElementBlock("span", {
            key: 1,
            class: "ks-upload-list__item-delete",
            onClick: ($event) => _ctx.handleClickDownload(file)
          }, _hoisted_10, 8, _hoisted_8$1)) : createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 16, ["class", "file-list", "on-success", "before-upload", "on-error", "on-remove", "on-exceed"]),
    createElementVNode("div", _hoisted_11, [
      renderSlot$2(_ctx.$slots, "default", {}, void 0, true)
    ])
  ]);
}
const ProUploadImage = /* @__PURE__ */ _export_sfc(_sfc_main$W, [["render", _sfc_render$f], ["__scopeId", "data-v-3179a0a8"]]);
const ProImgPopover_vue_vue_type_style_index_0_scoped_true_lang = "";
const ProImgPopover_vue_vue_type_style_index_1_lang = "";
const DEFAULT_POPOVER = {
  trigger: "hover",
  placement: "right"
};
const _sfc_main$V = defineComponent({
  name: "ProImgPopover",
  components: {
    KsPopover: Popover
  },
  props: {
    url: {
      type: String,
      default: ""
    },
    imgStyle: {
      type: Object,
      default: () => ({
        width: "150px",
        height: "150px"
      })
    },
    previewStyle: {
      type: Object,
      default: () => ({
        width: "50px",
        height: "50px"
      })
    },
    defaultImg: {
      type: [String, Boolean],
      default: false
    }
  },
  setup(props, ctx) {
    const state = reactive({
      error: false
    });
    const bindProps = computed(() => {
      return __spreadValues(__spreadValues({}, DEFAULT_POPOVER), ctx.attrs);
    });
    function handleImgError() {
      state.error = true;
    }
    return __spreadProps(__spreadValues({}, toRefs(state)), {
      bindProps,
      handleImgError
    });
  }
});
const _hoisted_1$E = ["src"];
const _hoisted_2$r = ["src"];
const _hoisted_3$l = {
  key: 0,
  class: "iconfont icon-liebiaozhuangtai-fasongzhong"
};
const _hoisted_4$e = {
  key: 1,
  class: "img",
  src: "https://cdnfile.corp.kuaishou.com/kc/files/a/polaris/public/img/hot-video-topic-magic-default-img.png",
  alt: ""
};
function _sfc_render$e(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ks_popover = resolveComponent("ks-popover");
  return !_ctx.error ? (openBlock(), createBlock(_component_ks_popover, mergeProps({ key: 0 }, _ctx.bindProps, {
    width: parseInt(_ctx.imgStyle.width) || 100,
    "popper-class": "co_img_popover__class"
  }), {
    reference: withCtx(() => [
      createElementVNode("img", {
        class: "co-img-preview",
        style: normalizeStyle(_ctx.previewStyle),
        src: _ctx.url
      }, null, 12, _hoisted_2$r)
    ]),
    default: withCtx(() => [
      createElementVNode("img", {
        class: "pro-img-popover",
        src: _ctx.url,
        alt: "\u5C01\u9762",
        style: normalizeStyle(_ctx.imgStyle),
        onError: _cache[0] || (_cache[0] = (...args) => _ctx.handleImgError && _ctx.handleImgError(...args))
      }, null, 44, _hoisted_1$E)
    ]),
    _: 1
  }, 16, ["width"])) : (openBlock(), createElementBlock("div", {
    key: 1,
    class: "error_box",
    style: normalizeStyle(_ctx.previewStyle)
  }, [
    _ctx.defaultImg ? (openBlock(), createElementBlock("span", _hoisted_3$l)) : (openBlock(), createElementBlock("img", _hoisted_4$e))
  ], 4));
}
const ProImgPopover = /* @__PURE__ */ _export_sfc(_sfc_main$V, [["render", _sfc_render$e], ["__scopeId", "data-v-43c8df63"]]);
const UploadImage_vue_vue_type_style_index_0_scoped_true_lang = "";
const _withScopeId$5 = (n) => (pushScopeId("data-v-4dd95a06"), n = n(), popScopeId(), n);
const _hoisted_1$D = {
  key: 0,
  class: "hover-image-wrapper"
};
const _hoisted_2$q = /* @__PURE__ */ _withScopeId$5(() => /* @__PURE__ */ createElementVNode("i", { class: "sys-icon-add avatar-uploader-icon" }, null, -1));
const _sfc_main$U = /* @__PURE__ */ defineComponent({
  __name: "UploadImage",
  props: {
    imageUrl: String,
    bucket: String,
    acceptKind: String,
    otherTip: String,
    disabled: Boolean,
    limit: {
      type: [Number, String],
      default: 2 * 1024 * 1024
    },
    uploadApi: {
      type: String,
      default: "/api/noah/resource/file/image/upload"
    },
    desc: {
      type: String,
      default: ""
    },
    size: {
      type: String,
      default: ""
    }
  },
  emits: ["onAvatarSuccess", "onDeleteImage"],
  setup(__props, { emit: emits }) {
    const props = __props;
    const elForm = inject(elFormKey, {});
    const imageDisabled = computed(() => {
      return elForm.disabled;
    });
    const uploadClass = computed(() => {
      let className = "uploader-wrapper";
      if (!props.bucket || imageDisabled.value) {
        className += " disable-uploader";
      }
      if (props.size === "line") {
        className += " uplpader-line";
      } else if (props.size === "small") {
        className += " uplpader-small";
      }
      return className;
    });
    const uploadImageClass = computed(() => {
      let className = "upload-image-wrapper";
      if (props.size === "small") {
        className += " upload-image-wrapper-small";
      }
      return className;
    });
    const onAvatarSuccess = (res, file) => {
      var _a, _b;
      if ((_a = res == null ? void 0 : res.data) == null ? void 0 : _a.imageUrl) {
        emits("onAvatarSuccess", (_b = res == null ? void 0 : res.data) == null ? void 0 : _b.imageUrl);
      } else {
        Message.error({
          message: res == null ? void 0 : res.message,
          type: "error"
        });
      }
    };
    const limitText = computed(() => {
      if (props.limit < 1024) {
        return `${props.limit}B`;
      }
      if (props.limit < 1024 * 1024) {
        return `${props.limit / 1024}KB`;
      }
      return `${props.limit / 1024 / 1024}MB`;
    });
    const onBeforeAvatarUpload = (file) => {
      if (props.limit === "any")
        return true;
      const isLimit = file.size < props.limit;
      if (!isLimit) {
        Message.error({
          type: "error",
          message: `\u4E0A\u4F20\u56FE\u7247\u5927\u5C0F\u4E0D\u80FD\u8D85\u8FC7${limitText.value}`
        });
      }
      return isLimit;
    };
    const preivewVisble = ref(false);
    const previewImage = () => {
      preivewVisble.value = true;
    };
    const deleteImage = () => {
      emits("onDeleteImage");
    };
    return (_ctx, _cache) => {
      var _a;
      const _component_ks_image = resolveComponent("ks-image");
      const _component_k18n = resolveComponent("k18n");
      const _component_ks_upload = resolveComponent("ks-upload");
      return openBlock(), createElementBlock(Fragment, null, [
        __props.imageUrl ? (openBlock(), createElementBlock("div", {
          key: 0,
          class: normalizeClass(unref(uploadImageClass))
        }, [
          createVNode(_component_ks_image, {
            src: __props.imageUrl,
            fit: "scale-down",
            class: "upload-image"
          }, null, 8, ["src"]),
          !unref(imageDisabled) ? (openBlock(), createElementBlock("div", _hoisted_1$D, [
            createElementVNode("span", {
              class: "action-icon",
              onClick: previewImage
            }, [
              createVNode(unref(IconGeneralEye), { color: "#fff" })
            ]),
            !__props.disabled ? (openBlock(), createElementBlock("span", {
              key: 0,
              class: "action-icon left-line",
              onClick: deleteImage
            }, [
              createVNode(unref(IconGeneralDelete), { color: "#fff" })
            ])) : createCommentVNode("", true)
          ])) : createCommentVNode("", true)
        ], 2)) : createCommentVNode("", true),
        preivewVisble.value ? (openBlock(), createBlock(unref(ImageViewer), {
          key: 1,
          "url-list": [__props.imageUrl],
          "hide-on-click-modal": false,
          "z-index": 1e4,
          onClose: _cache[0] || (_cache[0] = () => {
            preivewVisble.value = false;
          })
        }, null, 8, ["url-list"])) : createCommentVNode("", true),
        withDirectives(createVNode(_component_ks_upload, {
          class: normalizeClass(unref(uploadClass)),
          "on-success": onAvatarSuccess,
          "before-upload": onBeforeAvatarUpload,
          disabled: !((_a = __props.bucket) == null ? void 0 : _a.length),
          action: `${__props.uploadApi}?bucket=${__props.bucket}`,
          "show-file-list": false,
          accept: __props.acceptKind,
          multiple: "",
          drag: ""
        }, {
          default: withCtx(() => {
            var _a2;
            return [
              _hoisted_2$q,
              __props.size !== "small" ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
                createElementVNode("div", null, [
                  __props.desc ? (openBlock(), createBlock(_component_k18n, { key: 0 }, {
                    default: withCtx(() => [
                      createTextVNode(toDisplayString(__props.desc), 1)
                    ]),
                    _: 1
                  })) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                    createVNode(_component_k18n, null, {
                      default: withCtx(() => [
                        createTextVNode("\u56FE\u7247\u4E0D\u8D85\u8FC7")
                      ]),
                      _: 1
                    }),
                    createElementVNode("span", null, toDisplayString(unref(limitText)), 1),
                    __props.otherTip ? (openBlock(), createBlock(_component_k18n, { key: 0 }, {
                      default: withCtx(() => [
                        createTextVNode(toDisplayString(__props.otherTip), 1)
                      ]),
                      _: 1
                    })) : createCommentVNode("", true)
                  ], 64))
                ]),
                createElementVNode("div", null, [
                  !((_a2 = __props.bucket) == null ? void 0 : _a2.length) ? (openBlock(), createBlock(_component_k18n, { key: 0 }, {
                    default: withCtx(() => [
                      createTextVNode("\u8BF7\u5148\u6307\u5B9A\u6876")
                    ]),
                    _: 1
                  })) : createCommentVNode("", true)
                ])
              ], 64)) : createCommentVNode("", true)
            ];
          }),
          _: 1
        }, 8, ["class", "disabled", "action", "accept"]), [
          [vShow, !__props.imageUrl]
        ])
      ], 64);
    };
  }
});
const UploadImage = /* @__PURE__ */ _export_sfc(_sfc_main$U, [["__scopeId", "data-v-4dd95a06"]]);
const ProPagination_vue_vue_type_style_index_0_scoped_true_lang = "";
const _hoisted_1$C = {
  key: 0,
  class: "total"
};
const _sfc_main$T = /* @__PURE__ */ defineComponent({
  __name: "ProPagination",
  props: {
    pageInfo: {
      type: Object,
      default: () => ({ current: 0, pageSize: 0, total: 0 }),
      validator: (value2) => ["current", "pageSize"].every((v) => typeof value2[v] === "number")
    },
    paginationAttrs: {
      type: Object,
      default: () => ({})
    },
    hideLastBtn: {
      type: Boolean,
      default: true
    },
    showPagination: {
      type: Boolean,
      default: true
    }
  },
  emits: ["current-change", "size-change"],
  setup(__props, { emit: emit2 }) {
    const props = __props;
    const PAGINATION_CONFIG = {
      background: true,
      "page-sizes": [10, 20, 50, 100],
      layout: "total, prev, pager, next, sizes"
    };
    const paginationAttrsComputed = computed(() => {
      return __spreadValues(__spreadValues({}, PAGINATION_CONFIG), props.paginationAttrs);
    });
    const hasTotalConfig = computed(() => {
      var _a, _b;
      return (_b = (_a = paginationAttrsComputed.value) == null ? void 0 : _a.layout) == null ? void 0 : _b.includes("total");
    });
    function handleCurrentChange(size) {
      props.pageInfo.current = size;
      emit2("current-change", size);
    }
    function handleSizeChange(size) {
      props.pageInfo.pageSize = size;
      props.pageInfo.current = 1;
      emit2("size-change", size);
    }
    return (_ctx, _cache) => {
      var _a, _b;
      const _component_ks_pagination = resolveComponent("ks-pagination");
      return __props.showPagination ? (openBlock(), createElementBlock("div", {
        key: 0,
        class: normalizeClass(["pro_pagination", { hide_last: __props.hideLastBtn }])
      }, [
        unref(hasTotalConfig) ? (openBlock(), createElementBlock("span", _hoisted_1$C, "Total " + toDisplayString((_b = (_a = __props.pageInfo) == null ? void 0 : _a.total) == null ? void 0 : _b.toLocaleString()), 1)) : createCommentVNode("", true),
        createVNode(_component_ks_pagination, mergeProps({
          "current-page": __props.pageInfo.current,
          "page-size": __props.pageInfo.pageSize,
          total: __props.pageInfo.total
        }, unref(paginationAttrsComputed), {
          onCurrentChange: handleCurrentChange,
          onSizeChange: handleSizeChange
        }), null, 16, ["current-page", "page-size", "total"])
      ], 2)) : createCommentVNode("", true);
    };
  }
});
const ProPagination = /* @__PURE__ */ _export_sfc(_sfc_main$T, [["__scopeId", "data-v-b7f40746"]]);
const ProUploadVideo_vue_vue_type_style_index_0_scoped_true_lang = "";
const _hoisted_1$B = {
  key: 0,
  class: "upload_text__wrapper"
};
const _hoisted_2$p = {
  key: 0,
  class: "upload_text"
};
const _hoisted_3$k = {
  key: 1,
  class: "hot_video_video__player video_wrapper"
};
const _sfc_main$S = /* @__PURE__ */ defineComponent({
  __name: "ProUploadVideo",
  props: {
    modelValue: {
      type: [Object, String],
      default: () => ({})
    },
    urlKey: {
      type: String,
      default: "url"
    },
    exceedMsg: {
      type: String,
      default: "\u4E0A\u4F20\u6587\u4EF6\u6570\u91CF\u8D85\u9650\uFF01"
    },
    uploadText: {
      type: String,
      default: ""
    },
    responseCallback: {
      type: Function,
      default: () => {
      }
    }
  },
  emits: ["file-data", "update:modelValue"],
  setup(__props, { emit: emit2 }) {
    const props = __props;
    const attrs = useAttrs();
    const uploadRef = ref(null);
    const state = reactive({
      percent: 0
    });
    const bindProps = computed(() => {
      const { accept } = attrs;
      return __spreadValues({
        accept
      }, attrs);
    });
    function handleUploadSuccess(res) {
      var _a;
      if (!res) {
        return;
      }
      const { responseCallback } = props;
      const response = res;
      if (responseCallback && typeof responseCallback === "function") {
        const callbackRes = responseCallback(res);
        if (!callbackRes && typeof callbackRes === "boolean") {
          (_a = uploadRef.value) == null ? void 0 : _a.clearFiles();
          emit2("update:modelValue", "");
          state.percent = 0;
          return;
        }
      }
      const { data } = response;
      const url = (data == null ? void 0 : data[props.urlKey]) || data;
      emit2("update:modelValue", url);
      emit2("file-data", res.data);
    }
    function handleExceed() {
      Message.error(props.exceedMsg);
    }
    function handleUploadError() {
      state.percent = 0;
      Message.error("\u4E0A\u4F20\u63A5\u53E3\u51FA\u9519\uFF01");
    }
    function handleUploadRemove() {
      state.percent = 0;
      emit2("update:modelValue", "");
    }
    function handleUploadProcess(event) {
      const { percent } = event;
      state.percent = Math.floor(percent);
    }
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", null, [
        !__props.modelValue ? (openBlock(), createBlock(unref(Upload), mergeProps({
          key: 0,
          ref_key: "uploadRef",
          ref: uploadRef,
          multiple: false,
          limit: 1,
          drag: "",
          "on-success": handleUploadSuccess,
          "on-remove": handleUploadRemove,
          "on-error": handleUploadError,
          "on-exceed": handleExceed,
          "on-progress": handleUploadProcess,
          "show-file-list": false
        }, unref(bindProps)), {
          default: withCtx(() => [
            !state.percent ? (openBlock(), createElementBlock("div", _hoisted_1$B, [
              createVNode(unref(IconGeneralAddItem)),
              __props.uploadText ? (openBlock(), createElementBlock("div", _hoisted_2$p, toDisplayString(__props.uploadText), 1)) : createCommentVNode("", true)
            ])) : (openBlock(), createBlock(unref(Progress), {
              key: 1,
              class: "upload_process",
              "stroke-width": 1,
              type: "circle",
              percentage: state.percent
            }, null, 8, ["percentage"]))
          ]),
          _: 1
        }, 16)) : (openBlock(), createElementBlock("div", _hoisted_3$k, [
          !unref(bindProps).disabled ? (openBlock(), createBlock(unref(IconGeneralCloseCircle), {
            key: 0,
            onClick: handleUploadRemove
          })) : createCommentVNode("", true),
          createVNode(unref(VideoPlayer), {
            ref: "playerRef",
            src: __props.modelValue,
            "need-default-poster": false,
            "control-style": {
              reverse: false
            },
            config: {
              volume: true,
              playbackRate: false,
              screen: true,
              play: true
            },
            width: "100%",
            height: "100%"
          }, null, 8, ["src"])
        ]))
      ]);
    };
  }
});
const ProUploadVideo = /* @__PURE__ */ _export_sfc(_sfc_main$S, [["__scopeId", "data-v-2bbf4e32"]]);
const DragBox_vue_vue_type_style_index_0_scoped_true_lang = "";
const _hoisted_1$A = { class: "drag_box" };
const _hoisted_2$o = { class: "label" };
const _sfc_main$R = /* @__PURE__ */ defineComponent({
  __name: "DragBox",
  props: {
    label: {
      type: String,
      default: ""
    },
    k18nDesc: {
      type: String,
      default: ""
    }
  },
  emits: ["delete"],
  setup(__props, { emit: emit2 }) {
    function handleDelete() {
      emit2("delete");
    }
    return (_ctx, _cache) => {
      const _component_noah_icon = resolveComponent("noah-icon");
      return openBlock(), createElementBlock("div", _hoisted_1$A, [
        createElementVNode("div", _hoisted_2$o, [
          createVNode(_component_noah_icon, {
            id: "Noah-a-bianzu25",
            class: "drag-icon"
          }),
          createVNode(unref(ProTooltip), {
            "line-clamp": 1,
            content: unref(getK18nValueResult)(__props.label, __props.k18nDesc),
            "max-width": "120px"
          }, null, 8, ["content"])
        ]),
        createVNode(_component_noah_icon, {
          id: "Noah-a-bianzu18beifen",
          onClick: handleDelete
        })
      ]);
    };
  }
});
const DragBox = /* @__PURE__ */ _export_sfc(_sfc_main$R, [["__scopeId", "data-v-68c03686"]]);
const CheckAllBox_vue_vue_type_style_index_0_scoped_true_lang = "";
const _hoisted_1$z = { class: "group_wrapper" };
const _hoisted_2$n = { class: "check_all" };
const _hoisted_3$j = { class: "" };
const _sfc_main$Q = /* @__PURE__ */ defineComponent({
  __name: "CheckAllBox",
  props: {
    modelValue: {
      type: Array || Boolean,
      default: () => []
    },
    item: {
      type: Object,
      default: () => ({})
    },
    col: {
      type: Number,
      default: 3
    },
    maxWidth: {
      type: String,
      default: ""
    },
    k18nDesc: {
      type: String,
      default: ""
    }
  },
  emits: ["change"],
  setup(__props, { emit: emit2 }) {
    const props = __props;
    const state = reactive({
      checkValue: [],
      checkAll: false,
      isIndeterminate: false
    });
    const optionsKeys = computed(() => {
      var _a, _b;
      return ((_b = (_a = props.item) == null ? void 0 : _a.options) == null ? void 0 : _b.map((item) => item.key)) || [];
    });
    watch(
      () => props.modelValue,
      (val) => {
        state.checkValue = (val == null ? void 0 : val.filter((key) => optionsKeys.value.includes(key))) || [];
        setCheckAllValue(state.checkValue);
      },
      { immediate: true, deep: true }
    );
    function handleCheckAllChange(val) {
      state.checkValue = val ? optionsKeys.value : [];
      state.isIndeterminate = false;
      emit2("change", state.checkValue, props.item.label);
    }
    function handleChangeCheckbox(value2) {
      setCheckAllValue(value2);
      emit2("change", value2, props.item.label);
    }
    function setCheckAllValue(value2) {
      const checkedCount = value2.length;
      state.checkAll = checkedCount === optionsKeys.value.length;
      state.isIndeterminate = checkedCount > 0 && checkedCount < optionsKeys.value.length;
    }
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1$z, [
        createElementVNode("div", _hoisted_2$n, [
          createVNode(unref(Checkbox), {
            modelValue: state.checkAll,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => state.checkAll = $event),
            content: __props.item.label,
            indeterminate: state.isIndeterminate,
            "is-k18n": "",
            "k18n-desc": __props.k18nDesc,
            onChange: handleCheckAllChange
          }, null, 8, ["modelValue", "content", "indeterminate", "k18n-desc"])
        ]),
        createElementVNode("div", _hoisted_3$j, [
          createVNode(unref(Checkbox), {
            modelValue: state.checkValue,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => state.checkValue = $event),
            options: __props.item.options,
            "max-width": __props.maxWidth,
            "is-k18n": "",
            "k18n-desc": __props.k18nDesc,
            val: "key",
            class: normalizeClass(["checkbox_wrapper", `col${__props.col}`]),
            onChange: handleChangeCheckbox
          }, null, 8, ["modelValue", "options", "max-width", "k18n-desc", "class"])
        ])
      ]);
    };
  }
});
const CheckAllBox = /* @__PURE__ */ _export_sfc(_sfc_main$Q, [["__scopeId", "data-v-653f3756"]]);
const _sfc_main$P = /* @__PURE__ */ defineComponent({
  __name: "SelectTree",
  props: {
    columns: {
      type: Array,
      default: () => []
    },
    defaultGroup: {
      type: String,
      default: ""
    },
    defaultCheckedKeys: {
      type: Array,
      default: () => []
    }
  },
  emits: ["change", "submit"],
  setup(__props, { emit: emit2 }) {
    const props = __props;
    const $k18n = getK18n();
    const treeRef = ref();
    const state = reactive({
      treeData: [],
      groupName: /* @__PURE__ */ new Set()
    });
    onMounted(() => {
      getTreeData();
      watch(
        () => props.defaultCheckedKeys,
        (val) => {
          var _a;
          (_a = treeRef.value) == null ? void 0 : _a.setCheckedKeys(val);
        },
        { deep: true }
      );
    });
    function handleClickCheckBox(checkedNodes, data) {
      const { checkedKeys } = data;
      emit2(
        "change",
        checkedKeys.filter((key) => !state.groupName.has(key)).filter((_) => _)
      );
    }
    function getTreeData() {
      var _a;
      state.groupName = /* @__PURE__ */ new Set();
      (_a = props.columns) == null ? void 0 : _a.forEach((item) => {
        var _a2;
        const { colGroup = props.defaultGroup, colDisabled } = item;
        const k18nResultItem = __spreadProps(__spreadValues({}, item), {
          label: $k18n(item.label)
        });
        if (!colDisabled) {
          if (typeof colGroup === "string") {
            const listItem = (_a2 = state.treeData) == null ? void 0 : _a2.find((obj) => obj.label === $k18n(colGroup));
            if (!listItem) {
              state.treeData.push({
                label: $k18n(colGroup),
                children: [k18nResultItem]
              });
            } else {
              listItem.children.push(k18nResultItem);
            }
            state.groupName.add($k18n(colGroup));
          }
          if (Array.isArray(colGroup)) {
            list2Obj(state.treeData, colGroup, 0, k18nResultItem);
          }
        }
      });
    }
    function list2Obj(list, colGroup, index2, item) {
      const group = colGroup == null ? void 0 : colGroup[index2];
      if (!group) {
        return item;
      }
      state.groupName.add($k18n(colGroup));
      const listItem = list == null ? void 0 : list.find((item2) => item2.label === $k18n(group));
      if (!listItem) {
        const children = [];
        const result = list2Obj(children, colGroup, index2 + 1, item);
        if (result) {
          children.push(result);
        }
        list.push({
          label: $k18n(group),
          children
        });
      } else {
        const children = listItem.children;
        const result = list2Obj(children, colGroup, index2 + 1, item);
        if (result) {
          children.push(result);
        }
      }
    }
    return (_ctx, _cache) => {
      const _component_ks_tree = resolveComponent("ks-tree");
      return openBlock(), createElementBlock("div", null, [
        createVNode(_component_ks_tree, {
          ref_key: "treeRef",
          ref: treeRef,
          data: state.treeData,
          "show-checkbox": "",
          "node-key": "key",
          "default-checked-keys": __props.defaultCheckedKeys,
          "highlight-current": "",
          onCheck: handleClickCheckBox
        }, null, 8, ["data", "default-checked-keys"])
      ]);
    };
  }
});
const Base_vue_vue_type_style_index_0_scoped_true_lang = "";
const _hoisted_1$y = { class: "table_config_setting" };
const _hoisted_2$m = { class: "flex bottom_cover" };
const _hoisted_3$i = { class: "box_title" };
const _hoisted_4$d = { class: "content" };
const _hoisted_5$8 = { class: "indicator bottom_cover" };
const _hoisted_6$4 = { class: "box_title" };
const _hoisted_7$1 = { class: "content" };
const _hoisted_8 = { class: "footer" };
const _sfc_main$O = /* @__PURE__ */ defineComponent({
  __name: "Base",
  props: {
    modelValue: {
      type: Array,
      default: () => []
    },
    columns: {
      type: Array,
      default: () => []
    },
    col: {
      type: Number,
      default: 3
    },
    maxWidth: {
      type: String,
      default: "142px"
    },
    defaultGroup: {
      type: String,
      default: "\u5168\u9009"
    },
    k18nDesc: {
      type: String,
      default: ""
    },
    isTreeMode: {
      type: Boolean,
      default: false
    }
  },
  emits: ["submit", "close", "update:modelValue"],
  setup(__props, { emit: emit2 }) {
    const props = __props;
    const $k18n = getK18n();
    const state = reactive({
      sortList: [],
      fixedList: [],
      fixedLastList: [],
      colDisabledShowList: [],
      pendSortList: [],
      checkValue: [],
      fixedCheckValue: [],
      checkBoxOptionMap: {},
      checkBoxOrder: []
    });
    onMounted(() => {
      transformColumn();
      orderCheckboxOptions();
      getCheckedValue();
    });
    const allFixedList = computed(() => {
      return [...state.fixedList, ...state.fixedLastList];
    });
    function resetData() {
      state.pendSortList = [];
      state.fixedCheckValue = [];
      state.fixedList = [];
      state.fixedLastList = [];
    }
    function transformColumn() {
      resetData();
      const { columns } = props;
      columns == null ? void 0 : columns.forEach((item) => {
        const { colDisabled, key, colGroup = props.defaultGroup, colDisabledShow, fixed } = item;
        if (!colDisabledShow) {
          if (colDisabled) {
            if (fixed === "right") {
              state.fixedLastList.push(item);
            } else {
              state.fixedList.push(item);
            }
            state.fixedCheckValue.push(key);
          } else {
            state.pendSortList.push(item);
            let groupName = colGroup;
            if (Array.isArray(colGroup)) {
              groupName = colGroup[colGroup.length - 1];
            }
            if (!state.checkBoxOptionMap[groupName]) {
              state.checkBoxOptionMap[groupName] = {
                label: groupName,
                options: [item]
              };
            } else {
              state.checkBoxOptionMap[groupName].options.push(item);
            }
          }
        } else {
          state.colDisabledShowList.push(item);
        }
      });
    }
    function orderCheckboxOptions() {
      const keys = Object.keys(state.checkBoxOptionMap);
      keys.forEach((key) => {
        if (key !== props.defaultGroup) {
          state.checkBoxOrder.push(key);
        }
      });
      state.checkBoxOrder.push(props.defaultGroup);
    }
    function getCheckedValue() {
      var _a;
      state.checkValue = (_a = props.modelValue) == null ? void 0 : _a.map((item) => item.key).filter((key) => !state.fixedCheckValue.includes(key));
      handleChangeCheckbox(state.checkValue);
    }
    function handleChangeCheckbox(val, label = props.defaultGroup) {
      var _a, _b;
      const sortKeys = state.sortList.map((item) => item.key);
      const noInSortListKeys = val.filter((key) => !sortKeys.includes(key));
      if (noInSortListKeys.length) {
        noInSortListKeys.forEach((key) => {
          const findItem = state.pendSortList.find((item) => item.key === key);
          if (findItem) {
            state.sortList.push(findItem);
          }
        });
      } else {
        const keys = (_b = (_a = state.checkBoxOptionMap[label]) == null ? void 0 : _a.options) == null ? void 0 : _b.map((item) => item.key);
        state.sortList = state.sortList.filter((item) => {
          const { key } = item;
          return !(keys.includes(key) && (!val.includes(key) || val.length === 0));
        });
      }
    }
    function handleSortListDeleteItem(item, index2) {
      state.sortList.splice(index2, 1);
      const findIndex = state.checkValue.indexOf(item.key);
      state.checkValue.splice(findIndex, 1);
    }
    function handleClickClose() {
      emit2("close");
    }
    function handleClickSubmit() {
      const updateValue = [...state.colDisabledShowList, ...state.fixedList, ...state.sortList, ...state.fixedLastList];
      emit2("update:modelValue", updateValue);
      emit2("submit", updateValue);
    }
    function handleClickClean() {
      state.sortList = [];
      state.checkValue = [];
    }
    function handleTreeChange(val) {
      var _a;
      const sortItems = state.sortList.filter((item) => val.includes(item.key));
      const sortKeys = sortItems == null ? void 0 : sortItems.map((item) => item.key);
      const addItems = (_a = props.columns) == null ? void 0 : _a.filter((item) => val.includes(item.key) && !(sortKeys == null ? void 0 : sortKeys.includes(item.key)));
      state.sortList = [...sortItems, ...addItems];
      state.checkValue = state.sortList.map((item) => item.key);
    }
    return (_ctx, _cache) => {
      const _component_ks_button = resolveComponent("ks-button");
      return openBlock(), createElementBlock(Fragment, null, [
        createElementVNode("div", _hoisted_1$y, [
          createElementVNode("div", _hoisted_2$m, [
            createElementVNode("div", _hoisted_3$i, [
              createElementVNode("span", null, toDisplayString(unref($k18n)("\u9009\u62E9")), 1)
            ]),
            createElementVNode("div", _hoisted_4$d, [
              __props.isTreeMode ? (openBlock(), createBlock(_sfc_main$P, {
                key: 0,
                columns: __props.columns,
                "default-group": __props.defaultGroup,
                "default-checked-keys": state.checkValue,
                onChange: handleTreeChange
              }, null, 8, ["columns", "default-group", "default-checked-keys"])) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                unref(allFixedList).length ? (openBlock(), createBlock(unref(Checkbox), {
                  key: 0,
                  modelValue: state.fixedCheckValue,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => state.fixedCheckValue = $event),
                  options: unref(allFixedList),
                  disabled: "",
                  "is-k18n": "",
                  "k18n-desc": __props.k18nDesc,
                  "max-width": __props.maxWidth,
                  val: "key",
                  class: normalizeClass(["checkbox_wrapper", `col${__props.col}`])
                }, null, 8, ["modelValue", "options", "k18n-desc", "max-width", "class"])) : createCommentVNode("", true),
                (openBlock(true), createElementBlock(Fragment, null, renderList(state.checkBoxOrder, (key) => {
                  return openBlock(), createBlock(CheckAllBox, {
                    key,
                    modelValue: state.checkValue,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => state.checkValue = $event),
                    item: state.checkBoxOptionMap[key],
                    col: __props.col,
                    "k18n-desc": __props.k18nDesc,
                    "max-width": __props.maxWidth,
                    onChange: handleChangeCheckbox
                  }, null, 8, ["modelValue", "item", "col", "k18n-desc", "max-width"]);
                }), 128))
              ], 64))
            ])
          ]),
          createElementVNode("div", _hoisted_5$8, [
            createElementVNode("div", _hoisted_6$4, [
              createElementVNode("span", null, toDisplayString(unref($k18n)("\u6307\u6807")), 1),
              createElementVNode("span", {
                class: "clear_btn",
                onClick: handleClickClean
              }, toDisplayString(unref($k18n)("\u6E05\u9664")), 1)
            ]),
            createElementVNode("div", _hoisted_7$1, [
              (openBlock(true), createElementBlock(Fragment, null, renderList(unref(allFixedList), (item) => {
                return openBlock(), createElementBlock("div", {
                  key: item.key,
                  class: "item"
                }, toDisplayString(unref(getK18nValueResult)(item.label, __props.k18nDesc)), 1);
              }), 128)),
              createVNode(unref(Draggable), {
                list: state.sortList,
                handle: ".drag-icon",
                "ghost-class": "ghost",
                animation: "200",
                "item-key": "key"
              }, {
                item: withCtx(({ element, index: index2 }) => [
                  createVNode(DragBox, {
                    label: element.label,
                    "k18n-desc": __props.k18nDesc,
                    onDelete: ($event) => handleSortListDeleteItem(element, index2)
                  }, null, 8, ["label", "k18n-desc", "onDelete"])
                ]),
                _: 1
              }, 8, ["list"])
            ])
          ])
        ]),
        createElementVNode("div", _hoisted_8, [
          createVNode(_component_ks_button, { onClick: handleClickClose }, {
            default: withCtx(() => [
              createTextVNode(toDisplayString(unref($k18n)("\u53D6 \u6D88")), 1)
            ]),
            _: 1
          }),
          createVNode(_component_ks_button, {
            type: "primary",
            onClick: handleClickSubmit
          }, {
            default: withCtx(() => [
              createTextVNode(toDisplayString(unref($k18n)("\u786E \u8BA4")), 1)
            ]),
            _: 1
          })
        ])
      ], 64);
    };
  }
});
const TableColSetting = /* @__PURE__ */ _export_sfc(_sfc_main$O, [["__scopeId", "data-v-2f7b2f8b"]]);
const SettingIcon_vue_vue_type_style_index_0_scoped_true_lang = "";
const SettingIcon_vue_vue_type_style_index_1_lang = "";
const _sfc_main$N = /* @__PURE__ */ defineComponent({
  __name: "SettingIcon",
  props: {
    label: {
      type: String,
      default: "\u7F16\u8F91\u8868\u5934"
    },
    modelValue: {
      type: Array,
      default: () => []
    },
    columns: {
      type: Array,
      default: () => []
    },
    col: {
      type: Number,
      default: 3
    },
    maxWidth: {
      type: String,
      default: ""
    },
    defaultGroup: {
      type: String,
      default: "\u5168\u9009"
    },
    localStoreKey: {
      type: String,
      default: ""
    },
    getColumn: {
      type: Function || null,
      default: null
    },
    setColumn: {
      type: Function || null,
      default: null
    },
    isTreeMode: {
      type: Boolean,
      default: true
    }
  },
  emits: ["close", "submit", "update:modelValue", "columnConfigChange"],
  setup(__props, { emit: emit2 }) {
    const props = __props;
    const $k18n = getK18n();
    const tableColSettingRef = ref(null);
    const COL_WIDTH_MAP = {
      2: "204px",
      3: "142px"
    };
    const state = reactive({
      dialogVisible: false,
      tableSetting: []
    });
    watch(
      () => props.columns,
      (val, oldVal) => {
        if (val && val.length && val !== oldVal) {
          getTableColumn();
        }
      },
      { immediate: true, deep: true }
    );
    function getTableColumn() {
      return __async(this, null, function* () {
        var _a, _b;
        state.tableSetting = [];
        let checkedColumns;
        const { localStoreKey, getColumn } = props;
        if (getColumn && isFunction$2(getColumn)) {
          try {
            checkedColumns = yield getColumn(props.localStoreKey);
          } catch (e) {
            checkedColumns = [];
          }
        } else if (props.localStoreKey) {
          checkedColumns = ((_a = localStorage.getItem(localStoreKey)) == null ? void 0 : _a.split(",")) || [];
        } else {
          console.error("\u3010tableColSetting\u3011\u5FC5\u987B\u4F20\u5165localStoreKey\u6216getColumn \u51FD\u6570\u624D\u53EF\u4F7F\u7528");
          return;
        }
        checkedColumns = checkedColumns == null ? void 0 : checkedColumns.filter((_) => _);
        if (!Array.isArray(checkedColumns) || checkedColumns.length === 0) {
          state.tableSetting = (_b = props.columns) == null ? void 0 : _b.filter((item) => !item.colHide);
        } else {
          checkedColumns.forEach((key) => {
            var _a2;
            if (key) {
              const findItem = (_a2 = props.columns) == null ? void 0 : _a2.find((item) => item.key === key);
              if (findItem) {
                state.tableSetting.push(findItem);
              }
            }
          });
        }
        updateModelValueHack(state.tableSetting, true);
      });
    }
    function addTableColumn(val) {
      return __async(this, null, function* () {
        const checkedColumns = val.map((item) => item.key).filter((_) => _);
        const { localStoreKey, setColumn } = props;
        if (setColumn && isFunction$2(setColumn)) {
          try {
            yield setColumn(checkedColumns, props.localStoreKey);
          } catch (e) {
          }
        } else if (props.localStoreKey) {
          localStorage.setItem(localStoreKey, checkedColumns.join());
        }
      });
    }
    function handleClickSubmit(val) {
      addTableColumn(val);
      updateModelValueHack(val, true);
      state.dialogVisible = false;
    }
    function updateModelValueHack(val, isColumnConfigChange = false) {
      const { modelValue: modelValue2 } = props;
      if (val.length === modelValue2.length) {
        emit2("update:modelValue", [...val, { width: "1px", key: "hackProTableItem", label: " " }]);
        nextTick(() => {
          emit2("update:modelValue", val);
        });
      } else {
        emit2("update:modelValue", val);
      }
      emit2("columnConfigChange", val, isColumnConfigChange);
    }
    return (_ctx, _cache) => {
      const _component_ks_dialog = resolveComponent("ks-dialog");
      return openBlock(), createElementBlock(Fragment, null, [
        createElementVNode("div", {
          class: "setting_icon",
          onClick: _cache[0] || (_cache[0] = ($event) => state.dialogVisible = true)
        }, [
          createVNode(unref(IconGeneralSetting), {
            size: "16",
            color: "#A6AAB7"
          }),
          createElementVNode("span", null, toDisplayString(unref($k18n)(__props.label)), 1)
        ]),
        createVNode(_component_ks_dialog, {
          modelValue: state.dialogVisible,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => state.dialogVisible = $event),
          title: unref($k18n)(__props.label),
          width: "868px",
          "custom-class": "table_col_setting_icon__dialog"
        }, {
          default: withCtx(() => [
            state.dialogVisible ? (openBlock(), createBlock(TableColSetting, {
              key: 0,
              ref_key: "tableColSettingRef",
              ref: tableColSettingRef,
              modelValue: state.tableSetting,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => state.tableSetting = $event),
              columns: __props.columns,
              "is-tree-mode": __props.isTreeMode,
              col: __props.col,
              "default-group": __props.defaultGroup,
              "max-width": COL_WIDTH_MAP[__props.col],
              onSubmit: handleClickSubmit,
              onClose: _cache[2] || (_cache[2] = ($event) => state.dialogVisible = false)
            }, null, 8, ["modelValue", "columns", "is-tree-mode", "col", "default-group", "max-width"])) : createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["modelValue", "title"])
      ], 64);
    };
  }
});
const SettingIcon = /* @__PURE__ */ _export_sfc(_sfc_main$N, [["__scopeId", "data-v-07b23d5f"]]);
const ToolButtons_vue_vue_type_style_index_0_scoped_true_lang = "";
const _hoisted_1$x = { class: "tool_buttons" };
const _hoisted_2$l = {
  key: 0,
  class: "item"
};
const _hoisted_3$h = { class: "switch_highlight__label" };
const _hoisted_4$c = {
  key: 2,
  class: "item"
};
const _sfc_main$M = /* @__PURE__ */ defineComponent({
  __name: "ToolButtons",
  props: {
    columns: {
      type: Array,
      default: () => []
    },
    downloadConfig: {
      type: [Object, Boolean],
      default: false
    },
    colSetting: {
      type: [Object, String],
      default: ""
    },
    modelValue: {
      type: Array,
      default: () => []
    }
  },
  emits: ["update:modelValue", "click-export", "click-switch", "columnConfigChange"],
  setup(__props, { emit: emit2 }) {
    const props = __props;
    const $k18n = getK18n();
    const state = reactive({
      tableColumn: [],
      switchValue: false
    });
    const localStoreKey = computed(() => {
      var _a;
      if (typeof props.colSetting === "string") {
        return props.colSetting;
      }
      return (_a = props == null ? void 0 : props.colSetting) == null ? void 0 : _a.localStoreKey;
    });
    const hasDataTrend = computed(() => {
      var _a;
      return !!((_a = props.columns) == null ? void 0 : _a.find((item) => !!item.dataTrend));
    });
    function handleClickDownload() {
      return __async(this, null, function* () {
        const { url, method = "", payload, headers, custom } = props.downloadConfig || {};
        if (url) {
          if (custom) {
            if (typeof custom === "boolean") {
              getDownload(url, payload);
            } else {
              custom == null ? void 0 : custom();
            }
          } else if (method && method === "POST") {
            const { data } = yield http(POST()`${url}`, payload, { headers });
            const { success, message } = data;
            if (typeof success === "boolean") {
              if (success) {
                Message.success(message || "\u4E0B\u8F7D\u6210\u529F");
              } else {
                Message.error(message || "\u4E0B\u8F7D\u5931\u8D25");
              }
            }
          } else {
            download(url);
          }
        }
        emit2("click-export");
      });
    }
    function handleClickSwitch() {
      emit2("click-switch", state.switchValue);
    }
    function handleClickUpdateModelValue(val) {
      emit2("update:modelValue", val);
    }
    function handleColumnConfigChange(val, isColumnConfigChange) {
      emit2("columnConfigChange", val, isColumnConfigChange);
    }
    return (_ctx, _cache) => {
      var _a;
      const _component_ks_switch = resolveComponent("ks-switch");
      return openBlock(), createElementBlock("div", _hoisted_1$x, [
        unref(hasDataTrend) ? (openBlock(), createElementBlock("div", _hoisted_2$l, [
          createVNode(_component_ks_switch, {
            modelValue: state.switchValue,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => state.switchValue = $event),
            class: "switch_highlight",
            "active-color": "#005cff",
            "inactive-color": "#bbbdbf",
            size: "mini",
            onClick: handleClickSwitch
          }, null, 8, ["modelValue"]),
          createElementVNode("span", _hoisted_3$h, toDisplayString(unref($k18n)("\u6570\u503C\u9AD8\u4EAE")), 1),
          createVNode(unref(ProTooltip), { class: "tooltip" }, {
            content: withCtx(() => [
              createElementVNode("div", null, toDisplayString(unref($k18n)("\u4FBF\u4E8E\u6BD4\u8F83\u4E0D\u540C\u7684\u6570\u636E\u6307\u6807\u5728\u5F53\u524D\u9875\u9762\u7684\u9AD8\u4F4E\u60C5\u51B5")), 1),
              createElementVNode("div", null, toDisplayString(unref($k18n)("\u4EE5\u5217\u6570\u636E\u4E3A\u57FA\u51C6\uFF0C\u5728\u5F53\u524D\u9875\u9762\u67D0\u4E2A\u6307\u6807\u7684\u6570\u503C\u8D8A\u9AD8\uFF0C\u989C\u8272\u8D8A\u6DF1")), 1)
            ]),
            _: 1
          })
        ])) : createCommentVNode("", true),
        __props.downloadConfig ? (openBlock(), createElementBlock("div", {
          key: 1,
          class: "item",
          onClick: handleClickDownload
        }, [
          createVNode(unref(IconGeneralDownload)),
          createTextVNode(" " + toDisplayString(unref($k18n)(((_a = __props.downloadConfig) == null ? void 0 : _a.text) || "\u5BFC\u51FA")), 1)
        ])) : createCommentVNode("", true),
        unref(localStoreKey) ? (openBlock(), createElementBlock("div", _hoisted_4$c, [
          createVNode(SettingIcon, mergeProps({
            columns: __props.columns,
            "local-store-key": unref(localStoreKey),
            "model-value": __props.modelValue
          }, _ctx.$attrs, {
            onColumnConfigChange: handleColumnConfigChange,
            "onUpdate:modelValue": handleClickUpdateModelValue
          }), null, 16, ["columns", "local-store-key", "model-value"])
        ])) : createCommentVNode("", true)
      ]);
    };
  }
});
const ToolButtons = /* @__PURE__ */ _export_sfc(_sfc_main$M, [["__scopeId", "data-v-0afcd6be"]]);
const index_vue_vue_type_style_index_0_scoped_true_lang$5 = "";
const _hoisted_1$w = {
  key: 0,
  class: "tool_bar__wrapper"
};
const _hoisted_2$k = { class: "flex_wrapper" };
const _sfc_main$L = /* @__PURE__ */ defineComponent({
  __name: "index",
  props: {
    modelValue: {
      type: Array,
      default: () => []
    }
  },
  emits: ["show", "click-switch", "columnConfigChange"],
  setup(__props, { emit: emit2 }) {
    const toolButtonsRef = ref(null);
    const slots = useSlots();
    const $attrs = useAttrs();
    function handleShow(item, scope) {
      emit2("show", item, scope);
    }
    function handleClickSwitch(val) {
      emit2("click-switch", val);
    }
    function handleColumnConfigChange(val, isColumnConfigChange) {
      emit2("columnConfigChange", val, isColumnConfigChange);
    }
    const showToolBar = computed(() => {
      const { operators, downloadConfig, colSetting, columns } = $attrs;
      const slotsNames = ["table-top-left", "operation-buttons-left", "operation-buttons-right", "table-top-right"];
      const slotsKeys = Object.keys(slots);
      const findItem = slotsKeys.find((key) => slotsNames.includes(key));
      const hasDataTrend = !!(columns == null ? void 0 : columns.find((item) => !!item.dataTrend));
      return downloadConfig || colSetting || findItem || hasDataTrend || (operators == null ? void 0 : operators.length);
    });
    return (_ctx, _cache) => {
      return unref(showToolBar) ? (openBlock(), createElementBlock("div", _hoisted_1$w, [
        createElementVNode("div", null, [
          renderSlot$2(_ctx.$slots, "table-top-left", {}, () => [
            renderSlot$2(_ctx.$slots, "operation-buttons-left", {}, void 0, true),
            createVNode(_sfc_main$1b, mergeProps(unref($attrs), { onShow: handleShow }), null, 16),
            renderSlot$2(_ctx.$slots, "operation-buttons-right", {}, void 0, true)
          ], true)
        ]),
        createElementVNode("div", _hoisted_2$k, [
          renderSlot$2(_ctx.$slots, "table-top-right", {}, () => [
            renderSlot$2(_ctx.$slots, "tool-buttons-left", {}, void 0, true),
            createVNode(ToolButtons, mergeProps(unref($attrs), {
              ref_key: "toolButtonsRef",
              ref: toolButtonsRef,
              "model-value": __props.modelValue,
              onClickSwitch: handleClickSwitch,
              onColumnConfigChange: handleColumnConfigChange
            }), null, 16, ["model-value"]),
            renderSlot$2(_ctx.$slots, "tool-buttons-right", {}, void 0, true)
          ], true)
        ])
      ])) : createCommentVNode("", true);
    };
  }
});
const ToolBar = /* @__PURE__ */ _export_sfc(_sfc_main$L, [["__scopeId", "data-v-81336dc4"]]);
function renderOperationButtons(props, ctx, state, payload) {
  var _a, _b;
  const { slots } = ctx;
  const { colSetting } = useGlobalConfig();
  const { getColumn, setColumn } = colSetting || {};
  function handleShow(item, scope) {
    payload == null ? void 0 : payload.handleDrawerComponentShow(item, scope);
  }
  function updateDataHighlight() {
    nextTick(() => {
      setDataHighlight({
        show: state.showDataHighlight,
        list: props.data,
        columns: payload.filterColumns
      });
    });
  }
  function renderAfterDataChange() {
    if (!state.showDataHighlight) {
      return;
    }
    updateDataHighlight();
  }
  renderAfterDataChange();
  return h(ToolBar, __spreadProps(__spreadValues({}, props), {
    onShow: handleShow,
    getColumn: ((_a = props.colSetting) == null ? void 0 : _a.getColumn) || getColumn,
    setColumn: ((_b = props.colSetting) == null ? void 0 : _b.setColumn) || setColumn,
    modelValue: state.renderColumns,
    "onUpdate:modelValue": (value2) => {
      state.renderColumns = value2;
    },
    onClickSwitch: (val) => {
      state.showDataHighlight = val;
      updateDataHighlight();
    },
    onColumnConfigChange: (val, isColumnConfigChange) => {
      ctx.emit("columnConfigChange", val, isColumnConfigChange);
    }
  }), __spreadValues({}, slots));
}
const renderImg = (scope, item) => {
  const { row: row2 } = scope;
  const props = __objRest(item, []);
  const val = getTransformData(row2, item);
  const image = h(Image$1, __spreadValues({
    style: "width: 120px; height: 52px; text-align: center; background: #f9f9f9",
    src: val,
    "preview-src-list": [val]
  }, props), {
    error: () => {
      return [h("div", { class: "image-slot" }, h("i", { class: "noah-icon-imageLoadError" }))];
    }
  });
  return h("div", { style: "height:52px;background: #f9f9f9; text-align: center;" }, image);
};
var top = "top";
var bottom = "bottom";
var right = "right";
var left = "left";
var auto = "auto";
var basePlacements = [top, bottom, right, left];
var start = "start";
var end = "end";
var clippingParents = "clippingParents";
var viewport = "viewport";
var popper = "popper";
var reference = "reference";
var variationPlacements = /* @__PURE__ */ basePlacements.reduce(function(acc, placement) {
  return acc.concat([placement + "-" + start, placement + "-" + end]);
}, []);
var placements = /* @__PURE__ */ [].concat(basePlacements, [auto]).reduce(function(acc, placement) {
  return acc.concat([placement, placement + "-" + start, placement + "-" + end]);
}, []);
var beforeRead = "beforeRead";
var read = "read";
var afterRead = "afterRead";
var beforeMain = "beforeMain";
var main = "main";
var afterMain = "afterMain";
var beforeWrite = "beforeWrite";
var write = "write";
var afterWrite = "afterWrite";
var modifierPhases = [beforeRead, read, afterRead, beforeMain, main, afterMain, beforeWrite, write, afterWrite];
function getNodeName(element) {
  return element ? (element.nodeName || "").toLowerCase() : null;
}
function getWindow(node) {
  if (node == null) {
    return window;
  }
  if (node.toString() !== "[object Window]") {
    var ownerDocument = node.ownerDocument;
    return ownerDocument ? ownerDocument.defaultView || window : window;
  }
  return node;
}
function isElement(node) {
  var OwnElement = getWindow(node).Element;
  return node instanceof OwnElement || node instanceof Element;
}
function isHTMLElement(node) {
  var OwnElement = getWindow(node).HTMLElement;
  return node instanceof OwnElement || node instanceof HTMLElement;
}
function isShadowRoot(node) {
  if (typeof ShadowRoot === "undefined") {
    return false;
  }
  var OwnElement = getWindow(node).ShadowRoot;
  return node instanceof OwnElement || node instanceof ShadowRoot;
}
function applyStyles(_ref) {
  var state = _ref.state;
  Object.keys(state.elements).forEach(function(name) {
    var style2 = state.styles[name] || {};
    var attributes = state.attributes[name] || {};
    var element = state.elements[name];
    if (!isHTMLElement(element) || !getNodeName(element)) {
      return;
    }
    Object.assign(element.style, style2);
    Object.keys(attributes).forEach(function(name2) {
      var value2 = attributes[name2];
      if (value2 === false) {
        element.removeAttribute(name2);
      } else {
        element.setAttribute(name2, value2 === true ? "" : value2);
      }
    });
  });
}
function effect$2(_ref2) {
  var state = _ref2.state;
  var initialStyles = {
    popper: {
      position: state.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  Object.assign(state.elements.popper.style, initialStyles.popper);
  state.styles = initialStyles;
  if (state.elements.arrow) {
    Object.assign(state.elements.arrow.style, initialStyles.arrow);
  }
  return function() {
    Object.keys(state.elements).forEach(function(name) {
      var element = state.elements[name];
      var attributes = state.attributes[name] || {};
      var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]);
      var style2 = styleProperties.reduce(function(style3, property) {
        style3[property] = "";
        return style3;
      }, {});
      if (!isHTMLElement(element) || !getNodeName(element)) {
        return;
      }
      Object.assign(element.style, style2);
      Object.keys(attributes).forEach(function(attribute) {
        element.removeAttribute(attribute);
      });
    });
  };
}
const applyStyles$1 = {
  name: "applyStyles",
  enabled: true,
  phase: "write",
  fn: applyStyles,
  effect: effect$2,
  requires: ["computeStyles"]
};
function getBasePlacement(placement) {
  return placement.split("-")[0];
}
var max = Math.max;
var min = Math.min;
var round = Math.round;
function getUAString() {
  var uaData = navigator.userAgentData;
  if (uaData != null && uaData.brands) {
    return uaData.brands.map(function(item) {
      return item.brand + "/" + item.version;
    }).join(" ");
  }
  return navigator.userAgent;
}
function isLayoutViewport() {
  return !/^((?!chrome|android).)*safari/i.test(getUAString());
}
function getBoundingClientRect(element, includeScale, isFixedStrategy) {
  if (includeScale === void 0) {
    includeScale = false;
  }
  if (isFixedStrategy === void 0) {
    isFixedStrategy = false;
  }
  var clientRect = element.getBoundingClientRect();
  var scaleX = 1;
  var scaleY = 1;
  if (includeScale && isHTMLElement(element)) {
    scaleX = element.offsetWidth > 0 ? round(clientRect.width) / element.offsetWidth || 1 : 1;
    scaleY = element.offsetHeight > 0 ? round(clientRect.height) / element.offsetHeight || 1 : 1;
  }
  var _ref = isElement(element) ? getWindow(element) : window, visualViewport = _ref.visualViewport;
  var addVisualOffsets = !isLayoutViewport() && isFixedStrategy;
  var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
  var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
  var width = clientRect.width / scaleX;
  var height = clientRect.height / scaleY;
  return {
    width,
    height,
    top: y,
    right: x + width,
    bottom: y + height,
    left: x,
    x,
    y
  };
}
function getLayoutRect(element) {
  var clientRect = getBoundingClientRect(element);
  var width = element.offsetWidth;
  var height = element.offsetHeight;
  if (Math.abs(clientRect.width - width) <= 1) {
    width = clientRect.width;
  }
  if (Math.abs(clientRect.height - height) <= 1) {
    height = clientRect.height;
  }
  return {
    x: element.offsetLeft,
    y: element.offsetTop,
    width,
    height
  };
}
function contains(parent, child) {
  var rootNode = child.getRootNode && child.getRootNode();
  if (parent.contains(child)) {
    return true;
  } else if (rootNode && isShadowRoot(rootNode)) {
    var next = child;
    do {
      if (next && parent.isSameNode(next)) {
        return true;
      }
      next = next.parentNode || next.host;
    } while (next);
  }
  return false;
}
function getComputedStyle(element) {
  return getWindow(element).getComputedStyle(element);
}
function isTableElement(element) {
  return ["table", "td", "th"].indexOf(getNodeName(element)) >= 0;
}
function getDocumentElement(element) {
  return ((isElement(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}
function getParentNode(element) {
  if (getNodeName(element) === "html") {
    return element;
  }
  return element.assignedSlot || element.parentNode || (isShadowRoot(element) ? element.host : null) || getDocumentElement(element);
}
function getTrueOffsetParent(element) {
  if (!isHTMLElement(element) || getComputedStyle(element).position === "fixed") {
    return null;
  }
  return element.offsetParent;
}
function getContainingBlock(element) {
  var isFirefox = /firefox/i.test(getUAString());
  var isIE = /Trident/i.test(getUAString());
  if (isIE && isHTMLElement(element)) {
    var elementCss = getComputedStyle(element);
    if (elementCss.position === "fixed") {
      return null;
    }
  }
  var currentNode = getParentNode(element);
  if (isShadowRoot(currentNode)) {
    currentNode = currentNode.host;
  }
  while (isHTMLElement(currentNode) && ["html", "body"].indexOf(getNodeName(currentNode)) < 0) {
    var css = getComputedStyle(currentNode);
    if (css.transform !== "none" || css.perspective !== "none" || css.contain === "paint" || ["transform", "perspective"].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === "filter" || isFirefox && css.filter && css.filter !== "none") {
      return currentNode;
    } else {
      currentNode = currentNode.parentNode;
    }
  }
  return null;
}
function getOffsetParent(element) {
  var window2 = getWindow(element);
  var offsetParent = getTrueOffsetParent(element);
  while (offsetParent && isTableElement(offsetParent) && getComputedStyle(offsetParent).position === "static") {
    offsetParent = getTrueOffsetParent(offsetParent);
  }
  if (offsetParent && (getNodeName(offsetParent) === "html" || getNodeName(offsetParent) === "body" && getComputedStyle(offsetParent).position === "static")) {
    return window2;
  }
  return offsetParent || getContainingBlock(element) || window2;
}
function getMainAxisFromPlacement(placement) {
  return ["top", "bottom"].indexOf(placement) >= 0 ? "x" : "y";
}
function within(min$1, value2, max$1) {
  return max(min$1, min(value2, max$1));
}
function withinMaxClamp(min2, value2, max2) {
  var v = within(min2, value2, max2);
  return v > max2 ? max2 : v;
}
function getFreshSideObject() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function mergePaddingObject(paddingObject) {
  return Object.assign({}, getFreshSideObject(), paddingObject);
}
function expandToHashMap(value2, keys) {
  return keys.reduce(function(hashMap, key) {
    hashMap[key] = value2;
    return hashMap;
  }, {});
}
var toPaddingObject = function toPaddingObject2(padding, state) {
  padding = typeof padding === "function" ? padding(Object.assign({}, state.rects, {
    placement: state.placement
  })) : padding;
  return mergePaddingObject(typeof padding !== "number" ? padding : expandToHashMap(padding, basePlacements));
};
function arrow(_ref) {
  var _state$modifiersData$;
  var state = _ref.state, name = _ref.name, options = _ref.options;
  var arrowElement = state.elements.arrow;
  var popperOffsets2 = state.modifiersData.popperOffsets;
  var basePlacement = getBasePlacement(state.placement);
  var axis = getMainAxisFromPlacement(basePlacement);
  var isVertical = [left, right].indexOf(basePlacement) >= 0;
  var len = isVertical ? "height" : "width";
  if (!arrowElement || !popperOffsets2) {
    return;
  }
  var paddingObject = toPaddingObject(options.padding, state);
  var arrowRect = getLayoutRect(arrowElement);
  var minProp = axis === "y" ? top : left;
  var maxProp = axis === "y" ? bottom : right;
  var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets2[axis] - state.rects.popper[len];
  var startDiff = popperOffsets2[axis] - state.rects.reference[axis];
  var arrowOffsetParent = getOffsetParent(arrowElement);
  var clientSize = arrowOffsetParent ? axis === "y" ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
  var centerToReference = endDiff / 2 - startDiff / 2;
  var min2 = paddingObject[minProp];
  var max2 = clientSize - arrowRect[len] - paddingObject[maxProp];
  var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
  var offset2 = within(min2, center, max2);
  var axisProp = axis;
  state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset2, _state$modifiersData$.centerOffset = offset2 - center, _state$modifiersData$);
}
function effect$1(_ref2) {
  var state = _ref2.state, options = _ref2.options;
  var _options$element = options.element, arrowElement = _options$element === void 0 ? "[data-popper-arrow]" : _options$element;
  if (arrowElement == null) {
    return;
  }
  if (typeof arrowElement === "string") {
    arrowElement = state.elements.popper.querySelector(arrowElement);
    if (!arrowElement) {
      return;
    }
  }
  if (process.env.NODE_ENV !== "production") {
    if (!isHTMLElement(arrowElement)) {
      console.error(['Popper: "arrow" element must be an HTMLElement (not an SVGElement).', "To use an SVG arrow, wrap it in an HTMLElement that will be used as", "the arrow."].join(" "));
    }
  }
  if (!contains(state.elements.popper, arrowElement)) {
    if (process.env.NODE_ENV !== "production") {
      console.error(['Popper: "arrow" modifier\'s `element` must be a child of the popper', "element."].join(" "));
    }
    return;
  }
  state.elements.arrow = arrowElement;
}
const arrow$1 = {
  name: "arrow",
  enabled: true,
  phase: "main",
  fn: arrow,
  effect: effect$1,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function getVariation(placement) {
  return placement.split("-")[1];
}
var unsetSides = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function roundOffsetsByDPR(_ref) {
  var x = _ref.x, y = _ref.y;
  var win = window;
  var dpr = win.devicePixelRatio || 1;
  return {
    x: round(x * dpr) / dpr || 0,
    y: round(y * dpr) / dpr || 0
  };
}
function mapToStyles(_ref2) {
  var _Object$assign2;
  var popper2 = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
  var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
  var _ref3 = typeof roundOffsets === "function" ? roundOffsets({
    x,
    y
  }) : {
    x,
    y
  };
  x = _ref3.x;
  y = _ref3.y;
  var hasX = offsets.hasOwnProperty("x");
  var hasY = offsets.hasOwnProperty("y");
  var sideX = left;
  var sideY = top;
  var win = window;
  if (adaptive) {
    var offsetParent = getOffsetParent(popper2);
    var heightProp = "clientHeight";
    var widthProp = "clientWidth";
    if (offsetParent === getWindow(popper2)) {
      offsetParent = getDocumentElement(popper2);
      if (getComputedStyle(offsetParent).position !== "static" && position === "absolute") {
        heightProp = "scrollHeight";
        widthProp = "scrollWidth";
      }
    }
    offsetParent = offsetParent;
    if (placement === top || (placement === left || placement === right) && variation === end) {
      sideY = bottom;
      var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
      y -= offsetY - popperRect.height;
      y *= gpuAcceleration ? 1 : -1;
    }
    if (placement === left || (placement === top || placement === bottom) && variation === end) {
      sideX = right;
      var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
      x -= offsetX - popperRect.width;
      x *= gpuAcceleration ? 1 : -1;
    }
  }
  var commonStyles = Object.assign({
    position
  }, adaptive && unsetSides);
  var _ref4 = roundOffsets === true ? roundOffsetsByDPR({
    x,
    y
  }) : {
    x,
    y
  };
  x = _ref4.x;
  y = _ref4.y;
  if (gpuAcceleration) {
    var _Object$assign;
    return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? "0" : "", _Object$assign[sideX] = hasX ? "0" : "", _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
  }
  return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : "", _Object$assign2[sideX] = hasX ? x + "px" : "", _Object$assign2.transform = "", _Object$assign2));
}
function computeStyles(_ref5) {
  var state = _ref5.state, options = _ref5.options;
  var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
  if (process.env.NODE_ENV !== "production") {
    var transitionProperty = getComputedStyle(state.elements.popper).transitionProperty || "";
    if (adaptive && ["transform", "top", "right", "bottom", "left"].some(function(property) {
      return transitionProperty.indexOf(property) >= 0;
    })) {
      console.warn(["Popper: Detected CSS transitions on at least one of the following", 'CSS properties: "transform", "top", "right", "bottom", "left".', "\n\n", 'Disable the "computeStyles" modifier\'s `adaptive` option to allow', "for smooth transitions, or remove these properties from the CSS", "transition declaration on the popper element if only transitioning", "opacity or background-color for example.", "\n\n", "We recommend using the popper element as a wrapper around an inner", "element that can have any CSS property transitioned for animations."].join(" "));
    }
  }
  var commonStyles = {
    placement: getBasePlacement(state.placement),
    variation: getVariation(state.placement),
    popper: state.elements.popper,
    popperRect: state.rects.popper,
    gpuAcceleration,
    isFixed: state.options.strategy === "fixed"
  };
  if (state.modifiersData.popperOffsets != null) {
    state.styles.popper = Object.assign({}, state.styles.popper, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.popperOffsets,
      position: state.options.strategy,
      adaptive,
      roundOffsets
    })));
  }
  if (state.modifiersData.arrow != null) {
    state.styles.arrow = Object.assign({}, state.styles.arrow, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.arrow,
      position: "absolute",
      adaptive: false,
      roundOffsets
    })));
  }
  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    "data-popper-placement": state.placement
  });
}
const computeStyles$1 = {
  name: "computeStyles",
  enabled: true,
  phase: "beforeWrite",
  fn: computeStyles,
  data: {}
};
var passive = {
  passive: true
};
function effect(_ref) {
  var state = _ref.state, instance = _ref.instance, options = _ref.options;
  var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
  var window2 = getWindow(state.elements.popper);
  var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
  if (scroll) {
    scrollParents.forEach(function(scrollParent) {
      scrollParent.addEventListener("scroll", instance.update, passive);
    });
  }
  if (resize) {
    window2.addEventListener("resize", instance.update, passive);
  }
  return function() {
    if (scroll) {
      scrollParents.forEach(function(scrollParent) {
        scrollParent.removeEventListener("scroll", instance.update, passive);
      });
    }
    if (resize) {
      window2.removeEventListener("resize", instance.update, passive);
    }
  };
}
const eventListeners = {
  name: "eventListeners",
  enabled: true,
  phase: "write",
  fn: function fn() {
  },
  effect,
  data: {}
};
var hash$1 = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, function(matched) {
    return hash$1[matched];
  });
}
var hash = {
  start: "end",
  end: "start"
};
function getOppositeVariationPlacement(placement) {
  return placement.replace(/start|end/g, function(matched) {
    return hash[matched];
  });
}
function getWindowScroll(node) {
  var win = getWindow(node);
  var scrollLeft = win.pageXOffset;
  var scrollTop = win.pageYOffset;
  return {
    scrollLeft,
    scrollTop
  };
}
function getWindowScrollBarX(element) {
  return getBoundingClientRect(getDocumentElement(element)).left + getWindowScroll(element).scrollLeft;
}
function getViewportRect(element, strategy) {
  var win = getWindow(element);
  var html = getDocumentElement(element);
  var visualViewport = win.visualViewport;
  var width = html.clientWidth;
  var height = html.clientHeight;
  var x = 0;
  var y = 0;
  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height;
    var layoutViewport = isLayoutViewport();
    if (layoutViewport || !layoutViewport && strategy === "fixed") {
      x = visualViewport.offsetLeft;
      y = visualViewport.offsetTop;
    }
  }
  return {
    width,
    height,
    x: x + getWindowScrollBarX(element),
    y
  };
}
function getDocumentRect(element) {
  var _element$ownerDocumen;
  var html = getDocumentElement(element);
  var winScroll = getWindowScroll(element);
  var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
  var width = max(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
  var height = max(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
  var x = -winScroll.scrollLeft + getWindowScrollBarX(element);
  var y = -winScroll.scrollTop;
  if (getComputedStyle(body || html).direction === "rtl") {
    x += max(html.clientWidth, body ? body.clientWidth : 0) - width;
  }
  return {
    width,
    height,
    x,
    y
  };
}
function isScrollParent(element) {
  var _getComputedStyle = getComputedStyle(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
  return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}
function getScrollParent(node) {
  if (["html", "body", "#document"].indexOf(getNodeName(node)) >= 0) {
    return node.ownerDocument.body;
  }
  if (isHTMLElement(node) && isScrollParent(node)) {
    return node;
  }
  return getScrollParent(getParentNode(node));
}
function listScrollParents(element, list) {
  var _element$ownerDocumen;
  if (list === void 0) {
    list = [];
  }
  var scrollParent = getScrollParent(element);
  var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
  var win = getWindow(scrollParent);
  var target = isBody ? [win].concat(win.visualViewport || [], isScrollParent(scrollParent) ? scrollParent : []) : scrollParent;
  var updatedList = list.concat(target);
  return isBody ? updatedList : updatedList.concat(listScrollParents(getParentNode(target)));
}
function rectToClientRect(rect) {
  return Object.assign({}, rect, {
    left: rect.x,
    top: rect.y,
    right: rect.x + rect.width,
    bottom: rect.y + rect.height
  });
}
function getInnerBoundingClientRect(element, strategy) {
  var rect = getBoundingClientRect(element, false, strategy === "fixed");
  rect.top = rect.top + element.clientTop;
  rect.left = rect.left + element.clientLeft;
  rect.bottom = rect.top + element.clientHeight;
  rect.right = rect.left + element.clientWidth;
  rect.width = element.clientWidth;
  rect.height = element.clientHeight;
  rect.x = rect.left;
  rect.y = rect.top;
  return rect;
}
function getClientRectFromMixedType(element, clippingParent, strategy) {
  return clippingParent === viewport ? rectToClientRect(getViewportRect(element, strategy)) : isElement(clippingParent) ? getInnerBoundingClientRect(clippingParent, strategy) : rectToClientRect(getDocumentRect(getDocumentElement(element)));
}
function getClippingParents(element) {
  var clippingParents2 = listScrollParents(getParentNode(element));
  var canEscapeClipping = ["absolute", "fixed"].indexOf(getComputedStyle(element).position) >= 0;
  var clipperElement = canEscapeClipping && isHTMLElement(element) ? getOffsetParent(element) : element;
  if (!isElement(clipperElement)) {
    return [];
  }
  return clippingParents2.filter(function(clippingParent) {
    return isElement(clippingParent) && contains(clippingParent, clipperElement) && getNodeName(clippingParent) !== "body";
  });
}
function getClippingRect(element, boundary, rootBoundary, strategy) {
  var mainClippingParents = boundary === "clippingParents" ? getClippingParents(element) : [].concat(boundary);
  var clippingParents2 = [].concat(mainClippingParents, [rootBoundary]);
  var firstClippingParent = clippingParents2[0];
  var clippingRect = clippingParents2.reduce(function(accRect, clippingParent) {
    var rect = getClientRectFromMixedType(element, clippingParent, strategy);
    accRect.top = max(rect.top, accRect.top);
    accRect.right = min(rect.right, accRect.right);
    accRect.bottom = min(rect.bottom, accRect.bottom);
    accRect.left = max(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromMixedType(element, firstClippingParent, strategy));
  clippingRect.width = clippingRect.right - clippingRect.left;
  clippingRect.height = clippingRect.bottom - clippingRect.top;
  clippingRect.x = clippingRect.left;
  clippingRect.y = clippingRect.top;
  return clippingRect;
}
function computeOffsets(_ref) {
  var reference2 = _ref.reference, element = _ref.element, placement = _ref.placement;
  var basePlacement = placement ? getBasePlacement(placement) : null;
  var variation = placement ? getVariation(placement) : null;
  var commonX = reference2.x + reference2.width / 2 - element.width / 2;
  var commonY = reference2.y + reference2.height / 2 - element.height / 2;
  var offsets;
  switch (basePlacement) {
    case top:
      offsets = {
        x: commonX,
        y: reference2.y - element.height
      };
      break;
    case bottom:
      offsets = {
        x: commonX,
        y: reference2.y + reference2.height
      };
      break;
    case right:
      offsets = {
        x: reference2.x + reference2.width,
        y: commonY
      };
      break;
    case left:
      offsets = {
        x: reference2.x - element.width,
        y: commonY
      };
      break;
    default:
      offsets = {
        x: reference2.x,
        y: reference2.y
      };
  }
  var mainAxis = basePlacement ? getMainAxisFromPlacement(basePlacement) : null;
  if (mainAxis != null) {
    var len = mainAxis === "y" ? "height" : "width";
    switch (variation) {
      case start:
        offsets[mainAxis] = offsets[mainAxis] - (reference2[len] / 2 - element[len] / 2);
        break;
      case end:
        offsets[mainAxis] = offsets[mainAxis] + (reference2[len] / 2 - element[len] / 2);
        break;
    }
  }
  return offsets;
}
function detectOverflow(state, options) {
  if (options === void 0) {
    options = {};
  }
  var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? clippingParents : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? viewport : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? popper : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
  var paddingObject = mergePaddingObject(typeof padding !== "number" ? padding : expandToHashMap(padding, basePlacements));
  var altContext = elementContext === popper ? reference : popper;
  var popperRect = state.rects.popper;
  var element = state.elements[altBoundary ? altContext : elementContext];
  var clippingClientRect = getClippingRect(isElement(element) ? element : element.contextElement || getDocumentElement(state.elements.popper), boundary, rootBoundary, strategy);
  var referenceClientRect = getBoundingClientRect(state.elements.reference);
  var popperOffsets2 = computeOffsets({
    reference: referenceClientRect,
    element: popperRect,
    strategy: "absolute",
    placement
  });
  var popperClientRect = rectToClientRect(Object.assign({}, popperRect, popperOffsets2));
  var elementClientRect = elementContext === popper ? popperClientRect : referenceClientRect;
  var overflowOffsets = {
    top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
    bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
    left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
    right: elementClientRect.right - clippingClientRect.right + paddingObject.right
  };
  var offsetData = state.modifiersData.offset;
  if (elementContext === popper && offsetData) {
    var offset2 = offsetData[placement];
    Object.keys(overflowOffsets).forEach(function(key) {
      var multiply = [right, bottom].indexOf(key) >= 0 ? 1 : -1;
      var axis = [top, bottom].indexOf(key) >= 0 ? "y" : "x";
      overflowOffsets[key] += offset2[axis] * multiply;
    });
  }
  return overflowOffsets;
}
function computeAutoPlacement(state, options) {
  if (options === void 0) {
    options = {};
  }
  var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? placements : _options$allowedAutoP;
  var variation = getVariation(placement);
  var placements$1 = variation ? flipVariations ? variationPlacements : variationPlacements.filter(function(placement2) {
    return getVariation(placement2) === variation;
  }) : basePlacements;
  var allowedPlacements = placements$1.filter(function(placement2) {
    return allowedAutoPlacements.indexOf(placement2) >= 0;
  });
  if (allowedPlacements.length === 0) {
    allowedPlacements = placements$1;
    if (process.env.NODE_ENV !== "production") {
      console.error(["Popper: The `allowedAutoPlacements` option did not allow any", "placements. Ensure the `placement` option matches the variation", "of the allowed placements.", 'For example, "auto" cannot be used to allow "bottom-start".', 'Use "auto-start" instead.'].join(" "));
    }
  }
  var overflows = allowedPlacements.reduce(function(acc, placement2) {
    acc[placement2] = detectOverflow(state, {
      placement: placement2,
      boundary,
      rootBoundary,
      padding
    })[getBasePlacement(placement2)];
    return acc;
  }, {});
  return Object.keys(overflows).sort(function(a, b) {
    return overflows[a] - overflows[b];
  });
}
function getExpandedFallbackPlacements(placement) {
  if (getBasePlacement(placement) === auto) {
    return [];
  }
  var oppositePlacement = getOppositePlacement(placement);
  return [getOppositeVariationPlacement(placement), oppositePlacement, getOppositeVariationPlacement(oppositePlacement)];
}
function flip(_ref) {
  var state = _ref.state, options = _ref.options, name = _ref.name;
  if (state.modifiersData[name]._skip) {
    return;
  }
  var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
  var preferredPlacement = state.options.placement;
  var basePlacement = getBasePlacement(preferredPlacement);
  var isBasePlacement = basePlacement === preferredPlacement;
  var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [getOppositePlacement(preferredPlacement)] : getExpandedFallbackPlacements(preferredPlacement));
  var placements2 = [preferredPlacement].concat(fallbackPlacements).reduce(function(acc, placement2) {
    return acc.concat(getBasePlacement(placement2) === auto ? computeAutoPlacement(state, {
      placement: placement2,
      boundary,
      rootBoundary,
      padding,
      flipVariations,
      allowedAutoPlacements
    }) : placement2);
  }, []);
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var checksMap = /* @__PURE__ */ new Map();
  var makeFallbackChecks = true;
  var firstFittingPlacement = placements2[0];
  for (var i = 0; i < placements2.length; i++) {
    var placement = placements2[i];
    var _basePlacement = getBasePlacement(placement);
    var isStartVariation = getVariation(placement) === start;
    var isVertical = [top, bottom].indexOf(_basePlacement) >= 0;
    var len = isVertical ? "width" : "height";
    var overflow = detectOverflow(state, {
      placement,
      boundary,
      rootBoundary,
      altBoundary,
      padding
    });
    var mainVariationSide = isVertical ? isStartVariation ? right : left : isStartVariation ? bottom : top;
    if (referenceRect[len] > popperRect[len]) {
      mainVariationSide = getOppositePlacement(mainVariationSide);
    }
    var altVariationSide = getOppositePlacement(mainVariationSide);
    var checks = [];
    if (checkMainAxis) {
      checks.push(overflow[_basePlacement] <= 0);
    }
    if (checkAltAxis) {
      checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
    }
    if (checks.every(function(check) {
      return check;
    })) {
      firstFittingPlacement = placement;
      makeFallbackChecks = false;
      break;
    }
    checksMap.set(placement, checks);
  }
  if (makeFallbackChecks) {
    var numberOfChecks = flipVariations ? 3 : 1;
    var _loop = function _loop2(_i2) {
      var fittingPlacement = placements2.find(function(placement2) {
        var checks2 = checksMap.get(placement2);
        if (checks2) {
          return checks2.slice(0, _i2).every(function(check) {
            return check;
          });
        }
      });
      if (fittingPlacement) {
        firstFittingPlacement = fittingPlacement;
        return "break";
      }
    };
    for (var _i = numberOfChecks; _i > 0; _i--) {
      var _ret = _loop(_i);
      if (_ret === "break")
        break;
    }
  }
  if (state.placement !== firstFittingPlacement) {
    state.modifiersData[name]._skip = true;
    state.placement = firstFittingPlacement;
    state.reset = true;
  }
}
const flip$1 = {
  name: "flip",
  enabled: true,
  phase: "main",
  fn: flip,
  requiresIfExists: ["offset"],
  data: {
    _skip: false
  }
};
function getSideOffsets(overflow, rect, preventedOffsets) {
  if (preventedOffsets === void 0) {
    preventedOffsets = {
      x: 0,
      y: 0
    };
  }
  return {
    top: overflow.top - rect.height - preventedOffsets.y,
    right: overflow.right - rect.width + preventedOffsets.x,
    bottom: overflow.bottom - rect.height + preventedOffsets.y,
    left: overflow.left - rect.width - preventedOffsets.x
  };
}
function isAnySideFullyClipped(overflow) {
  return [top, right, bottom, left].some(function(side) {
    return overflow[side] >= 0;
  });
}
function hide(_ref) {
  var state = _ref.state, name = _ref.name;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var preventedOffsets = state.modifiersData.preventOverflow;
  var referenceOverflow = detectOverflow(state, {
    elementContext: "reference"
  });
  var popperAltOverflow = detectOverflow(state, {
    altBoundary: true
  });
  var referenceClippingOffsets = getSideOffsets(referenceOverflow, referenceRect);
  var popperEscapeOffsets = getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
  var isReferenceHidden = isAnySideFullyClipped(referenceClippingOffsets);
  var hasPopperEscaped = isAnySideFullyClipped(popperEscapeOffsets);
  state.modifiersData[name] = {
    referenceClippingOffsets,
    popperEscapeOffsets,
    isReferenceHidden,
    hasPopperEscaped
  };
  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    "data-popper-reference-hidden": isReferenceHidden,
    "data-popper-escaped": hasPopperEscaped
  });
}
const hide$1 = {
  name: "hide",
  enabled: true,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: hide
};
function distanceAndSkiddingToXY(placement, rects, offset2) {
  var basePlacement = getBasePlacement(placement);
  var invertDistance = [left, top].indexOf(basePlacement) >= 0 ? -1 : 1;
  var _ref = typeof offset2 === "function" ? offset2(Object.assign({}, rects, {
    placement
  })) : offset2, skidding = _ref[0], distance = _ref[1];
  skidding = skidding || 0;
  distance = (distance || 0) * invertDistance;
  return [left, right].indexOf(basePlacement) >= 0 ? {
    x: distance,
    y: skidding
  } : {
    x: skidding,
    y: distance
  };
}
function offset(_ref2) {
  var state = _ref2.state, options = _ref2.options, name = _ref2.name;
  var _options$offset = options.offset, offset2 = _options$offset === void 0 ? [0, 0] : _options$offset;
  var data = placements.reduce(function(acc, placement) {
    acc[placement] = distanceAndSkiddingToXY(placement, state.rects, offset2);
    return acc;
  }, {});
  var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
  if (state.modifiersData.popperOffsets != null) {
    state.modifiersData.popperOffsets.x += x;
    state.modifiersData.popperOffsets.y += y;
  }
  state.modifiersData[name] = data;
}
const offset$1 = {
  name: "offset",
  enabled: true,
  phase: "main",
  requires: ["popperOffsets"],
  fn: offset
};
function popperOffsets(_ref) {
  var state = _ref.state, name = _ref.name;
  state.modifiersData[name] = computeOffsets({
    reference: state.rects.reference,
    element: state.rects.popper,
    strategy: "absolute",
    placement: state.placement
  });
}
const popperOffsets$1 = {
  name: "popperOffsets",
  enabled: true,
  phase: "read",
  fn: popperOffsets,
  data: {}
};
function getAltAxis(axis) {
  return axis === "x" ? "y" : "x";
}
function preventOverflow(_ref) {
  var state = _ref.state, options = _ref.options, name = _ref.name;
  var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
  var overflow = detectOverflow(state, {
    boundary,
    rootBoundary,
    padding,
    altBoundary
  });
  var basePlacement = getBasePlacement(state.placement);
  var variation = getVariation(state.placement);
  var isBasePlacement = !variation;
  var mainAxis = getMainAxisFromPlacement(basePlacement);
  var altAxis = getAltAxis(mainAxis);
  var popperOffsets2 = state.modifiersData.popperOffsets;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var tetherOffsetValue = typeof tetherOffset === "function" ? tetherOffset(Object.assign({}, state.rects, {
    placement: state.placement
  })) : tetherOffset;
  var normalizedTetherOffsetValue = typeof tetherOffsetValue === "number" ? {
    mainAxis: tetherOffsetValue,
    altAxis: tetherOffsetValue
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, tetherOffsetValue);
  var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
  var data = {
    x: 0,
    y: 0
  };
  if (!popperOffsets2) {
    return;
  }
  if (checkMainAxis) {
    var _offsetModifierState$;
    var mainSide = mainAxis === "y" ? top : left;
    var altSide = mainAxis === "y" ? bottom : right;
    var len = mainAxis === "y" ? "height" : "width";
    var offset2 = popperOffsets2[mainAxis];
    var min$1 = offset2 + overflow[mainSide];
    var max$1 = offset2 - overflow[altSide];
    var additive = tether ? -popperRect[len] / 2 : 0;
    var minLen = variation === start ? referenceRect[len] : popperRect[len];
    var maxLen = variation === start ? -popperRect[len] : -referenceRect[len];
    var arrowElement = state.elements.arrow;
    var arrowRect = tether && arrowElement ? getLayoutRect(arrowElement) : {
      width: 0,
      height: 0
    };
    var arrowPaddingObject = state.modifiersData["arrow#persistent"] ? state.modifiersData["arrow#persistent"].padding : getFreshSideObject();
    var arrowPaddingMin = arrowPaddingObject[mainSide];
    var arrowPaddingMax = arrowPaddingObject[altSide];
    var arrowLen = within(0, referenceRect[len], arrowRect[len]);
    var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
    var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
    var arrowOffsetParent = state.elements.arrow && getOffsetParent(state.elements.arrow);
    var clientOffset = arrowOffsetParent ? mainAxis === "y" ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
    var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
    var tetherMin = offset2 + minOffset - offsetModifierValue - clientOffset;
    var tetherMax = offset2 + maxOffset - offsetModifierValue;
    var preventedOffset = within(tether ? min(min$1, tetherMin) : min$1, offset2, tether ? max(max$1, tetherMax) : max$1);
    popperOffsets2[mainAxis] = preventedOffset;
    data[mainAxis] = preventedOffset - offset2;
  }
  if (checkAltAxis) {
    var _offsetModifierState$2;
    var _mainSide = mainAxis === "x" ? top : left;
    var _altSide = mainAxis === "x" ? bottom : right;
    var _offset = popperOffsets2[altAxis];
    var _len = altAxis === "y" ? "height" : "width";
    var _min = _offset + overflow[_mainSide];
    var _max = _offset - overflow[_altSide];
    var isOriginSide = [top, left].indexOf(basePlacement) !== -1;
    var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
    var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
    var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
    var _preventedOffset = tether && isOriginSide ? withinMaxClamp(_tetherMin, _offset, _tetherMax) : within(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
    popperOffsets2[altAxis] = _preventedOffset;
    data[altAxis] = _preventedOffset - _offset;
  }
  state.modifiersData[name] = data;
}
const preventOverflow$1 = {
  name: "preventOverflow",
  enabled: true,
  phase: "main",
  fn: preventOverflow,
  requiresIfExists: ["offset"]
};
function getHTMLElementScroll(element) {
  return {
    scrollLeft: element.scrollLeft,
    scrollTop: element.scrollTop
  };
}
function getNodeScroll(node) {
  if (node === getWindow(node) || !isHTMLElement(node)) {
    return getWindowScroll(node);
  } else {
    return getHTMLElementScroll(node);
  }
}
function isElementScaled(element) {
  var rect = element.getBoundingClientRect();
  var scaleX = round(rect.width) / element.offsetWidth || 1;
  var scaleY = round(rect.height) / element.offsetHeight || 1;
  return scaleX !== 1 || scaleY !== 1;
}
function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
  if (isFixed === void 0) {
    isFixed = false;
  }
  var isOffsetParentAnElement = isHTMLElement(offsetParent);
  var offsetParentIsScaled = isHTMLElement(offsetParent) && isElementScaled(offsetParent);
  var documentElement = getDocumentElement(offsetParent);
  var rect = getBoundingClientRect(elementOrVirtualElement, offsetParentIsScaled, isFixed);
  var scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  var offsets = {
    x: 0,
    y: 0
  };
  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== "body" || isScrollParent(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }
    if (isHTMLElement(offsetParent)) {
      offsets = getBoundingClientRect(offsetParent, true);
      offsets.x += offsetParent.clientLeft;
      offsets.y += offsetParent.clientTop;
    } else if (documentElement) {
      offsets.x = getWindowScrollBarX(documentElement);
    }
  }
  return {
    x: rect.left + scroll.scrollLeft - offsets.x,
    y: rect.top + scroll.scrollTop - offsets.y,
    width: rect.width,
    height: rect.height
  };
}
function order(modifiers) {
  var map = /* @__PURE__ */ new Map();
  var visited = /* @__PURE__ */ new Set();
  var result = [];
  modifiers.forEach(function(modifier) {
    map.set(modifier.name, modifier);
  });
  function sort(modifier) {
    visited.add(modifier.name);
    var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
    requires.forEach(function(dep) {
      if (!visited.has(dep)) {
        var depModifier = map.get(dep);
        if (depModifier) {
          sort(depModifier);
        }
      }
    });
    result.push(modifier);
  }
  modifiers.forEach(function(modifier) {
    if (!visited.has(modifier.name)) {
      sort(modifier);
    }
  });
  return result;
}
function orderModifiers(modifiers) {
  var orderedModifiers = order(modifiers);
  return modifierPhases.reduce(function(acc, phase) {
    return acc.concat(orderedModifiers.filter(function(modifier) {
      return modifier.phase === phase;
    }));
  }, []);
}
function debounce(fn2) {
  var pending;
  return function() {
    if (!pending) {
      pending = new Promise(function(resolve2) {
        Promise.resolve().then(function() {
          pending = void 0;
          resolve2(fn2());
        });
      });
    }
    return pending;
  };
}
function format(str) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }
  return [].concat(args).reduce(function(p, c) {
    return p.replace(/%s/, c);
  }, str);
}
var INVALID_MODIFIER_ERROR = 'Popper: modifier "%s" provided an invalid %s property, expected %s but got %s';
var MISSING_DEPENDENCY_ERROR = 'Popper: modifier "%s" requires "%s", but "%s" modifier is not available';
var VALID_PROPERTIES = ["name", "enabled", "phase", "fn", "effect", "requires", "options"];
function validateModifiers(modifiers) {
  modifiers.forEach(function(modifier) {
    [].concat(Object.keys(modifier), VALID_PROPERTIES).filter(function(value2, index2, self2) {
      return self2.indexOf(value2) === index2;
    }).forEach(function(key) {
      switch (key) {
        case "name":
          if (typeof modifier.name !== "string") {
            console.error(format(INVALID_MODIFIER_ERROR, String(modifier.name), '"name"', '"string"', '"' + String(modifier.name) + '"'));
          }
          break;
        case "enabled":
          if (typeof modifier.enabled !== "boolean") {
            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"enabled"', '"boolean"', '"' + String(modifier.enabled) + '"'));
          }
          break;
        case "phase":
          if (modifierPhases.indexOf(modifier.phase) < 0) {
            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"phase"', "either " + modifierPhases.join(", "), '"' + String(modifier.phase) + '"'));
          }
          break;
        case "fn":
          if (typeof modifier.fn !== "function") {
            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"fn"', '"function"', '"' + String(modifier.fn) + '"'));
          }
          break;
        case "effect":
          if (modifier.effect != null && typeof modifier.effect !== "function") {
            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"effect"', '"function"', '"' + String(modifier.fn) + '"'));
          }
          break;
        case "requires":
          if (modifier.requires != null && !Array.isArray(modifier.requires)) {
            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"requires"', '"array"', '"' + String(modifier.requires) + '"'));
          }
          break;
        case "requiresIfExists":
          if (!Array.isArray(modifier.requiresIfExists)) {
            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"requiresIfExists"', '"array"', '"' + String(modifier.requiresIfExists) + '"'));
          }
          break;
        case "options":
        case "data":
          break;
        default:
          console.error('PopperJS: an invalid property has been provided to the "' + modifier.name + '" modifier, valid properties are ' + VALID_PROPERTIES.map(function(s) {
            return '"' + s + '"';
          }).join(", ") + '; but "' + key + '" was provided.');
      }
      modifier.requires && modifier.requires.forEach(function(requirement) {
        if (modifiers.find(function(mod) {
          return mod.name === requirement;
        }) == null) {
          console.error(format(MISSING_DEPENDENCY_ERROR, String(modifier.name), requirement, requirement));
        }
      });
    });
  });
}
function uniqueBy(arr, fn2) {
  var identifiers = /* @__PURE__ */ new Set();
  return arr.filter(function(item) {
    var identifier = fn2(item);
    if (!identifiers.has(identifier)) {
      identifiers.add(identifier);
      return true;
    }
  });
}
function mergeByName(modifiers) {
  var merged = modifiers.reduce(function(merged2, current) {
    var existing = merged2[current.name];
    merged2[current.name] = existing ? Object.assign({}, existing, current, {
      options: Object.assign({}, existing.options, current.options),
      data: Object.assign({}, existing.data, current.data)
    }) : current;
    return merged2;
  }, {});
  return Object.keys(merged).map(function(key) {
    return merged[key];
  });
}
var INVALID_ELEMENT_ERROR = "Popper: Invalid reference or popper argument provided. They must be either a DOM element or virtual element.";
var INFINITE_LOOP_ERROR = "Popper: An infinite loop in the modifiers cycle has been detected! The cycle has been interrupted to prevent a browser crash.";
var DEFAULT_OPTIONS = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function areValidElements() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  return !args.some(function(element) {
    return !(element && typeof element.getBoundingClientRect === "function");
  });
}
function popperGenerator(generatorOptions) {
  if (generatorOptions === void 0) {
    generatorOptions = {};
  }
  var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers2 = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? DEFAULT_OPTIONS : _generatorOptions$def2;
  return function createPopper2(reference2, popper2, options) {
    if (options === void 0) {
      options = defaultOptions;
    }
    var state = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, DEFAULT_OPTIONS, defaultOptions),
      modifiersData: {},
      elements: {
        reference: reference2,
        popper: popper2
      },
      attributes: {},
      styles: {}
    };
    var effectCleanupFns = [];
    var isDestroyed = false;
    var instance = {
      state,
      setOptions: function setOptions(setOptionsAction) {
        var options2 = typeof setOptionsAction === "function" ? setOptionsAction(state.options) : setOptionsAction;
        cleanupModifierEffects();
        state.options = Object.assign({}, defaultOptions, state.options, options2);
        state.scrollParents = {
          reference: isElement(reference2) ? listScrollParents(reference2) : reference2.contextElement ? listScrollParents(reference2.contextElement) : [],
          popper: listScrollParents(popper2)
        };
        var orderedModifiers = orderModifiers(mergeByName([].concat(defaultModifiers2, state.options.modifiers)));
        state.orderedModifiers = orderedModifiers.filter(function(m) {
          return m.enabled;
        });
        if (process.env.NODE_ENV !== "production") {
          var modifiers = uniqueBy([].concat(orderedModifiers, state.options.modifiers), function(_ref) {
            var name = _ref.name;
            return name;
          });
          validateModifiers(modifiers);
          if (getBasePlacement(state.options.placement) === auto) {
            var flipModifier = state.orderedModifiers.find(function(_ref2) {
              var name = _ref2.name;
              return name === "flip";
            });
            if (!flipModifier) {
              console.error(['Popper: "auto" placements require the "flip" modifier be', "present and enabled to work."].join(" "));
            }
          }
          var _getComputedStyle = getComputedStyle(popper2), marginTop = _getComputedStyle.marginTop, marginRight = _getComputedStyle.marginRight, marginBottom = _getComputedStyle.marginBottom, marginLeft = _getComputedStyle.marginLeft;
          if ([marginTop, marginRight, marginBottom, marginLeft].some(function(margin) {
            return parseFloat(margin);
          })) {
            console.warn(['Popper: CSS "margin" styles cannot be used to apply padding', "between the popper and its reference element or boundary.", "To replicate margin, use the `offset` modifier, as well as", "the `padding` option in the `preventOverflow` and `flip`", "modifiers."].join(" "));
          }
        }
        runModifierEffects();
        return instance.update();
      },
      forceUpdate: function forceUpdate() {
        if (isDestroyed) {
          return;
        }
        var _state$elements = state.elements, reference3 = _state$elements.reference, popper3 = _state$elements.popper;
        if (!areValidElements(reference3, popper3)) {
          if (process.env.NODE_ENV !== "production") {
            console.error(INVALID_ELEMENT_ERROR);
          }
          return;
        }
        state.rects = {
          reference: getCompositeRect(reference3, getOffsetParent(popper3), state.options.strategy === "fixed"),
          popper: getLayoutRect(popper3)
        };
        state.reset = false;
        state.placement = state.options.placement;
        state.orderedModifiers.forEach(function(modifier) {
          return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
        });
        var __debug_loops__ = 0;
        for (var index2 = 0; index2 < state.orderedModifiers.length; index2++) {
          if (process.env.NODE_ENV !== "production") {
            __debug_loops__ += 1;
            if (__debug_loops__ > 100) {
              console.error(INFINITE_LOOP_ERROR);
              break;
            }
          }
          if (state.reset === true) {
            state.reset = false;
            index2 = -1;
            continue;
          }
          var _state$orderedModifie = state.orderedModifiers[index2], fn2 = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
          if (typeof fn2 === "function") {
            state = fn2({
              state,
              options: _options,
              name,
              instance
            }) || state;
          }
        }
      },
      update: debounce(function() {
        return new Promise(function(resolve2) {
          instance.forceUpdate();
          resolve2(state);
        });
      }),
      destroy: function destroy() {
        cleanupModifierEffects();
        isDestroyed = true;
      }
    };
    if (!areValidElements(reference2, popper2)) {
      if (process.env.NODE_ENV !== "production") {
        console.error(INVALID_ELEMENT_ERROR);
      }
      return instance;
    }
    instance.setOptions(options).then(function(state2) {
      if (!isDestroyed && options.onFirstUpdate) {
        options.onFirstUpdate(state2);
      }
    });
    function runModifierEffects() {
      state.orderedModifiers.forEach(function(_ref3) {
        var name = _ref3.name, _ref3$options = _ref3.options, options2 = _ref3$options === void 0 ? {} : _ref3$options, effect2 = _ref3.effect;
        if (typeof effect2 === "function") {
          var cleanupFn = effect2({
            state,
            name,
            instance,
            options: options2
          });
          var noopFn = function noopFn2() {
          };
          effectCleanupFns.push(cleanupFn || noopFn);
        }
      });
    }
    function cleanupModifierEffects() {
      effectCleanupFns.forEach(function(fn2) {
        return fn2();
      });
      effectCleanupFns = [];
    }
    return instance;
  };
}
var defaultModifiers = [eventListeners, popperOffsets$1, computeStyles$1, applyStyles$1, offset$1, flip$1, preventOverflow$1, arrow$1, hide$1];
var createPopper = /* @__PURE__ */ popperGenerator({
  defaultModifiers
});
const text = "";
let removePopper;
let popperInstance;
const DEFAULT$3 = {
  handler: emptyFunc
};
function createTablePopper(trigger, popperContent, popperOptions) {
  function renderContent() {
    const content2 = document.createElement("div");
    content2.innerHTML = popperContent;
    content2.className = "is-dark";
    content2.style.zIndex = "3000";
    document.body.appendChild(content2);
    return content2;
  }
  function renderArrow() {
    const arrow22 = document.createElement("div");
    arrow22.id = "arrow";
    arrow22.style.bottom = "-4px";
    return arrow22;
  }
  removePopper = function removePopperFunc() {
    try {
      popperInstance && popperInstance.destroy();
      content && document.body.removeChild(content);
    } catch (e) {
    }
  };
  const content = renderContent();
  const arrow2 = renderArrow();
  content.appendChild(arrow2);
  popperInstance = createPopper(trigger, content, __spreadValues({
    modifiers: [
      {
        name: "offset",
        options: {
          offset: [0, 8]
        }
      },
      {
        name: "arrow",
        options: {
          element: arrow2,
          padding: 10
        }
      }
    ]
  }, popperOptions));
  return popperInstance;
}
function handleCellMouseLeave() {
  popperInstance && removePopper();
}
function handleCellMouseEnter(event) {
  const target = event.target;
  const targetSpan = target.querySelector("span");
  if (targetSpan.offsetHeight > target.offsetHeight) {
    const popperContent = targetSpan.innerText || targetSpan.textContent || "";
    createTablePopper(target, popperContent);
  }
}
function renderArray(row2, item, val) {
  const { lineClamp = 2, handler, type } = item;
  val = val.map((rowItem) => getK18nValue(rowItem, item));
  let disabled = true;
  let contentSlot;
  let defaultTxt;
  if (val.length > lineClamp) {
    disabled = false;
    const textArr = val.slice(0, lineClamp);
    textArr[lineClamp - 1] = `${textArr[lineClamp - 1]}...`;
    defaultTxt = textArr.map((rowItem) => {
      return h("div", rowItem);
    });
    contentSlot = val.join(",");
  } else {
    defaultTxt = val.map((rowItem) => {
      return h("div", rowItem);
    });
    disabled = true;
  }
  const defaultSlot = h("div", {
    class: type === TABLE_ITEM_TYPE.LINK ? "ilb tooltip-text-link" : "ilb",
    onClick: typeof handler === "function" ? () => handler(row2) : () => {
    }
  }, defaultTxt);
  return h(Tooltip, { effect: "dark", disabled }, {
    default: () => defaultSlot,
    content: () => contentSlot
  });
}
function renderCopyIcon(row2, item) {
  const { copy = false } = item;
  const value2 = getCopyValueByConfig(row2, item);
  return copy && value2 !== TEXT_EMPTY_VALUE ? h(CopyIcon, { class: "copy_icon", value: getK18nValue(value2, item) }) : "";
}
function renderStr(row2, item, val) {
  const { handler, type } = item;
  return h("div", {
    class: type === TABLE_ITEM_TYPE.LINK ? "tooltip-text tooltip-text-link" : "tooltip-text",
    onMouseenter: ($event) => handleCellMouseEnter($event),
    onMouseleave: handleCellMouseLeave
  }, [
    h("span", { class: "ws", onClick: typeof handler === "function" ? () => handler(row2) : () => {
    } }, getK18nValue(val, item)),
    renderCopyIcon(row2, item)
  ]);
}
const renderText = (scope, textItem) => {
  const { row: row2 } = scope;
  const item = __spreadValues(__spreadValues({}, DEFAULT$3), textItem);
  const { defaultVal } = item;
  const value2 = getTransformData(row2, item);
  let val = getMapValue(row2, value2, item);
  const { url, target = "_blank", arrayToString = false } = item;
  if (item.type === TABLE_ITEM_TYPE.LINK && item.url && !textItem.handler) {
    const result = renderArrayLink(val, row2, item);
    if (result) {
      return result;
    }
    if (val && val !== TEXT_EMPTY_VALUE) {
      item.handler = () => {
        window.open(scope.row[url || ""] || `${parseValue$1(url, "row", scope.row)}`, target);
      };
    }
  }
  if (isEmpty(val)) {
    return defaultVal ? h("div", {}, defaultVal) : TEXT_EMPTY_VALUE;
  }
  if (Array.isArray(val)) {
    if (arrayToString) {
      val = val.join(", ");
    } else {
      return renderArray(row2, item, val);
    }
  }
  if (typeof val === "string" || typeof val === "number" || typeof val === "boolean") {
    return renderStr(row2, item, val);
  }
};
function renderArrayLink(arr, row2, configItem) {
  var _a;
  const { url } = configItem;
  const temp = Array.isArray(arr) ? arr : (_a = `${arr}`) == null ? void 0 : _a.split(",");
  const arrayWrapperClass = Array.isArray(arr) ? "protable_link__wrapper" : "";
  if ((temp == null ? void 0 : temp.length) > 1 && url) {
    const result = temp.map((item, index2) => {
      const href = parseValue$1(url, "row", row2, index2);
      return [
        h("a", {
          class: arrayWrapperClass,
          target: "_blank",
          href
        }, item),
        index2 === temp.length - 1 ? "" : ", "
      ];
    });
    return h("div", {
      class: "tooltip-text tooltip-text-link array_link",
      onMouseenter: ($event) => handleCellMouseEnter($event),
      onMouseleave: handleCellMouseLeave
    }, h("span", {}, result));
  }
}
const style = "";
const renderDate = (scope, item) => {
  const { row: row2 } = scope;
  const { defaultVal, bindVal, separator, format: format2 } = __spreadValues(__spreadValues({}, DEFAULT$4), item);
  let dateWrapperClass = "";
  let val = "";
  const value2 = getTransformData(row2, item);
  if (bindVal) {
    if (Array.isArray(bindVal) && bindVal.length === 2) {
      const [start2, end2] = bindVal;
      const startTime = formatDate(row2[start2], format2);
      const endTime = formatDate(row2[end2], format2);
      if (separator === "break") {
        val = [h("span", null, startTime), h("br"), h("span", null, endTime)];
      } else {
        val = `${startTime}${separator}${endTime}`;
      }
    } else {
      val = "";
    }
  } else if (isEffectiveNumber(value2)) {
    val = formatDate(value2, format2);
    if (separator === "line") {
      val = val == null ? void 0 : val.split(" ").join("\n");
      dateWrapperClass = "pro_table_date_line";
    }
  }
  if (isEmpty(val)) {
    return defaultVal ? h("div", {}, defaultVal) : TEXT_EMPTY_VALUE;
  }
  return h("div", { class: dateWrapperClass }, val);
};
const renderBtn = (scope, item) => {
  const { btns } = item;
  const foldNumber = getFoldResult(item);
  const flag = h("span", { class: "action-flag" }, "|");
  const result = btns.map((item2) => {
    const { render: render2 } = item2;
    if (render2) {
      return render2(scope, item2);
    }
    return renderBuiltInBtn(item2, scope);
  }).filter((_) => _);
  const showBtns = result.splice(0, foldNumber).map((btn, index2) => {
    return index2 > 0 ? [flag, btn] : btn;
  });
  if (result == null ? void 0 : result.length) {
    return [showBtns, flag, renderBtnMore(result)];
  }
  return showBtns;
};
function getFoldResult(item) {
  const { fold, btns } = item;
  const defaultFold = btns.length;
  if (!fold || typeof fold !== "number") {
    return defaultFold;
  }
  return fold;
}
function renderBtnMore(btns) {
  const dropdownSlot = h(DropdownMenu, {
    class: "pro_table_btn_dropdown__menu"
  }, btns.map((item) => {
    return h(DropdownItem, {}, item);
  }));
  const dropDown = h(Dropdown, {
    class: "pro_table_btn_dropdown"
  }, {
    default: h("span", { class: "pro_table_btn_dropdown__icon" }, h(IconGeneralMore)),
    dropdown: dropdownSlot
  });
  return dropDown;
}
const DEFAULT$2 = {
  lineClamp: 1,
  toFixed: 2,
  disabled: false,
  light: false,
  multiply: 100,
  percent: false
};
const renderNumber = (scope, item) => {
  const { row: row2 } = scope;
  const resultItem = __spreadValues(__spreadValues({}, DEFAULT$2), item);
  const _a = resultItem, { lineClamp, light, percent } = _a, props = __objRest(_a, ["lineClamp", "light", "percent"]);
  const transValue = getTransformData(row2, item);
  const val = getMapValue(row2, transValue, item);
  let result;
  const numberVal = Number(val);
  if (Number.isNaN(numberVal)) {
    result = {
      lightContent: val,
      defaultSlot: val,
      content: val
    };
  } else if (percent) {
    result = getPercentContent(numberVal, resultItem);
  } else {
    result = getNumberContent(numberVal, resultItem);
  }
  const defaultSlot = result.defaultSlot;
  if (light || `${defaultSlot}` === "0") {
    return result.lightContent;
  }
  return h(ProTooltip, __spreadValues({
    lineClamp,
    content: result.content
  }, props), defaultSlot);
};
function getPercentContent(val, item) {
  const { multiply, toFixed } = item;
  const defaultSlot = formatRate(val, multiply, toFixed);
  return {
    defaultSlot,
    content: val,
    lightContent: defaultSlot
  };
}
function getNumberContent(val, item) {
  var _a, _b;
  const { toFixed } = item;
  const defaultSlot = formatValue(val, toFixed);
  if (Number(val) % 1 === 0) {
    return {
      defaultSlot,
      content: (_a = Number(val)) == null ? void 0 : _a.toLocaleString(),
      lightContent: (_b = Number(val)) == null ? void 0 : _b.toLocaleString()
    };
  }
  const valArray = `${val}`.split(".");
  const integer = Number(valArray[0]);
  const decimal = `0.${valArray[1]}` || "";
  const decimalFixed = strip(Number(decimal), toFixed, true);
  const lightContent = `${integer.toLocaleString()}${decimalFixed == null ? void 0 : decimalFixed.replace("0", "")}`;
  const content = `${integer.toLocaleString()}${decimal == null ? void 0 : decimal.replace("0", "")}`;
  return {
    defaultSlot,
    content,
    lightContent
  };
}
const DEFAULT$1 = {
  tagMap: {
    positive: "positive",
    negative: "negative",
    warning: "warning",
    normal: "normal",
    disabled: "disabled"
  },
  light: false
};
const renderTag = (scope, item) => {
  const { row: row2 } = scope;
  const { tagMap, light } = __spreadValues(__spreadValues({}, DEFAULT$1), item);
  const transValue = getTransformData(row2, item);
  const val = getMapValue(row2, transValue, item);
  if (val === void 0 || val === null || val === "") {
    return TEXT_EMPTY_VALUE;
  }
  const k18nValue = getK18nValue(val, item);
  return h(Tag, {
    "class-name": tagMap[val],
    light
  }, k18nValue);
};
const renderWidget = (scope, item) => {
  const { widget } = useGlobalConfig();
  if (!item.widget) {
    return "";
  }
  const componentWidget = widget[item.widget];
  if (typeof componentWidget === "function") {
    return componentWidget(scope, item);
  }
  return h(componentWidget, {
    data: scope.row,
    row: scope.row,
    item,
    index: scope.$index
  });
};
function renderSlot$1(scope, item) {
  var _a;
  const slots = useSlots();
  const { slot } = item;
  if (!slot) {
    if (DEV) {
      console.error('[ProTable error]: Unavailable value of "slot" key.');
    }
    return [];
  }
  return (_a = slots[slot]) == null ? void 0 : _a.call(slots, scope);
}
const renderHtml = (scope, item) => {
  const { row: row2 } = scope;
  const transValue = getTransformData(row2, item);
  const val = getMapValue(row2, transValue, item);
  return h("span", { innerHTML: val });
};
const RankNum_vue_vue_type_style_index_0_scoped_true_lang = "";
const _hoisted_1$v = { key: 1 };
const _sfc_main$K = /* @__PURE__ */ defineComponent({
  __name: "RankNum",
  props: {
    scope: {
      type: Object,
      default: () => {
      }
    },
    rank: {
      type: Number,
      default: 0
    }
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return __props.rank ? (openBlock(), createElementBlock("span", {
        key: 0,
        class: normalizeClass(["rank", { top3: __props.rank < 4 }])
      }, toDisplayString(__props.rank), 3)) : (openBlock(), createElementBlock("span", _hoisted_1$v, "-"));
    };
  }
});
const RankNum = /* @__PURE__ */ _export_sfc(_sfc_main$K, [["__scopeId", "data-v-2d89739e"]]);
const renderRank = (scope, item) => {
  const { row: row2 } = scope;
  const val = getTransformData(row2, item);
  return h(RankNum, { scope, rank: val });
};
const PercentBar_vue_vue_type_style_index_0_scoped_true_lang = "";
const _sfc_main$J = /* @__PURE__ */ defineComponent({
  __name: "PercentBar",
  props: {
    data: {
      type: Object,
      default: () => {
      }
    },
    config: {
      type: Object,
      default: () => {
      }
    }
  },
  setup(__props) {
    const props = __props;
    const bindProps = computed(() => {
      var _a;
      const toFixed = (_a = props.config.toFixed) != null ? _a : 2;
      const key = props.config.key;
      let percentage = 0;
      if (!Number.isNaN(Number(props.data[key]))) {
        percentage = Number(strip(props.data[key] * 100, toFixed));
      }
      return __spreadValues({
        percentage
      }, props.config);
    });
    return (_ctx, _cache) => {
      const _component_ks_progress = resolveComponent("ks-progress");
      return openBlock(), createBlock(_component_ks_progress, mergeProps(unref(bindProps), {
        type: "line",
        color: "#2675ff",
        class: "percent"
      }), null, 16);
    };
  }
});
const PercentBar = /* @__PURE__ */ _export_sfc(_sfc_main$J, [["__scopeId", "data-v-357601aa"]]);
const renderPercentBar = (scope, item) => {
  return h(PercentBar, { data: scope.row, config: item });
};
const UserHeadList_vue_vue_type_style_index_0_scoped_true_lang = "";
const _hoisted_1$u = { class: "user_head__list" };
const _hoisted_2$j = ["src"];
const _hoisted_3$g = { class: "num" };
const _sfc_main$I = /* @__PURE__ */ defineComponent({
  __name: "UserHeadList",
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    item: {
      type: Object,
      default: () => ({})
    }
  },
  setup(__props) {
    const props = __props;
    const DEFAULT_CONFIG = {
      key: "",
      maxlength: 7,
      picGap: 8,
      textKey: ""
    };
    const list = computed(() => {
      var _a, _b;
      const { key, maxlength } = configItem.value;
      return ((_b = (_a = props.data) == null ? void 0 : _a[key]) == null ? void 0 : _b.slice(0, maxlength)) || [];
    });
    const configItem = computed(() => {
      const result = __spreadValues(__spreadValues({}, DEFAULT_CONFIG), props.item);
      return result;
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1$u, [
        (openBlock(true), createElementBlock(Fragment, null, renderList(unref(list), (item, index2) => {
          return openBlock(), createElementBlock("span", {
            key: index2,
            style: normalizeStyle({ left: `${index2 * unref(configItem).picGap}px`, "z-index": index2 + 1 })
          }, [
            createElementVNode("img", {
              src: item,
              alt: ""
            }, null, 8, _hoisted_2$j)
          ], 4);
        }), 128)),
        unref(list).length > unref(configItem).maxlength ? (openBlock(), createElementBlock("span", {
          key: 0,
          class: "more",
          style: normalizeStyle({ left: `${unref(list).length * unref(configItem).picGap}px`, "z-index": unref(list).length + 1 })
        }, [
          createVNode(unref(IconGeneralMore))
        ], 4)) : createCommentVNode("", true),
        createElementVNode("div", _hoisted_3$g, toDisplayString(__props.data[unref(configItem).textKey] || 0), 1)
      ]);
    };
  }
});
const UserHeadList = /* @__PURE__ */ _export_sfc(_sfc_main$I, [["__scopeId", "data-v-259f09c6"]]);
const ImageInfoBox_vue_vue_type_style_index_0_scoped_true_lang = "";
const _hoisted_1$t = { class: "image_info__box" };
const _hoisted_2$i = ["onClick"];
const _hoisted_3$f = ["src"];
const _hoisted_4$b = { class: "content_wrapper" };
const _hoisted_5$7 = {
  key: 0,
  class: "id_wrapper"
};
const _hoisted_6$3 = {
  key: 0,
  class: "label"
};
const _sfc_main$H = /* @__PURE__ */ defineComponent({
  __name: "ImageInfoBox",
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    item: {
      type: Object,
      default: () => ({})
    }
  },
  setup(__props) {
    const props = __props;
    const $k18n = getK18n();
    const DEFAULT_CONFIG = {
      uid: "userId",
      k18nUid: false,
      uidLabel: "",
      imgSrc: "headUrl",
      userName: "name",
      userNameHoverStyle: false,
      idHoverStyle: false,
      showUidCopy: true,
      circle: false,
      contentMaxWidth: "100px",
      url: "",
      titleHandler: ""
    };
    const configItem = computed(() => {
      const result = __spreadValues(__spreadValues({}, DEFAULT_CONFIG), props.item);
      return result;
    });
    const showIdWrapper = computed(() => {
      const { uidLabel, uid } = configItem.value;
      return uidLabel || props.data[uid];
    });
    function handleClickTitle() {
      const { titleHandler } = configItem.value;
      if (titleHandler) {
        titleHandler(props.data);
      }
    }
    function handClick() {
      const { url } = props.item;
      if (!url) {
        return;
      }
      const result = parseValue$1(url, "row", props.data, 0);
      window.open(result, "_blank");
    }
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1$t, [
        createElementVNode("div", {
          class: normalizeClass(["img", { circle: unref(configItem).circle }]),
          onClick: withModifiers(handClick, ["stop"])
        }, [
          __props.data[unref(configItem).imgSrc] ? (openBlock(), createElementBlock("img", {
            key: 0,
            src: __props.data[unref(configItem).imgSrc],
            alt: "",
            loading: "lazy"
          }, null, 8, _hoisted_3$f)) : (openBlock(), createBlock(unref(IconColourUserNormal), { key: 1 }))
        ], 10, _hoisted_2$i),
        createElementVNode("div", _hoisted_4$b, [
          createElementVNode("div", {
            class: "title_wrapper",
            onClick: handleClickTitle
          }, [
            createVNode(unref(ProTooltip), {
              class: normalizeClass(["title", { hover: unref(configItem).userNameHoverStyle }]),
              "line-clamp": 1,
              content: __props.data[unref(configItem).userName] || "--",
              "max-width": unref(configItem).contentMaxWidth
            }, null, 8, ["class", "content", "max-width"])
          ]),
          unref(showIdWrapper) ? (openBlock(), createElementBlock("div", _hoisted_5$7, [
            unref(configItem).uidLabel ? (openBlock(), createElementBlock("span", _hoisted_6$3, toDisplayString(unref($k18n)(unref(configItem).uidLabel)), 1)) : createCommentVNode("", true),
            createElementVNode("span", {
              class: normalizeClass(["id", { hover: unref(configItem).idHoverStyle }]),
              onClick: _cache[0] || (_cache[0] = ($event) => handClick())
            }, [
              unref(configItem).k18nUid ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
                createTextVNode(toDisplayString(unref($k18n)(__props.data[unref(configItem).uid])), 1)
              ], 64)) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                createTextVNode(toDisplayString(__props.data[unref(configItem).uid]), 1)
              ], 64))
            ], 2),
            unref(configItem).showUidCopy && __props.data[unref(configItem).uid] ? (openBlock(), createBlock(unref(CopyIcon), {
              key: 1,
              value: __props.data[unref(configItem).uid],
              text: unref($k18n)("\u590D\u5236\u6210\u529F")
            }, null, 8, ["value", "text"])) : createCommentVNode("", true)
          ])) : createCommentVNode("", true),
          renderSlot$2(_ctx.$slots, "other-info", {}, void 0, true)
        ])
      ]);
    };
  }
});
const ImageInfoBox = /* @__PURE__ */ _export_sfc(_sfc_main$H, [["__scopeId", "data-v-1a2eda9d"]]);
const renderColumn = (item) => {
  const { render: customRender } = item;
  if (typeof customRender === "function") {
    return (scope) => customRender(scope.row);
  }
  return (scope) => {
    const { type, btns } = item;
    if (btns) {
      item.type = "btns";
    }
    if (JSON.stringify(scope.row) !== "{}") {
      switch (type) {
        case TABLE_ITEM_TYPE.IMG:
          return renderImg(scope, item);
        case TABLE_ITEM_TYPE.TEXT:
        case TABLE_ITEM_TYPE.LINK:
          return renderText(scope, item);
        case TABLE_ITEM_TYPE.DATE:
          return renderDate(scope, item);
        case TABLE_ITEM_TYPE.SLOT:
          return renderSlot$1(scope, item);
        case TABLE_ITEM_TYPE.BTNS:
          return renderBtn(scope, item);
        case TABLE_ITEM_TYPE.TAG:
          return renderTag(scope, item);
        case TABLE_ITEM_TYPE.NUMBER:
          return renderNumber(scope, item);
        case TABLE_ITEM_TYPE.EXPAND_CUSTOM:
          return renderExpand(scope, item);
        case TABLE_ITEM_TYPE.WIDGET:
          return renderWidget(scope, item);
        case TABLE_ITEM_TYPE.HTML:
          return renderHtml(scope, item);
        case TABLE_ITEM_TYPE.RANK:
          return renderRank(scope, item);
        case TABLE_ITEM_TYPE.PERCENTBAR:
          return renderPercentBar(scope, item);
        case TABLE_ITEM_TYPE.USER_HEAD_LIST:
          return h(UserHeadList, {
            data: scope.row,
            item
          });
        case TABLE_ITEM_TYPE.IMAGE_INFO_BOX:
          return h(ImageInfoBox, {
            data: scope.row,
            item
          });
        default:
          return renderText(scope, item);
      }
    }
  };
};
const FORM_ITEM_TYPE = {
  ARRAY: "array",
  LINE: "line",
  PANEL: "panel",
  COLLAPSE: "collapse",
  COLLAPSEITEM: "collapseItem",
  COLLAPSEPANEL: "collapsePanel",
  SELECT: "select",
  KEYSELECT: "keySelect",
  INPUT: "input",
  SELECTINPUT: "selectInput",
  TEXTAREA: "textarea",
  CASCADER: "cascader",
  DATEPICKER: "datePicker",
  PROTREESELECT: "treeSelect",
  TREESELECT: "treeSelect",
  SELECTMUTIINPUT: "selectMutiInput",
  MUTIINPUT: "mutiInput",
  BATCHINPUT: "batchInput",
  RADIO: "radio",
  UPLOADIMAGE: "uploadImage",
  UPLOADFile: "uploadFile",
  SLOT: "slot",
  WIDGET: "widget",
  WIDGETPANEL: "widgetPanel",
  CHECKBOX: "checkbox",
  INPUTRANGE: "inputRange",
  CHECKBOXINPUT: "checkboxInput",
  RADIOINPUT: "radioInput",
  INPUTNUMBER: "inputNumber",
  SUBTITLE: "subTitle",
  COLORPICKER: "colorPicker",
  DIRECTORSELECT: "directorSelect",
  COUNTRY: "country",
  BUCKET: "bucket"
};
const DEFAULT_RULE_MAP = {
  ARRAY: "\u8BF7\u8F93\u5165",
  LINE: "\u8BF7\u8F93\u5165",
  PANEL: "\u8BF7\u8F93\u5165",
  SELECT: "\u8BF7\u9009\u62E9",
  KEYSELECT: "\u8BF7\u9009\u62E9",
  INPUT: "\u8BF7\u8F93\u5165",
  SELECTINPUT: "\u8BF7\u8F93\u5165",
  TEXTAREA: "\u8BF7\u8F93\u5165",
  CASCADER: "\u8BF7\u9009\u62E9",
  DATEPICKER: "\u8BF7\u9009\u62E9",
  TREESELECT: "\u8BF7\u9009\u62E9",
  PROTREESELECT: "\u8BF7\u9009\u62E9",
  SELECTMUTIINPUT: "\u8BF7\u9009\u62E9",
  MUTIINPUT: "\u8BF7\u8F93\u5165",
  BATCHINPUT: "\u8BF7\u8F93\u5165",
  RADIO: "\u8BF7\u9009\u62E9",
  UPLOADIMAGE: "\u8BF7\u9009\u62E9",
  SLOT: "\u8BF7\u9009\u62E9",
  WIDGET: "\u8BF7\u9009\u62E9",
  CHECKBOX: "\u8BF7\u9009\u62E9",
  INPUTRANGE: "\u8BF7\u8F93\u5165",
  CHECKBOXINPUT: "\u8BF7\u8F93\u5165",
  INPUTNUMBER: "\u8BF7\u8F93\u5165",
  RADIOINPUT: "\u8BF7\u8F93\u5165",
  DIRECTORSELECT: "\u8BF7\u9009\u62E9",
  COUNTRY: "\u8BF7\u9009\u62E9",
  BUCKET: "\u8BF7\u9009\u62E9",
  undefined: "\u8BF7\u8F93\u5165"
};
const defaultRuleMessage = () => {
  const defaultRuleMessage2 = {};
  for (const key in DEFAULT_RULE_MAP) {
    defaultRuleMessage2[FORM_ITEM_TYPE[key]] = DEFAULT_RULE_MAP[key];
  }
  return defaultRuleMessage2;
};
const DEFAULT_RULE_MESSAGE = defaultRuleMessage();
const removeKeys = /* @__PURE__ */ new Set([]);
function getKeys(item) {
  if (!item)
    return;
  let keys = [];
  if (item.bindVal) {
    keys = item.key ? [...item.bindVal, item.key] : [...item.bindVal];
  } else {
    item.key && keys.push(item.key);
  }
  return keys;
}
function removeKeysHandler(result, item) {
  const keys = getKeys(item);
  if (!keys.length)
    return;
  if (result) {
    keys.forEach((key) => removeKeys.delete(key));
  } else {
    keys.forEach((key) => removeKeys.add(key));
  }
}
function conditionHandler(item, data) {
  const result = calcExpression(item, "condition", data);
  switch (item.type) {
    case FORM_ITEM_TYPE.ARRAY:
    case FORM_ITEM_TYPE.COLLAPSEITEM:
      if (!item.items)
        break;
      if (!item.childKeys) {
        const childKeys = item.items.reduce((res, arrayItem) => {
          var _a;
          if (Array.isArray(arrayItem)) {
            const keys = arrayItem.reduce((r, c) => {
              const cKeys = getKeys(c);
              return (cKeys == null ? void 0 : cKeys.length) ? r.concat(cKeys) : r;
            }, []);
            res.push(...keys);
          } else if ((_a = getKeys(arrayItem)) == null ? void 0 : _a.length) {
            res = res.concat(getKeys(arrayItem));
          }
          return res;
        }, []);
        item.childKeys = childKeys;
      }
      if (result) {
        item.childKeys.forEach((key) => removeKeys.delete(key));
      } else {
        item.childKeys.forEach((key) => removeKeys.add(key));
      }
      break;
    case FORM_ITEM_TYPE.COLLAPSE:
      break;
    case FORM_ITEM_TYPE.PANEL:
      break;
    case FORM_ITEM_TYPE.COLLAPSEPANEL:
      break;
    case FORM_ITEM_TYPE.SUBTITLE:
      break;
    default:
      removeKeysHandler(result, item);
      break;
  }
}
function calcExpression(item, key, data) {
  if (item[`${key}_expresstion`]) {
    const funcResult = transformMustacheToFunc(item[`${key}_expresstion`], "formData", data);
    set$1(item, key, funcResult);
    return funcResult;
  }
  return true;
}
const eventHandler = (item, handleValueChange, data) => {
  var _a;
  if (!item.isEventHandler) {
    item.isEventHandler = true;
    item.eventMaps = isObject(item.eventMaps) ? item.eventMaps : {};
    for (const key in item.eventMaps) {
      const mapKey = transform(key);
      const fn2 = item.eventMaps[key];
      item.eventMaps[mapKey] = fn2;
      delete item.eventMaps[key];
    }
    const changeEvent = (_a = item.eventMaps) == null ? void 0 : _a.onChange;
    const change = (item2, data2) => (value2) => {
      changeEvent && changeEvent(value2, data2);
      handleValueChange && handleValueChange({ key: item2.key, value: value2 });
    };
    item.eventMaps.onChange = change(item, data);
  }
};
const expressionHandler = (propsData, item, key) => {
  if (get$1(item, key) && isExpression(get$1(item, key))) {
    const val = get$1(item, key);
    const result = getMustacheContent(val);
    !item.expressionKey && (item.expressionKey = []);
    item.expressionKey.push(key);
    !item[`${key}_expresstion`] && (item[`${key}_expresstion`] = result);
    calcExpression(item, key, propsData);
  }
};
const DEFAULT = {
  condition: true,
  isK18n: true
};
const defaultHandler = (item) => {
  for (const key in DEFAULT) {
    if (item[key] === void 0) {
      item[key] = DEFAULT[key];
    }
  }
};
const itemsInit = (items, propsData) => {
  items.forEach((item, index2) => {
    defaultHandler(item);
    if (item.type === FORM_ITEM_TYPE.ARRAY || item.type === FORM_ITEM_TYPE.PANEL || item.type === FORM_ITEM_TYPE.COLLAPSE || item.type === FORM_ITEM_TYPE.COLLAPSEITEM || item.type === FORM_ITEM_TYPE.COLLAPSEPANEL) {
      if (!item.slot) {
        itemsInit(item.items);
      }
    }
    if (Array.isArray(item)) {
      return itemsInit(item);
    }
    Object.keys(item).forEach((key) => {
      if (key === "request") {
        expressionHandler(propsData, item, "request.url") && (item[key].debounce_time = 300);
      }
      expressionHandler(propsData, item, key);
    });
    return item;
  });
  return items;
};
const ProInputNumber_vue_vue_type_style_index_0_scoped_true_lang = "";
const _sfc_main$G = defineComponent({
  name: "ProSelect",
  props: {
    modelValue: {
      type: [String, Number],
      default: () => ""
    }
  },
  emits: ["update:modelValue", "change"],
  setup(props, ctx) {
    const model = computed({
      get() {
        return props.modelValue;
      },
      set(val) {
        ctx.emit("update:modelValue", val);
        ctx.emit("change", val);
      }
    });
    return {
      model
    };
  }
});
function _sfc_render$d(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ks_input_number = resolveComponent("ks-input-number");
  return openBlock(), createElementBlock(Fragment, null, [
    renderSlot$2(_ctx.$slots, "prepend", {}, () => [
      createElementVNode("span", {
        class: normalizeClass(_ctx.$attrs.prepend ? "prefix" : "")
      }, toDisplayString(_ctx.$attrs.prepend), 3)
    ], true),
    createVNode(_component_ks_input_number, mergeProps({
      modelValue: _ctx.model,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.model = $event)
    }, _ctx.$attrs), null, 16, ["modelValue"]),
    renderSlot$2(_ctx.$slots, "append", {}, () => [
      createElementVNode("span", {
        class: normalizeClass(_ctx.$attrs.append ? "suffix" : "")
      }, toDisplayString(_ctx.$attrs.append), 3)
    ], true)
  ], 64);
}
const ProInputNumber = /* @__PURE__ */ _export_sfc(_sfc_main$G, [["render", _sfc_render$d], ["__scopeId", "data-v-58be2770"]]);
const UploadFile_vue_vue_type_style_index_0_scoped_true_lang = "";
const _withScopeId$4 = (n) => (pushScopeId("data-v-da64f306"), n = n(), popScopeId(), n);
const _hoisted_1$s = /* @__PURE__ */ _withScopeId$4(() => /* @__PURE__ */ createElementVNode("i", { class: "sys-icon-add avatar-uploader-icon" }, null, -1));
const _hoisted_2$h = /* @__PURE__ */ _withScopeId$4(() => /* @__PURE__ */ createElementVNode("div", { class: "title" }, "\u70B9\u51FB\u6216\u62D6\u5165\u6587\u4EF6\u4E0A\u4F20", -1));
const _hoisted_3$e = { class: "sub-title" };
const _hoisted_4$a = { class: "sub-title" };
const _sfc_main$F = /* @__PURE__ */ defineComponent({
  __name: "UploadFile",
  props: {
    imageUrl: String,
    imageName: String,
    bucket: String,
    acceptKind: String,
    otherTip: String,
    disabled: Boolean,
    limit: {
      type: [Number, String],
      default: 2 * 1024 * 1024
    },
    uploadApi: {
      type: String,
      default: "/api/noah/resource/file/upload"
    },
    desc: {
      type: String,
      default: ""
    }
  },
  emits: ["onAvatarSuccess", "onDeleteImage"],
  setup(__props, { emit: emits }) {
    const props = __props;
    const state = reactive({
      fileList: props.imageUrl ? [{
        name: props.imageName || props.imageUrl,
        url: props.imageUrl
      }] : []
    });
    const onAvatarSuccess = (res, files, fileList) => {
      var _a, _b;
      if ((_a = res == null ? void 0 : res.data) == null ? void 0 : _a.imageUrl) {
        emits("onAvatarSuccess", (_b = res == null ? void 0 : res.data) == null ? void 0 : _b.imageUrl);
      } else {
        Message.error({
          message: res == null ? void 0 : res.message,
          type: "error"
        });
      }
    };
    const limitText = computed(() => {
      if (props.limit < 1024) {
        return `${props.limit}B`;
      }
      if (props.limit < 1024 * 1024) {
        return `${props.limit / 1024}KB`;
      }
      return `${props.limit / 1024 / 1024}MB`;
    });
    const onBeforeAvatarUpload = (file) => {
      if (props.limit === "any")
        return true;
      const isLimit = file.size < props.limit;
      if (!isLimit) {
        Message.error({
          type: "error",
          message: `\u4E0A\u4F20\u6587\u4EF6\u5927\u5C0F\u4E0D\u80FD\u8D85\u8FC7${limitText.value}`
        });
      }
      return isLimit;
    };
    const onChange = (file, files) => {
      state.fileList = files;
    };
    const onRemove = (file, files) => {
      state.fileList = files;
      emits("onDeleteImage");
    };
    const onError = function(err, file, fileList) {
      Message.error({
        type: "error",
        message: "Upload File Error"
      });
      console.log("error", err, file, fileList);
    };
    return (_ctx, _cache) => {
      var _a, _b;
      const _component_k18n = resolveComponent("k18n");
      const _component_ks_upload = resolveComponent("ks-upload");
      return openBlock(), createBlock(_component_ks_upload, {
        class: normalizeClass(["file-uploader", !((_a = __props.bucket) == null ? void 0 : _a.length) ? "disable-uploader" : "", state.fileList.length === 0 ? "" : "uploaded"]),
        "on-success": onAvatarSuccess,
        "on-change": onChange,
        "on-remove": onRemove,
        "on-error": onError,
        "before-upload": onBeforeAvatarUpload,
        disabled: !((_b = __props.bucket) == null ? void 0 : _b.length),
        action: `${__props.uploadApi}?bucket=${__props.bucket}`,
        accept: __props.acceptKind,
        "file-list": state.fileList,
        multiple: "",
        drag: ""
      }, {
        default: withCtx(() => {
          var _a2;
          return [
            _hoisted_1$s,
            _hoisted_2$h,
            createElementVNode("div", _hoisted_3$e, [
              __props.desc ? (openBlock(), createBlock(_component_k18n, { key: 0 }, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(__props.desc), 1)
                ]),
                _: 1
              })) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                createVNode(_component_k18n, null, {
                  default: withCtx(() => [
                    createTextVNode("\u6587\u4EF6\u4E0D\u8D85\u8FC7")
                  ]),
                  _: 1
                }),
                createElementVNode("span", null, toDisplayString(unref(limitText)), 1),
                __props.otherTip ? (openBlock(), createBlock(_component_k18n, { key: 0 }, {
                  default: withCtx(() => [
                    createTextVNode(toDisplayString(__props.otherTip), 1)
                  ]),
                  _: 1
                })) : createCommentVNode("", true)
              ], 64))
            ]),
            createElementVNode("div", _hoisted_4$a, [
              !((_a2 = __props.bucket) == null ? void 0 : _a2.length) ? (openBlock(), createBlock(_component_k18n, { key: 0 }, {
                default: withCtx(() => [
                  createTextVNode("\u8BF7\u5148\u6307\u5B9A\u6876")
                ]),
                _: 1
              })) : createCommentVNode("", true)
            ])
          ];
        }),
        _: 1
      }, 8, ["class", "disabled", "action", "accept", "file-list"]);
    };
  }
});
const UploadFile = /* @__PURE__ */ _export_sfc(_sfc_main$F, [["__scopeId", "data-v-da64f306"]]);
const selectInput_vue_vue_type_style_index_0_scoped_true_lang = "";
const _sfc_main$E = /* @__PURE__ */ defineComponent({
  __name: "selectInput",
  props: {
    filterReactive: {
      type: Object,
      default: () => reactive({})
    },
    item: {
      type: Object,
      default: () => reactive({})
    }
  },
  setup(__props) {
    const $k18n = getK18n();
    return (_ctx, _cache) => {
      const _component_ks_option = resolveComponent("ks-option");
      const _component_ks_select = resolveComponent("ks-select");
      const _component_ks_input = resolveComponent("ks-input");
      return openBlock(), createBlock(_component_ks_input, {
        modelValue: __props.filterReactive[__props.item.key],
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => __props.filterReactive[__props.item.key] = $event),
        placeholder: unref($k18n)("\u8BF7\u8F93\u5165\u5185\u5BB9"),
        class: "input-with-select",
        clearable: ""
      }, {
        prepend: withCtx(() => [
          createVNode(_component_ks_select, {
            modelValue: __props.filterReactive[__props.item.enumerateKey],
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => __props.filterReactive[__props.item.enumerateKey] = $event),
            clearable: "",
            placeholder: unref($k18n)("\u641C\u7D22\u5185\u5BB9")
          }, {
            default: withCtx(() => [
              (openBlock(true), createElementBlock(Fragment, null, renderList(__props.item.enumerate, (label, key) => {
                return openBlock(), createBlock(_component_ks_option, {
                  key,
                  label,
                  value: Number(key)
                }, null, 8, ["label", "value"]);
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue", "placeholder"])
        ]),
        _: 1
      }, 8, ["modelValue", "placeholder"]);
    };
  }
});
const SelectInput = /* @__PURE__ */ _export_sfc(_sfc_main$E, [["__scopeId", "data-v-41b0e6c2"]]);
function renderSlot(slots, item) {
  const { slot } = item;
  if (!slot) {
    console.warn('[CoForm warn]: Unavaliable value of "slot" key.');
    return [];
  }
  return slots[slot]("");
}
const _sfc_main$D = defineComponent({
  name: "DatePicker",
  props: {
    item: {
      type: Object,
      required: true
    },
    filterReactive: {
      type: Object,
      required: true
    }
  },
  emits: ["update:modelValue"],
  setup(props) {
    const $k18n = getK18n();
    const datePickShortCut = () => {
      return [
        {
          text: $k18n("\u8FD11\u5929"),
          value: (() => {
            const end2 = new Date();
            const start2 = moment(end2).add(-1, "d");
            return [start2, end2];
          })()
        },
        {
          text: $k18n("\u8FD17\u5929"),
          value: (() => {
            const end2 = new Date();
            const start2 = moment(end2).add(-7, "d");
            return [start2, end2];
          })()
        },
        {
          text: $k18n("\u8FD130\u5929"),
          value: (() => {
            const end2 = new Date();
            const start2 = moment(end2).add(-30, "d");
            return [start2, end2];
          })()
        },
        {
          text: $k18n("\u8FD160\u5929"),
          value: (() => {
            const end2 = new Date();
            const start2 = moment(end2).add(-60, "d");
            return [start2, end2];
          })()
        },
        {
          text: $k18n("\u8FD13\u4E2A\u6708"),
          value: (() => {
            const end2 = new Date();
            const start2 = moment(end2).add(-3, "M");
            return [start2, end2];
          })()
        },
        {
          text: $k18n("\u8FD16\u4E2A\u6708"),
          value: (() => {
            const end2 = new Date();
            const start2 = moment(end2).add(-6, "M");
            return [start2, end2];
          })()
        }
      ];
    };
    ref([new Date(2001, 1, 1, 12, 0, 0), new Date(2001, 2, 1, 8, 0, 0)]);
    const getDefaultProps = () => {
      if (!props.item.dateType || props.item.dateType === "datetimerange") {
        return {
          align: "right",
          type: props.item.dateType || "datetimerange",
          "range-separator": "-",
          "start-placeholder": $k18n("\u5F00\u59CB\u65E5\u671F"),
          "end-placeholder": $k18n("\u7ED3\u675F\u65E5\u671F"),
          shortcuts: props.item.showShortcuts ? datePickShortCut() : [],
          "default-time": [new Date(0, 0, 0, 0, 0, 0), new Date(0, 0, 0, 23, 59, 59)]
        };
      }
      return { align: "right", type: props.item.dateType, laceholder: $k18n("\u5F00\u59CB\u65E5\u671F") };
    };
    const DEFAULT_PROPS = getDefaultProps();
    const getVal = (value2) => {
      if (props.item["value-format"]) {
        return value2;
      }
      return value2 == null ? void 0 : value2.getTime();
    };
    const model = computed({
      get: () => {
        const { bindVal } = props.item;
        if (bindVal) {
          const startTime = props.filterReactive[bindVal[0]];
          const endTime = props.filterReactive[bindVal[1]];
          const res = startTime && endTime ? [startTime, endTime] : [];
          props.filterReactive[props.item.key] = res;
          return res;
        }
        return props.filterReactive[props.item.key];
      },
      set: (value2) => {
        const { bindVal } = props.item;
        if (bindVal) {
          props.filterReactive[bindVal[0]] = value2 && getVal(value2[0]);
          props.filterReactive[bindVal[1]] = value2 && getVal(value2[1]);
          return;
        }
        props.filterReactive[props.item.key] = getVal(value2);
      }
    });
    return () => {
      const _a = props.item, { type, key, name, slotsMap } = _a, dateProps = __objRest(_a, ["type", "key", "name", "slotsMap"]);
      return h(DatePicker, __spreadProps(__spreadValues(__spreadValues(__spreadValues({}, DEFAULT_PROPS), dateProps), props.item.eventMaps), {
        modelValue: model.value,
        "onUpdate:modelValue": ($event) => {
          model.value = $event;
        }
      }));
    };
  }
});
const _sfc_main$C = defineComponent({
  name: "RenderDispatcher",
  inject: ["handleValueChange", "enumerateObjMap"],
  props: {
    item: {
      type: Object,
      required: true
    },
    filterReactive: {
      type: Object,
      required: true
    }
  },
  emits: ["update:modelValue"],
  render() {
    const $k18n = getK18n();
    const { item, filterReactive } = this;
    eventHandler(item, this.handleValueChange, this.filterReactive);
    if (typeof item.enumerate === "string") {
      item.enumerate = this.enumerateObjMap.value[item.enumerate];
    }
    if (item.expressionKey) {
      item.expressionKey.forEach((key2) => {
        calcExpression(item, key2, filterReactive);
      });
    }
    const _a = item, { type, key, name, itemClass, itemStyle, enumerate, label } = _a, props = __objRest(_a, ["type", "key", "name", "itemClass", "itemStyle", "enumerate", "label"]);
    switch (this.item.type) {
      case FORM_ITEM_TYPE.SELECT:
      case FORM_ITEM_TYPE.KEYSELECT: {
        return h(
          ProSelect,
          __spreadValues(__spreadProps(__spreadValues({
            placeholder: $k18n("\u8BF7\u9009\u62E9"),
            clearable: true
          }, props), {
            label: item.optionLabel || "label",
            val: item.optionVal || (this.item.type === FORM_ITEM_TYPE.SELECT ? "label" : "value"),
            options: item.enumerate || [],
            modelValue: get$1(filterReactive, item.key),
            "onUpdate:modelValue": (value2) => set$1(filterReactive, item.key, value2)
          }), item.eventMaps),
          item.slotsMap
        );
      }
      case FORM_ITEM_TYPE.RADIO: {
        return h(
          Radio,
          __spreadValues(__spreadProps(__spreadValues({
            placeholder: $k18n("\u8BF7\u9009\u62E9")
          }, props), {
            label: item.optionLabel || "label",
            val: item.optionVal || "value",
            options: item.enumerate,
            modelValue: get$1(filterReactive, item.key),
            "onUpdate:modelValue": (value2) => set$1(filterReactive, item.key, value2)
          }), item.eventMaps),
          item.slotsMap
        );
      }
      case FORM_ITEM_TYPE.INPUT:
      case FORM_ITEM_TYPE.TEXTAREA: {
        return h(
          ProInput,
          __spreadValues(__spreadProps(__spreadValues({
            placeholder: $k18n("\u8BF7\u8F93\u5165"),
            type: this.item.type === FORM_ITEM_TYPE.TEXTAREA ? "textarea" : "text"
          }, props), {
            modelValue: get$1(filterReactive, item.key),
            "onUpdate:modelValue": (value2) => {
              set$1(filterReactive, item.key, value2);
            }
          }), item.eventMaps),
          item.slotsMap
        );
      }
      case FORM_ITEM_TYPE.INPUTNUMBER: {
        return h(
          ProInputNumber,
          __spreadValues(__spreadProps(__spreadValues({
            placeholder: $k18n("\u8BF7\u9009\u62E9")
          }, props), {
            modelValue: get$1(filterReactive, item.key),
            "onUpdate:modelValue": (value2) => {
              set$1(filterReactive, item.key, value2);
            }
          }), item.eventMaps),
          item.slotsMap
        );
      }
      case FORM_ITEM_TYPE.CASCADER: {
        return h(Cascader, __spreadValues(__spreadProps(__spreadValues({
          props: {
            expandTrigger: "hover",
            emitPath: false,
            checkStrictly: true
          },
          placeholder: $k18n("\u8BF7\u9009\u62E9"),
          hideRadio: true,
          hideSelectMenu: true,
          clearable: true
        }, props), {
          options: item.enumerate,
          disabled: item.disabled,
          modelValue: get$1(filterReactive, item.key),
          "onUpdate:modelValue": (value2) => set$1(filterReactive, item.key, value2)
        }), item.eventMaps));
      }
      case FORM_ITEM_TYPE.DATEPICKER: {
        return h(_sfc_main$D, { item, filterReactive });
      }
      case FORM_ITEM_TYPE.PROTREESELECT: {
        return h(ProTreeSelect, __spreadValues(__spreadValues(__spreadProps(__spreadValues({}, props), {
          modelValue: get$1(filterReactive, item.key) || [],
          "onUpdate:modelValue": (value2) => {
            set$1(filterReactive, item.key, value2);
          }
        }), item), item.eventMaps));
      }
      case FORM_ITEM_TYPE.SELECTINPUT: {
        return h(SelectInput, { item, filterReactive });
      }
      case FORM_ITEM_TYPE.SELECTMUTIINPUT:
      case FORM_ITEM_TYPE.MUTIINPUT: {
        return h(
          BatchInput,
          __spreadValues(__spreadProps(__spreadValues({
            placeholder: $k18n("\u6279\u91CF\u8F93\u5165ID\uFF0C\u4EE5\u82F1\u6587\u9017\u53F7\u6216\u7A7A\u683C\u6216\u6362\u884C\u7B26\u9694\u5F00"),
            inputValue: get$1(filterReactive, item.key)
          }, props), {
            "onUpdate:inputValue": (value2) => set$1(filterReactive, item.key, value2),
            selectValue: filterReactive[item.enumerateKey],
            "onUpdate:selectValue": (value2) => {
              filterReactive[item.enumerateKey] = value2;
            },
            enumerate: item.enumerate
          }), item.eventMaps),
          item.slotsMap
        );
      }
      case FORM_ITEM_TYPE.BATCHINPUT: {
        return h(
          ProBatchId,
          __spreadValues(__spreadProps(__spreadValues({}, props), {
            modelValue: get$1(filterReactive, item.key),
            "onUpdate:modelValue": (value2) => {
              set$1(filterReactive, item.key, value2);
            }
          }), item.eventMaps),
          item.slotsMap
        );
      }
      case FORM_ITEM_TYPE.INPUTRANGE:
        return h(
          ProInputRange,
          __spreadProps(__spreadValues({}, props), {
            min: get$1(filterReactive, item.min),
            max: get$1(filterReactive, item.max),
            modelValue: get$1(filterReactive, item.key),
            "onUpdate:modelValue": (value2) => set$1(filterReactive, item.key, value2),
            "onUpdate:max": (value2) => {
              if (item.max) {
                set$1(filterReactive, item.max, value2);
              }
            },
            "onUpdate:min": (value2) => {
              if (item.min) {
                set$1(filterReactive, item.min, value2);
              }
            }
          }),
          item.slotsMap
        );
      case FORM_ITEM_TYPE.UPLOADIMAGE:
      case FORM_ITEM_TYPE.UPLOADFile: {
        const onAvatarSuccess = (imgUrl) => {
          set$1(filterReactive, item.key, imgUrl);
        };
        const onDeleteImage = () => {
          set$1(filterReactive, item.key, "");
        };
        const comName = this.item.type === FORM_ITEM_TYPE.UPLOADIMAGE ? UploadImage : UploadFile;
        return h(comName, __spreadValues(__spreadProps(__spreadValues({
          "image-url": get$1(filterReactive, item.key)
        }, props), {
          bucket: get$1(filterReactive, item.bucket),
          onOnAvatarSuccess: onAvatarSuccess,
          onOnDeleteImage: onDeleteImage,
          limit: item.limit
        }), item.eventMaps));
      }
      case FORM_ITEM_TYPE.SLOT: {
        return renderSlot(this.$slots, item);
      }
      case FORM_ITEM_TYPE.CHECKBOX: {
        return h(
          Checkbox,
          __spreadValues(__spreadProps(__spreadValues({
            options: item.enumerate
          }, props), {
            label: item.optionLabel || "label",
            val: item.optionVal || "value",
            modelValue: get$1(filterReactive, item.key),
            "onUpdate:modelValue": (value2) => set$1(filterReactive, item.key, value2)
          }), item.eventMaps),
          item.slotsMap
        );
      }
      case FORM_ITEM_TYPE.CHECKBOXINPUT: {
        return h(
          ProCheckboxInput,
          __spreadValues(__spreadProps(__spreadValues({
            options: item.enumerate,
            widget: "checkbox"
          }, props), {
            label: item.optionLabel || "label",
            val: item.optionVal || "value",
            modelValue: get$1(filterReactive, item.key),
            "onUpdate:modelValue": (value2) => set$1(filterReactive, item.key, value2)
          }), item.eventMaps),
          item.slotsMap
        );
      }
      case FORM_ITEM_TYPE.RADIOINPUT: {
        return h(
          ProCheckboxInput,
          __spreadValues(__spreadProps(__spreadValues({
            options: item.enumerate,
            widget: "radio"
          }, props), {
            label: item.optionLabel || "label",
            val: item.optionVal || "value",
            modelValue: get$1(filterReactive, item.key),
            "onUpdate:modelValue": (value2) => set$1(filterReactive, item.key, value2)
          }), item.eventMaps),
          item.slotsMap
        );
      }
      case FORM_ITEM_TYPE.COLORPICKER: {
        return h(
          ColorPicker,
          __spreadValues(__spreadProps(__spreadValues({}, props), {
            modelValue: get$1(filterReactive, item.key),
            "onUpdate:modelValue": (value2) => set$1(filterReactive, item.key, value2)
          }), item.eventMaps),
          item.slotsMap
        );
      }
      default: {
        const WIDGET = inject("widget");
        const widgetCom = WIDGET && WIDGET[item.type];
        return widgetCom ? h(widgetCom, __spreadValues(__spreadProps(__spreadValues({
          placeholder: $k18n("\u8BF7\u9009\u62E9"),
          clearable: true
        }, props), {
          data: filterReactive,
          modelValue: get$1(filterReactive, item.key),
          "onUpdate:modelValue": (value2) => set$1(filterReactive, item.key, value2),
          onSetData: (obj) => {
            for (const key2 in obj) {
              set$1(filterReactive, key2, obj[key2]);
            }
          }
        }), item.eventMaps)) : h(
          ProInput,
          __spreadValues(__spreadProps(__spreadValues({
            placeholder: $k18n("\u8BF7\u8F93\u5165"),
            type: item.type
          }, props), {
            modelValue: get$1(filterReactive, item.key),
            "onUpdate:modelValue": (value2) => {
              set$1(filterReactive, item.key, value2);
            }
          }), item.eventMaps),
          item.slotsMap
        );
      }
    }
  }
});
var IOrder$1 = /* @__PURE__ */ ((IOrder2) => {
  IOrder2["ascending"] = "ascending";
  IOrder2["descending"] = "descending";
  return IOrder2;
})(IOrder$1 || {});
function processFormItem(formItemConfig) {
  const { type, background, suffixType } = formItemConfig;
  const { INPUT } = FORM_ITEM_TYPE;
  if (type === INPUT) {
    if (!suffixType) {
      formItemConfig.suffixType = "search";
    }
    if (!background) {
      formItemConfig.background = false;
    }
  }
  return formItemConfig;
}
const Label_vue_vue_type_style_index_0_scoped_true_lang = "";
const _hoisted_1$r = {
  key: 0,
  class: "label_text"
};
const _hoisted_2$g = {
  key: 1,
  class: "label_text"
};
const _sfc_main$B = /* @__PURE__ */ defineComponent({
  __name: "Label",
  props: {
    item: {
      type: Object,
      default: () => ({})
    }
  },
  setup(__props) {
    const props = __props;
    const $k18n = getK18n();
    const labelText = computed(() => {
      const { item } = props;
      return item.isLabelK18n === false ? item.label : $k18n(item.label);
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock(Fragment, null, [
        __props.item.enLabel ? (openBlock(), createElementBlock("span", _hoisted_1$r, toDisplayString(unref(getTableLabel)(__props.item)), 1)) : (openBlock(), createElementBlock("span", _hoisted_2$g, toDisplayString(unref(labelText)), 1)),
        __props.item.headerDesc ? (openBlock(), createBlock(unref(ProTooltip), {
          key: 2,
          content: unref($k18n)(__props.item.headerDesc)
        }, null, 8, ["content"])) : createCommentVNode("", true)
      ], 64);
    };
  }
});
const Label = /* @__PURE__ */ _export_sfc(_sfc_main$B, [["__scopeId", "data-v-71f28e2c"]]);
const TableHeader_vue_vue_type_style_index_0_scoped_true_lang = "";
const TableHeader_vue_vue_type_style_index_1_lang = "";
const _hoisted_1$q = { class: "base_table_header" };
const _hoisted_2$f = { class: "label" };
const _hoisted_3$d = { class: "op_wrapper" };
const _hoisted_4$9 = {
  key: 1,
  class: "hide_item"
};
const _sfc_main$A = /* @__PURE__ */ defineComponent({
  __name: "TableHeader",
  props: {
    item: {
      type: Object,
      default: void 0
    },
    formItems: {
      type: Array,
      default: () => []
    },
    formData: {
      type: Object,
      default: () => ({})
    },
    enumerateObj: {
      type: Object,
      default: () => ({})
    },
    orderData: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ["current-change", "sort-change"],
  setup(__props, { emit: emit2 }) {
    const props = __props;
    const renderInPopover = [FORM_ITEM_TYPE.INPUTRANGE, FORM_ITEM_TYPE.INPUT];
    const ORDER_LIST = [IOrder$1.descending, IOrder$1.ascending, ""];
    onMounted(() => {
      const { item } = props;
      const { defaultSort, key } = item;
      if (defaultSort) {
        props.orderData.prop = key;
        props.orderData.order = ORDER_LIST.includes(defaultSort) ? defaultSort : IOrder$1.descending;
      }
    });
    const state = reactive({
      dataChange: false,
      visible: false
    });
    const formItem = computed(() => {
      const { item, formItems } = props;
      const { key } = item;
      return formItems == null ? void 0 : formItems.find((obj) => obj.key === key);
    });
    const isPopoverComp = computed(() => {
      var _a;
      return renderInPopover.includes((_a = formItem.value) == null ? void 0 : _a.type);
    });
    function handlePopValueChange() {
      state.dataChange = true;
    }
    function handleClick() {
      var _a;
      if (((_a = formItem.value) == null ? void 0 : _a.type) === FORM_ITEM_TYPE.INPUT) {
        state.dataChange = false;
        state.visible = false;
        emit2("current-change", 1);
      }
    }
    function handleVisibleChange(visible) {
      if (!visible) {
        handleValueChange();
      }
    }
    function handleValueChange() {
      if (!state.dataChange) {
        return;
      }
      emit2("current-change", 1);
      state.dataChange = false;
    }
    function getOnClass(order2) {
      const { item, orderData: orderData2 } = props;
      return (item == null ? void 0 : item.key) === orderData2.prop && orderData2.order === order2;
    }
    function handleOrderChange() {
      var _a;
      const { orderData: orderData2, item } = props;
      const { prop, order: order2 } = orderData2;
      if (prop === (item == null ? void 0 : item.key)) {
        const index2 = ORDER_LIST.indexOf(order2) + 1;
        const next = index2 === ORDER_LIST.length ? 0 : index2;
        props.orderData.order = ORDER_LIST[next];
      } else {
        props.orderData.order = ORDER_LIST[0];
        props.orderData.prop = ((_a = props.item) == null ? void 0 : _a.key) || "";
      }
      emit2("sort-change", item);
    }
    const hasCheckedValue = computed(() => {
      const { formData } = props;
      const { key } = formItem.value;
      const value2 = formData[key];
      if (Array.isArray(value2)) {
        return !!value2.length;
      }
      if (typeof value2 === "boolean" && value2) {
        return true;
      }
      return value2;
    });
    return (_ctx, _cache) => {
      const _component_ks_popover = resolveComponent("ks-popover");
      return openBlock(), createElementBlock("div", _hoisted_1$q, [
        createElementVNode("span", _hoisted_2$f, [
          createVNode(Label, { item: __props.item }, null, 8, ["item"])
        ]),
        createElementVNode("div", _hoisted_3$d, [
          unref(formItem) ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
            unref(isPopoverComp) ? (openBlock(), createBlock(_component_ks_popover, {
              key: 0,
              visible: state.visible,
              "onUpdate:visible": _cache[0] || (_cache[0] = ($event) => state.visible = $event),
              "popper-class": "base_table_header_filter__popover",
              width: "auto",
              onHide: handleValueChange
            }, {
              reference: withCtx(() => [
                createVNode(unref(IconGeneralFilter), {
                  class: normalizeClass({ checked: unref(hasCheckedValue) })
                }, null, 8, ["class"])
              ]),
              default: withCtx(() => [
                createVNode(_sfc_main$C, {
                  item: unref(processFormItem)(unref(formItem)),
                  "filter-reactive": __props.formData,
                  class: "header_filter__item",
                  onSuffixClick: handleClick,
                  onChange: handlePopValueChange
                }, null, 8, ["item", "filter-reactive"])
              ]),
              _: 1
            }, 8, ["visible"])) : (openBlock(), createElementBlock("div", _hoisted_4$9, [
              createVNode(unref(IconGeneralFilter), {
                class: normalizeClass({ checked: unref(hasCheckedValue) })
              }, null, 8, ["class"]),
              createVNode(_sfc_main$C, {
                item: unref(processFormItem)(unref(formItem)),
                "filter-reactive": __props.formData,
                class: "header_filter__item",
                onVisibleChange: handleVisibleChange,
                onChange: handlePopValueChange
              }, null, 8, ["item", "filter-reactive"])
            ]))
          ], 64)) : createCommentVNode("", true),
          __props.item.sortable ? (openBlock(), createElementBlock("div", {
            key: 1,
            class: "sort_wrapper",
            onClick: handleOrderChange
          }, [
            createVNode(unref(IconDirectionDown), {
              size: 16,
              style: {
                bottom: "-3px"
              },
              class: normalizeClass({
                on: getOnClass(unref(IOrder$1).descending)
              })
            }, null, 8, ["class"]),
            createVNode(unref(IconDirectionUp), {
              size: 16,
              style: {
                top: "-4px"
              },
              class: normalizeClass({
                on: getOnClass(unref(IOrder$1).ascending)
              })
            }, null, 8, ["class"])
          ])) : createCommentVNode("", true)
        ])
      ]);
    };
  }
});
const TableHeader = /* @__PURE__ */ _export_sfc(_sfc_main$A, [["__scopeId", "data-v-bacb1404"]]);
const TABLE_FIXED_CLASS_NAME = {
  ["left"]: ".ks-table__fixed",
  ["right"]: ".ks-table__fixed-right"
};
const HEIGHT_DISTANCE = 6;
const TABLE_HEADER_HEIGHT = "47px";
function useHeaderSticky(props, tableRef) {
  let tableHeader = null;
  let tableEl = null;
  let timer = null;
  const fixedColumn = {
    ["left"]: [],
    ["right"]: []
  };
  const stickyTop = props.headerSticky - HEIGHT_DISTANCE;
  let cloneEl = null;
  onMounted(() => {
    var _a;
    tableEl = (_a = tableRef.value) == null ? void 0 : _a.$el;
    if (props.headerSticky > 0 && tableEl) {
      tableHeader = tableEl.querySelector(".ks-table__header-wrapper");
      createHackDiv();
      document.addEventListener("scroll", handleScroll);
    }
  });
  onBeforeUnmount(() => {
    if (props.headerSticky > 0) {
      document.removeEventListener("scroll", handleScroll);
    }
  });
  function createHackDiv() {
    cloneEl = document.createElement("div");
    cloneEl.style.height = TABLE_HEADER_HEIGHT;
    cloneEl.style.display = "none";
    tableHeader.parentNode.insertBefore(cloneEl, tableHeader);
  }
  function setFixedColumnStyle(key) {
    var _a;
    const fixColumnEl = tableEl.querySelector(TABLE_FIXED_CLASS_NAME[key]);
    if (fixColumnEl) {
      const fixedTh = fixColumnEl.querySelectorAll("th:not(.is-hidden)");
      const headerWrapper = fixColumnEl.querySelector(".ks-table__fixed-header-wrapper");
      fixColumnEl.clientWidth;
      const itemWidthArr = [];
      let lastItemWidth = 0;
      if (fixedTh == null ? void 0 : fixedTh.length) {
        const itemHeight = (_a = fixedTh[0]) == null ? void 0 : _a.clientHeight;
        fixedColumn[key] = fixedTh;
        fixedTh == null ? void 0 : fixedTh.forEach((item) => {
          itemWidthArr.push(item.clientWidth);
        });
        fixedTh == null ? void 0 : fixedTh.forEach((item, index2) => {
          item.style.width = `${itemWidthArr[index2]}px`;
          item.style.height = `${itemHeight}px`;
          item.style.position = "fixed";
          item.style["z-index"] = 4;
          item.style.top = `${props.headerSticky}px`;
          item.style["margin-left"] = `${lastItemWidth}px`;
          lastItemWidth += parseFloat(itemWidthArr[index2]);
        });
      }
      fixColumnEl.style["z-index"] = 4;
      headerWrapper.style["z-index"] = 4;
    }
  }
  function setTableHeaderStyle() {
    const originalScrollLeft = tableHeader.scrollLeft;
    tableHeader.style.position = "fixed";
    tableHeader.style.top = `${props.headerSticky}px`;
    tableHeader.style.opacity = 1;
    tableHeader.style.width = `${tableEl.clientWidth}px`;
    tableHeader.style["z-index"] = 4;
    tableHeader.scrollLeft = originalScrollLeft;
    cloneEl.style.display = "block";
  }
  function resetFixedColumnStyle(key) {
    fixedColumn[key].forEach((item) => {
      item.style.position = "initial";
      item.style.width = "auto";
      item.style["z-index"] = "auto";
    });
  }
  function resetTableHeaderStyle() {
    tableHeader.style.position = "initial";
    tableHeader.style.width = "auto";
    tableHeader.style.opacity = 1;
    tableHeader.style["z-index"] = "auto";
    cloneEl.style.display = "none";
  }
  function handleScroll() {
    requestAnimationFrame(() => {
      const { top: top2 } = tableEl == null ? void 0 : tableEl.getBoundingClientRect();
      clearTimeout(timer);
      timer = setTimeout(() => {
        if ((tableEl == null ? void 0 : tableEl.getBoundingClientRect().top) === top2) {
          if (top2 <= stickyTop) {
            setFixedColumnStyle("left");
            setFixedColumnStyle("right");
            setTableHeaderStyle();
          }
        }
      }, 200);
      if (top2 <= stickyTop) {
        if (cloneEl.style.display === "block") {
          return;
        }
        tableHeader.style.opacity = 0;
      } else {
        resetTableHeaderStyle();
        resetFixedColumnStyle("left");
        resetFixedColumnStyle("right");
      }
    });
  }
}
const index_vue_vue_type_style_index_0_scoped_true_lang$4 = "";
const index_vue_vue_type_style_index_1_lang$2 = "";
const _sfc_main$z = defineComponent({
  name: "BaseTable",
  props: {
    data: {
      type: Array,
      default: () => []
    },
    columns: {
      type: Array,
      default: () => []
    },
    formItems: {
      type: Array,
      default: () => []
    },
    formData: {
      type: Object,
      default: () => ({})
    },
    enumerateObj: {
      type: Object,
      default: () => ({})
    },
    utils: {
      type: Object,
      default: () => ({})
    },
    headerSticky: {
      type: Number,
      default: 0
    },
    pageInfo: {
      type: Object,
      default: () => ({ current: 0, pageSize: 0, total: 0 }),
      validator: (value2) => ["current", "pageSize"].every((v) => typeof value2[v] === "number")
    },
    paginationAttrs: {
      type: Object,
      default: () => ({})
    },
    showPagination: {
      type: Boolean,
      default: false
    },
    colMaxWidth: {
      type: Number,
      default: TABLE_COLUMN_WIDTH.medium
    },
    useEnHeaderWrap: {
      type: Boolean,
      default: true
    },
    useCnHeaderWrap: {
      type: Boolean,
      default: false
    },
    selectionBar: {
      type: Object,
      default: null
    },
    drawerProps: {
      type: Object,
      default: null
    },
    operators: {
      type: Array,
      default: () => []
    },
    downloadConfig: {
      type: [Object, Boolean],
      default: false
    },
    colSetting: {
      type: [Object, String],
      default: ""
    },
    forceUpdate: {
      type: Boolean,
      default: false
    }
  },
  emits: [
    "current-change",
    "size-change",
    "sort-change",
    "update:selection",
    "reload",
    "show",
    "columnConfigChange",
    "selection-bar-close",
    "selection-bar-click",
    "selection-change"
  ],
  setup(props, ctx) {
    const ksTableRef = ref();
    const drawerComponentRef = ref();
    const $k18n = getK18n();
    const slots = useSlots();
    const state = reactive({
      selection: [],
      renderColumns: props.columns,
      showDrawer: false,
      showDataHighlight: false
    });
    useHeaderSticky(props, ksTableRef);
    const orderData2 = reactive({
      prop: "",
      order: ""
    });
    function isColSetting() {
      var _a;
      if (typeof (props == null ? void 0 : props.colSetting) === "string") {
        return !!props.colSetting;
      }
      return !!((_a = props == null ? void 0 : props.colSetting) == null ? void 0 : _a.localStoreKey);
    }
    function getFilterColumns() {
      if (!isColSetting()) {
        state.renderColumns = props.columns;
      }
      const columns = transformExpandColumns(state.renderColumns);
      return columns && columns.filter((item) => {
        const { condition } = item;
        if (typeof condition === "boolean") {
          return condition;
        }
        if (!condition) {
          return true;
        }
        if (isFunction$2(condition)) {
          return condition(item);
        }
        return condition;
      });
    }
    function generateColumns(filterColumns) {
      const { formItems, formData, enumerateObj, utils: utils2 } = props;
      return filterColumns.map((item, index2) => {
        if (item.type === TABLE_ITEM_TYPE.SELECTION) {
          return h(TableColumn, __spreadValues({
            type: "selection"
          }, item));
        }
        if (item.type === TABLE_ITEM_TYPE.EXPAND) {
          const expandContent = slots["expand-content"];
          return h(
            TableColumn,
            __spreadValues({
              type: "expand"
            }, item),
            {
              default: expandContent
            }
          );
        }
        const k18nLabel = getTableLabel(item);
        return h(
          TableColumn,
          __spreadValues(__spreadValues({
            prop: item.key,
            label: k18nLabel
          }, omit(item, ["sortable"])), getColWidth(props, __spreadProps(__spreadValues({}, item), {
            label: k18nLabel
          }))),
          {
            default: renderColumn(item),
            header: h(TableHeader, {
              key: item.key,
              item,
              formData,
              orderData: orderData2,
              utils: utils2,
              enumerateObj,
              formItems,
              onCurrentChange,
              onSortChange
            })
          }
        );
      });
    }
    function onCurrentChange(size) {
      ctx.emit("current-change", size);
    }
    function onSizeChange(size) {
      ctx.emit("size-change", size);
    }
    function onSortChange(item) {
      const { sortable } = item;
      if (sortable === true) {
        const { prop, order: order2 } = orderData2;
        ksTableRef.value.sort(prop, order2);
      }
      ctx.emit("sort-change", orderData2);
    }
    function handleSelectionChange(val) {
      state.selection = val;
      ctx.emit("update:selection", val);
      ctx.emit("selection-change", val);
    }
    function handleDrawerComponentShow(item, scope) {
      drawerComponentRef.value.handleClickShow(item, scope);
    }
    function render2() {
      const filterColumns = getFilterColumns();
      const table = h(
        Table,
        __spreadProps(__spreadValues({
          class: getTableClass(props, ctx),
          ref: ksTableRef,
          data: props.data
        }, ctx.attrs), {
          key: props.forceUpdate ? Date.now() : "",
          onSelectionChange: handleSelectionChange
        }),
        {
          default: () => generateColumns(filterColumns),
          empty: slots.empty
        }
      );
      const pagination = h(ProPagination, {
        class: "pagination",
        pageInfo: props.pageInfo,
        paginationAttrs: props.paginationAttrs,
        showPagination: props.showPagination,
        onCurrentChange,
        onSizeChange
      });
      const selectionBar = renderSelectionBar(props, ctx, ksTableRef, state);
      const drawerComponent = renderDrawerComponent(props, ctx, drawerComponentRef);
      const operationButtons = renderOperationButtons(props, ctx, state, {
        handleDrawerComponentShow,
        filterColumns
      });
      return h(
        "div",
        {
          class: "base_table__wrapper"
        },
        { default: () => [operationButtons, table, pagination, selectionBar, drawerComponent] }
      );
    }
    watch(
      () => {
        var _a, _b;
        return (_b = (_a = $k18n == null ? void 0 : $k18n.global) == null ? void 0 : _a.locale) == null ? void 0 : _b.value;
      },
      (val, pre) => {
        if (val !== pre && props.colMaxWidth) {
          nextTick(() => {
            ksTableRef.value.doLayout();
          });
        }
      }
    );
    ctx.expose({
      ksTableRef,
      handleDrawerComponentShow
    });
    return render2;
  }
});
const ProTable = /* @__PURE__ */ _export_sfc(_sfc_main$z, [["__scopeId", "data-v-1f18ad7f"]]);
const ENGINE_API = "/admin/render/engine";
const DEFAULT_LABEL = "label";
const DEFAULT_VALUE = "value";
function transformEnumerate(item) {
  const { optionLabel = "label", optionVal = "value", enumerate } = item == null ? void 0 : item.extra;
  const result = [];
  if (Array.isArray(enumerate)) {
    enumerate.forEach((item2) => {
      result.push({
        [DEFAULT_LABEL]: item2[optionLabel],
        [DEFAULT_VALUE]: item2[optionVal]
      });
    });
    return result;
  }
  const keys = Object.keys(enumerate);
  keys.forEach((key) => {
    result.push({
      [DEFAULT_LABEL]: enumerate[key],
      [DEFAULT_VALUE]: key
    });
  });
  return result;
}
function mitt(n) {
  return { all: n = n || /* @__PURE__ */ new Map(), on: function(t, e) {
    var i = n.get(t);
    i ? i.push(e) : n.set(t, [e]);
  }, off: function(t, e) {
    var i = n.get(t);
    i && (e ? i.splice(i.indexOf(e) >>> 0, 1) : n.set(t, []));
  }, emit: function(t, e) {
    var i = n.get(t);
    i && i.slice().map(function(n2) {
      n2(e);
    }), (i = n.get("*")) && i.slice().map(function(n2) {
      n2(t, e);
    });
  } };
}
const RenderItem_vue_vue_type_style_index_0_scoped_true_lang = "";
const _sfc_main$y = defineComponent({
  name: "RenderGroup",
  props: {
    item: {
      type: Object,
      default: () => reactive({})
    },
    data: {
      type: Object,
      default: () => reactive({})
    },
    prop: {
      type: String,
      default: ""
    },
    propKey: {
      type: String,
      default: ""
    }
  },
  setup(props, ctx) {
    const $k18n = getK18n();
    const slotKey = ["tips", "label", "error"];
    const itemSlots = reactive({});
    const hasLabelSlot = ref(false);
    slotKey.forEach((slotName) => {
      const slot = props.item[slotName];
      if (slot) {
        if (typeof slot === "object") {
          if (slotName === "label" && slot) {
            hasLabelSlot.value = true;
          }
          itemSlots[slotName] = slot;
          return;
        }
        slotName !== "label" && (itemSlots[slotName] = h("p", null, slot));
      }
    });
    const propkey = props.propKey || props.item.key;
    return () => {
      const namedSlots = {};
      if (Object.keys(itemSlots).length !== 0) {
        Object.keys(itemSlots).forEach((name) => {
          namedSlots[name] = () => itemSlots[name];
        });
      }
      if (!hasLabelSlot.value && props.item.label) {
        const tooltip2 = props.item.tooltip ? h(
          Tooltip,
          {
            class: "item",
            effect: "dark",
            content: $k18n(props.item.tooltip),
            placement: "top"
          },
          h(IconGeneralQuestion, { class: "tooltip-icon" })
        ) : "";
        namedSlots.label = () => [
          $k18n({
            text: props.item.label,
            desc: props.item.k18nDesc || ""
          }),
          tooltip2
        ];
      }
      if (props.item.type === "slot") {
        return renderSlot(ctx.slots, props.item);
      }
      let rules2 = props.item.rules;
      if (props.item.required) {
        const requiredRule = {
          required: true,
          message: $k18n(DEFAULT_RULE_MESSAGE[props.item.type]) + $k18n(props.item.label),
          trigger: ["blur", "change"]
        };
        if (rules2) {
          rules2 = Array.isArray(rules2) ? rules2 : [rules2];
          rules2.push(requiredRule);
        } else {
          rules2 = requiredRule;
        }
      }
      return h(
        FormItem,
        __spreadValues(__spreadValues({
          key: props.item.key,
          class: [props.item.itemClass],
          style: props.item.itemStyle,
          prop: propkey,
          rules: rules2
        }, props.item.itemProps), props.item.itemEvents),
        __spreadProps(__spreadValues({}, namedSlots), {
          default: () => h(
            _sfc_main$C,
            {
              item: props.item,
              "filter-reactive": props.data
            },
            ctx.slots
          )
        })
      );
    };
  }
});
const RenderItem = /* @__PURE__ */ _export_sfc(_sfc_main$y, [["__scopeId", "data-v-13154d29"]]);
const GroupTitle_vue_vue_type_style_index_0_scoped_true_lang = "";
const _hoisted_1$p = { class: "group-title" };
const _sfc_main$x = /* @__PURE__ */ defineComponent({
  __name: "GroupTitle",
  props: {
    item: {
      type: Object,
      default: () => reactive({})
    }
  },
  setup(__props) {
    const $k18n = getK18n();
    return (_ctx, _cache) => {
      const _component_k18n = resolveComponent("k18n");
      const _component_ks_tooltip = resolveComponent("ks-tooltip");
      return openBlock(), createElementBlock("div", _hoisted_1$p, [
        createVNode(_component_k18n, null, {
          default: withCtx(() => [
            createTextVNode(toDisplayString(__props.item.title), 1)
          ]),
          _: 1
        }),
        __props.item.tooltip ? (openBlock(), createBlock(_component_ks_tooltip, {
          key: 0,
          class: "item",
          effect: "dark",
          content: unref($k18n)(__props.item.tooltip),
          placement: "top"
        }, {
          default: withCtx(() => [
            createVNode(unref(IconGeneralQuestion), { class: "sys-icon-question tooltip-icon" })
          ]),
          _: 1
        }, 8, ["content"])) : createCommentVNode("", true)
      ]);
    };
  }
});
const GroupTitle = /* @__PURE__ */ _export_sfc(_sfc_main$x, [["__scopeId", "data-v-78079c87"]]);
const RenderArray_vue_vue_type_style_index_0_scoped_true_lang = "";
const RenderArray = defineComponent({
  name: "RenderArray",
  props: {
    item: {
      type: Object,
      default: () => reactive({})
    },
    data: {
      type: Object,
      default: () => reactive({})
    },
    propKey: {
      type: String,
      default: ""
    }
  },
  setup(props, ctx) {
    const $k18n = getK18n();
    const elForm = inject(elFormKey, {});
    const tooltip2 = props.item.tooltip ? h(
      Tooltip,
      {
        class: "item",
        effect: "dark",
        content: $k18n(props.item.tooltip),
        placement: "top"
      },
      h(IconGeneralQuestion, { class: "tooltip-icon" })
    ) : "";
    return () => {
      const children = [];
      let title;
      if (props.item.title) {
        if (props.item.type === FORM_ITEM_TYPE.COLLAPSEITEM) {
          title = () => [
            h(IconMediaPlay, {
              class: "collapse-icon"
            }),
            $k18n(props.item.title),
            tooltip2,
            props.item.delete && !elForm.disabled ? h(IconGeneralDelete, {
              class: "delete-icon",
              onClick: (e) => {
                const { relatekey, relateValue } = props.item.delete;
                const index2 = props.data[relatekey].indexOf(relateValue);
                props.data[relatekey].splice(index2, 1);
                e.stopPropagation();
              }
            }) : ""
          ];
        } else {
          children.push(h(GroupTitle, { item: props.item }));
        }
      }
      if (props.item.slot) {
        children.push(renderSlot(ctx.slots, props.item));
      }
      if (props.item.items) {
        const itemArray = props.item.items.map((arrayItem) => {
          if (Array.isArray(arrayItem)) {
            const realItem = arrayItem.filter((i) => {
              conditionHandler(i, props.data);
              return i.condition;
            });
            const arrayItemLen = realItem.length;
            const curSpan = 24 / arrayItemLen;
            const colRender = realItem.map((iItem) => {
              return h(
                Col,
                { span: iItem.span ? iItem.span : curSpan },
                {
                  default: () => h(
                    RenderCom,
                    {
                      item: iItem,
                      data: props.data,
                      propKey: props.propKey ? `${props.propKey}.${iItem.key}` : iItem.key
                    },
                    ctx.slots
                  )
                }
              );
            });
            return h(Row, { gutter: 16 }, { default: () => colRender });
          }
          return h(
            RenderCom,
            {
              item: arrayItem,
              data: props.data,
              propKey: props.propKey ? `${props.propKey}.${arrayItem.key}` : arrayItem.key
            },
            ctx.slots
          );
        });
        children.push(...itemArray);
      }
      if (props.item.type === FORM_ITEM_TYPE.COLLAPSEITEM) {
        return h(
          CollapseItem,
          {
            name: props.item.name,
            class: props.item.styleType === "panel" ? "collapse-item-panel" : ""
          },
          {
            title,
            default: () => h("div", { class: "group-panel", style: props.item.style }, children)
          }
        );
      }
      return h("div", { class: "group-panel", style: props.item.style }, children);
    };
  }
});
const _sfc_main$w = RenderArray;
const RenderArray$1 = /* @__PURE__ */ _export_sfc(_sfc_main$w, [["__scopeId", "data-v-1b4b4245"]]);
const RenderPanel_vue_vue_type_style_index_0_scoped_true_lang = "";
const _withScopeId$3 = (n) => (pushScopeId("data-v-e0decbd8"), n = n(), popScopeId(), n);
const _hoisted_1$o = {
  key: 0,
  class: "title"
};
const _hoisted_2$e = {
  key: 1,
  class: "title"
};
const _hoisted_3$c = /* @__PURE__ */ _withScopeId$3(() => /* @__PURE__ */ createElementVNode("span", { class: "add-icon" }, "+", -1));
const _sfc_main$v = /* @__PURE__ */ defineComponent({
  __name: "RenderPanel",
  props: {
    item: {
      type: Object,
      default: () => reactive({})
    },
    data: {
      type: Object,
      default: () => reactive({})
    }
  },
  setup(__props) {
    const props = __props;
    const reactiveData = computed(() => props.data[props.item.key]);
    const getDefault = (items, defaultObj2 = {}) => {
      items.forEach((item) => {
        if (Array.isArray(item)) {
          return getDefault(item, defaultObj2);
        }
        if (typeof item.key === "string") {
          defaultObj2[item.key] = "";
        }
      });
      return defaultObj2;
    };
    const defaultObj = computed(() => {
      const { data, item } = props;
      return __spreadValues(__spreadValues({}, getDefault(item.items)), item.default || {});
    });
    const showAdd = computed(() => {
      const { limit } = props.item;
      if (typeof limit === "number" || typeof limit === "string") {
        const num = Number(limit);
        return !isNaN(num) ? reactiveData.value.length < limit : limit;
      }
      return limit;
    });
    const showDelete = computed(() => {
      if (props.item.showDelete === void 0) {
        return true;
      }
      return props.item.showDelete;
    });
    function initData() {
      const { data, item } = props;
      if (!(Array.isArray(data[item.key]) && data[item.key].length)) {
        data[item.key] = [cloneDeep(defaultObj.value)];
      }
    }
    initData();
    const addQuery = () => {
      props.data[props.item.key].push(cloneDeep(defaultObj.value));
    };
    const deleteQuery = (index2) => {
      props.data[props.item.key].splice(index2, 1);
    };
    return (_ctx, _cache) => {
      const _component_k18n = resolveComponent("k18n");
      const _component_ks_row = resolveComponent("ks-row");
      const _component_ks_divider = resolveComponent("ks-divider");
      const _component_ks_col = resolveComponent("ks-col");
      return openBlock(), createElementBlock(Fragment, null, [
        (openBlock(true), createElementBlock(Fragment, null, renderList(unref(reactiveData), (panel, panelIdx) => {
          return openBlock(), createElementBlock("div", {
            key: panelIdx,
            class: "panel-wrapper"
          }, [
            createVNode(_component_ks_row, {
              type: "flex",
              justify: "space-between",
              align: "middle"
            }, {
              default: withCtx(() => [
                panel.panelTitle ? (openBlock(), createElementBlock("span", _hoisted_1$o, toDisplayString(panel.panelTitle), 1)) : (openBlock(), createElementBlock("span", _hoisted_2$e, [
                  createVNode(_component_k18n, null, {
                    default: withCtx(() => [
                      createTextVNode(toDisplayString(__props.item.title), 1)
                    ]),
                    _: 1
                  }),
                  createTextVNode(toDisplayString(panelIdx + 1), 1)
                ])),
                unref(showDelete) && unref(reactiveData).length > 1 ? (openBlock(), createBlock(unref(IconGeneralDelete), {
                  key: 2,
                  class: "delete-icon",
                  onClick: ($event) => deleteQuery(panelIdx)
                }, null, 8, ["onClick"])) : createCommentVNode("", true)
              ]),
              _: 2
            }, 1024),
            createVNode(_component_ks_divider, { class: "divider" }),
            (openBlock(true), createElementBlock(Fragment, null, renderList(__props.item.items, (itemBar, barIdx) => {
              return openBlock(), createElementBlock(Fragment, { key: barIdx }, [
                Array.isArray(itemBar) ? (openBlock(), createBlock(_component_ks_row, {
                  key: 0,
                  gutter: 16,
                  type: "flex",
                  justify: "space-between"
                }, {
                  default: withCtx(() => [
                    (openBlock(true), createElementBlock(Fragment, null, renderList(itemBar, (singleItem, idx) => {
                      return openBlock(), createBlock(_component_ks_col, { key: idx }, {
                        default: withCtx(() => [
                          singleItem.condition ? (openBlock(), createBlock(RenderItem, {
                            key: 0,
                            item: singleItem,
                            data: unref(reactiveData)[panelIdx],
                            "prop-key": `${__props.item.key}.${panelIdx}.${singleItem.key}`
                          }, null, 8, ["item", "data", "prop-key"])) : createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1024);
                    }), 128))
                  ]),
                  _: 2
                }, 1024)) : itemBar.condition ? (openBlock(), createBlock(RenderItem, {
                  key: 1,
                  item: itemBar,
                  data: unref(reactiveData)[panelIdx]
                }, null, 8, ["item", "data"])) : createCommentVNode("", true)
              ], 64);
            }), 128))
          ]);
        }), 128)),
        unref(showAdd) ? (openBlock(), createElementBlock("div", {
          key: 0,
          class: "add-btn",
          onClick: addQuery
        }, [
          _hoisted_3$c,
          createVNode(_component_k18n, null, {
            default: withCtx(() => [
              createTextVNode(toDisplayString(__props.item.btnText || "\u65B0\u589E"), 1)
            ]),
            _: 1
          })
        ])) : createCommentVNode("", true)
      ], 64);
    };
  }
});
const RenderPanel = /* @__PURE__ */ _export_sfc(_sfc_main$v, [["__scopeId", "data-v-e0decbd8"]]);
const RenderCollapse_vue_vue_type_style_index_0_scoped_true_lang = "";
const _sfc_main$u = /* @__PURE__ */ defineComponent({
  __name: "RenderCollapse",
  props: {
    item: {
      type: Object,
      default: () => reactive({})
    },
    data: {
      type: Object,
      default: () => reactive({})
    },
    propKey: {
      type: String,
      default: ""
    }
  },
  emits: ["change"],
  setup(__props, { emit: emits }) {
    const props = __props;
    const activeNames = ref([]);
    watch(
      () => props.item.activeNames,
      (newVal) => {
        activeNames.value = newVal;
      },
      { immediate: true, deep: true }
    );
    const change = (value2) => {
      emits("change", value2);
    };
    return (_ctx, _cache) => {
      const _component_ks_collapse = resolveComponent("ks-collapse");
      return openBlock(), createBlock(_component_ks_collapse, {
        modelValue: activeNames.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => activeNames.value = $event),
        class: "custom-collapse-style",
        onChange: change,
        accordion: __props.item.accordion
      }, {
        default: withCtx(() => [
          (openBlock(true), createElementBlock(Fragment, null, renderList(__props.item.items, (collapseItem, collapseItemIdx) => {
            return openBlock(), createElementBlock("div", {
              key: collapseItemIdx,
              class: "collapse-item-wrapper"
            }, [
              createVNode(RenderCom, {
                data: __props.data,
                item: collapseItem,
                "prop-key": __props.propKey
              }, createSlots({ _: 2 }, [
                renderList(_ctx.$slots, (slotVal, slotName) => {
                  return {
                    name: slotName,
                    fn: withCtx(() => [
                      renderSlot$2(_ctx.$slots, slotName, {}, void 0, true)
                    ])
                  };
                })
              ]), 1032, ["data", "item", "prop-key"])
            ]);
          }), 128))
        ]),
        _: 3
      }, 8, ["modelValue", "accordion"]);
    };
  }
});
const RenderCollapse = /* @__PURE__ */ _export_sfc(_sfc_main$u, [["__scopeId", "data-v-435839d4"]]);
const RenderCollapsePanel_vue_vue_type_style_index_0_scoped_true_lang = "";
const _withScopeId$2 = (n) => (pushScopeId("data-v-15ba8c4a"), n = n(), popScopeId(), n);
const _hoisted_1$n = ["onClick"];
const _hoisted_2$d = {
  key: 1,
  class: "title-text"
};
const _hoisted_3$b = { class: "icon-group" };
const _hoisted_4$8 = { style: { "margin": "4px 0px 12px 4px" } };
const _hoisted_5$6 = { style: { "margin-left": "36px", "display": "flex" } };
const _hoisted_6$2 = /* @__PURE__ */ _withScopeId$2(() => /* @__PURE__ */ createElementVNode("span", { class: "add-icon" }, "+", -1));
const _sfc_main$t = /* @__PURE__ */ defineComponent({
  __name: "RenderCollapsePanel",
  props: {
    item: {
      type: Object,
      default: () => reactive({})
    },
    data: {
      type: Object,
      default: () => reactive({})
    }
  },
  setup(__props) {
    const props = __props;
    const $k18n = getK18n();
    const isTitleEdit = ref(false);
    const inputRef = ref(null);
    const updatePanelTitle = () => {
      const data = props.data[props.item.key];
      const panelTitleKey = props.item.panelTitleKey;
      if (panelTitleKey && !isTitleEdit.value) {
        const reg = new RegExp(`^${props.item.panelTitle}\\d+`);
        data.forEach((dataItem, index2) => {
          if (!dataItem[panelTitleKey] || reg.test(dataItem[panelTitleKey])) {
            dataItem[panelTitleKey] = $k18n(props.item.panelTitle) + (index2 + 1);
          }
        });
      }
    };
    const config = ref([{ deleteVisible: false, items: cloneDeep(props.item.items) }]);
    watch(
      () => props.data,
      () => {
        var _a;
        const length = (_a = props.data[props.item.key]) == null ? void 0 : _a.length;
        if (length) {
          config.value.length = length;
          for (let i = 0; i < length; i++) {
            config.value[i] = { deleteVisible: false, items: cloneDeep(props.item.items) };
          }
        }
      },
      {
        immediate: true
      }
    );
    const reactiveData = computed(() => {
      const data = props.data[props.item.key];
      updatePanelTitle();
      if (props.item.relativeKey) {
        props.item.relativeKey.forEach((relativeKey) => {
          data.forEach((dataItem) => {
            dataItem[relativeKey] = props.data[relativeKey];
          });
        });
      }
      return data;
    });
    const getDefault = (items, obj = {}) => {
      items.forEach((item) => {
        if (Array.isArray(item)) {
          return getDefault(item, obj);
        }
        if (typeof item.key === "string") {
          obj[item.key] = "";
        }
      });
      return obj;
    };
    const defaultObj = computed(() => {
      const { data, item } = props;
      return __spreadValues(__spreadValues({}, getDefault(item.items)), item.default || {});
    });
    const showAdd = computed(() => {
      const { limit } = props.item;
      if (typeof limit === "number" || typeof limit === "string") {
        const num = Number(limit);
        return !isNaN(num) ? reactiveData.value.length < limit : limit;
      }
      return limit;
    });
    const computedBtn = (key) => {
      if (props.item[key] === void 0) {
        return true;
      }
      return props.item[key];
    };
    const showEdit = computed(() => computedBtn("showEdit"));
    const showCopy = computed(() => computedBtn("showCopy"));
    const showDelete = computed(() => computedBtn("showDelete"));
    function initData() {
      const { data, item } = props;
      if (!(Array.isArray(data[item.key]) && data[item.key].length)) {
        data[item.key] = [cloneDeep(defaultObj.value)];
      }
    }
    initData();
    const addQuery = () => {
      props.data[props.item.key].push(cloneDeep(defaultObj.value));
      config.value.push({ deleteVisible: false, items: cloneDeep(props.item.items) });
    };
    const panelTitle = reactive([]);
    const onEdit = (index2, bool) => {
      isTitleEdit.value = bool;
      panelTitle[index2] = bool;
      nextTick().then(() => {
        inputRef.value[0].focus();
      });
    };
    const onCopy = (index2) => {
      props.data[props.item.key].push(cloneDeep(reactiveData.value[index2]));
      config.value.push({ deleteVisible: false, items: cloneDeep(props.item.items) });
    };
    const onDelete = (index2, type) => {
      if (type === "show") {
        config.value[index2].deleteVisible = true;
        return;
      }
      if (type === "confirm") {
        props.data[props.item.key].splice(index2, 1);
        config.value.splice(index2, 1);
      }
      config.value[index2].deleteVisible = false;
    };
    const change = (activeNames, itemBar) => {
      itemBar.activeNames = activeNames;
    };
    return (_ctx, _cache) => {
      const _component_k18n = resolveComponent("k18n");
      const _component_ks_tooltip = resolveComponent("ks-tooltip");
      const _component_ks_button = resolveComponent("ks-button");
      const _component_ks_popover = resolveComponent("ks-popover");
      const _component_ks_row = resolveComponent("ks-row");
      const _component_ks_divider = resolveComponent("ks-divider");
      return openBlock(), createElementBlock(Fragment, null, [
        createVNode(GroupTitle, { item: __props.item }, null, 8, ["item"]),
        (openBlock(true), createElementBlock(Fragment, null, renderList(unref(reactiveData), (panel, panelIdx) => {
          return openBlock(), createElementBlock("div", {
            key: panelIdx,
            class: "panel-wrapper"
          }, [
            createVNode(_component_ks_row, {
              type: "flex",
              justify: "space-between",
              align: "middle",
              class: "title"
            }, {
              default: withCtx(() => [
                __props.item.panelTitleKey ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
                  withDirectives(createVNode(unref(ProInput), {
                    ref_for: true,
                    ref_key: "inputRef",
                    ref: inputRef,
                    modelValue: panel[__props.item.panelTitleKey],
                    "onUpdate:modelValue": ($event) => panel[__props.item.panelTitleKey] = $event,
                    class: "title-input",
                    placeholder: unref($k18n)("\u8BF7\u8F93\u5165"),
                    onBlur: ($event) => onEdit(panelIdx, false)
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder", "onBlur"]), [
                    [vShow, panelTitle[panelIdx]]
                  ]),
                  withDirectives(createElementVNode("span", {
                    class: "title-text",
                    onClick: ($event) => onEdit(panelIdx, true)
                  }, toDisplayString(panel[__props.item.panelTitleKey]), 9, _hoisted_1$n), [
                    [vShow, !panelTitle[panelIdx]]
                  ])
                ], 64)) : (openBlock(), createElementBlock("span", _hoisted_2$d, [
                  createVNode(_component_k18n, null, {
                    default: withCtx(() => [
                      createTextVNode(toDisplayString(__props.item.panelTitle), 1)
                    ]),
                    _: 1
                  }),
                  createTextVNode(toDisplayString(panelIdx + 1), 1)
                ])),
                withDirectives(createElementVNode("div", _hoisted_3$b, [
                  unref(showEdit) ? (openBlock(), createBlock(_component_ks_tooltip, {
                    key: 0,
                    content: unref($k18n)("\u7F16\u8F91\u6807\u9898"),
                    placement: "top"
                  }, {
                    default: withCtx(() => [
                      createVNode(unref(IconEditorEdit), {
                        onClick: ($event) => onEdit(panelIdx, true)
                      }, null, 8, ["onClick"])
                    ]),
                    _: 2
                  }, 1032, ["content"])) : createCommentVNode("", true),
                  unref(showCopy) ? (openBlock(), createBlock(_component_ks_tooltip, {
                    key: 1,
                    content: unref($k18n)("\u521B\u5EFA\u526F\u672C"),
                    placement: "top"
                  }, {
                    default: withCtx(() => [
                      createVNode(unref(IconEditorCopy), {
                        onClick: ($event) => onCopy(panelIdx)
                      }, null, 8, ["onClick"])
                    ]),
                    _: 2
                  }, 1032, ["content"])) : createCommentVNode("", true),
                  unref(showDelete) ? (openBlock(), createElementBlock(Fragment, { key: 2 }, [
                    panelIdx === 0 ? (openBlock(), createBlock(_component_ks_tooltip, {
                      key: 0,
                      content: unref($k18n)("\u5220\u9664\u7EC4"),
                      placement: "top"
                    }, {
                      default: withCtx(() => [
                        createVNode(unref(IconGeneralDelete), {
                          class: normalizeClass(panelIdx === 0 ? "disabled delete-icon" : "delete-icon")
                        }, null, 8, ["class"])
                      ]),
                      _: 2
                    }, 1032, ["content"])) : (openBlock(), createBlock(_component_ks_popover, {
                      key: 1,
                      placement: "top",
                      visible: config.value[panelIdx].deleteVisible,
                      trigger: "hover"
                    }, {
                      reference: withCtx(() => [
                        createVNode(unref(IconGeneralDelete), {
                          class: normalizeClass(panelIdx === 0 ? "disabled delete-icon" : "delete-icon"),
                          onClick: ($event) => onDelete(panelIdx, "show")
                        }, null, 8, ["class", "onClick"])
                      ]),
                      default: withCtx(() => [
                        createElementVNode("p", _hoisted_4$8, [
                          createVNode(_component_k18n, null, {
                            default: withCtx(() => [
                              createTextVNode("\u786E\u5B9A\u5220\u9664\u7EC4\uFF1F")
                            ]),
                            _: 1
                          })
                        ]),
                        createElementVNode("div", _hoisted_5$6, [
                          createVNode(_component_ks_button, {
                            size: "mini",
                            onClick: ($event) => onDelete(panelIdx, "cancel")
                          }, {
                            default: withCtx(() => [
                              createVNode(_component_k18n, null, {
                                default: withCtx(() => [
                                  createTextVNode("\u53D6\u6D88")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 2
                          }, 1032, ["onClick"]),
                          createVNode(_component_ks_button, {
                            size: "mini",
                            type: "primary",
                            onClick: ($event) => onDelete(panelIdx, "confirm")
                          }, {
                            default: withCtx(() => [
                              createVNode(_component_k18n, null, {
                                default: withCtx(() => [
                                  createTextVNode("\u786E\u5B9A")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ])
                      ]),
                      _: 2
                    }, 1032, ["visible"]))
                  ], 64)) : createCommentVNode("", true)
                ], 512), [
                  [vShow, !panelTitle[panelIdx]]
                ])
              ]),
              _: 2
            }, 1024),
            createVNode(_component_ks_divider, { class: "divider" }),
            (openBlock(true), createElementBlock(Fragment, null, renderList(config.value[panelIdx].items, (itemBar, itemBarIdx) => {
              return openBlock(), createBlock(RenderCom, {
                key: itemBarIdx,
                item: itemBar,
                data: unref(reactiveData)[panelIdx],
                "prop-key": `${__props.item.key}.${panelIdx}`,
                onChange: ($event) => change($event, itemBar)
              }, createSlots({ _: 2 }, [
                renderList(_ctx.$slots, (slotVal, slotName) => {
                  return {
                    name: slotName,
                    fn: withCtx(() => [
                      renderSlot$2(_ctx.$slots, slotName, {
                        panelId: panelIdx,
                        panelData: unref(reactiveData)[panelIdx]
                      }, void 0, true)
                    ])
                  };
                })
              ]), 1032, ["item", "data", "prop-key", "onChange"]);
            }), 128))
          ]);
        }), 128)),
        unref(showAdd) ? (openBlock(), createElementBlock("div", {
          key: 0,
          class: "add-btn",
          onClick: addQuery
        }, [
          _hoisted_6$2,
          createVNode(_component_k18n, null, {
            default: withCtx(() => [
              createTextVNode(toDisplayString(__props.item.btnText || "\u65B0\u589E"), 1)
            ]),
            _: 1
          })
        ])) : createCommentVNode("", true)
      ], 64);
    };
  }
});
const RenderCollapsePanel = /* @__PURE__ */ _export_sfc(_sfc_main$t, [["__scopeId", "data-v-15ba8c4a"]]);
const RenderSubTitle_vue_vue_type_style_index_0_scoped_true_lang = "";
const _sfc_main$s = defineComponent({
  name: "RenderGroup",
  props: {
    item: {
      type: Object,
      default: () => reactive({})
    }
  }
});
function _sfc_render$c(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_k18n = resolveComponent("k18n");
  return openBlock(), createElementBlock("div", {
    class: "sub-title",
    style: normalizeStyle(_ctx.item.style)
  }, [
    createVNode(_component_k18n, null, {
      default: withCtx(() => [
        createTextVNode(toDisplayString(_ctx.item.label), 1)
      ]),
      _: 1
    })
  ], 4);
}
const RenderSubTitle = /* @__PURE__ */ _export_sfc(_sfc_main$s, [["render", _sfc_render$c], ["__scopeId", "data-v-26337a99"]]);
const _sfc_main$r = /* @__PURE__ */ defineComponent({
  __name: "WidgetPanel",
  props: {
    data: Object,
    item: {
      type: Object,
      default: () => {
        "widgetPanel";
      }
    }
  },
  setup(__props) {
    const props = __props;
    const WIDGET = inject("widget");
    const widgetCom = WIDGET && WIDGET[props.item.widget];
    return (_ctx, _cache) => {
      return openBlock(), createBlock(resolveDynamicComponent(unref(widgetCom)), mergeProps(__props.item, { data: __props.data }), null, 16, ["data"]);
    };
  }
});
const _sfc_main$q = defineComponent({
  name: "RenderCom",
  props: {
    item: {
      type: Object,
      default: () => reactive({})
    },
    data: {
      type: Object,
      default: () => reactive({})
    },
    propKey: {
      type: String,
      default: ""
    }
  },
  render() {
    const { item, data, propKey, $slots } = this;
    conditionHandler(item, data);
    switch (item.type) {
      case FORM_ITEM_TYPE.ARRAY:
      case FORM_ITEM_TYPE.COLLAPSEITEM:
        return item.condition ? h(
          RenderArray$1,
          {
            item,
            data,
            propKey
          },
          $slots
        ) : "";
      case FORM_ITEM_TYPE.COLLAPSE:
        return item.condition ? h(
          RenderCollapse,
          {
            item,
            data,
            propKey
          },
          $slots
        ) : "";
      case FORM_ITEM_TYPE.PANEL:
        return item.condition ? h(
          RenderPanel,
          {
            item,
            data,
            propKey
          },
          $slots
        ) : "";
      case FORM_ITEM_TYPE.COLLAPSEPANEL:
        return item.condition ? h(
          RenderCollapsePanel,
          {
            item,
            data,
            propKey
          },
          $slots
        ) : "";
      case FORM_ITEM_TYPE.SUBTITLE:
        return item.condition ? h(RenderSubTitle, {
          item
        }) : "";
      case FORM_ITEM_TYPE.WIDGETPANEL:
        return item.condition ? h(_sfc_main$r, {
          data,
          item
        }) : "";
      default:
        return item.condition ? h(
          RenderItem,
          {
            item,
            data,
            propKey
          },
          $slots
        ) : "";
    }
  }
});
const RenderCom = _sfc_main$q;
const index_vue_vue_type_style_index_0_scoped_true_lang$3 = "";
const _sfc_main$p = defineComponent({
  name: "ProForm",
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    initData: {
      type: Object
    },
    rules: {
      type: Object,
      default: () => ({})
    },
    items: {
      type: Array,
      default: () => []
    },
    immediately: {
      type: Boolean,
      default: false
    },
    enumerateObj: {
      type: Object,
      default: () => ({})
    },
    utils: {
      type: Object,
      default: () => ({})
    },
    clearValue: {
      type: Boolean,
      default: false
    },
    syncRouterConfig: {
      type: Object || null,
      default: () => {
        return null;
      }
    }
  },
  emits: ["validateChange", "change", "value-change"],
  setup(props, { emit: emit2, slots, attrs, expose }) {
    const $PROCONFIG2 = useGlobalConfig();
    const ruleForm = ref();
    const DEFAULT_FORM_PROPS = { "label-position": "top" };
    const enumerateObjMap = computed(() => {
      return Object.assign(cloneDeep($PROCONFIG2.enumerateObj), props.enumerateObj);
    });
    const formMitt = mitt();
    const clearValueFuncs = [];
    formMitt.on("clearVal", (clearValueFunc) => {
      clearValueFuncs.push(clearValueFunc);
    });
    const resetValueFuncs = [];
    formMitt.on("resetVal", (resetValueFunc) => {
      resetValueFuncs.push(resetValueFunc);
    });
    const deleteKeys = (data, keys) => {
      keys.forEach((key) => {
        delete data[key];
      });
    };
    const proForm = reactive({
      formMitt,
      deleteKeys
    });
    provide("proForm", proForm);
    provide("widget", __spreadValues(__spreadValues({}, $PROCONFIG2.widget), props.utils.widget));
    provide("enumerateObjMap", enumerateObjMap);
    const getItemsMap = (itemsData, obj = {}) => {
      itemsData.forEach((item, index2) => {
        if (item.type === FORM_ITEM_TYPE.ARRAY) {
          if (!item.slot) {
            getItemsMap(item.items, obj);
          }
        }
        if (Array.isArray(item)) {
          getItemsMap(item, obj);
        }
        if (item.key) {
          obj[item.key] = item;
        }
      });
      return obj;
    };
    const formItems = itemsInit(props.items, props.data);
    const itemsMap = computed(() => getItemsMap(formItems));
    const dataHandler = (originData) => {
      const obj = {};
      let valid = true;
      if (props.clearValue) {
        const data = cloneDeep(originData);
        for (const key in data) {
          if (data[key] !== void 0) {
            obj[key] = data[key];
          }
        }
        removeKeys.forEach((key) => delete obj[key]);
        for (const fn2 of clearValueFuncs) {
          if (fn2(obj) === false) {
            valid = false;
            break;
          }
        }
      } else {
        for (const key in originData) {
          if (originData[key] !== void 0) {
            obj[key] = originData[key];
          }
        }
      }
      return {
        data: obj,
        valid
      };
    };
    const validate = () => new Promise((resolve2) => {
      ruleForm.value.validate((valid, failObj) => {
        Object.keys(failObj).forEach((key) => {
          validateKey[key] = false;
        });
        const handlerData = dataHandler(props.data);
        if (valid) {
          resolve2({
            data: handlerData.data,
            valid: handlerData.valid,
            failObj
          });
        } else {
          Object.keys(failObj).forEach((key) => {
            validateKey[key] = false;
          });
          resolve2({
            data: handlerData.data,
            valid,
            failObj
          });
        }
        syncToRouter && syncToRouter(dataHandler(props.data).data);
      });
    });
    const reset = () => {
      ruleForm.value.clearValidate();
      ruleForm.value.resetFields();
      resetValueFuncs.forEach((fn2) => {
        fn2(props.data);
      });
      if (props.initData) {
        return props.initData;
      }
      const handlerData = dataHandler(props.data);
      return handlerData.data;
    };
    const setSchemaByKey = (path, params) => {
      if (Reflect.has(itemsMap.value, path)) {
        Object.assign(itemsMap.value[path], params, {});
      } else {
        console.warn(`form item\u4E2D\u7F3A\u5C11${path}\u7684\u914D\u7F6E`);
      }
    };
    const handleValueChange = ({ key, value: value2 }) => {
      var _a;
      ruleForm.value && emit2("change", dataHandler(props.data));
      ruleForm.value && emit2("value-change", { key, value: value2 });
      if (!!syncToRouter && ((_a = props.syncRouterConfig) == null ? void 0 : _a.isSearchSubmitToRouter)) {
        syncToRouter(dataHandler(props.data).data);
      }
    };
    provide("handleValueChange", handleValueChange);
    props.immediately && emit2("change", dataHandler(props.data));
    const hasRules = computed(() => Object.keys(props.rules).length);
    const rules2 = computed(() => props.rules || {});
    const validateKey = reactive(
      Object.keys(rules2.value).reduce((res, curr) => {
        res[curr] = true;
        return res;
      }, {})
    );
    const isPass = computed(() => {
      if (!hasRules.value)
        return true;
      return Object.values(validateKey).reduce((res, curr) => res && curr, true);
    });
    watch(
      () => isPass.value,
      (curr) => {
        emit2("validateChange", curr);
      },
      { immediate: true }
    );
    const onValidate = (key, value2) => {
      validateKey[key] = !!value2;
    };
    getCurrentInstance();
    onMounted(() => {
      if (hasRules.value) {
        ruleForm.value.validate((valid, failObj) => {
          if (failObj) {
            Object.keys(failObj).forEach((key) => {
              validateKey[key] = false;
            });
          }
        });
        ruleForm.value.resetFields();
      }
    });
    const getSyncRouteConfig = (props2) => {
      const { data, syncRouterConfig } = toRefs(props2);
      if (syncRouterConfig.value) {
        if (syncRouterConfig.value.name) {
          const { syncToRouter: syncToRouter2, syncFromRouter } = useSyncRouter(data.value, syncRouterConfig.value || {});
          return { syncToRouter: syncToRouter2, syncFromRouter };
        }
        console.warn("form syncRouterConfig \u4E2D\u7F3A\u5C11 name \u7684\u914D\u7F6E");
      }
      return { syncToRouter: null, syncFromRouter: null };
    };
    const { syncToRouter } = getSyncRouteConfig(props);
    expose({
      validate,
      reset,
      setSchemaByKey,
      syncToRouter
    });
    function render2() {
      const formItemArray = formItems.map((item) => {
        return h(
          RenderCom,
          {
            item,
            data: props.data
          },
          slots
        );
      });
      return h(
        Form$1,
        __spreadProps(__spreadValues({
          rules: rules2,
          model: props.data
        }, __spreadValues(__spreadValues({}, DEFAULT_FORM_PROPS), attrs)), {
          ref: ruleForm,
          onValidate
        }),
        {
          default: () => {
            var _a;
            return [
              ...formItemArray,
              (_a = slots == null ? void 0 : slots.default) == null ? void 0 : _a.call(slots, {
                isPass: isPass.value
              })
            ];
          }
        }
      );
    }
    return render2;
  }
});
const ProForm = /* @__PURE__ */ _export_sfc(_sfc_main$p, [["__scopeId", "data-v-e08ff30e"]]);
const DrawerProps = {
  modelValue: {
    type: Boolean,
    default: false
  },
  title: {
    type: String,
    default: ""
  },
  component: {
    type: String,
    default: "formDrawer"
  },
  width: {
    type: Number,
    default: ""
  },
  outerProps: {
    type: Object,
    default: () => ({})
  }
};
const getComponent = (props) => {
  return computed(() => {
    const drawerRe = /Drawer/g;
    const dialogObj = {
      com: Dialog,
      widthKey: "width",
      widthValue: props.width || 560
    };
    const drawerObj = {
      com: Drawer,
      widthKey: "size",
      widthValue: props.width || 720
    };
    return drawerRe ? drawerRe.test(props.component) ? drawerObj : dialogObj : drawerObj;
  });
};
const CurdProps = {
  bizName: String,
  kconf: {
    type: [Object, String],
    default: ""
  },
  flatKey: {
    type: Array,
    default: () => []
  },
  titleConfig: {
    type: Object,
    default: () => ({
      title: "",
      guideUrl: ""
    })
  },
  tableConfig: {
    type: Object,
    default: () => ({
      title: "",
      columns: [],
      operators: []
    })
  },
  commonConfig: {
    type: Object,
    default: () => ({})
  },
  initCurdData: {
    type: Object,
    default: () => ({})
  },
  showPagination: {
    type: Boolean,
    default: true
  },
  pageConfig: {
    type: Object,
    default: () => ({})
  },
  enumerateObj: {
    type: Object,
    default: () => ({})
  },
  initSearchForm: {
    type: Object,
    default: () => ({})
  },
  payload: {
    type: Object,
    default: () => ({})
  },
  useTableSetting: {
    type: Boolean,
    default: false
  },
  localStoreKey: {
    type: String,
    default: ""
  },
  col: {
    type: Number,
    default: 3
  }
};
const FormProps = {
  rules: {
    type: Object,
    default: () => ({})
  },
  items: {
    type: Object,
    default: () => []
  },
  syncRouterConfig: {
    type: Object || null,
    default: () => {
      return null;
    }
  },
  clearValue: {
    type: Boolean,
    default: false
  }
};
const search_vue_vue_type_style_index_0_scoped_true_lang = "";
const _hoisted_1$m = { class: "btn-wrapper" };
const _sfc_main$o = /* @__PURE__ */ defineComponent({
  __name: "search",
  props: __spreadProps(__spreadValues({}, FormProps), {
    data: {
      type: Object,
      default: () => reactive({})
    },
    showFoldBtn: {
      type: Boolean,
      default: true
    },
    fold: {
      type: Boolean,
      default: true
    },
    showBtn: {
      type: Boolean,
      default: true
    },
    showSearchBtn: {
      type: Boolean,
      default: true
    },
    resetBtnText: {
      type: String,
      default: "\u91CD\u7F6E"
    },
    syncRouterConfig: {
      type: Object || null,
      default: () => {
        return null;
      }
    },
    preventEnterSubmit: {
      type: Boolean,
      default: true
    }
  }),
  emits: ["onSearch", "onReset"],
  setup(__props, { expose, emit: emit2 }) {
    const props = __props;
    const formRef = ref(null);
    const key = ref(1);
    const calcFold = ref(props.showFoldBtn);
    const isFold = ref(false);
    const foldItems = ref([]);
    let formItemWidthArr = [];
    let num = 0;
    const showSearch = computed(() => {
      var _a;
      return props.showBtn && ((_a = props.items) == null ? void 0 : _a.length);
    });
    watch(
      () => isFold.value,
      () => {
        key.value++;
      }
    );
    function calcFoldItems() {
      var _a;
      const el = (_a = formRef.value) == null ? void 0 : _a.$el;
      const formWidth = el == null ? void 0 : el.offsetWidth;
      const btnWrapperEl = el == null ? void 0 : el.querySelector(".btn-wrapper");
      if (btnWrapperEl) {
        const btnWrapperWidth = btnWrapperEl.offsetWidth;
        let sumWidth = btnWrapperWidth;
        for (let i = 0; i < formItemWidthArr.length; i++) {
          sumWidth += formItemWidthArr[i];
          if (sumWidth > formWidth) {
            num = i;
            break;
          }
        }
        foldItems.value = props.items.slice(0, num);
      }
    }
    onMounted(() => {
      var _a, _b;
      if (calcFold.value) {
        const el = formRef.value.$el;
        const formHeight = el.offsetHeight;
        const formItems = el.children;
        const itemHeight = (_a = formItems[0]) == null ? void 0 : _a.offsetHeight;
        const SPACE = 16;
        if (!formHeight || formHeight < itemHeight * 2) {
          calcFold.value = false;
          return;
        }
        nextTick().then(() => isFold.value = props.fold);
        if ((_b = formItems == null ? void 0 : formItems[0]) == null ? void 0 : _b.offsetWidth) {
          formItemWidthArr = Array.from(formItems).map((item) => item.offsetWidth + SPACE);
          calcFoldItems();
        }
      }
      !props.preventEnterSubmit && setEnter();
    });
    const toggleFold = () => {
      isFold.value = !isFold.value;
    };
    if (calcFold.value) {
      window.onresize = debounce$2(() => {
        calcFoldItems();
        key.value++;
      });
    }
    const onSearch = () => {
      formRef.value.validate().then(({ data, valid, failObj }) => {
        emit2("onSearch", data);
      });
    };
    const onReset = () => {
      var _a;
      emit2("onReset", (_a = formRef.value) == null ? void 0 : _a.reset());
    };
    const setEnter = () => {
      document.onkeydown = function(e) {
        if (e.keyCode === 13) {
          onSearch();
        }
      };
    };
    expose({
      syncToRouter: computed(() => {
        var _a;
        return (_a = formRef.value) == null ? void 0 : _a.syncToRouter;
      })
    });
    return (_ctx, _cache) => {
      const _component_ks_button = resolveComponent("ks-button");
      return openBlock(), createBlock(ProForm, {
        ref_key: "formRef",
        ref: formRef,
        key: key.value,
        data: __props.data,
        rules: _ctx.rules,
        items: isFold.value ? foldItems.value : _ctx.items,
        "clear-value": _ctx.clearValue,
        "sync-router-config": __props.syncRouterConfig
      }, createSlots({ _: 2 }, [
        renderList(_ctx.$slots, (slotVal, slotName) => {
          return {
            name: slotName,
            fn: withCtx(() => [
              renderSlot$2(_ctx.$slots, slotName, {}, void 0, true)
            ])
          };
        }),
        unref(showSearch) ? {
          name: "default",
          fn: withCtx((slotProps) => [
            createElementVNode("div", _hoisted_1$m, [
              withDirectives(createElementVNode("span", {
                class: "fold-wrapper",
                underline: false,
                onClick: toggleFold
              }, [
                createVNode(unref(IconDirectionDown), {
                  rotate: isFold.value ? 0 : 180
                }, null, 8, ["rotate"])
              ], 512), [
                [vShow, calcFold.value]
              ]),
              __props.showSearchBtn ? (openBlock(), createBlock(_component_ks_button, {
                key: 0,
                type: "primary",
                class: normalizeClass({ disabled: !slotProps.isPass }),
                onClick: onSearch
              }, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(_ctx.$k18n("\u641C\u7D22")), 1)
                ]),
                _: 2
              }, 1032, ["class"])) : createCommentVNode("", true),
              createVNode(_component_ks_button, {
                type: "text",
                style: { "color": "#333333", "font-size": "14px" },
                onClick: onReset
              }, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(_ctx.$k18n(__props.resetBtnText)), 1)
                ]),
                _: 1
              })
            ])
          ]),
          key: "0"
        } : void 0
      ]), 1032, ["data", "rules", "items", "clear-value", "sync-router-config"]);
    };
  }
});
const ProSearch = /* @__PURE__ */ _export_sfc(_sfc_main$o, [["__scopeId", "data-v-52d8a7ec"]]);
const DEFAULT_SEPARATOR = "~";
function transformInputRange(value2) {
  var _a;
  let result = "";
  if (Array.isArray(value2)) {
    if (value2.length === 1) {
      return `${value2}${DEFAULT_SEPARATOR}`;
    }
    result = value2.join();
  }
  return (_a = result == null ? void 0 : result.replace(",", DEFAULT_SEPARATOR)) == null ? void 0 : _a.replace("null", "");
}
function getRequestFilter(searchForm, config) {
  const payload = {};
  const { INPUTRANGE, DATEPICKER, SELECT, CASCADER, KEYSELECT } = FORM_ITEM_TYPE;
  config == null ? void 0 : config.forEach((item) => {
    var _a, _b;
    const { type, key, submitType } = item;
    const value2 = searchForm[key];
    if (value2) {
      const transformValue = transformInputRange(value2);
      if ([DATEPICKER].includes(type)) {
        payload[key] = transformValue === "" ? null : transformValue;
      }
      if ([INPUTRANGE].includes(type)) {
        payload[key] = transformValue;
      }
      if ([KEYSELECT, SELECT, CASCADER].includes(type) && ((item == null ? void 0 : item.multiple) || ((_a = item == null ? void 0 : item.props) == null ? void 0 : _a.multiple))) {
        payload[key] = (value2 == null ? void 0 : value2.join()) || "";
      }
      if (submitType) {
        if (["num", "array_num"].includes(submitType) && Array.isArray(value2)) {
          payload[key] = (_b = value2 == null ? void 0 : value2.map((item2) => parseFloat(item2))) == null ? void 0 : _b.filter((_) => !Number.isNaN(_));
        }
        if (submitType === "num") {
          payload[key] = parseFloat(value2) || value2;
        }
        if (submitType === "bool") {
          payload[key] = !!value2;
        }
      }
    }
  });
  return payload;
}
const SelectedTag_vue_vue_type_style_index_0_scoped_true_lang = "";
const _withScopeId$1 = (n) => (pushScopeId("data-v-051a7a7d"), n = n(), popScopeId(), n);
const _hoisted_1$l = {
  key: 0,
  class: "selected_tag__wrapper"
};
const _hoisted_2$c = { class: "left" };
const _hoisted_3$a = /* @__PURE__ */ _withScopeId$1(() => /* @__PURE__ */ createElementVNode("span", { class: "label_name" }, "Selected: ", -1));
const _hoisted_4$7 = { class: "tag_wrapper" };
const _hoisted_5$5 = ["onClick"];
const _sfc_main$n = /* @__PURE__ */ defineComponent({
  __name: "SelectedTag",
  props: {
    selectedForm: {
      type: Object,
      default: () => ({})
    },
    filterData: {
      type: Object,
      default: () => ({})
    },
    searchConfig: {
      type: Array,
      default: () => []
    },
    showResetBtn: {
      type: Boolean,
      default: true
    }
  },
  emits: ["change", "reset"],
  setup(__props, { expose, emit: emit2 }) {
    const props = __props;
    const $k18n = getK18n();
    const state = reactive({
      selectArr: []
    });
    function generateSelectData() {
      const tempArr = [];
      const tempKeyArr = [];
      const { selectedForm } = props;
      const keys = Object.keys(selectedForm);
      state.selectArr.forEach((item) => {
        const { key } = item;
        if (keys.includes(key)) {
          const obj = getSelectObj(key);
          if (obj) {
            tempArr.push(obj);
            tempKeyArr.push(key);
          }
        }
      });
      keys.forEach((key) => {
        if (!tempKeyArr.includes(key)) {
          const obj = getSelectObj(key);
          if (obj) {
            tempArr.push(obj);
            tempKeyArr.push(key);
          }
        }
      });
      state.selectArr = [...tempArr];
    }
    function getSelectObj(key) {
      var _a, _b;
      const { selectedForm, filterData, searchConfig } = props;
      const options = filterData[key];
      const selectedValue = selectedForm[key];
      if (options && hasValue(selectedValue)) {
        const findItem = searchConfig.find((item) => item.key === key);
        let markValue = "";
        if (Array.isArray(options) && options.length) {
          const mapResult = getMappingConfig(findItem);
          const hasChild = (options || []).find((item) => {
            var _a2;
            return (_a2 = item == null ? void 0 : item[mapResult == null ? void 0 : mapResult.children]) == null ? void 0 : _a2.length;
          });
          if (hasChild) {
            markValue = getTreeValue(key, mapResult) || "";
          } else {
            markValue = getSelectName(key, options, mapResult);
          }
        } else if ((_b = (_a = Object.keys) == null ? void 0 : _a.call(Object, options)) == null ? void 0 : _b.length) {
          markValue = options[selectedValue];
        }
        if (markValue === "") {
          markValue = getSpecialSelectObj(selectedValue, key);
        }
        return {
          key,
          msg: `${$k18n(findItem == null ? void 0 : findItem.label)}: ${markValue}`
        };
      }
    }
    function getSpecialSelectObj(selectedValue, key) {
      let result = selectedValue;
      if (Array.isArray(selectedValue)) {
        const findItem = props.searchConfig.find((item) => item.key === key);
        const { type } = findItem;
        if (type === FORM_ITEM_TYPE.DATEPICKER) {
          result = selectedValue.map((item) => moment(+item).format("YYYY-MM-DD"));
        }
        if (type === FORM_ITEM_TYPE.INPUTRANGE) {
          result = selectedValue.map((item) => formatValue(item));
        }
        return result.join("~");
      }
      return result;
    }
    function getTreeValue(key, mapResult) {
      var _a;
      const id = mapResult.value;
      const name = mapResult.label;
      const flattenTreeResult = flattenTree(props.filterData[key], mapResult);
      const value2 = props.selectedForm[key];
      const result = flattenTreeResult == null ? void 0 : flattenTreeResult.filter((item) => {
        if (Array.isArray(value2)) {
          return (value2 || []).includes(item[id]);
        }
        return value2 === item[id];
      }).map((item) => item[name]);
      return (_a = result == null ? void 0 : result.reverse()) == null ? void 0 : _a.join();
    }
    function flattenTree(list, mapResult) {
      const result = [];
      const children = mapResult.children;
      if (list.length === 0) {
        return null;
      }
      for (let i = 0; i < list.length; i++) {
        const item = list[i];
        const childList = item[children];
        if (childList == null ? void 0 : childList.length) {
          result.push(...childList, omit(item, [childList]));
        } else {
          result.push(item);
        }
      }
      return result;
    }
    function hasValue(value2) {
      if (Array.isArray(value2)) {
        return Boolean(value2.length);
      }
      if (typeof value2 === "number") {
        return true;
      }
      return Boolean(value2);
    }
    function getSelectName(key, options, mapResult = {}) {
      const id = mapResult.value;
      const name = mapResult.label;
      const value2 = props.selectedForm[key];
      if (Array.isArray(value2)) {
        const result2 = (options || []).filter((op) => value2.includes(op[id])).map((item) => item[name]);
        return result2.join();
      }
      const result = (options || []).find((item) => item[id] === value2);
      return result == null ? void 0 : result[name];
    }
    function resetValue(key) {
      const { selectedForm } = props;
      const value2 = selectedForm[key];
      if (Array.isArray(value2)) {
        selectedForm[key] = [];
      } else {
        selectedForm[key] = "";
      }
    }
    function getMappingConfig(item = {}) {
      const { type } = item;
      const { CASCADER, SELECT, KEYSELECT } = FORM_ITEM_TYPE;
      const DEFAULT2 = {
        children: "children",
        label: "label",
        value: "value"
      };
      if (type === CASCADER) {
        return __spreadValues(__spreadValues({}, DEFAULT2), item.props || {});
      }
      if ([SELECT, KEYSELECT].includes(type)) {
        return {
          label: item.optionLabel || "label",
          value: item.optionVal || "value"
        };
      }
      return DEFAULT2;
    }
    function handleClickDelete(index2) {
      const item = state.selectArr[index2];
      resetValue(item.key);
      state.selectArr.splice(index2, 1);
      nextTick(() => {
        emit2("change");
      });
    }
    function handleClickReset() {
      clickReset();
      nextTick(() => {
        emit2("reset");
      });
    }
    function clickReset() {
      state.selectArr = [];
      const { selectedForm } = props;
      const keys = Object.keys(selectedForm);
      keys.forEach((key) => {
        resetValue(key);
      });
    }
    expose({
      clickReset
    });
    watch(
      () => props.selectedForm,
      () => {
        generateSelectData();
      },
      { deep: true, immediate: true }
    );
    return (_ctx, _cache) => {
      const _component_k18n = resolveComponent("k18n");
      return state.selectArr.length > 0 ? (openBlock(), createElementBlock("div", _hoisted_1$l, [
        createElementVNode("span", _hoisted_2$c, [
          _hoisted_3$a,
          createElementVNode("span", _hoisted_4$7, [
            (openBlock(true), createElementBlock(Fragment, null, renderList(state.selectArr, (item, index2) => {
              return openBlock(), createElementBlock("span", {
                key: index2,
                class: "tag"
              }, [
                createVNode(unref(ProTooltip), {
                  disabled: false,
                  "line-clamp": 1,
                  content: item.msg
                }, null, 8, ["content"]),
                createElementVNode("i", {
                  class: "sys-icon-close",
                  onClick: ($event) => handleClickDelete(index2)
                }, null, 8, _hoisted_5$5)
              ]);
            }), 128))
          ])
        ]),
        __props.showResetBtn ? (openBlock(), createElementBlock("span", {
          key: 0,
          class: "reset_btn",
          onClick: handleClickReset
        }, [
          createVNode(_component_k18n, null, {
            default: withCtx(() => [
              createTextVNode("\u91CD\u7F6E")
            ]),
            _: 1
          })
        ])) : createCommentVNode("", true)
      ])) : createCommentVNode("", true);
    };
  }
});
const SelectedTag = /* @__PURE__ */ _export_sfc(_sfc_main$n, [["__scopeId", "data-v-051a7a7d"]]);
function transformExtraData(arrConfig, func) {
  const result = [];
  arrConfig == null ? void 0 : arrConfig.forEach((item) => {
    let temp;
    const { extra } = item;
    if (item.extra && isObject$6(extra)) {
      temp = __spreadValues(__spreadValues({}, item), extra);
    } else {
      temp = item;
    }
    if (func) {
      func(item, temp);
    }
    result.push(temp);
  });
  return result;
}
var IOrder = /* @__PURE__ */ ((IOrder2) => {
  IOrder2["ascending"] = "ascending";
  IOrder2["descending"] = "descending";
  return IOrder2;
})(IOrder || {});
var OrderType = /* @__PURE__ */ ((OrderType2) => {
  OrderType2["ASC"] = "ASC";
  OrderType2["DESC"] = "DESC";
  return OrderType2;
})(OrderType || {});
function processDefaultConfig(item, result) {
  var _a;
  const { type } = result;
  const { CASCADER, DATEPICKER } = FORM_ITEM_TYPE;
  if ([CASCADER].includes(type) && ((_a = result == null ? void 0 : result.props) == null ? void 0 : _a.multiple)) {
    result.props.emitPath = false;
  }
  if ([DATEPICKER].includes(type)) {
    result["default-time"] = [DAY_START, DAY_END];
  }
}
function processDefaultValue(state, data) {
  const { filterDefaultValue, type, key } = data;
  const { DATEPICKER } = FORM_ITEM_TYPE;
  if (type === DATEPICKER && filterDefaultValue) {
    const end2 = Date.now();
    const map = {
      1: [+moment(end2).add(-1, "d"), end2],
      3: [+moment(end2).add(-3, "d"), end2],
      7: [+moment(end2).add(-7, "d"), end2],
      30: [+moment(end2).add(-30, "d"), end2],
      60: [+moment(end2).add(-60, "d"), end2],
      90: [+moment(end2).add(-3, "M"), end2],
      180: [+moment(end2).add(-6, "M"), end2]
    };
    if (map[filterDefaultValue]) {
      state.searchForm[key] = map[filterDefaultValue];
    }
  }
}
function processDefaultOrder(state, data) {
  const { defaultSort, key } = data;
  if (defaultSort) {
    state.orderData = {
      order: defaultSort !== IOrder.ascending ? IOrder.descending : defaultSort,
      prop: key
    };
  }
}
const index_vue_vue_type_style_index_0_scoped_true_lang$2 = "";
const index_vue_vue_type_style_index_1_lang$1 = "";
const _hoisted_1$k = { class: "render_table" };
const _hoisted_2$b = {
  key: 0,
  class: "title"
};
const _hoisted_3$9 = { class: "total" };
const _hoisted_4$6 = { class: "num" };
const _sfc_main$m = /* @__PURE__ */ defineComponent({
  __name: "index",
  props: {
    urlPrefix: {
      type: String,
      default: ""
    },
    auditor: {
      type: String,
      default: ""
    },
    kconfKey: {
      type: String,
      default: ""
    },
    enumerateObj: {
      type: Object,
      default: () => ({})
    },
    utils: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ["reset"],
  setup(__props, { emit: emit2 }) {
    const props = __props;
    const DEFAULT_CONFIG = {
      DOWNLOAD_MAX_PAGE_SIZE: 500
    };
    const performanceSwitch = 0;
    const proTableRef = ref(null);
    const state = reactive({
      searchForm: {},
      defaultSearchData: {},
      list: [],
      title: "",
      show: false,
      kconfLoading: false,
      loading: false,
      filterData: {},
      columns: [],
      hasDataTrend: false,
      switchValue: false,
      orderData: {
        prop: "",
        order: ""
      },
      enumMap: {},
      kconfData: {}
    });
    const renderTableConfig = reactive({
      selectedTagOmitKeys: [],
      filterConfig: [],
      tableHeaderConfig: [],
      searchConfig: [],
      tableConfig: {
        columns: [],
        downloadConfig: {},
        title: ""
      }
    });
    const pageInfo = reactive({
      current: 1,
      pageSize: 10,
      total: 10
    });
    const downloadConfig = computed(() => {
      var _a, _b;
      if ((_a = renderTableConfig.tableConfig) == null ? void 0 : _a.downloadDisplay) {
        return {
          url: `${apiPrefix.value}/download`,
          text: "\u4E0B\u8F7D",
          method: "POST",
          payload: __spreadProps(__spreadValues({}, getPayload()), {
            pageNo: 1,
            pageSize: ((_b = renderTableConfig.tableConfig) == null ? void 0 : _b.downloadMaxDataCount) || DEFAULT_CONFIG.DOWNLOAD_MAX_PAGE_SIZE
          }),
          headers: {
            username: props.auditor
          }
        };
      }
      return false;
    });
    const colSetting = computed(() => {
      return {
        localStoreKey: props.kconfKey,
        setColumn,
        getColumn
      };
    });
    const apiPrefix = computed(() => {
      return `${props.urlPrefix}${ENGINE_API}`;
    });
    const showTitle = computed(() => {
      const { title } = renderTableConfig.tableConfig;
      return !(typeof title === "boolean" && !title);
    });
    onMounted(() => __async(this, null, function* () {
      state.kconfLoading = true;
      yield getKconf();
      watch(
        () => props.enumerateObj,
        () => {
          transformEnum();
        },
        { immediate: true, deep: true }
      );
      setDefaultSearchData();
    }));
    function setDefaultSearchData() {
      state.defaultSearchData = {
        searchForm: cloneDeep(state.searchForm),
        orderData: cloneDeep(state.orderData)
      };
    }
    function getKconf() {
      return __async(this, null, function* () {
        const { kconfKey, auditor } = props;
        const { data } = yield http(POST()`${apiPrefix.value}/config?kconfKey=${kconfKey}&auditor=${auditor}`, {
          kconfKey,
          auditor
        });
        state.kconfData = data;
        const { searchConfig, tableConfig } = data == null ? void 0 : data.config;
        renderTableConfig.searchConfig = transformExtraData(searchConfig, processSearch);
        tableConfig.columns = transformExtraData(tableConfig.columns, processColumn);
        renderTableConfig.tableConfig = tableConfig;
      });
    }
    function handleColumnConfigChange(val, isColumnConfigChange) {
      if (isColumnConfigChange) {
        state.columns = val;
        onSearch(1);
        state.kconfLoading = false;
      }
    }
    function processSearch(item, result) {
      const { filterPlacement } = result;
      if (filterPlacement)
        ;
      else {
        result.itemClass = "hide_search__item";
      }
      processDefaultConfig(item, result);
      processDefaultValue(state, result);
      generateEnumMap(item);
    }
    function processColumn(item, result) {
      const { sortEnable, dataTrend } = result;
      if (sortEnable) {
        result.sortable = "custom";
      }
      if (dataTrend) {
        state.hasDataTrend = true;
      }
      processDefaultOrder(state, result);
    }
    function transformEnum() {
      const { searchConfig } = renderTableConfig;
      const commonSelectors = __spreadValues({}, props.enumerateObj);
      const transformResult = {};
      searchConfig == null ? void 0 : searchConfig.forEach((config) => {
        const { enumerate, key } = config;
        if (typeof enumerate === "string") {
          transformResult[key] = commonSelectors[enumerate] || [];
        } else {
          transformResult[key] = enumerate || [];
        }
      });
      state.filterData = __spreadValues(__spreadValues({}, commonSelectors), transformResult);
    }
    function generateEnumMap(item) {
      const { enumerate, extra, key } = item;
      if ((enumerate || key) && (extra == null ? void 0 : extra.enumerate)) {
        state.enumMap[enumerate || key] = transformEnumerate(item);
      }
    }
    function getPayload() {
      const { current, pageSize } = pageInfo;
      const { prop, order: order2 } = state.orderData;
      const payload = {
        kconfKey: props.kconfKey,
        enumMap: state.enumMap,
        auditor: props.auditor,
        pageNo: current,
        pageSize,
        filter: __spreadValues(__spreadValues({}, state.searchForm), getRequestFilter(state.searchForm, renderTableConfig.searchConfig)),
        column: [...state.columns.map((item) => item.key)]
      };
      if (prop && order2) {
        const orderMap = {
          [IOrder.ascending]: OrderType.ASC,
          [IOrder.descending]: OrderType.DESC
        };
        payload.sort = [
          {
            sortField: prop,
            sortType: (orderMap == null ? void 0 : orderMap[order2]) || ""
          }
        ];
      }
      return payload;
    }
    onUpdated(() => {
      if (state.switchValue && !state.loading) {
        sendWebloggerClick("\u9AD8\u4EAE\u6570\u636E\u6E32\u67D3\u6027\u80FD", {
          param1: Date.now() - performanceSwitch,
          param2: pageInfo.pageSize
        });
      }
    });
    function onSearch(p, resetDefault = false, appendMode = false) {
      return __async(this, null, function* () {
        state.loading = true;
        const performanceGetList = Date.now();
        if (typeof p === "number") {
          pageInfo.current = p;
        }
        if (resetDefault) {
          const cloneDeepDefault = state.defaultSearchData;
          state.orderData = cloneDeepDefault.orderData;
          state.searchForm = cloneDeepDefault.searchForm;
          emit2("reset");
        }
        const payload = getPayload();
        try {
          const response = yield http(POST()`${apiPrefix.value}/search`, payload);
          const { data, result, message } = response;
          if (result === 1) {
            const { list, total } = data;
            pageInfo.total = total || 0;
            state.list = list.filter((_) => _);
            if (Array.isArray(state.list)) {
              if (appendMode) {
                state.list.push(...state.list);
              } else {
                state.list = list;
              }
            }
            sendWebloggerClick("\u5217\u8868\u8BF7\u6C42\u65F6\u957F", {
              param1: Date.now() - performanceGetList
            });
          } else {
            Message.error(message || "\u63A5\u53E3\u8BF7\u6C42\u5931\u8D25");
          }
        } catch (e) {
          Message.error("error");
        } finally {
          state.loading = false;
        }
      });
    }
    function handleSortChange(prams) {
      state.orderData = prams;
      onSearch(1);
    }
    function getColumn() {
      return __async(this, null, function* () {
        var _a;
        return ((_a = state.kconfData) == null ? void 0 : _a.title) || [];
      });
    }
    function setColumn(checkedColumns) {
      return __async(this, null, function* () {
        yield http(POST()`${apiPrefix.value}/title`, {
          title: checkedColumns,
          kconfKey: props.kconfKey,
          auditor: props.auditor
        });
      });
    }
    return (_ctx, _cache) => {
      var _a, _b;
      const _component_k18n = resolveComponent("k18n");
      const _directive_loading = resolveDirective("loading");
      return withDirectives((openBlock(), createElementBlock("div", _hoisted_1$k, [
        unref(showTitle) ? (openBlock(), createElementBlock("h1", _hoisted_2$b, [
          renderSlot$2(_ctx.$slots, "title", {}, () => [
            createVNode(_component_k18n, null, {
              default: withCtx(() => {
                var _a2;
                return [
                  createTextVNode(toDisplayString((_a2 = renderTableConfig.tableConfig) == null ? void 0 : _a2.title), 1)
                ];
              }),
              _: 1
            })
          ], true),
          renderSlot$2(_ctx.$slots, "title-right", {}, void 0, true)
        ])) : createCommentVNode("", true),
        ((_a = renderTableConfig.searchConfig) == null ? void 0 : _a.length) ? (openBlock(), createBlock(ProSearch, {
          key: 1,
          data: state.searchForm,
          items: renderTableConfig.searchConfig,
          utils: __props.utils,
          "enumerate-obj": __props.enumerateObj,
          "show-fold-btn": false,
          onOnSearch: _cache[0] || (_cache[0] = ($event) => onSearch(1)),
          onOnReset: _cache[1] || (_cache[1] = ($event) => onSearch(1, true))
        }, null, 8, ["data", "items", "utils", "enumerate-obj"])) : createCommentVNode("", true),
        !state.loading ? (openBlock(), createBlock(SelectedTag, {
          key: 2,
          "show-reset-btn": false,
          "selected-form": state.searchForm,
          "filter-data": state.filterData,
          "search-config": renderTableConfig.searchConfig,
          onChange: _cache[2] || (_cache[2] = ($event) => onSearch(1)),
          onReset: _cache[3] || (_cache[3] = ($event) => onSearch(1, true))
        }, null, 8, ["selected-form", "filter-data", "search-config"])) : createCommentVNode("", true),
        withDirectives((openBlock(), createElementBlock("div", null, [
          createVNode(ProTable, mergeProps({
            ref_key: "proTableRef",
            ref: proTableRef,
            border: "",
            "header-sticky": 56,
            data: state.list,
            "download-config": unref(downloadConfig),
            "order-data": state.orderData,
            columns: (_b = renderTableConfig.tableConfig) == null ? void 0 : _b.columns,
            "col-setting": unref(colSetting),
            "form-items": renderTableConfig.searchConfig,
            "form-data": state.searchForm,
            "enumerate-obj": __props.enumerateObj,
            "use-cn-header-wrap": true,
            utils: __props.utils,
            "col-max-width": 150,
            "show-pagination": "",
            "page-info": pageInfo
          }, _ctx.$attrs, {
            onCurrentChange: onSearch,
            onSortChange: handleSortChange,
            onColumnConfigChange: handleColumnConfigChange,
            onReload: _cache[4] || (_cache[4] = ($event) => onSearch(1)),
            onSizeChange: _cache[5] || (_cache[5] = ($event) => onSearch(1))
          }), createSlots({
            "operation-buttons-left": withCtx(() => [
              createElementVNode("div", _hoisted_3$9, [
                createTextVNode(" Total of "),
                createElementVNode("span", _hoisted_4$6, toDisplayString(pageInfo.total.toLocaleString()), 1)
              ])
            ]),
            _: 2
          }, [
            renderList(_ctx.$slots, (slotVal, slotName) => {
              return {
                name: slotName,
                fn: withCtx(({ row: row2, submit, close }) => [
                  renderSlot$2(_ctx.$slots, slotName, {
                    row: row2,
                    submit,
                    close
                  }, void 0, true)
                ])
              };
            })
          ]), 1040, ["data", "download-config", "order-data", "columns", "col-setting", "form-items", "form-data", "enumerate-obj", "utils", "page-info"])
        ])), [
          [_directive_loading, state.loading]
        ])
      ])), [
        [_directive_loading, state.kconfLoading]
      ]);
    };
  }
});
const index$3 = /* @__PURE__ */ _export_sfc(_sfc_main$m, [["__scopeId", "data-v-04e1aac7"]]);
const FormDrawer_vue_vue_type_style_index_0_scoped_true_lang = "";
const _hoisted_1$j = {
  key: 0,
  class: "btns"
};
const _hoisted_2$a = { key: 0 };
const _hoisted_3$8 = { key: 1 };
const _sfc_main$l = /* @__PURE__ */ defineComponent({
  __name: "FormDrawer",
  props: __spreadValues(__spreadProps(__spreadValues({}, FormProps), {
    rules: {
      type: [Object, Function],
      default: () => ({})
    },
    clearValue: {
      type: Boolean,
      default: true
    },
    initData: {
      type: Object
    },
    type: {
      type: String,
      default: "create"
    },
    request: {
      type: Object,
      default: null
    },
    resetAfterSubmit: {
      type: Boolean,
      default: true
    },
    commonConfig: {
      type: Object,
      default: () => ({})
    },
    row: {
      type: Object,
      default: () => ({})
    },
    exclude: {
      type: Object,
      default: () => []
    },
    cancelText: {
      type: String,
      default: "\u53D6\u6D88"
    },
    confirmText: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    },
    showBtn: {
      type: Boolean,
      default: true
    },
    syncRouterConfig: {
      type: Object || null,
      default: () => {
        return null;
      }
    },
    path: {
      type: [String, Boolean],
      default: ""
    }
  }), DrawerProps),
  emits: ["onUpdateList", "submit", "update:modelValue", "change"],
  setup(__props, { emit: emit2 }) {
    const props = __props;
    const component = getComponent(props);
    const state = reactive({
      formData: __spreadValues({}, cloneDeep(props.initData)),
      items: reactive(props.items)
    });
    const ruleConfig = computed(() => {
      if (typeof props.rules === "function") {
        return props.rules(state.formData);
      }
      return props.rules;
    });
    const formRef = ref(null);
    const $k18n = getK18n();
    const isEdit = computed(() => props.type === "edit");
    const isView = computed(() => props.type === "view");
    const isCreate = computed(() => props.type === "create");
    const isCopy = computed(() => props.type === "copy");
    const loading = ref(false);
    const change = (data) => {
      emit2("change", data);
    };
    const visible = ref(false);
    watch(
      () => props.modelValue,
      (newVal) => {
        visible.value = newVal;
      }
    );
    watch(
      () => props.modelValue,
      (curr) => {
        if (curr) {
          if (isCreate.value) {
            state.formData = __spreadValues({}, cloneDeep(props.initData));
            const query = getUrlParams();
            if (query.add === "true") {
              setTimeout(() => {
                const { syncFromRouter } = useSyncRouter(state.formData, props.syncRouterConfig || {});
                syncFromRouter();
              }, 0);
            }
          } else {
            if (!Object.keys(props.row).length)
              return;
            state.formData = props.row;
            if (isCopy.value) {
              props.exclude.forEach((key) => {
                state.formData[key] = (props.initData || {})[key];
              });
            }
          }
          nextTick(() => {
            originData = JSON.stringify(state.formData);
          });
        }
      }
    );
    const hiddenBtn = computed(() => isView.value || !props.showBtn);
    let originData;
    if (!hiddenBtn.value) {
      originData = JSON.stringify(state.formData);
      const drawerMitt = mitt();
      provide("drawerMitt", drawerMitt);
      drawerMitt.on("setOrigin", () => {
        originData = JSON.stringify(state.formData);
      });
    }
    const beforeClose = () => {
      if (hiddenBtn.value)
        return onClose();
      console.log(originData, JSON.stringify(state.formData));
      if (originData === JSON.stringify(state.formData)) {
        return onClose();
      }
      MessageBox.confirm($k18n("\u6B64\u64CD\u4F5C\u5C06\u6E05\u7A7A\u7F16\u8F91\u4E2D\u7684\u8F93\u5165\u5185\u5BB9\uFF0C\u662F\u5426\u7EE7\u7EED?"), $k18n("\u63D0\u793A"), {
        confirmButtonText: $k18n("\u786E\u5B9A"),
        cancelButtonText: $k18n("\u53D6\u6D88"),
        type: "warning"
      }).then(() => {
        onClose();
      }).catch(() => {
      });
    };
    let isFetching = false;
    const submit = () => {
      !isFetching && formRef.value.validate().then((_0) => __async(this, [_0], function* ({ data, valid, failObj }) {
        if (valid) {
          isFetching = true;
          if (props.request) {
            let param = {};
            if (typeof props.request === "string") {
              param.url = props.request;
              param.payload = data;
            } else {
              param = __spreadValues({}, props.request);
              param.payload = Object.assign(data, props.commonConfig.headers, param.payload);
            }
            const res = yield getRequest(__spreadValues({}, param), props.commonConfig);
            if (res.result === 1) {
              emit2("onUpdateList", res.data);
              onClose();
            }
          }
          emit2("submit");
          isFetching = false;
        }
      }));
    };
    const onClose = () => {
      clearRoute();
      emit2("update:modelValue", false);
      state.formData = formRef.value.reset();
    };
    const resetUrl = (url) => {
      const oldUrl = url || location.href;
      const path = oldUrl.replace(/\?.*/, "");
      history.pushState({}, "", path);
    };
    function clearRoute() {
      if (!props.path)
        return;
      const url = props.path === true ? "" : props.path;
      resetUrl(url);
    }
    return (_ctx, _cache) => {
      const _component_k18n = resolveComponent("k18n");
      const _component_ks_button = resolveComponent("ks-button");
      const _directive_loading = resolveDirective("loading");
      return openBlock(), createBlock(resolveDynamicComponent(unref(component).com), mergeProps({
        "model-value": _ctx.modelValue,
        [unref(component).widthKey || ""]: unref(component).widthValue,
        "before-close": beforeClose,
        title: _ctx.title ? unref($k18n)(_ctx.title) : ""
      }, _ctx.outerProps), {
        default: withCtx(() => [
          withDirectives((openBlock(), createBlock(ProForm, {
            ref_key: "formRef",
            ref: formRef,
            data: state.formData,
            rules: unref(ruleConfig),
            items: state.items,
            "init-data": __props.initData,
            "clear-value": __props.clearValue,
            disabled: unref(isView) || __props.disabled,
            onChange: change
          }, createSlots({ _: 2 }, [
            renderList(_ctx.$slots, (slotVal, slotName) => {
              return {
                name: slotName,
                fn: withCtx(() => [
                  renderSlot$2(_ctx.$slots, slotName, {}, void 0, true)
                ])
              };
            })
          ]), 1032, ["data", "rules", "items", "init-data", "clear-value", "disabled"])), [
            [_directive_loading, loading.value]
          ]),
          !unref(hiddenBtn) ? (openBlock(), createElementBlock("div", _hoisted_1$j, [
            createVNode(_component_ks_button, { onClick: beforeClose }, {
              default: withCtx(() => [
                createVNode(_component_k18n, null, {
                  default: withCtx(() => [
                    createTextVNode(toDisplayString(__props.cancelText), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            createVNode(_component_ks_button, {
              type: "primary",
              class: "primary-btn",
              onClick: _cache[0] || (_cache[0] = ($event) => submit())
            }, {
              default: withCtx(() => [
                unref(isEdit) ? (openBlock(), createElementBlock("span", _hoisted_2$a, [
                  createVNode(_component_k18n, null, {
                    default: withCtx(() => [
                      createTextVNode(toDisplayString(__props.confirmText || "\u4FEE\u6539"), 1)
                    ]),
                    _: 1
                  })
                ])) : (openBlock(), createElementBlock("span", _hoisted_3$8, [
                  createVNode(_component_k18n, null, {
                    default: withCtx(() => [
                      createTextVNode(toDisplayString(__props.confirmText || "\u63D0\u4EA4"), 1)
                    ]),
                    _: 1
                  })
                ]))
              ]),
              _: 1
            })
          ])) : createCommentVNode("", true),
          renderSlot$2(_ctx.$slots, "default", {}, void 0, true)
        ]),
        _: 3
      }, 16, ["model-value", "title"]);
    };
  }
});
const FormDrawer = /* @__PURE__ */ _export_sfc(_sfc_main$l, [["__scopeId", "data-v-4ea55239"]]);
const CurdDrawer_vue_vue_type_style_index_0_scoped_true_lang = "";
const _sfc_main$k = /* @__PURE__ */ defineComponent({
  __name: "CurdDrawer",
  props: __spreadValues(__spreadProps(__spreadValues({}, CurdProps), {
    paramKeys: {
      type: Array,
      default: () => []
    },
    row: {
      type: Object,
      default: () => ({})
    }
  }), DrawerProps),
  setup(__props) {
    const props = __props;
    const curdTitle = { title: "" };
    const component = getComponent(props);
    const $k18n = getK18n();
    const param = computed(() => {
      const obj = __spreadValues({}, props.payload);
      for (const key of props.paramKeys) {
        obj[key] = props.row[key];
      }
      return obj;
    });
    watch(
      () => props.modelValue,
      (curr) => {
        if (curr && Object.keys(props.row).length)
          ;
      }
    );
    return (_ctx, _cache) => {
      return openBlock(), createBlock(resolveDynamicComponent(unref(component).com), mergeProps({
        modelValue: _ctx.modelValue,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.modelValue = $event),
        [unref(component).widthKey || ""]: unref(component).widthValue,
        title: _ctx.title ? unref($k18n)(_ctx.title) : ""
      }, _ctx.outerProps), {
        default: withCtx(() => [
          createVNode(unref(CurdTable), {
            kconf: _ctx.kconf,
            payload: unref(param),
            "flat-key": _ctx.flatKey,
            "title-config": curdTitle
          }, null, 8, ["kconf", "payload", "flat-key"]),
          renderSlot$2(_ctx.$slots, "default", {}, void 0, true)
        ]),
        _: 3
      }, 16, ["modelValue", "title"]);
    };
  }
});
const CurdDrawer = /* @__PURE__ */ _export_sfc(_sfc_main$k, [["__scopeId", "data-v-3e1736c4"]]);
const CurdTable_vue_vue_type_style_index_0_scoped_true_lang = "";
const _hoisted_1$i = { class: "curd_table" };
const _hoisted_2$9 = {
  key: 0,
  class: "title"
};
const _hoisted_3$7 = {
  key: 0,
  class: "commomTitle"
};
const _hoisted_4$5 = { class: "operation_buttons" };
const _hoisted_5$4 = { class: "flex" };
const _hoisted_6$1 = {
  class: "flex",
  style: { "flex-shrink": "0" }
};
const _sfc_main$j = /* @__PURE__ */ defineComponent({
  __name: "CurdTable",
  props: __spreadValues({}, CurdProps),
  setup(__props, { expose }) {
    const props = __props;
    const route = useRoute();
    const { params, query } = route;
    const DEFAULT_PAGE_CONFIG = {
      pageNo: "pageNo",
      pageSize: "pageSize"
    };
    const searchFrom = ref(null);
    const DEFAULT_KCONF_URL = "/api/noah/common/getKconf";
    const state = reactive({
      searchForm: __spreadValues({}, props.initSearchForm),
      list: [],
      component: FormDrawer,
      slotName: "",
      kconfKey: "",
      payload: "",
      slots: [],
      title: "",
      show: false,
      loading: false,
      requestPayload: {},
      tableColumn: []
    });
    const config = reactive({
      useRouterQuery: true,
      operators: []
    });
    const pageInfo = reactive({
      pageNo: 1,
      pageSize: 10,
      total: 10
    });
    const titleConfig = computed(() => {
      var _a, _b;
      const title = typeof config.titleConfig === "string" ? config.titleConfig : (_a = config.titleConfig) == null ? void 0 : _a.title;
      const showTitle = !(typeof title === "boolean" && !title);
      return {
        showTitle,
        title,
        guideUrl: (_b = config.titleConfig) == null ? void 0 : _b.guideUrl
      };
    });
    const kconfConfig = computed(() => {
      if (typeof props.kconf === "string") {
        return {
          url: DEFAULT_KCONF_URL,
          payload: { body: props.kconf }
        };
      }
      if (props.kconf.payload) {
        return __spreadValues({
          url: DEFAULT_KCONF_URL
        }, props.kconf);
      }
      return {};
    });
    const isKconf = computed(() => !!Object.keys(kconfConfig.value).length);
    function getConfig() {
      return __async(this, null, function* () {
        if (isKconf.value) {
          const { data } = yield getRequest(kconfConfig.value, props.commonConfig);
          for (const key in data.body) {
            config[key] = data.body[key];
          }
        } else {
          const attrs = useAttrs();
          for (const key in attrs) {
            config[key] = attrs[key];
          }
        }
      });
    }
    onMounted(() => __async(this, null, function* () {
      var _a, _b, _c;
      state.loading = true;
      yield getConfig();
      if (!((_a = config.tableConfig) == null ? void 0 : _a.useTableSetting)) {
        state.tableColumn = config == null ? void 0 : config.tableConfig.columns;
      }
      if ((_b = config.filterConfig) == null ? void 0 : _b.initData) {
        state.searchForm = Object.assign(state.searchForm, (_c = config.filterConfig) == null ? void 0 : _c.initData);
      }
      yield onSearch(1);
      state.loading = false;
    }));
    function onSearch(page, data) {
      return __async(this, null, function* () {
        var _a, _b, _c, _d, _e;
        if (data)
          state.searchForm = data;
        if (typeof page === "number") {
          pageInfo.pageNo = page;
        }
        const { pageNo, pageSize } = pageInfo;
        const pageConfig = __spreadValues(__spreadValues({}, DEFAULT_PAGE_CONFIG), (_a = config == null ? void 0 : config.tableConfig) == null ? void 0 : _a.pageConfig);
        state.requestPayload = omit(
          __spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues({
            [pageConfig.pageNo]: pageNo,
            [pageConfig.pageSize]: pageSize
          }, state.searchForm), (_c = (_b = config.tableConfig) == null ? void 0 : _b.request) == null ? void 0 : _c.payload), (_e = (_d = config.filterConfig) == null ? void 0 : _d.request) == null ? void 0 : _e.payload), config.useRouterQuery ? __spreadValues(__spreadValues({}, query), params) : {}), props.payload),
          ["nav", "nav1", "nav2", "nav3", "undefined"]
        );
        const request2 = __spreadValues({}, config.tableConfig.request);
        request2.payload = state.requestPayload;
        try {
          const { data: data2 } = yield getRequest(request2, props.commonConfig);
          const { list, total } = data2;
          pageInfo.total = total || 0;
          let datalist = list;
          if (props.flatKey.length) {
            datalist = list == null ? void 0 : list.map((item) => {
              props.flatKey.forEach((key) => {
                Object.assign(item, item[key]);
              });
              return item;
            });
          }
          state.list = datalist;
        } catch (e) {
          Message.error("error");
        }
      });
    }
    const isConfig = computed(() => !!(state.kconfKey || state.slotName || state.payload.kconf));
    function handleClickShow(item, row2) {
      return __async(this, null, function* () {
        const { title, label, type } = item || {};
        switch (type) {
          case "drawer":
            state.component = BindDrawer;
            break;
          case "dialog":
            state.component = Dialog;
            break;
          case "curdDrawer":
          case "curdDialog":
            state.component = CurdDrawer;
            break;
          case "formDrawer":
          case "formDialog":
          default:
            state.component = FormDrawer;
            break;
        }
        state.slotName = item.slotName;
        const _a = item, { slotName, request: request2 } = _a, rest = __objRest(_a, ["slotName", "request"]);
        state.item = rest;
        state.payload = item.payload;
        state.title = title || label;
        state.row = row2;
        state.kconfKey = item.kconfKey;
        const currentKey = state.kconfKey || state.slotName;
        if (currentKey) {
          config[currentKey].initData = Object.assign(config[currentKey].initData || {}, props.initCurdData[currentKey]);
        }
        if (item.request) {
          item.request.payload.id = parseValue$1(item.request.payload.id, "row", row2);
          const { result, data } = yield getRequest(item.request);
          if (result === 1) {
            state.row = data;
          }
        }
        state.show = true;
      });
    }
    function handleClickClose() {
      state.show = false;
    }
    function handleSubmit() {
      state.show = false;
      onSearch(1);
    }
    expose({
      reload: () => onSearch(1)
    });
    return (_ctx, _cache) => {
      var _a;
      const _component_k18n = resolveComponent("k18n");
      const _component_ks_row = resolveComponent("ks-row");
      const _directive_loading = resolveDirective("loading");
      return openBlock(), createElementBlock("div", _hoisted_1$i, [
        unref(titleConfig).showTitle ? (openBlock(), createElementBlock("div", _hoisted_2$9, [
          createVNode(_component_ks_row, {
            type: "flex",
            justify: "space-between"
          }, {
            default: withCtx(() => [
              unref(titleConfig).title ? (openBlock(), createElementBlock("h1", _hoisted_3$7, [
                createTextVNode(toDisplayString(unref(titleConfig).title) + " ", 1),
                renderSlot$2(_ctx.$slots, "after-title", {}, void 0, true)
              ])) : createCommentVNode("", true),
              renderSlot$2(_ctx.$slots, "titleRight", {}, () => [
                unref(titleConfig).guideUrl ? (openBlock(), createElementBlock("div", {
                  key: 0,
                  class: "guide-msg",
                  onClick: _cache[0] || (_cache[0] = ($event) => unref(openPage)(unref(titleConfig).guideUrl))
                }, [
                  createVNode(_component_k18n, null, {
                    default: withCtx(() => [
                      createTextVNode("\u914D\u7F6E\u6307\u5357")
                    ]),
                    _: 1
                  }),
                  createVNode(unref(IconDirectionDown), {
                    size: 18,
                    class: "guide-msg-icon"
                  })
                ])) : createCommentVNode("", true)
              ], true)
            ]),
            _: 3
          })
        ])) : createCommentVNode("", true),
        config.filterConfig ? (openBlock(), createBlock(unref(ProSearch), mergeProps({ key: 1 }, config.filterConfig, {
          ref_key: "searchFrom",
          ref: searchFrom,
          data: state.searchForm,
          style: { "margin-top": "16px" },
          onOnSearch: _cache[1] || (_cache[1] = ($event) => onSearch(1, $event)),
          onOnReset: _cache[2] || (_cache[2] = ($event) => onSearch(1, $event))
        }), null, 16, ["data"])) : createCommentVNode("", true),
        createElementVNode("div", _hoisted_4$5, [
          createElementVNode("div", _hoisted_5$4, [
            createVNode(_sfc_main$1b, {
              config: config.operators,
              onShow: handleClickShow
            }, null, 8, ["config"]),
            renderSlot$2(_ctx.$slots, "left", {}, void 0, true)
          ]),
          createElementVNode("div", _hoisted_6$1, [
            renderSlot$2(_ctx.$slots, "right", {
              requestPayload: state.requestPayload
            }, void 0, true),
            _ctx.useTableSetting ? (openBlock(), createBlock(SettingIcon, {
              key: 0,
              modelValue: state.tableColumn,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => state.tableColumn = $event),
              class: "setting_icon",
              "local-store-key": _ctx.localStoreKey,
              columns: config.tableConfig.columns
            }, null, 8, ["modelValue", "local-store-key", "columns"])) : createCommentVNode("", true)
          ])
        ]),
        renderSlot$2(_ctx.$slots, "tableTop", {}, void 0, true),
        withDirectives(createVNode(unref(ProTable), {
          data: state.list,
          "header-sticky": 56,
          columns: state.tableColumn,
          "show-pagination": _ctx.showPagination,
          "page-info": pageInfo,
          onCurrentChange: onSearch,
          onShow: handleClickShow,
          onReload: _cache[4] || (_cache[4] = ($event) => onSearch(1)),
          onSizeChange: _cache[5] || (_cache[5] = ($event) => onSearch(1))
        }, null, 8, ["data", "columns", "show-pagination", "page-info"]), [
          [_directive_loading, state.loading]
        ]),
        unref(isConfig) ? (openBlock(), createElementBlock(Fragment, { key: 2 }, [
          state.kconfKey || state.payload.kconf ? (openBlock(), createBlock(resolveDynamicComponent(state.component), mergeProps({
            key: 0,
            modelValue: state.show,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => state.show = $event),
            component: (_a = state == null ? void 0 : state.item) == null ? void 0 : _a.type,
            title: state.title
          }, Object.assign(config[state.kconfKey] || {}, state.payload), {
            "common-config": _ctx.commonConfig,
            row: state.row,
            onSubmit: handleSubmit,
            onClose: handleClickClose
          }), {
            default: withCtx(() => [
              (openBlock(true), createElementBlock(Fragment, null, renderList(state.item.slots, (name) => {
                return renderSlot$2(_ctx.$slots, name, {}, void 0, true);
              }), 256))
            ]),
            _: 3
          }, 16, ["modelValue", "component", "title", "common-config", "row"])) : (openBlock(), createBlock(resolveDynamicComponent(state.component), {
            key: 1,
            modelValue: state.show,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => state.show = $event),
            title: state.title,
            width: "560px"
          }, {
            default: withCtx(() => [
              state.show ? renderSlot$2(_ctx.$slots, state.slotName, {
                key: 0,
                row: state.row,
                commonConfig: _ctx.commonConfig,
                submit: handleSubmit,
                close: handleClickClose
              }, void 0, true) : createCommentVNode("", true)
            ]),
            _: 3
          }, 8, ["modelValue", "title"]))
        ], 64)) : createCommentVNode("", true)
      ]);
    };
  }
});
const CurdTable = /* @__PURE__ */ _export_sfc(_sfc_main$j, [["__scopeId", "data-v-e188e026"]]);
const _sfc_main$i = defineComponent({
  name: "ProGroupItem",
  props: {
    item: {
      type: Object,
      default: () => ({})
    },
    data: {
      type: Array,
      default: () => []
    }
  },
  setup(props, ctx) {
    function render2() {
      const column = renderColumn(props.item, ctx.slots)({ row: props.data });
      return h("span", {}, { default: () => [column] });
    }
    return render2;
  }
});
const index_vue_vue_type_style_index_0_scoped_true_lang$1 = "";
const _hoisted_1$h = { class: "pro_group__label" };
const _sfc_main$h = /* @__PURE__ */ defineComponent({
  __name: "index",
  props: {
    data: {
      type: Array,
      default: () => []
    },
    columns: {
      type: Array,
      default: () => []
    },
    mode: {
      type: String,
      default: "block"
    },
    dark: {
      type: Boolean,
      default: false
    }
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(["pro_group__wrapper", [__props.mode, __props.dark ? "dark" : ""]])
      }, [
        (openBlock(true), createElementBlock(Fragment, null, renderList(__props.columns, (item, index2) => {
          return openBlock(), createElementBlock("div", {
            key: item.key || index2,
            class: "pro_group__item"
          }, [
            createElementVNode("span", _hoisted_1$h, [
              createVNode(Label, { item }, null, 8, ["item"])
            ]),
            createVNode(_sfc_main$i, {
              item,
              data: __props.data,
              class: "pro_group__value"
            }, null, 8, ["item", "data"])
          ]);
        }), 128))
      ], 2);
    };
  }
});
const index$2 = /* @__PURE__ */ _export_sfc(_sfc_main$h, [["__scopeId", "data-v-13d03b39"]]);
function getToolTipWrapper(title, html) {
  return `
        <div  class="procharts_global_line_tooltip" >
          <!--\u5DE6\u4E0A\u89D2\u6587\u6848-->
          <span class="title">
                ${title}
            </span>
            <div class="content_wrapper">
                ${html}
            </div>
        </div>
    `;
}
function getTooltipItem(marker, seriesName, seriesContent, highlight) {
  return `
        <div class="${highlight ? "item_wrapper highlight" : "item_wrapper"}">
            ${marker}
            <span class="name"  >
                ${seriesName}
            </span>
            <span class="value" >
                ${seriesContent}
            </span>
        </div>
    `;
}
function hexToRgb(hex) {
  const rgb = [];
  for (let i = 1; i < 7; i += 2) {
    rgb.push(parseInt(`0x${hex.slice(i, i + 2)}`));
  }
  return rgb;
}
const COMMON_BASIC_OPTIONS = {
  legend: {
    type: "scroll",
    show: true,
    left: 67,
    bottom: 12,
    icon: "circle",
    itemGap: 24,
    itemHeight: 6,
    width: "92%",
    selector: [
      {
        type: "all",
        title: "All"
      },
      {
        type: "inverse",
        title: "Inverse"
      }
    ],
    order: "valueAsc"
  },
  tooltip: {
    padding: 0,
    enterable: true,
    appendToBody: true,
    backgroundColor: "rgba(255, 255, 255, 0)",
    borderColor: "rgba(255, 255, 255, 0)",
    axisPointer: {
      z: 3
    }
  }
};
const EMPTY_OPTIONS = {
  title: {
    text: "No data",
    x: "center",
    y: "center",
    textStyle: {
      fontFamily: "Roboto, Roboto-Regular",
      color: "#ccc",
      fontWeight: "normal",
      fontSize: 16
    }
  }
};
function transformLineData(data, dataSet) {
  const result = transformSeriesFieldLineData(data, dataSet);
  return orderData(result);
}
function orderData(result) {
  const { data, dataSet } = result;
  const { x, y } = dataSet;
  const categoryList = y.map((item) => item.key);
  const orderMap = {};
  data.forEach((item) => {
    categoryList.forEach((cateGory) => {
      const value2 = item[cateGory];
      if (!orderMap[cateGory]) {
        orderMap[cateGory] = 0;
      }
      orderMap[cateGory] += value2 / data.length;
    });
  });
  const orderY = y.sort((a, b) => orderMap[b.key] - orderMap[a.key]);
  return {
    data,
    dataSet: __spreadProps(__spreadValues({}, dataSet), {
      y: orderY
    })
  };
}
function transformSeriesFieldLineData(data, dataSet) {
  const { x, y, seriesField, seriesFieldValue } = dataSet;
  const xData = [];
  const categoryList = [];
  const result = [];
  const obj = {};
  const resultDataSet = {
    x: dataSet.x,
    y: y || []
  };
  if (seriesField && seriesFieldValue) {
    data.forEach((item) => {
      const category = item[seriesField];
      const xLabel = item[x.key];
      if (!categoryList.includes(category)) {
        categoryList.push(category);
        if (!Array.isArray(y)) {
          resultDataSet.y.push({
            key: category,
            name: category
          });
        }
      }
      if (!xData.includes(xLabel)) {
        xData.push(xLabel);
      }
      const value2 = item[seriesFieldValue];
      if (!obj[xLabel]) {
        obj[xLabel] = {
          [x.key]: xLabel
        };
      }
      obj[xLabel][category] = value2;
    });
    xData.forEach((xKey) => {
      categoryList.forEach((categoryItem) => {
        if (!obj[xKey][categoryItem]) {
          obj[xKey][categoryItem] = 0;
        }
      });
      result.push(obj[xKey]);
    });
    return {
      data: result,
      dataSet: resultDataSet
    };
  }
  return {
    data,
    dataSet
  };
}
function transformPieData(data, dataSet, k18n) {
  const { y } = dataSet;
  const yConfig = (y == null ? void 0 : y[0]) || {};
  const result = data == null ? void 0 : data.map((item, index2) => {
    var _a;
    const result2 = __spreadProps(__spreadValues({}, item), {
      name: getK18nText(dataSet, item[yConfig.name], k18n),
      value: item[yConfig.value]
    });
    if ((yConfig == null ? void 0 : yConfig.color) && ((_a = yConfig == null ? void 0 : yConfig.color) == null ? void 0 : _a[index2])) {
      result2.color = yConfig.color[index2];
    }
    return result2;
  }).sort((a, b) => b.value - a.value);
  return {
    data: result,
    dataSet
  };
}
var ChartType = /* @__PURE__ */ ((ChartType2) => {
  ChartType2["pie"] = "pie";
  return ChartType2;
})(ChartType || {});
var LogType = /* @__PURE__ */ ((LogType2) => {
  LogType2["ACC"] = "ACC";
  LogType2["STACK"] = "STACK";
  LogType2["SELECT"] = "SELECT";
  return LogType2;
})(LogType || {});
function transformData(data, dataSet, k18n) {
  if (Array.isArray(data)) {
    const { y } = dataSet;
    const yConfig = (y == null ? void 0 : y[0]) || {};
    if (yConfig.type === ChartType.pie) {
      return transformPieData(data, dataSet, k18n);
    }
    return transformLineData(data, dataSet);
  }
  return {
    data,
    dataSet
  };
}
function getK18nText(dataSet, label, k18n) {
  const { seriesFieldK18n } = dataSet;
  if (isObject$6(seriesFieldK18n)) {
    return (seriesFieldK18n == null ? void 0 : seriesFieldK18n[label]) || label;
  }
  const $k18n = k18n || getK18n();
  return typeof seriesFieldK18n === "boolean" ? $k18n(label) : $k18n({ text: label, desc: seriesFieldK18n });
}
function formatMoneyNum(val) {
  if (typeof val === "number") {
    return Number(val).toLocaleString("en-US");
  }
  return 0;
}
function generateXData(data, xConfig) {
  return xConfig.type === "time" ? data.map((item) => moment(String(item[xConfig.key])).format(xConfig.format || "YYYY-MM")) : data.map((item) => item[xConfig.key]);
}
const DEFAULT_COLORS$1 = [
  "#326BFB",
  "#2AB2FF",
  "#5CC6C7",
  "#ACD84A",
  "#07D091",
  "#E1479A",
  "#C73AD2",
  "#6938C9",
  "#FE8800",
  "#F7DA1A",
  "#204DD4",
  "#008CDC",
  "#0AA5A8",
  "#90B71D",
  "#00B47B",
  "#CB1E83",
  "#B010B6",
  "#551DB0",
  "#E5810C",
  "#D2B007"
];
const tooltip = merge$1({}, COMMON_BASIC_OPTIONS.tooltip, {
  trigger: "axis",
  formatter(param) {
    const orderResult = param.sort((a, b) => b.data.value - a.data.value);
    const itemHtml = orderResult.map((item) => {
      const content = `${item.data.unit ? item.data.value : formatMoneyNum(item.data.value)}${item.data.unit || ""}`;
      return getTooltipItem(item.marker, item.seriesName, content);
    }).join("");
    return getToolTipWrapper(param[0].axisValue, itemHtml);
  }
});
const xAxis = {
  type: "category",
  data: [],
  axisTick: {
    show: false,
    gridIndex: 0
  },
  axisLine: {
    lineStyle: {
      color: "#ebedf0"
    }
  },
  offset: 10,
  axisLabel: {
    show: true,
    margin: 10,
    textStyle: {
      color: "#999999",
      fontSize: "12px",
      fontFamily: " Roboto, Roboto-Regular",
      fontWeight: 400,
      textAlign: "CENTER"
    }
  }
};
const yAxis = {
  type: "value",
  name: "",
  position: "left",
  alignTicks: true,
  axisLabel: {
    show: true,
    alignTicks: true,
    textStyle: {
      color: "#999999",
      fontSize: "12px",
      fontFamily: " Roboto, Roboto-Regular",
      fontWeight: 400,
      textAlign: "CENTER"
    }
  },
  offset: 16,
  splitLine: {
    show: true,
    lineStyle: {
      color: "#f5f7fa",
      type: "dashed"
    }
  },
  axisLine: {
    lineStyle: {
      color: "#898A8C"
    }
  }
};
const grid = {
  top: 20,
  bottom: 66,
  right: 40,
  left: 40,
  containLabel: true
};
function getBasicOptions(itemConfig = {}) {
  const barType = (itemConfig == null ? void 0 : itemConfig.type) === "bar";
  return merge$1({}, COMMON_BASIC_OPTIONS, {
    color: DEFAULT_COLORS$1,
    tooltip: barType ? {
      axisPointer: {
        type: "shadow"
      },
      shadowStyle: {
        color: "rgba(0,0,0,0.3)"
      }
    } : {},
    xAxis,
    yAxis,
    series: {
      name: "",
      type: "line",
      data: [],
      connectNulls: true,
      barWidth: 16,
      barMinHeight: 1,
      smooth: true,
      symbol: "circle",
      showSymbol: false,
      symbolSize: 9,
      emphasis: barType ? {} : {
        itemStyle: {
          borderColor: "#FFF",
          borderWidth: 3,
          shadowBlur: 3,
          shadowColor: "rgba(106, 106, 106, 0.12)"
        }
      }
    },
    grid
  });
}
function getColor(index2) {
  const len = DEFAULT_COLORS$1.length;
  return DEFAULT_COLORS$1[index2 % len];
}
function getStackAreaItem(index2) {
  return {
    areaStyle: getAreaStyle(getColor(index2), getColor(index2)),
    stack: "All",
    emphasis: {
      focus: "series"
    }
  };
}
const getAreaStyle = (isStack, color) => {
  return {
    opacity: isStack ? 0.4 : 0.12,
    color: {
      type: "linear",
      x: 0,
      y: 0,
      x2: 0,
      y2: 1,
      colorStops: [
        {
          offset: 0,
          color
        },
        {
          offset: 1,
          color: isStack ? color : "#fff"
        }
      ]
    }
  };
};
function getSeriesItemLineStyle(color) {
  return {
    lineStyle: {
      width: 4,
      type: "solid",
      cap: "round",
      shadowOffsetY: 4,
      shadowBlur: 4,
      shadowColor: `${color}46`
    }
  };
}
function getSeriesItemBarStyle(color) {
  const [r, g, b] = hexToRgb(color);
  return {
    itemStyle: {
      color: {
        type: "linear",
        x: 0,
        y: 0,
        x2: 0,
        y2: 1,
        colorStops: [
          {
            offset: 0,
            color
          },
          {
            offset: 1,
            color: `rgba(${r},${g},${b},0.4)`
          }
        ]
      }
    }
  };
}
function getSingleLineSeriesItem() {
  return {
    lineStyle: {
      width: 4,
      type: "solid",
      cap: "round",
      shadowOffsetY: 4,
      shadowBlur: 4,
      shadowColor: "rgba(50,107,251,0.15)",
      color: {
        type: "linear",
        x: 0,
        y: 0,
        x2: 1,
        y2: 0,
        colorStops: [
          {
            offset: 0,
            color: "#32FBFB"
          },
          {
            offset: 1,
            color: "#326BFB"
          }
        ]
      }
    }
  };
}
function yAxisFormat(unit) {
  if (unit) {
    return (value2) => `${value2}${unit}`;
  }
  return (num) => {
    const texts = [];
    if (Number(num) >= 1e4 && Number(num) < 1e6) {
      const data = `${parseFloat((Number(num) / 1e3).toFixed(1))}K`;
      texts.push(data);
    } else if (Number(num) >= 1e6) {
      const data = `${parseFloat((Number(num) / 1e6).toFixed(2))}M`;
      texts.push(data);
    } else {
      const data = Number(num);
      texts.push(data);
    }
    return texts;
  };
}
const DEFAULT_COLORS = [
  "#326BFB",
  "#07D091",
  "#FE8800",
  "#ACD84A",
  "#2AB2FF",
  "#5CC6C7",
  "#E1479A",
  "#C73AD2",
  "#6938C9",
  "#F7DA1A",
  "#204DD4",
  "#00B47B",
  "#E5810C",
  "#90B71D",
  "#008CDC",
  "#0AA5A8",
  "#CB1E83",
  "#B010B6",
  "#551DB0",
  "#D2B007"
];
const BASIC_OPTIONS = merge$1({}, COMMON_BASIC_OPTIONS, {
  color: [...DEFAULT_COLORS, ...DEFAULT_COLORS, ...DEFAULT_COLORS, ...DEFAULT_COLORS],
  tooltip: {
    trigger: "item",
    formatter(param) {
      const content = formatMoneyNum(param.data.value);
      const itemHtml = getTooltipItem(param.marker, param.name, content);
      return getToolTipWrapper("", itemHtml);
    }
  }
});
const commonItem = {
  type: "pie",
  bottom: 50,
  startAngle: -90
};
function getFinalOptions(data, dataSet) {
  var _a;
  if ((dataSet == null ? void 0 : dataSet.chartType) === "piePercent") {
    const yObj = ((_a = dataSet == null ? void 0 : dataSet.y) == null ? void 0 : _a[0]) || {};
    return __spreadProps(__spreadValues({}, BASIC_OPTIONS), {
      series: [
        __spreadProps(__spreadValues(__spreadProps(__spreadValues({}, commonItem), {
          label: {
            normal: {
              show: true,
              position: "inner",
              textStyle: {
                fontWeight: 600,
                fontSize: 14,
                color: "#fff"
              },
              formatter: (param) => {
                return `${(param == null ? void 0 : param.percent) || 0}%`;
              }
            }
          },
          radius: ["60%", "90%"]
        }), yObj), {
          data
        })
      ]
    });
  }
  const color = data.map((item) => item.color).filter((_) => _);
  return __spreadProps(__spreadValues({}, BASIC_OPTIONS), {
    series: [
      __spreadProps(__spreadValues({}, commonItem), {
        radius: "50%",
        labelLine: {
          length2: 100
        },
        label: {
          lineHeight: 20,
          position: "outer",
          edgeDistance: "6%",
          alignTo: "labelLine",
          formatter(param) {
            return `${param.name} ${param.percent}%`;
          }
        },
        color: (color == null ? void 0 : color.length) ? color : null,
        data
      })
    ]
  });
}
const index_vue_vue_type_style_index_0_scoped_true_lang = "";
const index_vue_vue_type_style_index_1_lang = "";
const _hoisted_1$g = {
  key: 0,
  class: "tool_bar__wrapper"
};
const _sfc_main$g = /* @__PURE__ */ defineComponent({
  __name: "index",
  props: {
    data: {
      type: Array,
      default: () => []
    },
    height: {
      type: String,
      default: "300px"
    },
    width: {
      type: String,
      default: "100%"
    },
    extraOption: {
      type: Object,
      default: () => ({})
    },
    dataSet: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ["mouseover", "mouseout", "mousemove"],
  setup(__props, { emit: emit2 }) {
    const props = __props;
    const k18n = getK18n();
    const chartRef = ref();
    const tooltipHighlight = reactive({
      seriesIndex: -1,
      dataIndex: -1
    });
    const state = reactive({
      data: {},
      dataSet: {},
      finalOptions: {}
    });
    const toolBar = reactive({
      showSelect: false,
      stackChecked: false,
      dataAccChecked: false,
      selectOptions: [],
      select: 10
    });
    let chart;
    const handleResize = debounce$2(() => {
      if (!chart)
        return;
      chart.resize();
    }, 500);
    const showToolBar = computed(() => {
      var _a, _b;
      return toolBar.showSelect || !!((_a = props.dataSet) == null ? void 0 : _a.stack) || ((_b = props.dataSet) == null ? void 0 : _b.dataAcc);
    });
    const chartHeight = computed(() => {
      const { height } = props;
      if (showToolBar.value) {
        return `${parseFloat(height) - 36}px`;
      }
      return height;
    });
    function getSeries() {
      var _a;
      const series = [];
      let xAxisData = [];
      let yAxisData = [];
      const { x, y } = state.dataSet;
      xAxisData = generateXData(state.data, x);
      if (y.length) {
        y.forEach((yObj, index2) => {
          const yValue = state.data.map((item) => __spreadProps(__spreadValues({}, item), { value: item[yObj.key], unit: yObj.unit || "" }));
          if (!yValue.every((item) => isEmpty(item.value))) {
            const seriesItem = __spreadProps(__spreadValues(__spreadProps(__spreadValues({}, getBasicOptions(yObj).series), {
              yAxisIndex: 0
            }), yObj), {
              name: yObj.name || yObj.key,
              tooltip: {
                valueFormatter: (value2) => `${value2}${yObj.unit}`,
                show: true
              },
              data: yValue,
              lineStyle: getSeriesItemLineStyle(getColor(index2)).lineStyle,
              areaStyle: getAreaStyle(toolBar.stackChecked, getColor(index2))
            });
            if (yObj.type === "bar") {
              seriesItem.itemStyle = getSeriesItemBarStyle(yObj.color || getColor(index2)).itemStyle;
            }
            seriesItem.yAxisIndex = seriesItem.yAxisIndex >= y.length ? y.length - 1 : seriesItem.yAxisIndex;
            series.push(seriesItem);
            if (seriesItem.yAxisIndex !== 0 && isEmpty$1(yAxisData[seriesItem.yAxisIndex])) {
              yAxisData[seriesItem.yAxisIndex] = __spreadProps(__spreadValues({}, getBasicOptions(yObj).yAxis), {
                position: "right",
                alignTicks: true,
                axisLabel: {
                  formatter: yAxisFormat(yObj.unit)
                }
              });
              if (yObj.yAxisIndex % 2 !== 0) {
                yAxisData[yObj.yAxisIndex].offset = 40;
              }
            }
          }
        });
      }
      yAxisData.unshift(__spreadProps(__spreadValues({}, getBasicOptions().yAxis), {
        axisLabel: {
          formatter: yAxisFormat(y.length === 1 ? y[0].unit : (_a = y.find((item) => !item.yAxisIndex)) == null ? void 0 : _a.unit)
        },
        position: "left"
      }));
      yAxisData = yAxisData.filter((item) => !isEmpty$1(item));
      return {
        xAxisData,
        yAxisData,
        series
      };
    }
    function handleMergedOptions() {
      var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j;
      let finalOptions;
      let merged;
      if (isEmpty$1(state.data) || ((_a = state.data) == null ? void 0 : _a.length) === 0 || !((_c = (_b = state.dataSet) == null ? void 0 : _b.y) == null ? void 0 : _c.length)) {
        finalOptions = EMPTY_OPTIONS;
      } else if (state.dataSet.y[0].type === ChartType.pie) {
        finalOptions = merge$1({}, getFinalOptions(state.data, state.dataSet), props.extraOption);
      } else {
        const { xAxisData, yAxisData, series } = getSeries();
        const bar = ((_d = state.dataSet) == null ? void 0 : _d.tooltipShadow) ? "bar" : "";
        merged = merge$1(
          {},
          getBasicOptions({ type: bar }),
          {
            tooltip: {
              trigger: "axis",
              formatter(param) {
                const orderResult = param.sort((a, b) => b.data.value - a.data.value);
                const itemHtml = orderResult.map((item) => {
                  const content = `${item.data.unit ? item.data.value : formatMoneyNum(item.data.value)}${item.data.unit || ""}`;
                  const highlight = item.seriesIndex === tooltipHighlight.seriesIndex;
                  return getTooltipItem(item.marker, item.seriesName, content, highlight);
                }).join("");
                return getToolTipWrapper(param[0].axisValue, itemHtml);
              }
            },
            xAxis: { data: xAxisData },
            yAxis: yAxisData,
            series
          },
          props.extraOption
        );
        finalOptions = merged;
        if (((_e = finalOptions.series) == null ? void 0 : _e.length) === 1) {
          merge$1(finalOptions.series[0], getSingleLineSeriesItem());
          finalOptions.yAxis.length && (finalOptions.yAxis[0].yAxisIndex = 0);
        }
        if (!props.dataSet.hideItemSelect) {
          generateSelectOption(finalOptions);
        }
        if ((_f = props.dataSet) == null ? void 0 : _f.stack) {
          generateStack(finalOptions);
        }
        if ((_g = props.dataSet) == null ? void 0 : _g.dataAcc) {
          generateDataAcc(finalOptions);
        }
        if ((_h = props.dataSet) == null ? void 0 : _h.topN) {
          transformTopNData(finalOptions);
        }
        if ((_i = props.dataSet) == null ? void 0 : _i.rotateX) {
          handleXLabelRotate(finalOptions, (_j = props.dataSet) == null ? void 0 : _j.rotateX);
        }
      }
      return finalOptions;
    }
    function generateDataAcc(finalOptions) {
      if (toolBar.dataAccChecked) {
        finalOptions.series.forEach((item) => {
          const { data } = item;
          const result = [];
          data.forEach((subItem, i) => {
            if (i > 0) {
              subItem.value += data[i - 1].value;
            }
            result.push(subItem);
          });
          item.data = result;
        });
      }
    }
    function generateStack(finalOptions) {
      var _a;
      if (toolBar.stackChecked) {
        const { omit: omit2 = [] } = ((_a = props.dataSet) == null ? void 0 : _a.stack) || {};
        const stackResult = [];
        finalOptions.series.forEach((item, index2) => {
          if (!(Array.isArray(omit2) && omit2.includes(item == null ? void 0 : item.name))) {
            stackResult.push(__spreadValues(__spreadValues({}, item), getStackAreaItem(index2)));
          } else if (index2 < finalOptions.color.length) {
            finalOptions.color.splice(index2, 1);
          }
        });
        finalOptions.series = stackResult;
      }
    }
    function generateSelectOption(finalOptions) {
      const { series } = finalOptions;
      const len = series.length;
      if (len >= 20) {
        toolBar.showSelect = true;
        toolBar.selectOptions = [
          { label: `All (${len})`, value: 0 },
          { label: k18n("\u524D10\u9879"), value: 10 },
          { label: k18n("\u524D20\u9879"), value: 20 }
        ];
        if (len >= 30) {
          toolBar.selectOptions.push({ label: k18n("\u524D30\u9879"), value: 30 });
        }
        if (len >= 50) {
          toolBar.selectOptions.push({ label: k18n("\u524D50\u9879"), value: 50 });
        }
      } else {
        toolBar.show = false;
      }
    }
    function transformTopNData(finalOptions) {
      var _a;
      (_a = finalOptions.series) == null ? void 0 : _a.forEach((seriesItem) => {
        var _a2, _b, _c, _d, _e;
        const { data } = seriesItem;
        const color = (_d = (_c = (_b = (_a2 = seriesItem == null ? void 0 : seriesItem.itemStyle) == null ? void 0 : _a2.color) == null ? void 0 : _b.colorStops) == null ? void 0 : _c[0]) == null ? void 0 : _d.color;
        if (Array.isArray(data)) {
          const sortResult = (_e = cloneDeep(data)) == null ? void 0 : _e.sort((a, b) => b.value - a.value);
          sortResult == null ? void 0 : sortResult.forEach((item, index2) => {
            if (index2 < 3) {
              const findItem = data == null ? void 0 : data.find((d) => item.value === d.value);
              findItem.label = {
                color: (seriesItem == null ? void 0 : seriesItem.color) || color,
                show: true,
                position: "top",
                formatter: (param) => {
                  return formatValue(param.value);
                }
              };
            }
          });
        }
      });
    }
    function handleXLabelRotate(finalOptions, rotate) {
      finalOptions.xAxis.axisLabel.rotate = rotate;
      finalOptions.xAxis.axisLabel.width = 50;
      finalOptions.xAxis.axisLabel.overflow = "truncate";
    }
    function updateChart(logType = "") {
      if (typeof logType === "string" && logType) {
        sendLog(logType);
      }
      if (chartRef.value && chartRef.value.dispose) {
        chartRef.value.dispose();
      }
      const options = handleMergedOptions();
      if (toolBar.showSelect && toolBar.select && options.series) {
        options.series = options.series.slice(0, toolBar.select);
      }
      chart && chart.setOption(options, true);
      chart.on("mouseover", (data) => {
        tooltipHighlight.seriesIndex = data.seriesIndex;
        tooltipHighlight.dataIndex = data.dataIndex;
        emit2("mouseover", data);
      });
      chart.on("mouseout", (data) => {
        tooltipHighlight.seriesIndex = -1;
        tooltipHighlight.dataIndex = -1;
        emit2("mouseout", data);
      });
      chart.on("mousemove", (data) => {
        emit2("mousemove", data);
      });
    }
    onMounted(() => {
      chart = chartRef.value && echarts.init(chartRef.value);
      handleResize();
      window.addEventListener("resize", handleResize);
      watch(
        () => [props.data, props.extraOption, props.dataSet],
        () => {
          const { data, dataSet } = transformData(props.data, props.dataSet, k18n);
          state.data = data;
          state.dataSet = dataSet;
          updateChart();
        },
        {
          deep: true,
          immediate: true
        }
      );
    });
    function sendLog(logType) {
      if (logType === LogType.ACC && toolBar.dataAccChecked) {
        sendWebloggerClick("\u6309\u65F6\u95F4\u7D2F\u52A0\u6570\u636E");
      }
      if (logType === LogType.STACK && toolBar.stackChecked) {
        sendWebloggerClick("\u5806\u53E0\u56FE");
      }
      if (logType === LogType.SELECT && toolBar.select) {
        sendWebloggerClick("\u7B5B\u9009\u6309\u94AE");
      }
    }
    onBeforeUnmount(() => {
      if (chartRef.value && chartRef.value.dispose) {
        chartRef.value.dispose();
        chartRef.value = null;
      }
      window.removeEventListener("resize", handleResize);
    });
    return (_ctx, _cache) => {
      var _a, _b;
      const _component_ks_checkbox = resolveComponent("ks-checkbox");
      return openBlock(), createElementBlock("div", {
        style: normalizeStyle({ height: __props.height, width: __props.width }),
        class: "pro_charts__wrapper"
      }, [
        unref(showToolBar) ? (openBlock(), createElementBlock("div", _hoisted_1$g, [
          !!((_a = __props.dataSet) == null ? void 0 : _a.dataAcc) ? (openBlock(), createBlock(unref(ProTooltip), {
            key: 0,
            content: unref(k18n)("\u4E3E\u4F8B\uFF1ADay3\u6570\u636E\u603B\u91CF\u663E\u793A=Day1+Day2+Day3"),
            placement: "top",
            style: { "margin-right": "12px" },
            "max-width": "500"
          }, {
            default: withCtx(() => [
              createVNode(_component_ks_checkbox, {
                modelValue: toolBar.dataAccChecked,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => toolBar.dataAccChecked = $event),
                onChange: _cache[1] || (_cache[1] = ($event) => updateChart(unref(LogType).ACC))
              }, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(unref(k18n)("\u6309\u65F6\u95F4\u7D2F\u52A0\u6570\u636E")), 1)
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["content"])) : createCommentVNode("", true),
          !!((_b = __props.dataSet) == null ? void 0 : _b.stack) ? (openBlock(), createBlock(_component_ks_checkbox, {
            key: 1,
            modelValue: toolBar.stackChecked,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => toolBar.stackChecked = $event),
            onChange: _cache[3] || (_cache[3] = ($event) => updateChart(unref(LogType).STACK))
          }, {
            default: withCtx(() => [
              createTextVNode(toDisplayString(unref(k18n)("\u5806\u53E0\u56FE")), 1)
            ]),
            _: 1
          }, 8, ["modelValue"])) : createCommentVNode("", true),
          toolBar.showSelect ? (openBlock(), createBlock(unref(ProTooltip), {
            key: 2,
            content: unref(k18n)("\u5C55\u793A\u5728\u5F53\u524D\u7B5B\u9009\u65F6\u95F4\u8303\u56F4\u5185\uFF0C\u6240\u6709\u5206\u7EC4\u901A\u8FC7\u5E73\u5747\u503C\u964D\u5E8F\u6392\u5217\u540E\u7684\u524DN\u4E2A\u5206\u7EC4\u6570\u636E"),
            placement: "top"
          }, {
            default: withCtx(() => [
              createVNode(unref(ProSelect), {
                modelValue: toolBar.select,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => toolBar.select = $event),
                options: toolBar.selectOptions,
                class: "item_select",
                size: "mini",
                onChange: _cache[5] || (_cache[5] = ($event) => updateChart(unref(LogType).SELECT))
              }, null, 8, ["modelValue", "options"])
            ]),
            _: 1
          }, 8, ["content"])) : createCommentVNode("", true)
        ])) : createCommentVNode("", true),
        createElementVNode("div", {
          ref_key: "chartRef",
          ref: chartRef,
          class: "chart",
          style: normalizeStyle({ height: unref(chartHeight), width: __props.width })
        }, null, 4)
      ], 4);
    };
  }
});
const index$1 = /* @__PURE__ */ _export_sfc(_sfc_main$g, [["__scopeId", "data-v-49b43bf8"]]);
const index = {
  line: {
    tooltip,
    yAxis,
    xAxis,
    grid,
    DEFAULT_COLORS: DEFAULT_COLORS$1
  }
};
const ProTab_vue_vue_type_style_index_0_scoped_true_lang = "";
const _hoisted_1$f = { class: "tab-wraper" };
const _sfc_main$f = /* @__PURE__ */ defineComponent({
  __name: "ProTab",
  props: {
    modelValue: {
      type: [Number, String, Boolean],
      default: ""
    },
    className: {
      type: String,
      default: "normal"
    },
    style: {
      type: Object,
      default: () => {
        return {};
      }
    },
    syncRouterConfig: {
      type: Object,
      default: () => {
        return null;
      }
    }
  },
  emits: ["tabClick", "update:modelValue", "change"],
  setup(__props, { emit: emits }) {
    var _a, _b;
    const props = __props;
    const { syncRouterConfig, modelValue: modelValue2 } = toRefs(props);
    const { sendWebloggerClick: sendWebloggerClick2 } = useGlobalConfig();
    const level = ref(((_a = syncRouterConfig == null ? void 0 : syncRouterConfig.value) == null ? void 0 : _a.level) || 1);
    let keyStr = "";
    const afterDataUpdate = ((_b = syncRouterConfig.value) == null ? void 0 : _b.afterDataUpdate) || (() => {
    });
    if (syncRouterConfig.value) {
      syncRouterConfig.value.afterDataUpdate = () => {
        if (modelData[keyStr] === void 0 || modelData[keyStr] === null || modelData[keyStr] === "")
          return;
        const value2 = level.value === 1 ? { props: { name: modelData[keyStr] } } : modelData[keyStr];
        tabChange(value2, true);
        afterDataUpdate(modelData[keyStr]);
      };
      syncRouterConfig.value.menuName = syncRouterConfig.value.name || syncRouterConfig.value.customName;
      delete syncRouterConfig.value.name;
    }
    const modelData = reactive({});
    let TAB_KEY = "";
    function initSyncRoute() {
      if (syncRouterConfig.value) {
        if (syncRouterConfig.value.menuName) {
          TAB_KEY = keyStr = `${!syncRouterConfig.value.customName ? `tabLevel${level.value}` : ""}${syncRouterConfig.value.menuName}`;
          modelData[TAB_KEY] = modelValue2.value;
          syncRouterConfig.value.type = { [TAB_KEY]: syncRouterConfig.value.type || "string" };
          const { syncToRouter: syncToRouter2 } = useSyncRouter(modelData, syncRouterConfig.value);
          return { syncToRouter: syncToRouter2, modelData, key: TAB_KEY };
        }
        console.warn("sync route tab name or customName is required");
        return { syncToRouter: null, modelData: null };
      }
      return { syncToRouter: null, modelData: null };
    }
    const { syncToRouter, key } = initSyncRoute();
    const tabChange = (value2, isNotClick) => {
      const name = getValue2(value2);
      emits("update:modelValue", name);
      if (level.value === 1) {
        emits("tabClick", name);
      } else {
        emits("change", name);
      }
      if (syncToRouter && key) {
        modelData[key] = name;
        syncToRouter(modelData);
        if (!isNotClick && TAB_KEY && sendWebloggerClick2) {
          sendWebloggerClick2(TAB_KEY, { param1: name });
        }
      }
    };
    function getValue2(value2) {
      return level.value === 1 ? value2.props.name : value2;
    }
    return (_ctx, _cache) => {
      const _component_ks_tabs = resolveComponent("ks-tabs");
      const _component_ks_radio_group = resolveComponent("ks-radio-group");
      return openBlock(), createElementBlock("div", _hoisted_1$f, [
        level.value === 1 ? (openBlock(), createBlock(_component_ks_tabs, mergeProps({
          key: 0,
          modelValue: unref(modelValue2),
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => isRef(modelValue2) ? modelValue2.value = $event : null),
          class: [__props.className],
          type: "senior",
          size: "medium"
        }, _ctx.$attrs, { onTabClick: tabChange }), {
          default: withCtx(() => [
            renderSlot$2(_ctx.$slots, "default", {}, void 0, true)
          ]),
          _: 3
        }, 16, ["modelValue", "class"])) : [2, 3, 4].includes(level.value) ? (openBlock(), createBlock(_component_ks_radio_group, {
          key: 1,
          modelValue: unref(modelValue2),
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => isRef(modelValue2) ? modelValue2.value = $event : null),
          class: normalizeClass(["radio-tab", level.value === 3 ? "radio-tab-level-three" : "", __props.className]),
          onChange: tabChange
        }, {
          default: withCtx(() => [
            renderSlot$2(_ctx.$slots, "default", {}, void 0, true)
          ]),
          _: 3
        }, 8, ["modelValue", "class"])) : createCommentVNode("", true)
      ]);
    };
  }
});
const ProTab = /* @__PURE__ */ _export_sfc(_sfc_main$f, [["__scopeId", "data-v-064db753"]]);
const DEFAULT_CONTROL_BAR_STYLE = {
  barBackground: "linear-gradient(rgba(0,0,0,0), rgba(0,0,0,0.7))",
  progressHeight: 40,
  reverse: true,
  delay: 0
};
const CONTROL_SHOW_STICKY = "sticky";
const videoProperty = [
  "duration",
  "currentTime",
  "buffered",
  "ended",
  "error",
  "paused",
  "playbackRate",
  "player",
  "readyState",
  "seekable",
  "seeking"
];
const DEFAULT_POSTER = "";
const DEFAULT_RATE_CONFIG = [
  {
    value: 3,
    text: "3.0"
  },
  {
    value: 2,
    text: "2.0"
  },
  {
    value: 1.5,
    text: "1.5"
  },
  {
    value: 1,
    text: "1.0"
  }
];
const lyricPlayer_vue_vue_type_style_index_0_lang = "";
const REG_LYRIC = /\[([^\]]*)\](.*)$/;
const REG_FLAG_TIME = /^\d/;
const REG_FLAG_OFFSET = /^offset:(\d+)/;
const REG_LYRIC_DURATION = /<[\d,]+>/g;
const _sfc_main$e = {
  name: "video-lyric-player",
  props: {
    lyrics: {
      type: String,
      default: ""
    },
    currentTime: {
      type: Number,
      default: 0
    },
    offset: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      lyricArr: [],
      lyricOffset: 0
    };
  },
  computed: {
    lyric() {
      let lyric = "";
      this.lyricArr.some((lyricItem) => {
        if (this.currentTime >= lyricItem.startTime + this.realOffset) {
          lyric = lyricItem.lyric;
        } else {
          return true;
        }
      });
      return lyric;
    },
    realOffset() {
      return this.offset + this.lyricOffset;
    }
  },
  watch: {
    lyrics: {
      immediate: true,
      handler: "transformToLyricArr"
    }
  },
  methods: {
    toSeconds(timeStr) {
      let times = [];
      const speratedMs = timeStr.split(".");
      times.unshift(speratedMs[1]);
      const speratedS = speratedMs[0].split(":");
      times.unshift(...speratedS);
      times = times.map((time) => Number(time || 0));
      return times[0] * 60 + times[1] + times[2] / 1e3;
    },
    formatLyric(lyric) {
      return lyric.replace(REG_LYRIC_DURATION, "").replace(/M:/, "\u7537\u751F\uFF1A").replace(/F:/, "\u5973\u751F\uFF1A").replace(/D:/, "\u5408\u5531\uFF1A");
    },
    transformToLyricArr(lyrics) {
      const firstLyricItem = {
        startTime: 0,
        lyric: ""
      };
      this.lyricArr = lyrics.split("\n").filter((lyric) => lyric).map((lyric) => {
        const matched = lyric.match(REG_LYRIC);
        return {
          flag: matched[1] || "",
          text: matched[2] || ""
        };
      }).reduce(
        (lyricArr, { flag, text: text2 }) => {
          if (flag.match(REG_FLAG_TIME)) {
            lyricArr.push({
              startTime: this.toSeconds(flag),
              lyric: this.formatLyric(text2)
            });
          } else {
            const offset2 = flag.match(REG_FLAG_OFFSET);
            if (offset2) {
              this.lyricOffset = Number(offset2[1] || 0) / 1e3;
            } else if (text2) {
              firstLyricItem.lyric += `
${text2}`;
            }
          }
          return lyricArr;
        },
        [firstLyricItem]
      );
    }
  }
};
const _hoisted_1$e = { class: "video-lyric-player" };
function _sfc_render$b(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1$e, toDisplayString($options.lyric), 1);
}
const VideoLyricPlayer = /* @__PURE__ */ _export_sfc(_sfc_main$e, [["render", _sfc_render$b]]);
const getFormatTime = (time) => {
  let hour = Math.floor(time / 60 / 60);
  let minute = Math.floor(time % 3600 / 60);
  let second = Math.floor(time % 3600 % 60);
  minute = minute < 10 ? `0${String(minute)}` : minute;
  if (hour === 0) {
    hour = "";
  } else if (hour < 10) {
    hour = `0${String(hour)}`;
  }
  second = second < 10 ? `0${String(second)}` : second;
  return hour ? `${hour}:${minute}:${second}` : `${minute}:${second}`;
};
const progress_vue_vue_type_style_index_0_lang = "";
const BTM_MAX_HEIGHT = 15;
const _sfc_main$d = {
  name: "video-progress",
  props: {
    percent: {
      type: Number,
      default: 0
    },
    loadPercentage: {
      type: Number,
      default: 0
    },
    duration: {
      type: Number,
      default: 0
    },
    progressHeight: {
      type: Number,
      default: BTM_MAX_HEIGHT,
      validator: (val) => val > 9
    },
    screenshotVtt: {
      type: String,
      default: void 0
    },
    isToolShow: {
      type: Boolean,
      default: false
    },
    isFullscreen: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      timeTagOffset: 0,
      isTimeTagShow: false,
      timeTagValue: "00:00",
      timeLineOffset: 0,
      isDragging: false,
      useScreenshot: false,
      showScreenshot: false,
      screenshotDataList: null,
      currentScreenshotData: null,
      timer: null,
      barWidth: null
    };
  },
  computed: {
    formatDuration() {
      return getFormatTime(this.duration * this.timeTagOffset);
    },
    progressBtnSize() {
      return Math.min(this.progressHeight, BTM_MAX_HEIGHT);
    },
    minScreenshotLeft() {
      try {
        if (!this.currentScreenshotData) {
          return null;
        }
        const screenshotWidth = parseInt(this.currentScreenshotData.w, 10);
        const screenshotWidthHalf = screenshotWidth / 2;
        return screenshotWidthHalf / this.barWidth;
      } catch (e) {
        return null;
      }
    },
    screenshotLeft() {
      const minScreenshotLeft = this.minScreenshotLeft;
      const timeTagOffset = this.timeTagOffset;
      if (typeof minScreenshotLeft === "number") {
        const maxScreenshotLeft = 1 - minScreenshotLeft;
        if (timeTagOffset <= minScreenshotLeft) {
          return minScreenshotLeft;
        }
        if (timeTagOffset >= maxScreenshotLeft) {
          return maxScreenshotLeft;
        }
      }
      return timeTagOffset;
    }
  },
  watch: {
    screenshotVtt(val, oldVal) {
      if (val !== oldVal) {
        this.initScreenshot();
      }
    },
    isToolShow(val, oldVal) {
      if (!val && val !== oldVal) {
        this.showScreenshot = false;
      }
    },
    isFullscreen(val, oldVal) {
      if (val !== oldVal) {
        this.barWidth = this.$refs.bar.clientWidth;
      }
    }
  },
  mounted() {
    this.barWidth = this.$refs.bar.clientWidth;
    this.initScreenshot();
  },
  methods: {
    onMouseEnterHandler(event) {
      this.isTimeTagShow = true;
      this.barClientLeft = this.$refs.bar.getBoundingClientRect().left;
      this.barWidth = this.$refs.bar.clientWidth;
      this.updateTimeTagOffset(event);
      if (this.$refs && this.$refs.bar) {
        this.$refs.bar.addEventListener("mousemove", this.onMousemoveWithoutClickHandler);
      }
    },
    updateTimeTagOffset(event) {
      const startPosition = event.clientX;
      const newTimeTagOffset = startPosition - this.barClientLeft;
      this.setNewTimeTagOffset(newTimeTagOffset);
    },
    setNewTimeTagOffset(offset2) {
      offset2 = Math.min(this.barWidth, Math.max(0, offset2));
      const timeTagWidth = 40;
      this.timeLineOffset = offset2 / this.barWidth;
      if (offset2 < timeTagWidth / 2) {
        this.timeTagOffset = timeTagWidth / 2 / this.barWidth;
      } else if (offset2 > this.barWidth - timeTagWidth / 2) {
        this.timeTagOffset = (this.barWidth - timeTagWidth / 2) / this.barWidth;
      } else {
        this.timeTagOffset = offset2 / this.barWidth;
      }
      const timeValue = offset2 / this.barWidth * this.duration;
      this.timeTagValue = getFormatTime(timeValue);
      this.openScreenshot(timeValue);
    },
    onMousemoveWithoutClickHandler(event) {
      this.updateTimeTagOffset(event);
    },
    onMouseleaveHandler() {
      this.isTimeTagShow = false;
      this.closeScreenshot();
      if (this.$refs && this.$refs.bar) {
        this.$refs.bar.removeEventListener("mousemove", this.onMousemoveWithoutClickHandler);
      }
    },
    onMousedownHandler(event) {
      this.isDragging = true;
      event.stopPropagation();
      this.setMoveStart(event);
    },
    setMoveStart(event) {
      this.barClientLeft = this.$refs.bar.getBoundingClientRect().left;
      this.barWidth = this.$refs.bar.clientWidth;
      this.updatePercent(event);
      document.addEventListener("mousemove", this.onMousemoveHandler);
      document.addEventListener("mouseup", this.onMouseupHandler);
    },
    updatePercent(event) {
      const startPosition = event.clientX;
      const newPercent = (startPosition - this.barClientLeft) / this.barWidth;
      this.setNewPercent(newPercent);
      this.openScreenshot(newPercent * this.duration);
    },
    setNewPercent(percent) {
      if (percent < 0) {
        percent = 0;
      }
      if (percent > 1) {
        percent = 1;
      }
      this.$emit("percent-change", percent);
    },
    onMousemoveHandler(event) {
      this.updatePercent(event);
    },
    onMouseupHandler() {
      this.isDragging = false;
      document.removeEventListener("mousemove", this.onMousemoveHandler);
      document.removeEventListener("mouseup", this.onMouseupHandler);
    },
    initScreenshot() {
      if (!this.screenshotVtt) {
        this.screenshotClean();
        return;
      }
      try {
        const screenshotDataList = this.parseWebvtt(this.screenshotVtt);
        if (Array.isArray(screenshotDataList) && screenshotDataList.length) {
          this.screenshotDataList = screenshotDataList;
          this.useScreenshot = true;
        } else {
          this.screenshotClean();
        }
      } catch (e) {
        this.screenshotClean();
      }
    },
    parseWebvtt(screenshotVtt) {
      const dataList = screenshotVtt.split(/\n{2,}/);
      const len = dataList.length;
      const result = [];
      for (let i = 0; i < len; i++) {
        const strItem = dataList[i];
        if (strItem && strItem !== "WEBVTT") {
          const screenshotList = strItem.split(/\n/);
          result.push(Object.assign(this.parseTime(screenshotList[0]), this.parseUrl(screenshotList[1])));
        }
      }
      return result;
    },
    parseTime(timeItem) {
      const timeList = timeItem.split(" --> ");
      return {
        start: this.transformTime(timeList[0]),
        end: this.transformTime(timeList[1])
      };
    },
    transformTime(timeStr) {
      const arr = timeStr.split(":");
      let count = 0;
      let num = 1e3;
      while (arr.length) {
        const item = arr.pop();
        if (item.indexOf(".") !== -1) {
          const itemList = item.split(".");
          count += num * parseInt(itemList[0], 10) + parseInt(itemList[1], 10);
        } else {
          count += num * parseInt(item, 10);
        }
        num *= 60;
      }
      return count;
    },
    parseUrl(urlItem) {
      const urlList = urlItem.match(/(.*)#xywh=(.*)$/);
      const result = {};
      if (urlList && urlList.length > 2) {
        const params = urlList[2].split(",");
        result.url = urlList[1];
        result.x = params[0];
        result.y = params[1];
        result.w = params[2];
        result.h = params[3];
      }
      return result;
    },
    screenshotClean() {
      this.currentScreenshotData = null;
      this.screenshotDataList = null;
      this.useScreenshot = false;
      this.showScreenshot = false;
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
    },
    closeScreenshot() {
      if (!this.useScreenshot) {
        return;
      }
      this.showScreenshot = false;
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
    },
    openScreenshot(currentTime) {
      if (!this.useScreenshot || this.timer) {
        return;
      }
      this.timer = setTimeout(() => {
        this.timer = null;
        const timeStamp = currentTime * 1e3;
        const currentData = this.getScreenshotItem(timeStamp);
        if (currentData) {
          this.currentScreenshotData = currentData;
          if (!this.showScreenshot) {
            this.showScreenshot = true;
          }
        }
      }, 200);
    },
    getScreenshotItem(timeStamp) {
      const dataList = this.screenshotDataList;
      const len = dataList.length;
      let leftIndex = 0;
      let rightIndex = len - 1;
      const result = null;
      while (leftIndex <= rightIndex) {
        const halfIndex = leftIndex + (rightIndex - leftIndex >> 1);
        const dataItem = dataList[halfIndex];
        const start2 = dataItem.start;
        const end2 = dataItem.end;
        if (timeStamp < start2) {
          rightIndex = halfIndex - 1;
        } else if (timeStamp >= end2) {
          leftIndex = halfIndex + 1;
        } else {
          return dataItem;
        }
      }
      return result;
    }
  }
};
const _hoisted_1$d = ["width", "height"];
const _hoisted_2$8 = ["cx", "cy", "r"];
const _hoisted_3$6 = /* @__PURE__ */ createElementVNode("div", { class: "video-progress-bar-current-sign-down" }, null, -1);
const _hoisted_4$4 = /* @__PURE__ */ createElementVNode("div", { class: "video-progress-bar-current-sign-up" }, null, -1);
const _hoisted_5$3 = [
  _hoisted_3$6,
  _hoisted_4$4
];
function _sfc_render$a(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    class: "video-progress",
    style: normalizeStyle({
      height: $props.progressHeight + "px"
    })
  }, [
    createElementVNode("div", {
      ref: "bar",
      class: normalizeClass(["video-progress-bar", { "is-hover-bar": $data.isTimeTagShow || $data.isDragging }]),
      style: normalizeStyle({
        height: $props.progressHeight + "px"
      }),
      onMousedown: _cache[0] || (_cache[0] = (...args) => $options.onMousedownHandler && $options.onMousedownHandler(...args)),
      onMouseenter: _cache[1] || (_cache[1] = (...args) => $options.onMouseEnterHandler && $options.onMouseEnterHandler(...args)),
      onMouseleave: _cache[2] || (_cache[2] = (...args) => $options.onMouseleaveHandler && $options.onMouseleaveHandler(...args))
    }, [
      createElementVNode("div", {
        class: "video-progress-bar-played video-progress-bar-item",
        style: normalizeStyle({
          width: `${$props.percent * 100}%`
        })
      }, null, 4),
      createElementVNode("div", {
        class: "video-progress-bar-unplayed video-progress-bar-item",
        style: normalizeStyle({
          width: `${(1 - $props.percent) * 100}%`
        })
      }, null, 4),
      createElementVNode("div", {
        class: "video-progress-bar-btn",
        style: normalizeStyle({
          left: `${$props.percent * 100}%`
        })
      }, [
        (openBlock(), createElementBlock("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          width: $options.progressBtnSize,
          height: $options.progressBtnSize,
          style: normalizeStyle({
            marginLeft: -$options.progressBtnSize / 2 + "px"
          })
        }, [
          createElementVNode("circle", {
            fill: "#fff",
            cx: $options.progressBtnSize / 2,
            cy: $options.progressBtnSize / 2,
            r: $options.progressBtnSize / 2
          }, null, 8, _hoisted_2$8)
        ], 12, _hoisted_1$d))
      ], 4),
      createElementVNode("div", {
        class: "video-progress-bar-load video-progress-bar-item",
        style: normalizeStyle({
          width: `${$props.loadPercentage * 100}%`
        })
      }, null, 4),
      $data.useScreenshot ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
        $data.showScreenshot && $data.currentScreenshotData ? (openBlock(), createElementBlock("div", {
          key: 0,
          class: "screenshotContainer",
          style: normalizeStyle({
            left: `${$options.screenshotLeft * 100}%`
          })
        }, [
          createElementVNode("div", {
            style: normalizeStyle({
              width: `${$data.currentScreenshotData.w}px`,
              height: `${$data.currentScreenshotData.h}px`,
              backgroundRepeat: "no-repeat",
              backgroundPosition: `-${$data.currentScreenshotData.x}px -${$data.currentScreenshotData.y}px`,
              backgroundImage: `url(${$data.currentScreenshotData.url})`
            })
          }, [
            createElementVNode("span", null, toDisplayString($data.timeTagValue), 1)
          ], 4)
        ], 4)) : createCommentVNode("", true)
      ], 64)) : $data.isTimeTagShow ? (openBlock(), createElementBlock("span", {
        key: 1,
        ref: "timeTag",
        class: "video-progress-bar-current-time",
        style: normalizeStyle({
          left: `${$data.timeTagOffset * 100}%`
        })
      }, toDisplayString($data.timeTagValue), 5)) : createCommentVNode("", true),
      withDirectives(createElementVNode("span", {
        class: "video-progress-bar-current-sign",
        style: normalizeStyle({
          left: `${$data.timeLineOffset * 100}%`
        })
      }, _hoisted_5$3, 4), [
        [vShow, $data.isTimeTagShow]
      ])
    ], 38)
  ], 4);
}
const VideoProgress = /* @__PURE__ */ _export_sfc(_sfc_main$d, [["render", _sfc_render$a]]);
const pause = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJubyI/PjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+PHN2ZyB0PSIxNjM5MzgyMzAzNjc0IiBjbGFzcz0iaWNvbiIgdmlld0JveD0iMCAwIDEwMjQgMTAyNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHAtaWQ9IjUxNjEiIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMTYiIGhlaWdodD0iMTYiPjxkZWZzPjxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+PC9zdHlsZT48L2RlZnM+PHBhdGggZD0iTTE5MiAyMjRhOTYgOTYgMCAxIDEgMTkyIDB2NTc2YTk2IDk2IDAgMCAxLTE5MiAwdi01NzZ6TTY0MCAyMjRhOTYgOTYgMCAwIDEgMTkyIDB2NTc2YTk2IDk2IDAgMCAxLTE5MiAwdi01NzZ6IiBwLWlkPSI1MTYyIiBmaWxsPSIjZmZmZmZmIj48L3BhdGg+PC9zdmc+";
const play = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJubyI/PjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+PHN2ZyB0PSIxNjM5MzgxNDI3NDMzIiBjbGFzcz0iaWNvbiIgdmlld0JveD0iMCAwIDEwMjQgMTAyNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHAtaWQ9IjUxMDEiIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMTYiIGhlaWdodD0iMTYiPjxkZWZzPjxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+PC9zdHlsZT48L2RlZnM+PHBhdGggZD0iTTM1NC4zNjggMTI2LjU5Mmw1MjAuNzY4IDMzMS4zOTJhNjQgNjQgMCAwIDEgMCAxMDguMDMybC01MjAuNzY4IDMzMS4zOTJBNjQgNjQgMCAwIDEgMjU2IDg0My4zOTJWMTgwLjYwOGE2NCA2NCAwIDAgMSA5OC4zNjgtNTQuMDE2eiIgcC1pZD0iNTEwMiIgZmlsbD0iI2ZmZmZmZiI+PC9wYXRoPjwvc3ZnPg==";
const play_vue_vue_type_style_index_0_lang = "";
const _sfc_main$c = {
  name: "video-play",
  components: {},
  mixins: [],
  props: {
    isPlaying: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      icon: {
        pause,
        play
      }
    };
  },
  computed: {},
  watch: {},
  created() {
  },
  mounted() {
  },
  methods: {
    onPlayClickHandler() {
      this.$emit("state-change");
    }
  }
};
const _hoisted_1$c = ["src"];
function _sfc_render$9(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    class: "video-play",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.onPlayClickHandler && $options.onPlayClickHandler(...args))
  }, [
    createElementVNode("img", {
      src: !$props.isPlaying ? $data.icon.play : $data.icon.pause,
      class: "play-icon"
    }, null, 8, _hoisted_1$c)
  ]);
}
const VideoPlay = /* @__PURE__ */ _export_sfc(_sfc_main$c, [["render", _sfc_render$9]]);
const fullscreen = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJubyI/PjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+PHN2ZyB0PSIxNjM5Mzc3MzcyODYxIiBjbGFzcz0iaWNvbiIgdmlld0JveD0iMCAwIDEwMjQgMTAyNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHAtaWQ9IjYzMjMiIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMTYiIGhlaWdodD0iMTYiPjxkZWZzPjxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+PC9zdHlsZT48L2RlZnM+PHBhdGggZD0iTTE3Ny45ODQgMjU3Ljk4NGMwLTQ0LjE2IDM1Ljg0LTgwIDgwLTgwaDE2NC4wMzJ2OTZIMjczLjkydjE0OC4wMzJoLTk2VjI1Ny45MnogbTUyMC4xMjggMTZINjE3Ljk4NHYtOTZoMTY0LjAzMmM0NC4xNiAwIDgwIDM1Ljg0IDgwIDgwdjE2NC4wMzJoLTk2VjM0MS44ODhMNjI3LjQ1NiA0ODAuNDQ4bC02Ny44NC02Ny44NCAxMzguNDk2LTEzOC42MjR6IG0tNDI0LjEyOCA0MjQuMTI4bDEzOC41Ni0xMzguNTYgNjcuODQgNjcuODQtMTM4LjQ5NiAxMzguNjI0aDgwLjEyOHY5NkgyNTcuOTJjLTQ0LjE2IDAtODAtMzUuODQtODAtODBWNjE3Ljk4NGg5NnY4MC4xMjh6IG01ODguMDMyLTgwLjEyOHYxNjQuMDMyYzAgNDQuMTYtMzUuODQgODAtODAgODBINjE3Ljk4NHYtOTZoMTQ4LjAzMlY2MTcuOTg0aDk2eiIgcC1pZD0iNjMyNCIgZmlsbD0iI2ZmZmZmZiI+PC9wYXRoPjwvc3ZnPg==";
const smallscreen = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJubyI/PjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+PHN2ZyB0PSIxNTQxNzMzNTUzMzQ1IiBjbGFzcz0iaWNvbiIgc3R5bGU9IiIgdmlld0JveD0iMCAwIDEwMjQgMTAyNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHAtaWQ9IjM4ODMiIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCI+PGRlZnM+PHN0eWxlIHR5cGU9InRleHQvY3NzIj48L3N0eWxlPjwvZGVmcz48cGF0aCBkPSJNNTk3LjMzMzMzMyAzOTUuODYxMzMzVjE5MmEyMS4zMzMzMzMgMjEuMzMzMzMzIDAgMCAwLTQyLjY2NjY2NiAwdjI1NmEyMS4zMzMzMzMgMjEuMzMzMzMzIDAgMCAwIDIxLjMzMzMzMyAyMS4zMzMzMzNoMjU2YTIxLjMzMzMzMyAyMS4zMzMzMzMgMCAwIDAgMC00Mi42NjY2NjZoLTIwNS4xMkw4OTAuMjQgMTYzLjMwNjY2N2EyMS4zMzMzMzMgMjEuMzMzMzMzIDAgMCAwLTMwLjE2NTMzMy0zMC4xNjUzMzRMNTk3LjMzMzMzMyAzOTUuODYxMzMzeiBtLTE3MC42NjY2NjYgMjMyLjI3NzMzNFY4MzJhMjEuMzMzMzMzIDIxLjMzMzMzMyAwIDAgMCA0Mi42NjY2NjYgMFY1NzZhMjEuMzMzMzMzIDIxLjMzMzMzMyAwIDAgMC0yMS4zMzMzMzMtMjEuMzMzMzMzSDE5MmEyMS4zMzMzMzMgMjEuMzMzMzMzIDAgMCAwIDAgNDIuNjY2NjY2aDIwNS4xMkwxMzMuNzYgODYwLjY5MzMzM2EyMS4zMzMzMzMgMjEuMzMzMzMzIDAgMCAwIDMwLjE2NTMzMyAzMC4xNjUzMzRMNDI2LjY2NjY2NyA2MjguMTM4NjY3eiIgcC1pZD0iMzg4NCI+PC9wYXRoPjwvc3ZnPg==";
const screen_vue_vue_type_style_index_0_lang = "";
const _sfc_main$b = {
  name: "video-screen",
  components: {},
  mixins: [],
  props: {
    isFullscreen: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      icon: {
        fullscreen,
        smallscreen
      }
    };
  },
  computed: {},
  watch: {},
  created() {
  },
  mounted() {
  },
  methods: {
    onScreenClickHandler() {
      this.$emit("state-change");
    }
  }
};
const _hoisted_1$b = ["src"];
function _sfc_render$8(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    class: "video-screen",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.onScreenClickHandler && $options.onScreenClickHandler(...args))
  }, [
    createElementVNode("img", {
      src: $data.icon.fullscreen,
      class: "screen-icon"
    }, null, 8, _hoisted_1$b)
  ]);
}
const VideoScreen = /* @__PURE__ */ _export_sfc(_sfc_main$b, [["render", _sfc_render$8]]);
const time_vue_vue_type_style_index_0_lang = "";
const _sfc_main$a = {
  name: "video-play",
  components: {},
  mixins: [],
  props: {
    currentTime: {
      type: Number,
      default: 0
    },
    showCurrTime: {
      type: Boolean,
      default: false
    },
    duration: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {};
  },
  computed: {
    formatCurrentTime() {
      return getFormatTime(this.currentTime);
    },
    formatDuration() {
      return getFormatTime(this.duration);
    }
  },
  watch: {},
  created() {
  },
  mounted() {
  },
  methods: {}
};
const _hoisted_1$a = { class: "video-time" };
const _hoisted_2$7 = { key: 0 };
const _hoisted_3$5 = { class: "video-time-all" };
function _sfc_render$7(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1$a, [
    $props.showCurrTime ? (openBlock(), createElementBlock("span", _hoisted_2$7, toDisplayString($options.formatCurrentTime) + "\xA0/\xA0", 1)) : createCommentVNode("", true),
    createElementVNode("span", _hoisted_3$5, toDisplayString($options.formatDuration), 1)
  ]);
}
const VideoTime = /* @__PURE__ */ _export_sfc(_sfc_main$a, [["render", _sfc_render$7]]);
const volume = "data:image/svg+xml;base64,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";
const mute = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJubyI/PjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+PHN2ZyB0PSIxNjM5Mzc3MzU5NTg2IiBjbGFzcz0iaWNvbiIgdmlld0JveD0iMCAwIDEwMjQgMTAyNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHAtaWQ9IjYxMzQiIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMTYiIGhlaWdodD0iMTYiPjxkZWZzPjxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+PC9zdHlsZT48L2RlZnM+PHBhdGggZD0iTTUyOS45MiAxMzIuMTZhNDMuOTY4IDQzLjk2OCAwIDAgMC0xMC40MzItMy4wNzJjLTEwLjQ5Ni0xLjY2NC0yNS43OTItMC4xOTItNDIuMTc2IDE1LjIzMmwtMzUuNjQ4IDMzLjQ3Mi0xNi42NCAxNS42OC0xMDQuNTc2IDk4LjI0SDE5NC4zMDRjLTM2LjI4OCAwLjA2NC02NS41MzYgMzAuNTI4LTY1LjUzNiA2OC4wOTZ2MjE4LjQzMmMwIDM3LjU2OCAyOS40NCA2OC4wOTYgNjUuNTM2IDY4LjA5Nmg4OC4wNjRsMTQyLjY1NiAxMzQuMDggNTIuMjg4IDQ5LjE1MmMxMy4yNDggMTIuMzUyIDI1Ljc5MiAxNS44MDggMzUuNTg0IDE1LjgwOCAyLjQ5NiAwIDQuNDgtMC40NDggNi41OTItMC44MzJhNDQuNDE2IDQ0LjQxNiAwIDAgMCAxMC41Ni0yLjg4YzguMDY0LTMuNjQ4IDI2LjYyNC0xNS42OCAyNi42MjQtNDguMjU2di02MTMuMTJjMC0wLjg5Ni0wLjI1Ni0xLjY2NC0wLjMyLTIuNTYtMC43NjgtMjEuMTItMTAuMzA0LTM4LjE0NC0yNi4zNjgtNDUuNTA0TTg0MC4wNjQgMzkyLjMyYzE4LjExMiAxOC4xMTIgMTguMTEyIDM2LjIyNCAwIDU0LjRMNjc3LjEyIDYwOS41MzZjLTE4LjExMiAxOC4xMTItMzYuMjI0IDE4LjExMi01NC4yNzIgMC0xOC4xMTItMTguMTEyLTE4LjExMi0zNi4yMjQgMC01NC4zMzZsMTYyLjg4LTE2Mi44OGMxOC4xMTItMTguMTEyIDM2LjIyNC0xOC4xMTIgNTQuMzM2IDB6IiBwLWlkPSI2MTM1IiBmaWxsPSIjZmZmZmZmIj48L3BhdGg+PHBhdGggZD0iTTg0MC4wNjQgNjA5LjZjLTE4LjExMiAxOC4xMTItMzYuMjI0IDE4LjExMi01NC4zMzYgMEw2MjIuODQ4IDQ0Ni42NTZjLTE4LjExMi0xOC4xMTItMTguMTEyLTM2LjIyNCAwLTU0LjI3MiAxOC4xMTItMTguMTEyIDM2LjE2LTE4LjExMiA1NC4yNzIgMGwxNjIuOTQ0IDE2Mi44OGMxOC4xMTIgMTguMTEyIDE4LjExMiAzNi4yMjQgMCA1NC4zMzZ6IiBwLWlkPSI2MTM2IiBmaWxsPSIjZmZmZmZmIj48L3BhdGg+PC9zdmc+";
const volume_vue_vue_type_style_index_0_lang = "";
const _sfc_main$9 = {
  name: "video-volume",
  components: {},
  mixins: [],
  props: {
    volume: {
      type: Number,
      default: 0.5
    }
  },
  data() {
    return {
      barShow: false,
      isMoving: false,
      icon: {
        volume,
        mute
      }
    };
  },
  computed: {},
  watch: {},
  created() {
  },
  mounted() {
  },
  methods: {
    onMouseenterHandler() {
      this.barShow = true;
    },
    onMouseleaveHandler() {
      this.barShow = false;
    },
    onVolumeClickHandler() {
      if (this.volume) {
        this.setNewVolume(0);
      } else {
        this.setNewVolume(0.5);
      }
    },
    onMousedownHandler(event) {
      event.stopPropagation();
      this.isMoving = true;
      this.setMoveStart(event);
    },
    setMoveStart(event) {
      this.barClientTop = this.$refs.bar.getBoundingClientRect().top;
      this.barHeight = this.$refs.bar.clientHeight;
      this.updateVolume(event);
      document.addEventListener("mousemove", this.onMousemoveHandler);
      document.addEventListener("mouseup", this.onMouseupHandler);
    },
    updateVolume(event) {
      this.startPosition = event.clientY;
      const newVolume = 1 - (this.startPosition - this.barClientTop) / this.barHeight;
      this.setNewVolume(newVolume);
    },
    setNewVolume(volume2) {
      if (volume2 < 0) {
        volume2 = 0;
      }
      if (volume2 > 1) {
        volume2 = 1;
      }
      this.$emit("volume-change", volume2);
    },
    onMousemoveHandler(event) {
      this.updateVolume(event);
    },
    onMouseupHandler() {
      this.isMoving = false;
      document.removeEventListener("mousemove", this.onMousemoveHandler);
      document.removeEventListener("mouseup", this.onMouseupHandler);
    }
  }
};
const _hoisted_1$9 = ["src"];
const _hoisted_2$6 = { class: "video-volume-wrapper" };
const _hoisted_3$4 = { class: "video-volume-container" };
const _hoisted_4$3 = { class: "video-volume-value" };
const _hoisted_5$2 = { class: "video-volume-bar-tracker" };
function _sfc_render$6(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    class: "video-volume",
    onMouseleave: _cache[3] || (_cache[3] = (...args) => $options.onMouseleaveHandler && $options.onMouseleaveHandler(...args))
  }, [
    createElementVNode("span", {
      class: "video-volume-icon-wraaper",
      onClick: _cache[0] || (_cache[0] = (...args) => $options.onVolumeClickHandler && $options.onVolumeClickHandler(...args)),
      onMouseenter: _cache[1] || (_cache[1] = (...args) => $options.onMouseenterHandler && $options.onMouseenterHandler(...args))
    }, [
      createElementVNode("img", {
        src: $props.volume === 0 ? $data.icon.mute : $data.icon.volume,
        class: "volume-icon"
      }, null, 8, _hoisted_1$9)
    ], 32),
    withDirectives(createElementVNode("div", _hoisted_2$6, [
      createElementVNode("div", _hoisted_3$4, [
        createElementVNode("div", _hoisted_4$3, toDisplayString(Math.floor($props.volume * 100)), 1),
        createElementVNode("div", {
          ref: "bar",
          class: "video-volume-bar",
          onMousedown: _cache[2] || (_cache[2] = (...args) => $options.onMousedownHandler && $options.onMousedownHandler(...args))
        }, [
          createElementVNode("div", _hoisted_5$2, [
            createElementVNode("div", {
              class: "video-volume-bar-tracker-active",
              style: normalizeStyle({
                height: `${$props.volume * 100}%`
              })
            }, null, 4),
            createElementVNode("div", {
              class: "video-volume-bar-tracker-btn",
              style: normalizeStyle({
                bottom: `${$props.volume * 100}%`
              })
            }, null, 4)
          ])
        ], 544)
      ])
    ], 512), [
      [vShow, $data.barShow || $data.isMoving]
    ])
  ], 32);
}
const VideoVolume = /* @__PURE__ */ _export_sfc(_sfc_main$9, [["render", _sfc_render$6]]);
const loading_vue_vue_type_style_index_0_lang = "";
const _sfc_main$8 = {
  name: "video-loading",
  components: {},
  mixins: [],
  props: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},
  created() {
  },
  mounted() {
  },
  methods: {}
};
const _hoisted_1$8 = { class: "spinner" };
const _hoisted_2$5 = /* @__PURE__ */ createStaticVNode('<div class="rect1 rect"></div><div class="rect2 rect"></div><div class="rect3 rect"></div><div class="rect4 rect"></div><div class="rect5 rect"></div>', 5);
const _hoisted_7 = [
  _hoisted_2$5
];
function _sfc_render$5(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1$8, _hoisted_7);
}
const VideoLoading = /* @__PURE__ */ _export_sfc(_sfc_main$8, [["render", _sfc_render$5]]);
const playbackRate_vue_vue_type_style_index_0_lang = "";
const _sfc_main$7 = {
  name: "video-playback-rate",
  components: {},
  mixins: [],
  props: {
    playbackRate: {
      type: Number,
      default: 1
    },
    rateConfig: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      barShow: false
    };
  },
  computed: {
    rateList() {
      return this.rateConfig.rateList;
    },
    curRate() {
      const rate = this.rateList.find((item) => item.value === this.playbackRate);
      return rate && `X${rate.text}`;
    }
  },
  watch: {},
  created() {
  },
  mounted() {
  },
  methods: {
    onMouseleaveHandler() {
      this.barShow = false;
    },
    onRateClickHandler() {
      this.barShow = !this.barShow;
    },
    onRateButtonClickHandler(rate) {
      this.$emit("rate-change", rate);
    }
  }
};
const _hoisted_1$7 = { class: "video-playback-rate-wrapper" };
const _hoisted_2$4 = { class: "video-playback-rate-list" };
const _hoisted_3$3 = ["onClick"];
function _sfc_render$4(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    class: "video-playback-rate",
    onMouseleave: _cache[1] || (_cache[1] = (...args) => $options.onMouseleaveHandler && $options.onMouseleaveHandler(...args))
  }, [
    createElementVNode("span", {
      class: "video-playback-rate-current-rate",
      onClick: _cache[0] || (_cache[0] = (...args) => $options.onRateClickHandler && $options.onRateClickHandler(...args))
    }, toDisplayString($options.curRate), 1),
    withDirectives(createElementVNode("div", _hoisted_1$7, [
      createElementVNode("ul", _hoisted_2$4, [
        (openBlock(true), createElementBlock(Fragment, null, renderList($options.rateList, (rate) => {
          return openBlock(), createElementBlock("li", {
            key: rate,
            class: "video-playback-rate-list-item",
            onClick: ($event) => $options.onRateButtonClickHandler(rate.value)
          }, [
            createElementVNode("span", {
              class: normalizeClass({ "is-select": rate.value === $props.playbackRate })
            }, toDisplayString(rate.text), 3)
          ], 8, _hoisted_3$3);
        }), 128))
      ])
    ], 512), [
      [vShow, $data.barShow]
    ])
  ], 32);
}
const VideoPlaybackRate = /* @__PURE__ */ _export_sfc(_sfc_main$7, [["render", _sfc_render$4]]);
const picInPic_vue_vue_type_style_index_0_lang = "";
const _sfc_main$6 = {
  name: "video-pic-in-pic",
  props: {
    icon: {
      type: String,
      default: ""
    }
  },
  methods: {
    onPicInPicClickHandler() {
      this.$emit("pic-in-pic");
    }
  }
};
const _hoisted_1$6 = {
  key: 0,
  t: "1616657860628",
  class: "icon",
  viewBox: "0 0 1024 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "p-id": "2437",
  width: "300",
  height: "300"
};
const _hoisted_2$3 = /* @__PURE__ */ createElementVNode("path", {
  d: "M512 64a448 448 0 1 1 0 896A448 448 0 0 1 512 64zM408.576 363.136a32\n                32 0 1 0-45.312 45.248l103.808 103.744-103.808 103.744a32 32 0 1 0\n                45.312 45.248l103.744-103.68 103.744 103.68a32 32 0 1 0 45.248-45.248l-103.744-103.68\n                103.744-103.808a32 32 0 0 0-45.248-45.248L512.32 466.88z",
  fill: "#707070",
  "p-id": "2438"
}, null, -1);
const _hoisted_3$2 = [
  _hoisted_2$3
];
const _hoisted_4$2 = {
  key: 1,
  t: "1611756416191",
  class: "icon",
  viewBox: "0 0 1024 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "p-id": "2318",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  width: "200",
  height: "200"
};
const _hoisted_5$1 = /* @__PURE__ */ createElementVNode("path", {
  d: "M810.666667 469.333333H469.333333v255.786667h341.333334V469.333333z\n                    m170.666666 341.333334V212.48C981.333333 165.546667 942.933333 128 896 128H128C81.066667\n                    128 42.666667 165.546667 42.666667 212.48V810.666667c0 46.933333 38.4 85.333333 85.333333\n                    85.333333h768c46.933333 0 85.333333-38.4 85.333333-85.333333z\n                    m-85.333333 0.853333H128V212.053333h768v599.466667z",
  "p-id": "2319"
}, null, -1);
const _hoisted_6 = [
  _hoisted_5$1
];
function _sfc_render$3(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    class: "video-pic-in-pic",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.onPicInPicClickHandler && $options.onPicInPicClickHandler(...args))
  }, [
    createElementVNode("span", {
      class: normalizeClass(["icon", { "close-icon": $props.icon === "close" }])
    }, [
      $props.icon === "close" ? (openBlock(), createElementBlock("svg", _hoisted_1$6, _hoisted_3$2)) : (openBlock(), createElementBlock("svg", _hoisted_4$2, _hoisted_6))
    ], 2)
  ]);
}
const VideoPicInPic = /* @__PURE__ */ _export_sfc(_sfc_main$6, [["render", _sfc_render$3]]);
const MiniPlayerMixin = {
  props: {
    secProps: {
      type: Object,
      default: () => ({})
    }
  },
  created() {
    this.updateMiniVideoStyle = null;
  },
  data() {
    return {
      showSecPlayer: false
    };
  },
  computed: {
    secPlayerProps() {
      const props = this.secProps || {};
      if (!props.config) {
        props.config = Object.assign({}, this.config);
      }
      return props;
    }
  },
  mounted() {
    this.isSecPlayer = this.$el.className === "sec-player";
    if (!this.isSecPlayer && this.config.miniplayer) {
      this.onResizeHandler();
    }
  },
  methods: {
    picInPicChange() {
      const miniPlayed = !this.miniPlayed;
      if (this.config.multiPlayer) {
        if (!this.$refs["sec-player"]) {
          this.showSecPlayer = true;
          this.$nextTick(() => {
            const { openMiniPlayer, updateVideoStyleMap } = this.$refs["sec-player"];
            openMiniPlayer();
            this.updateMiniVideoStyle = updateVideoStyleMap;
            this.$emit("open-mini-player");
          });
        } else {
          this.showSecPlayer = false;
          this.updateMiniVideoStyle = null;
          this.$emit("close-mini-player");
        }
      } else if (this.isSecPlayer) {
        this.$parent.showSecPlayer = false;
        this.$parent.updateMiniVideoStyle = null;
        this.$parent.$emit("close-mini-player");
      } else if (miniPlayed) {
        this.openMiniPlayer();
        this.changeMaskStatus(true);
        this.updateMiniVideoStyle = this.updateVideoStyleMap;
        this.$emit("open-mini-player");
      } else {
        this.closeMiniPlayer();
        this.changeMaskStatus(false);
        this.updateMiniVideoStyle = null;
        this.$emit("close-mini-player");
      }
    },
    onResizeHandler() {
      this.onResize = debounce_1(this.updateVideoStyle, 1e3);
      window.addEventListener("resize", this.onResize);
      this.$once("hook:beforeDestroy", () => {
        window.removeEventListener("resize", this.onResize);
      });
    },
    updateVideoStyle() {
      this.updateMiniVideoStyle && this.updateMiniVideoStyle();
    }
  }
};
const miniPlayer_vue_vue_type_style_index_0_scoped_true_lang = "";
const _sfc_main$5 = {
  components: {
    VideoProgress,
    VideoPlay,
    VideoVolume,
    VideoPicInPic
  },
  props: {
    miniPlayed: {
      type: Boolean
    },
    isFullscreen: {
      type: Boolean
    },
    control: {
      type: [Boolean, String],
      default: true
    },
    config: {
      type: Object,
      default: () => ({
        play: true,
        time: false,
        volume: false,
        screen: true,
        playbackRate: false
      })
    },
    controlBarStyle: {
      type: Object,
      required: true
    },
    original: {
      type: Object,
      required: true
    },
    playedProgress: {
      type: Number,
      required: true
    },
    loadProgress: {
      type: Number,
      required: true
    },
    screenshotVtt: {
      type: String,
      default: void 0
    },
    isToolShow: {
      type: Boolean
    }
  },
  data() {
    return {
      videoStyleMap: {},
      showVideoMask: false
    };
  },
  created() {
    this.MINI_PLAYER_WIDTH = 250;
    this.MINI_PLAYER_HEIGHT = 150;
    this.$emit("expose-methods", {
      openMiniPlayer: this.openMiniPlayer,
      closeMiniPlayer: this.closeMiniPlayer,
      updateVideoStyleMap: this.updateVideoStyleMap,
      changeMaskStatus: this.changeMaskStatus
    });
  },
  methods: {
    openMiniPlayer() {
      this.$emit("mini-played-change", true);
      const { innerWidth, innerHeight } = window;
      this.videoStyleMap = {
        position: "fixed",
        left: `${innerWidth - this.MINI_PLAYER_WIDTH - 20}px`,
        top: `${innerHeight - this.MINI_PLAYER_HEIGHT - 20}px`,
        width: `${this.MINI_PLAYER_WIDTH}px`,
        height: `${this.MINI_PLAYER_HEIGHT}px`,
        zIndex: 99999
      };
    },
    closeMiniPlayer() {
      this.$emit("mini-played-change", false);
      this.videoStyleMap = {};
    },
    updateVideoStyleMap() {
      if (this.miniPlayed) {
        const { innerWidth, innerHeight } = window;
        const { left: left2, top: top2 } = this.videoStyleMap;
        const limitLeft = `${innerWidth - this.MINI_PLAYER_WIDTH - 20}px`;
        const limitTop = `${innerHeight - this.MINI_PLAYER_HEIGHT - 20}px`;
        if (parseFloat(left2) > parseFloat(limitLeft)) {
          this.videoStyleMap.left = limitLeft;
        }
        if (parseFloat(top2) > parseFloat(limitTop)) {
          this.videoStyleMap.top = limitTop;
        }
      }
    },
    changeMaskStatus(status) {
      this.showVideoMask = status;
    },
    onMiniPlayerMousedownHandler(event) {
      if (this.miniPlayed) {
        const { left: left2, top: top2 } = event.currentTarget.getBoundingClientRect();
        const x = event.clientX - left2;
        const y = event.clientY - top2;
        this.miniPlayerInitPos = {
          x,
          y
        };
        this.setMiniPlayerMoveStart();
      }
    },
    onMiniPlayerMousemoveHandler(event) {
      event.preventDefault();
      const { x, y } = this.miniPlayerInitPos;
      const { clientX, clientY } = event;
      const { innerWidth, innerHeight } = window;
      const left2 = clientX - x;
      const top2 = clientY - y;
      const leftBoundary = 20 - this.MINI_PLAYER_WIDTH;
      const rightBoundary = innerWidth - 30;
      const topBoundary = 60 - this.MINI_PLAYER_HEIGHT;
      const bottomBoundary = innerHeight - 20;
      if (left2 < leftBoundary) {
        this.videoStyleMap.left = `${leftBoundary}px`;
      } else if (left2 > rightBoundary) {
        this.videoStyleMap.left = `${rightBoundary}px`;
      } else {
        this.videoStyleMap.left = `${left2}px`;
      }
      if (top2 < topBoundary) {
        this.videoStyleMap.top = `${topBoundary}px`;
      } else if (top2 > bottomBoundary) {
        this.videoStyleMap.top = `${bottomBoundary}px`;
      } else {
        this.videoStyleMap.top = `${top2}px`;
      }
    },
    setMiniPlayerMoveStart() {
      document.addEventListener("mousemove", this.onMiniPlayerMousemoveHandler);
      document.addEventListener("mouseup", this.onMiniPlayerMouseupHandler);
    },
    onMiniPlayerMouseupHandler() {
      document.removeEventListener("mousemove", this.onMiniPlayerMousemoveHandler);
      document.removeEventListener("mouseup", this.onMiniPlayerMouseupHandler);
    }
  }
};
const _hoisted_1$5 = { class: "mini-player" };
const _hoisted_2$2 = {
  key: 0,
  class: "mini-player-control ks-admin-video-player-tool"
};
function _sfc_render$2(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_video_play = resolveComponent("video-play");
  const _component_video_progress = resolveComponent("video-progress");
  const _component_video_pic_in_pic = resolveComponent("video-pic-in-pic");
  const _component_video_volume = resolveComponent("video-volume");
  return openBlock(), createElementBlock("div", _hoisted_1$5, [
    createElementVNode("div", {
      class: normalizeClass(["video-wrap", { "mini-video-wrap": $props.miniPlayed && !$props.isFullscreen }]),
      style: normalizeStyle([$props.isFullscreen ? {} : $data.videoStyleMap]),
      onMousedown: _cache[4] || (_cache[4] = withModifiers((...args) => $options.onMiniPlayerMousedownHandler && $options.onMiniPlayerMousedownHandler(...args), ["stop"]))
    }, [
      renderSlot$2(_ctx.$slots, "video", {}, void 0, true),
      $props.control && $props.miniPlayed ? (openBlock(), createElementBlock("div", _hoisted_2$2, [
        $props.config.play ? (openBlock(), createBlock(_component_video_play, {
          key: 0,
          class: "control-item",
          "is-playing": !$props.original.paused,
          onStateChange: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("play-state-change"))
        }, null, 8, ["is-playing"])) : createCommentVNode("", true),
        createVNode(_component_video_progress, {
          class: "mini-player-control__video-progress",
          "progress-height": $props.controlBarStyle.progressHeight,
          percent: $props.playedProgress,
          "load-percentage": $props.loadProgress,
          duration: $props.original.duration,
          "screenshot-vtt": $props.screenshotVtt,
          "is-tool-show": $props.isToolShow,
          "is-fullscreen": $props.isFullscreen,
          onPercentChange: _cache[1] || (_cache[1] = ($event) => _ctx.$emit("progress-change", $event))
        }, null, 8, ["progress-height", "percent", "load-percentage", "duration", "screenshot-vtt", "is-tool-show", "is-fullscreen"]),
        $props.config.miniplayer ? (openBlock(), createBlock(_component_video_pic_in_pic, {
          key: 1,
          class: "video-pic-in-pic control-item close-icon",
          icon: "close",
          onPicInPic: _cache[2] || (_cache[2] = ($event) => _ctx.$emit("pic-in-pic-change"))
        })) : createCommentVNode("", true),
        $props.config.volume ? (openBlock(), createBlock(_component_video_volume, {
          key: 2,
          class: "control-item",
          volume: $props.original.volume,
          onVolumeChange: _cache[3] || (_cache[3] = ($event) => _ctx.$emit("volume-change", $event))
        }, null, 8, ["volume"])) : createCommentVNode("", true)
      ])) : createCommentVNode("", true)
    ], 38),
    !$props.isFullscreen && $data.showVideoMask ? (openBlock(), createElementBlock("div", {
      key: 0,
      class: "video-pic-in-pic-mask",
      onClick: _cache[5] || (_cache[5] = ($event) => _ctx.$emit("mask-click"))
    }, '\u4EE5"\u753B\u4E2D\u753B"\u6A21\u5F0F\u64AD\u653E')) : createCommentVNode("", true)
  ]);
}
const MiniPlayer = /* @__PURE__ */ _export_sfc(_sfc_main$5, [["render", _sfc_render$2], ["__scopeId", "data-v-71244fb9"]]);
const videoWrapper_vue_vue_type_style_index_0_scoped_true_lang = "";
const _sfc_main$4 = {
  name: "video-wrapper",
  components: {
    MiniPlayer
  },
  props: {
    config: {
      type: Object,
      default: () => ({})
    }
  }
};
const _hoisted_1$4 = { class: "video-wrapper" };
function _sfc_render$1(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_mini_player = resolveComponent("mini-player");
  return openBlock(), createElementBlock("div", _hoisted_1$4, [
    $props.config.miniplayer ? (openBlock(), createBlock(_component_mini_player, mergeProps({ key: 0 }, _ctx.$attrs, { config: $props.config }, toHandlers(_ctx.$listeners)), {
      video: withCtx(() => [
        renderSlot$2(_ctx.$slots, "video", {}, void 0, true)
      ]),
      _: 3
    }, 16, ["config"])) : renderSlot$2(_ctx.$slots, "video", { key: 1 }, void 0, true)
  ]);
}
const VideoWrapper = /* @__PURE__ */ _export_sfc(_sfc_main$4, [["render", _sfc_render$1], ["__scopeId", "data-v-69528009"]]);
const DEFAULT_IMG_BIG = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAALgAAAC4CAMAAABn7db1AAAAmVBMVEUAAADg4OD////h4eHj4+Pk5OTh4eHj4+Pm5ubh4eHp6enh4eHh4eHj4+Ph4eH6+vrh4eHi4uL////g4ODg4ODh4eHg4ODh4eHh4eHj4+Ph4eHh4eHi4uLi4uLn5+fh4eHh4eHg4ODi4uLh4eHi4uLh4eHh4eHm5ubr6+vh4eHh4eHi4uLh4eHi4uLm5ubh4eHj4+Ph4eHg4OCTD83BAAAAMnRSTlMA1gTuQDCiNxfMEal9IrEH4ysC+vn36b6dR7eVeE8K8t/YhF5T0IonDNuNa2NNHcVZrWuRmYsAAAQGSURBVHja7NrZbhoxGIbhD2bfGWYIO2FJAlkgyXf/F1do1ChmBsap2vK74jm2pVeWLR/YuLoU7yG4oWxF5zVeQ5WkNMTAxxe2RWN0nC/dJQ1y+1m+M2i9Dzo+PkQ0jIufHBonx8GSxlniIKBxAhxIv3dq3OCABrqGN7iG/+fh1qJ1UY/Wb4T3xsMMFxfeRd8Mj3YQwnn9TvgEcmSufngMUSLd8BSyzFp64UUCYbZ64S7ECbTCpxAn1grfQBxPJ9yCPDud8EfIM9MJb0Ge9jW8wTX8T4b73nBr5xnOERcePqcWP9w/eThJWHjuFurIVRf1RIWHY1bce6glKdybs86ydtEFhU97rPeeoUpO+JQnjdqoEBPu9XjaABVSwsM5z1nhmJTwMc+yfBwREp6zwRhHhIS7bFD6UMkIDws2iaGSEf7MRguoZISnbJZAISPcYrMVFCLCfWp4gEJEuEcNERQiwofUMIJCRPiUGvpQiAi3qSGFQkS4Qw0uFCLCN9QQQyEiHAs2G0IhI3zMRsUGChnh9sXPpn64as4mU6iEhL+womGKkPB2i+dtoZIS3rTL33FMSjiWPKMT4piY8G7a9GNUJSYc2ehkt40qOeFoD07+La6SFA6sLFZFIeqICoc/LqkKhqgnKxzw40d+6kWns6WF7yUvT9Gonw4mdoa/IvOT3PHsu7et7TnrZJck69yx5T4Xbry3eDAKOiVriQyf2ZN0zl9MCc8n/YJ7ZoX7k3vumRbuuQVpXHh3FZA0Lrz7tiANDL9rkQaGr/ukgeFZXNLE8LxFmhj+0qOJ4TOXNDHcD2hkeD6nkeG2RSPDhz0aGb4taWT4tKCR4XZJI8O9W/6D8B/t3dtqwkAUheGt1qhRUWw1nuoBYzyCZb3/w7XXDeJSNtNMWf8TfOQmkMmwNuZdvwGHwv+xf6whCBx1c4j40usOb5prBYAw8J159gWPwl9gao5B5ANvDMyt9hBEDnDnU8tjB0Ru8Js5NZqDyA+ON/NpCiJP+L5uHp3hUvCrvz0QOcPHzWq778KxSSvtvg9HtjI+7hDdH+4vrycg84cjS+3V0gx0/nBsD/ZazS1KhYSjkdsrXT5QKiwcSFJ7tv4c5YLDMbmM7JkGyzGI/OHlavkT9HwLojBw4HRZGdXnHkTh4MA6mT187KsrwXaGM02SXdvulubJGkTOcLZTdznrD36bW9dFB2z+cL5JZ96dnotzsZh2s1oDTJWAVyLBHyS44GSCC04muOBkggtOJrjgZIILTia44GSCC04muOBkggtOJrjgZIILTia44GSCC04muOBkggtOJvj/gEc7LBrtlGu047nRzhVHOxAd7yR3tCPo8c7Oxzv0/1Or6FT9TfQ+vPUOpv6obza+k1HEc4J4AAAAAElFTkSuQmCC";
const downSvg = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJubyI/PjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+PHN2ZyB0PSIxNjM5Mzc3MzE5OTgyIiBjbGFzcz0iaWNvbiIgdmlld0JveD0iMCAwIDEwMjQgMTAyNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHAtaWQ9IjU3NTgiIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMTYiIGhlaWdodD0iMTYiPjxkZWZzPjxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+PC9zdHlsZT48L2RlZnM+PHBhdGggZD0iTTUxNy4zMTIgMTkyYTMyIDMyIDAgMCAxIDMyIDMydjMyNC4wMzJsODcuMTY4LTg3LjE2OGEzMiAzMiAwIDAgMSA0NS4yNDggMGw3LjI5NiA3LjI5NmEzMiAzMiAwIDAgMSAwIDQ1LjI0OGwtMTU0LjQzMiAxNTQuNDMyYTMyIDMyIDAgMCAxLTQ1LjI0OCAwTDMzNC45MTIgNTEzLjQwOGEzMiAzMiAwIDAgMSAwLTQ1LjI0OGw3LjI5Ni03LjI5NmEzMiAzMiAwIDAgMSA0NS4yNDggMGw4Ny41NTIgODcuNTUyVjIyNGEzMiAzMiAwIDAgMSAzMi0zMmgxMC4zMDR6IG0tMzE1LjAwOCA0NzcuOTUyYTMyIDMyIDAgMCAwLTMyLTMySDE2MGEzMiAzMiAwIDAgMC0zMiAzMnYxNzEuMzI4YTMyIDMyIDAgMCAwIDMyIDMyaDcwNGEzMiAzMiAwIDAgMCAzMi0zMnYtMTcxLjMyOGEzMiAzMiAwIDAgMC0zMi0zMmgtMTAuMzA0YTMyIDMyIDAgMCAwLTMyIDMydjEyOS4wMjRIMjAyLjI0di0xMjkuMDI0eiIgcC1pZD0iNTc1OSIgZmlsbD0iI2ZmZmZmZiI+PC9wYXRoPjwvc3ZnPg==";
const download_vue_vue_type_style_index_0_scoped_true_lang = "";
const _hoisted_1$3 = ["src"];
const _sfc_main$3 = /* @__PURE__ */ defineComponent({
  __name: "download",
  props: {
    videoId: {
      type: [String, Number],
      default: ""
    }
  },
  setup(__props) {
    const props = __props;
    const onClickHandler = () => {
      if (props.videoId) {
        window.location.href = `/api/noah/video/download/video?photoId=${props.videoId}&original=true`;
      }
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: "video-download",
        onClick: onClickHandler
      }, [
        createElementVNode("img", {
          src: unref(downSvg),
          class: "download-img"
        }, null, 8, _hoisted_1$3)
      ]);
    };
  }
});
const VideoDownload = /* @__PURE__ */ _export_sfc(_sfc_main$3, [["__scopeId", "data-v-2f2ca2a3"]]);
const playCenter_vue_vue_type_style_index_0_lang = "";
const _hoisted_1$2 = ["src"];
const _sfc_main$2 = /* @__PURE__ */ defineComponent({
  __name: "play-center",
  props: {
    isPlaying: {
      type: Boolean,
      default: false
    }
  },
  emits: ["state-change"],
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: "video-play-center",
        onClick: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("state-change"))
      }, [
        createElementVNode("img", {
          src: !__props.isPlaying ? unref(play) : unref(pause),
          class: "play-icon"
        }, null, 8, _hoisted_1$2)
      ]);
    };
  }
});
const coverImg_vue_vue_type_style_index_0_scoped_true_lang = "";
const _withScopeId = (n) => (pushScopeId("data-v-73167caf"), n = n(), popScopeId(), n);
const _hoisted_1$1 = { class: "video-cover" };
const _hoisted_2$1 = { class: "cover-img" };
const _hoisted_3$1 = /* @__PURE__ */ _withScopeId(() => /* @__PURE__ */ createElementVNode("div", { class: "image-slot" }, [
  /* @__PURE__ */ createElementVNode("i", { class: "noah-icon-imageLoadError" })
], -1));
const _hoisted_4$1 = /* @__PURE__ */ _withScopeId(() => /* @__PURE__ */ createElementVNode("div", null, [
  /* @__PURE__ */ createElementVNode("i", { class: "sys-icon-image-minus cover-img-icon" })
], -1));
const _sfc_main$1 = /* @__PURE__ */ defineComponent({
  __name: "cover-img",
  props: {
    coverUrl: {
      type: String,
      default: ""
    }
  },
  setup(__props) {
    return (_ctx, _cache) => {
      const _component_ks_image = resolveComponent("ks-image");
      const _component_ks_popover = resolveComponent("ks-popover");
      return openBlock(), createElementBlock("div", _hoisted_1$1, [
        createVNode(_component_ks_popover, {
          placement: "bottom",
          width: 186,
          trigger: "hover"
        }, {
          reference: withCtx(() => [
            _hoisted_4$1
          ]),
          default: withCtx(() => [
            createElementVNode("div", _hoisted_2$1, [
              createVNode(_component_ks_image, {
                style: { "width": "186px", "height": "328px", "text-align": "center", "background": "#f9f9f9" },
                src: __props.coverUrl,
                "preview-src-list": [__props.coverUrl],
                fit: "scale-down"
              }, {
                error: withCtx(() => [
                  _hoisted_3$1
                ]),
                _: 1
              }, 8, ["src", "preview-src-list"])
            ])
          ]),
          _: 1
        })
      ]);
    };
  }
});
const VideoCoverImg = /* @__PURE__ */ _export_sfc(_sfc_main$1, [["__scopeId", "data-v-73167caf"]]);
const index_vue_vue_type_style_index_0_lang = "";
const index_vue_vue_type_style_index_1_scoped_true_lang = "";
const _sfc_main = {
  name: "KsAdminVideoPlayer",
  components: {
    VideoLyricPlayer,
    VideoProgress,
    VideoPlay,
    VideoScreen,
    VideoTime,
    VideoVolume,
    VideoLoading,
    VideoPlaybackRate,
    VideoPicInPic,
    VideoWrapper,
    VideoDownload,
    VideoPlayCenter: _sfc_main$2,
    VideoCoverImg
  },
  mixins: [MiniPlayerMixin],
  props: {
    showFrameList: {
      type: Boolean,
      default: false
    },
    frameUrlList: {
      type: Array,
      default: () => []
    },
    videoId: {
      type: [String, Number],
      default: ""
    },
    width: {
      type: [String, Number],
      default: ""
    },
    height: {
      type: [String, Number],
      default: ""
    },
    muted: {
      type: Boolean,
      default: false
    },
    autoplay: {
      type: Boolean,
      default: false
    },
    lyrics: {
      type: String,
      default: ""
    },
    lyricsOffset: {
      type: Number,
      default: 0
    },
    poster: {
      type: String,
      default: DEFAULT_POSTER
    },
    preload: {
      type: String,
      default: "metadata"
    },
    src: {
      type: String || Array,
      default: ""
    },
    type: {
      type: String,
      default: ""
    },
    initVolume: {
      type: Number,
      default: 0.5
    },
    config: {
      type: Object,
      default: () => ({
        play: true,
        time: false,
        volume: false,
        screen: true,
        playbackRate: false
      })
    },
    control: {
      type: [Boolean, String],
      default: true,
      validator(val) {
        return typeof val === "boolean" || val === CONTROL_SHOW_STICKY;
      }
    },
    kernel: {
      type: [Function, Boolean],
      default: false
    },
    controlStyle: {
      type: Object,
      default: () => ({})
    },
    needDefaultPoster: {
      type: Boolean,
      default: false
    },
    rateConfig: {
      type: Object,
      default: () => ({
        rateList: [...DEFAULT_RATE_CONFIG],
        defaultRate: 1
      })
    },
    screenshotVtt: {
      type: String,
      default: void 0
    },
    fullscreenPlay: {
      type: Boolean,
      default: false
    },
    m3u8: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isFullscreen: false,
      loadProgress: 0,
      isToolShow: this.control === CONTROL_SHOW_STICKY,
      isWaiting: false,
      played: false,
      original: {
        currentTime: 0,
        duration: 0,
        volume: 0.5,
        buffered: {},
        playbackRate: 5,
        paused: true,
        ended: true
      },
      miniPlayed: false,
      getFormatTime,
      hisRef: null
    };
  },
  computed: {
    localPoster() {
      if (!this.showFrameList && this.poster && this.poster.toString().trim()) {
        return this.poster;
      }
      return this.needDefaultPoster ? DEFAULT_IMG_BIG : "";
    },
    hasVideo() {
      return !!this.videoSrc;
    },
    videoSrc() {
      const { src: src2 } = this;
      const formatSrc = Array.isArray(src2) && src2.length ? src2[0] : src2 || "";
      return formatSrc.toString().trim();
    },
    computedWidth() {
      if (typeof this.width === "number") {
        return `${this.width}px`;
      }
      return this.width;
    },
    computedHeight() {
      if (typeof this.height === "number") {
        return `${this.height}px`;
      }
      return this.height;
    },
    playedProgress() {
      return this.original.currentTime / this.original.duration;
    },
    controlBarStyle() {
      return __spreadValues(__spreadValues({}, DEFAULT_CONTROL_BAR_STYLE), this.controlStyle);
    },
    playCurrTime() {
      return this.original.currentTime;
    }
  },
  watch: {
    control(val) {
      if (val === CONTROL_SHOW_STICKY) {
        clearTimeout(this.toolTimer);
        this.isToolShow = true;
      } else {
        this.isToolShow = false;
      }
    },
    src() {
      this.clicks = 0;
      this.playtimes = 0;
      this.$nextTick(() => {
        this.initVideo();
      });
    },
    playCurrTime(val) {
      if (this.showFrameList) {
        let index2 = parseInt(val / 2);
        if (index2 > this.frameUrlList.length - 1) {
          index2 = this.frameUrlList.length - 1;
        }
        this.$refs.imgsCarousel.setActiveItem(index2);
      }
    }
  },
  created() {
    this.clicks = 0;
    this.delay = 300;
    this.clickCount = 0;
    this.playtimes = 0;
    this.DEFAULT_IMG_BIG = DEFAULT_IMG_BIG;
    this.prevVolume = this.original.volume;
  },
  mounted() {
    this.initVideo();
  },
  beforeUnmount() {
    return __async(this, null, function* () {
      this.$refs.video.preload = "none";
      this.$refs.video.src = null;
      if (this.m3u8) {
        this.hlsRef.destroy();
      }
      yield new Promise((resolve2) => {
        setTimeout(() => {
          resolve2(true);
        }, 10);
      });
    });
  },
  methods: {
    onError(event) {
      this.$emit("error", event, this.$refs.video ? this.$refs.video.error : "");
    },
    progressEventHandler() {
      if (!this.original.duration) {
        return;
      }
      const { buffered, currentTime } = this.$refs.video;
      if (!buffered.length) {
        return;
      }
      let i = buffered.length - 1;
      while (i > 0 && !(buffered.start(i) <= currentTime && currentTime <= buffered.end(i))) {
        i--;
      }
      this.loadProgress = buffered.end(i) / this.original.duration;
    },
    canplayEventHandler() {
      this.isWaiting = false;
    },
    playEventHandler() {
      this.played = true;
    },
    endedEventHandler() {
      this.playtimes++;
    },
    onPlaybackRateChangeHandler(rate) {
      this.$refs.video.playbackRate = this.original.playbackRate = rate;
    },
    onProgressChangeHandler(progress) {
      if (!this.original.duration) {
        return;
      }
      this.original.currentTime = this.$refs.video.currentTime = this.original.duration * progress;
    },
    onFullscreenChange() {
      this.isFullscreen = !this.isFullscreen;
      this.$emit("full-screen-change", this.isFullscreen);
      if (this.fullscreenPlay && !this.isFullscreen) {
        this.pause();
      }
    },
    onVolumeChangeHandler(volume2) {
      this.$refs.video.volume = this.original.volume = volume2;
    },
    onWaitingHandler() {
      this.isWaiting = true;
    },
    getValue() {
      if (this.$refs.video) {
        const value2 = videoProperty.reduce((obj, cur) => {
          obj[cur] = this.$refs.video[cur];
          return obj;
        }, {});
        value2.playtimes = this.playtimes;
        return value2;
      }
      return {};
    },
    setValue(property, value2) {
      this.$refs.video[property] = value2;
    },
    screenChange(fullscreen2) {
      if (fullscreen2) {
        this.exitFullScreen();
      } else {
        this.requestFullScreen(this.$refs.videoWrapper);
      }
    },
    play() {
      var _a;
      if (!this.hasVideo) {
        return;
      }
      (_a = this.$refs.video) == null ? void 0 : _a.play();
    },
    pause() {
      var _a;
      if (!this.hasVideo) {
        return;
      }
      (_a = this.$refs.video) == null ? void 0 : _a.pause();
    },
    load() {
      var _a;
      if (!this.hasVideo) {
        return;
      }
      this.initVideo();
      (_a = this.$refs.video) == null ? void 0 : _a.load();
    },
    syncAndEmit({ name, properties, event }) {
      if (!this.$refs.video) {
        return;
      }
      const changeValue = {};
      properties.forEach((item) => {
        this.original[item] = changeValue[item] = this.$refs.video[item];
      });
      if (this[`${name}EventHandler`]) {
        this[`${name}EventHandler`]();
      }
      this.eventHandler(name, {
        event,
        changeValue
      });
    },
    showControlBar() {
      if (this.control === CONTROL_SHOW_STICKY) {
        return;
      }
      this.$refs.videoWrapper.addEventListener("mousemove", this.checkControlBar);
      this.isToolShow = true;
      this.resetControlBarTimer(this.controlBarStyle.delay);
    },
    hideControlBar() {
      if (this.control === CONTROL_SHOW_STICKY) {
        return;
      }
      if (this.controlBarStyle.delay === 0) {
        this.isToolShow = false;
      }
      this.$refs.videoWrapper.removeEventListener("mousemove", this.checkControlBar);
    },
    checkControlBar() {
      if (this.control === CONTROL_SHOW_STICKY) {
        return;
      }
      this.isToolShow = true;
      this.resetControlBarTimer(this.controlBarStyle.delay || 2e3);
    },
    resetControlBarTimer(delay) {
      if (!delay) {
        return;
      }
      clearTimeout(this.toolTimer);
      this.toolTimer = setTimeout(() => {
        this.isToolShow = false;
      }, delay);
    },
    onMouseenterHandler() {
      this.onVolumeStatusHandler(true);
      this.showControlBar();
    },
    onMouseleaveHandler() {
      this.onVolumeStatusHandler(false);
      this.hideControlBar();
    },
    onVolumeStatusHandler(open) {
      if (this.config.volume && this.config.hoverOpenVolume) {
        if (open) {
          this.onVolumeChangeHandler(this.prevVolume);
        } else {
          this.prevVolume = this.original.volume;
          this.onVolumeChangeHandler(0);
        }
      }
    },
    onPlayStateChangeHandler() {
      this.playInline();
      if (this.fullscreenPlay) {
        this.playWithScreenChange();
      }
    },
    eventHandler(type, value2) {
      this.$emit(type, value2);
    },
    clickHandler($event, validSingleClick = true) {
      this.isToolShow = true;
      if (this.control !== CONTROL_SHOW_STICKY) {
        this.resetControlBarTimer(this.controlBarStyle.delay || 2e3);
      }
      this.clicks++;
      if (this.clicks === 1) {
        this.timer = setTimeout(() => {
          if (validSingleClick) {
            this.singelClicKHandler();
          }
          this.clicks = 0;
        }, this.delay);
      } else {
        clearTimeout(this.timer);
        this.doubleClickHandler();
        this.clicks = 0;
      }
    },
    singelClicKHandler() {
      this.playInline();
    },
    doubleClickHandler() {
      this.playWithScreenChange();
    },
    loadImg(selector = "img") {
      setTimeout(() => {
        const imgList = this.$el.querySelectorAll(selector);
        Array.from(imgList).forEach((img) => {
          const src2 = img.getAttribute("data-img-src");
          if (src2.trim()) {
            img.setAttribute("src", src2);
          }
        });
      }, 1);
    },
    playInline() {
      if (!this.hasVideo) {
        return;
      }
      const { video } = this.$refs;
      if (!this.original.paused && !video.ended) {
        this.pause();
        return;
      }
      this.play();
    },
    playWithScreenChange() {
      if (!this.hasVideo) {
        return;
      }
      this.play();
      if (this.isFullscreen) {
        this.exitFullScreen();
        return;
      }
      this.requestFullScreen(this.$refs.videoWrapper);
    },
    requestFullScreen(dom) {
      const requestMethod = dom.requestFullscreen || dom.webkitRequestFullscreen || dom.mozRequestFullScreen || dom.msRequestFullscreen;
      if (requestMethod) {
        requestMethod.call(dom);
      } else if (typeof window.ActiveXObject !== "undefined") {
        const wscript = new window.ActiveXObject("WScript.Shell");
        if (wscript !== null) {
          wscript.SendKeys("{F11}");
        }
      }
    },
    exitFullScreen() {
      if (!this.isFullscreen) {
        return;
      }
      const exitMethod = document.exitFullscreen || document.mozCancelFullScreen || document.webkitExitFullscreen || document.msExitFullscreen;
      if (exitMethod) {
        exitMethod.call(document);
      } else if (typeof window.ActiveXObject !== "undefined") {
        const wscript = new window.ActiveXObject("WScript.Shell");
        if (wscript !== null) {
          wscript.SendKeys("{F11}");
        }
      }
    },
    initKernel(videoElement, config) {
      if (this.kernel) {
        this.$kernel = new this.kernel(videoElement, config);
        this.$kernel.load();
      } else {
        this.$kernel = null;
        if (this.m3u8) {
          const hls = new Hls();
          this.hlsRef = hls;
          hls.loadSource(this.videoSrc);
          hls.attachMedia(this.$refs.video);
          hls.on(Hls.Events.MANIFEST_PARSED, () => {
          });
          hls.on(Hls.Events.ERROR, () => {
          });
        } else {
          this.$refs.video.src = this.videoSrc;
        }
        this.$refs.video.playbackRate = this.original.playbackRate;
      }
    },
    initVideo() {
      if (!this.hasVideo) {
        return;
      }
      this.original = {
        currentTime: 0,
        duration: 0,
        volume: this.initVolume,
        buffered: {},
        paused: true,
        ended: true,
        playbackRate: this.rateConfig.defaultRate || 1
      };
      this.loadProgress = 0;
      this.isFullscreen = false;
      this.played = false;
      this.$refs.video.volume = this.initVolume;
      this.initKernel(this.$refs.video, { src: this.videoSrc });
    },
    onMiniPlayerExposeMethodsHandler(methods) {
      Object.assign(this, methods);
    },
    onContextmenuHandler(e) {
      if (this.miniPlayed) {
        e.preventDefault();
      }
    }
  }
};
const _hoisted_1 = ["muted", "autoplay", "preload", "poster"];
const _hoisted_2 = { class: "ks-admin-video-player-center-state" };
const _hoisted_3 = { class: "control" };
const _hoisted_4 = { class: "control-left" };
const _hoisted_5 = { class: "control-right" };
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_video_wrapper = resolveComponent("video-wrapper");
  const _component_video_lyric_player = resolveComponent("video-lyric-player");
  const _component_video_loading = resolveComponent("video-loading");
  const _component_video_play_center = resolveComponent("video-play-center");
  const _component_video_progress = resolveComponent("video-progress");
  const _component_video_play = resolveComponent("video-play");
  const _component_video_time = resolveComponent("video-time");
  const _component_video_cover_img = resolveComponent("video-cover-img");
  const _component_video_playback_rate = resolveComponent("video-playback-rate");
  const _component_video_volume = resolveComponent("video-volume");
  const _component_video_pic_in_pic = resolveComponent("video-pic-in-pic");
  const _component_video_download = resolveComponent("video-download");
  const _component_video_screen = resolveComponent("video-screen");
  const _component_ks_image = resolveComponent("ks-image");
  const _component_ks_carousel_item = resolveComponent("ks-carousel-item");
  const _component_ks_carousel = resolveComponent("ks-carousel");
  return openBlock(), createElementBlock("div", {
    style: normalizeStyle({
      width: $data.isFullscreen ? "100%" : $options.computedWidth,
      height: $data.isFullscreen ? "100%" : $options.computedHeight
    })
  }, [
    createElementVNode("div", {
      ref: "videoWrapper",
      class: "ks-admin-video-player",
      style: normalizeStyle({
        width: $data.isFullscreen ? "100%" : $options.computedWidth,
        height: $data.isFullscreen ? "100%" : $options.computedHeight
      }),
      onMouseenter: _cache[20] || (_cache[20] = (...args) => $options.onMouseenterHandler && $options.onMouseenterHandler(...args)),
      onMouseleave: _cache[21] || (_cache[21] = (...args) => $options.onMouseleaveHandler && $options.onMouseleaveHandler(...args)),
      onFullscreenchange: _cache[22] || (_cache[22] = (...args) => $options.onFullscreenChange && $options.onFullscreenChange(...args)),
      onWebkitfullscreenchange: _cache[23] || (_cache[23] = (...args) => $options.onFullscreenChange && $options.onFullscreenChange(...args)),
      onMozfullscreenchange: _cache[24] || (_cache[24] = (...args) => $options.onFullscreenChange && $options.onFullscreenChange(...args)),
      "on:MSFullscreenChange": _cache[25] || (_cache[25] = (...args) => $options.onFullscreenChange && $options.onFullscreenChange(...args))
    }, [
      createVNode(_component_video_wrapper, {
        ref: "miniPlayer",
        "mini-played": $data.miniPlayed,
        "is-fullscreen": $data.isFullscreen,
        control: $props.control,
        config: $props.config,
        "control-bar-style": $options.controlBarStyle,
        "played-progress": $options.playedProgress,
        "load-progress": $data.loadProgress,
        original: $data.original,
        "screenshot-vtt": $props.screenshotVtt,
        "is-tool-show": $data.isToolShow,
        onMiniPlayedChange: _cache[18] || (_cache[18] = (status) => $data.miniPlayed = status),
        onPicInPicChange: _ctx.picInPicChange,
        onPlayStateChange: $options.onPlayStateChangeHandler,
        onProgressChange: $options.onProgressChangeHandler,
        onVolumeChange: $options.onVolumeChangeHandler,
        onExposeMethods: $options.onMiniPlayerExposeMethodsHandler,
        onMaskClick: $options.clickHandler
      }, {
        video: withCtx(() => [
          createElementVNode("video", {
            ref: "video",
            class: "video-item",
            muted: $props.muted || !$data.original.volume,
            autoplay: $props.autoplay,
            preload: $props.preload,
            poster: $options.localPoster,
            onContextmenu: _cache[0] || (_cache[0] = (...args) => $options.onContextmenuHandler && $options.onContextmenuHandler(...args)),
            onClick: _cache[1] || (_cache[1] = ($event) => $options.clickHandler($event, !$props.config.miniplayer || !$data.miniPlayed)),
            onDurationchange: _cache[2] || (_cache[2] = ($event) => $options.syncAndEmit({
              name: "durationchange",
              properties: ["duration", "buffered"],
              event: $event
            })),
            onPlay: _cache[3] || (_cache[3] = ($event) => $options.syncAndEmit({
              name: "play",
              properties: ["paused", "ended"],
              event: $event
            })),
            onPlaying: _cache[4] || (_cache[4] = ($event) => $options.syncAndEmit({
              name: "playing",
              properties: ["paused", "ended"],
              event: $event
            })),
            onLoadstart: _cache[5] || (_cache[5] = ($event) => $options.syncAndEmit({
              name: "loadstart",
              properties: ["buffered"],
              event: $event
            })),
            onLoadedmetadata: _cache[6] || (_cache[6] = ($event) => $options.syncAndEmit({
              name: "loadedmetadata",
              properties: ["buffered"],
              event: $event
            })),
            onEnded: _cache[7] || (_cache[7] = ($event) => $options.syncAndEmit({
              name: "ended",
              properties: ["paused", "ended"],
              event: $event
            })),
            onPause: _cache[8] || (_cache[8] = ($event) => $options.syncAndEmit({
              name: "pause",
              properties: ["paused", "ended"],
              event: $event
            })),
            onProgress: _cache[9] || (_cache[9] = ($event) => $options.syncAndEmit({
              name: "progress",
              properties: ["buffered"],
              event: $event
            })),
            onRatechange: _cache[10] || (_cache[10] = ($event) => $options.syncAndEmit({
              name: "ratechange",
              properties: ["playbackRate"],
              event: $event
            })),
            onTimeupdate: _cache[11] || (_cache[11] = ($event) => $options.syncAndEmit({
              name: "timeupdate",
              properties: ["currentTime"],
              event: $event
            })),
            onVolumechange: _cache[12] || (_cache[12] = ($event) => $options.syncAndEmit({
              name: "volumechange",
              properties: ["volume"],
              event: $event
            })),
            onCanplay: _cache[13] || (_cache[13] = ($event) => $options.syncAndEmit({
              name: "canplay",
              properties: ["buffered"],
              event: $event
            })),
            onWaiting: _cache[14] || (_cache[14] = (...args) => $options.onWaitingHandler && $options.onWaitingHandler(...args)),
            onSeeking: _cache[15] || (_cache[15] = ($event) => $options.eventHandler("seeking", $event)),
            onSeeked: _cache[16] || (_cache[16] = ($event) => $options.eventHandler("seeked", $event)),
            onError: _cache[17] || (_cache[17] = (...args) => $options.onError && $options.onError(...args))
          }, " \u60A8\u7684\u6D4F\u89C8\u5668\u4E0D\u652F\u6301 video \u6807\u7B7E ", 40, _hoisted_1)
        ]),
        _: 1
      }, 8, ["mini-played", "is-fullscreen", "control", "config", "control-bar-style", "played-progress", "load-progress", "original", "screenshot-vtt", "is-tool-show", "onPicInPicChange", "onPlayStateChange", "onProgressChange", "onVolumeChange", "onExposeMethods", "onMaskClick"]),
      $data.played && $props.lyrics ? (openBlock(), createBlock(_component_video_lyric_player, {
        key: 0,
        "current-time": $data.original.currentTime,
        lyrics: $props.lyrics,
        offset: $props.lyricsOffset
      }, null, 8, ["current-time", "lyrics", "offset"])) : createCommentVNode("", true),
      createElementVNode("div", _hoisted_2, [
        renderSlot$2(_ctx.$slots, "center-state", {}, () => [
          $data.isWaiting ? (openBlock(), createBlock(_component_video_loading, { key: 0 })) : createCommentVNode("", true)
        ], true)
      ]),
      withDirectives(createVNode(_component_video_play_center, {
        class: "ks-admin-video-player-center-pause",
        onClick: $options.onPlayStateChangeHandler
      }, null, 8, ["onClick"]), [
        [vShow, $data.original.paused && !$data.isWaiting]
      ]),
      $props.control ? (openBlock(), createElementBlock("div", {
        key: 1,
        class: "ks-admin-video-player-tool",
        style: normalizeStyle({
          background: $options.controlBarStyle.barBackground || "",
          transform: $data.isToolShow ? "translateY(0)" : `translateY(100%)`,
          flexDirection: $options.controlBarStyle.reverse ? "column-reverse" : "column"
        })
      }, [
        createVNode(_component_video_progress, {
          "progress-height": $options.controlBarStyle.progressHeight,
          percent: $options.playedProgress,
          "load-percentage": $data.loadProgress,
          duration: $data.original.duration,
          "screenshot-vtt": $props.screenshotVtt,
          "is-tool-show": $data.isToolShow,
          "is-fullscreen": $data.isFullscreen,
          onPercentChange: $options.onProgressChangeHandler
        }, null, 8, ["progress-height", "percent", "load-percentage", "duration", "screenshot-vtt", "is-tool-show", "is-fullscreen", "onPercentChange"]),
        createElementVNode("div", _hoisted_3, [
          createElementVNode("div", _hoisted_4, [
            renderSlot$2(_ctx.$slots, "bar-left", {}, () => [
              $props.config.play ? (openBlock(), createBlock(_component_video_play, {
                key: 0,
                class: "control-item",
                "is-playing": !$data.original.paused,
                onStateChange: $options.onPlayStateChangeHandler
              }, null, 8, ["is-playing", "onStateChange"])) : createCommentVNode("", true),
              $props.config.time ? (openBlock(), createBlock(_component_video_time, {
                key: 1,
                "show-curr-time": $props.config.showCurrTime,
                class: "control-item",
                "current-time": $data.original.currentTime,
                duration: $data.original.duration
              }, null, 8, ["show-curr-time", "current-time", "duration"])) : createCommentVNode("", true),
              $props.config.coverImg ? (openBlock(), createBlock(_component_video_cover_img, {
                key: 2,
                class: "control-item",
                "cover-url": $props.poster
              }, null, 8, ["cover-url"])) : createCommentVNode("", true)
            ], true)
          ]),
          createElementVNode("div", _hoisted_5, [
            renderSlot$2(_ctx.$slots, "bar-right", {}, () => [
              $props.config.playbackRate ? (openBlock(), createBlock(_component_video_playback_rate, {
                key: 0,
                class: "control-item",
                "rate-config": $props.rateConfig,
                "playback-rate": $data.original.playbackRate,
                onRateChange: $options.onPlaybackRateChangeHandler
              }, null, 8, ["rate-config", "playback-rate", "onRateChange"])) : createCommentVNode("", true),
              $props.config.volume ? (openBlock(), createBlock(_component_video_volume, {
                key: 1,
                class: "control-item",
                volume: $data.original.volume,
                onVolumeChange: $options.onVolumeChangeHandler
              }, null, 8, ["volume", "onVolumeChange"])) : createCommentVNode("", true),
              $props.config.miniplayer ? (openBlock(), createBlock(_component_video_pic_in_pic, {
                key: 2,
                class: "control-item",
                "mini-played": $data.miniPlayed,
                onPicInPic: _ctx.picInPicChange
              }, null, 8, ["mini-played", "onPicInPic"])) : createCommentVNode("", true),
              $props.config.download ? (openBlock(), createBlock(_component_video_download, {
                key: 3,
                class: "control-item",
                "video-id": $props.videoId
              }, null, 8, ["video-id"])) : createCommentVNode("", true),
              $props.config.screen ? (openBlock(), createBlock(_component_video_screen, {
                key: 4,
                class: "control-item",
                "is-fullscreen": $data.isFullscreen,
                onStateChange: _cache[19] || (_cache[19] = ($event) => $options.screenChange($data.isFullscreen))
              }, null, 8, ["is-fullscreen"])) : createCommentVNode("", true)
            ], true)
          ])
        ])
      ], 4)) : createCommentVNode("", true),
      $props.showFrameList ? renderSlot$2(_ctx.$slots, "imgs-poster", { key: 2 }, () => [
        (openBlock(), createBlock(_component_ks_carousel, {
          key: $data.isFullscreen,
          ref: "imgsCarousel",
          "indicator-position": "none",
          class: "imgs-poster",
          autoplay: false,
          interval: 2e3,
          arrow: "never",
          loop: false,
          "pause-on-hover": false,
          onClick: $options.onPlayStateChangeHandler
        }, {
          default: withCtx(() => [
            (openBlock(true), createElementBlock(Fragment, null, renderList($props.frameUrlList, (item) => {
              return openBlock(), createBlock(_component_ks_carousel_item, { key: item }, {
                default: withCtx(() => [
                  createVNode(_component_ks_image, {
                    src: item,
                    fit: "contain"
                  }, null, 8, ["src"])
                ]),
                _: 2
              }, 1024);
            }), 128))
          ]),
          _: 1
        }, 8, ["onClick"]))
      ], true) : createCommentVNode("", true)
    ], 36)
  ], 4);
}
const VideoPlayer = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__scopeId", "data-v-d1ff0f34"]]);
export {
  BatchInput,
  _sfc_main$1c as BtnConfirm,
  CopyIcon,
  CurdDrawer,
  CurdTable,
  FormDrawer,
  NoahIcon,
  ProBatchId,
  Cascader as ProCascader,
  index$1 as ProCharts,
  index as ProChartsOptions,
  Checkbox as ProCheckbox,
  ProCheckboxInput,
  ColorPicker as ProColorPicker,
  ProDatePicker,
  ProFileUpload,
  ProForm,
  index$2 as ProGroup,
  ProImgPopover,
  ProInput,
  ProInputRange,
  ProPagination,
  Radio as ProRadio,
  index$3 as ProRenderTable,
  ProSearch,
  ProSelect,
  ProTab,
  ProTable,
  ProTooltip,
  ProTreeSelect,
  ProUploadImage,
  ProUploadVideo,
  index$4 as ProUtils,
  ToolBar as SelectionBar,
  SettingIcon,
  TABLE_ITEM_TYPE,
  Tag,
  UploadImage,
  VideoPlayer,
  renderBuiltInBtn
};
